export const HomeCasino = {
  HotGame: [
    {
      name: "Super Ace",
      img: "/assets/Casino/JL0033.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
    },
    {
      name: "Wild Bounty Showdown",
      img: "/assets/Casino/PG0113.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
    },
    {
      name: "Royal Ace",
      img: "/assets/Casino/YB0036.webp",
      vendor: "/assets/Platform/YB-COLOR.webp",
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-022",
    },
    {
      name: "Super Ace II",
      img: "/assets/Casino/JL0214.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-130",
    },
    {
      name: "Fortune Gems",
      img: "/assets/Casino/JL0045.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
    },
    {
      name: "Aviator",
      img: "/assets/Casino/SPB002.webp",
      vendor: "/assets/Platform/SPB-COLOR.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
    },
    {
      name: "Boxing King",
      img: "/assets/Casino/JL0038.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
    },
    {
      name: "Ultimate Sic Bo",
      img: "/assets/Casino/EZ0108.webp",
      vendor: "/assets/Platform/EZ-COLOR.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-079",
    },
    {
      name: "Money Coming 2",
      img: "/assets/Casino/JL0215.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
    },
    {
      name: "Super Ace Deluxe",
      img: "/assets/Casino/JL0162.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
    },
    {
      name: "Leprechaun Riches",
      img: "/assets/Casino/PG0041.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-038",
    },
    {
      name: "Fortune Gems 3",
      img: "/assets/Casino/JL0156.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
    },
    {
      name: "Crazy Time",
      img: "/assets/Casino/EG4147.webp?t=1762231266402",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
    },
    {
      name: "Money Coming",
      img: "/assets/Casino/JL0036.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
    },
    {
      name: "Safari Wilds",
      img: "/assets/Casino/PG0130.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-122",
    },
    {
      name: "10 Sparkling Crown",
      img: "/assets/Casino/JL0217.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-133",
    },
    {
      name: "Fortune Coins",
      img: "/assets/Casino/JL0211.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-129",
    },
    {
      name: "3 Charge Buffalo",
      img: "/assets/Casino/JL0213.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-131",
    },
    {
      name: "Joker Coins",
      img: "/assets/Casino/JL0218.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-137",
    },
    {
      name: "Fortune Gems 2",
      img: "/assets/Casino/JL0125.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
    },
    {
      name: "Wild Bandito",
      img: "/assets/Casino/PG0083.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-075",
    },
    {
      name: "Magic Ace WILD LOCK",
      img: "/assets/Casino/JDB225.webp",
      vendor: "/assets/Platform/JDB-COLOR.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
    },
    {
      name: "777-Classic Style",
      img: "/assets/Casino/BT0085.webp",
      vendor: "/assets/Platform/BT-COLOR.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-003",
    },
    {
      name: "Money Coming Expand Bets",
      img: "/assets/Casino/JL0167.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-107",
    },
    {
      name: "Aviator Extra Bet",
      img: "/assets/Casino/JDB227.webp",
      vendor: "/assets/Platform/JDB-COLOR.webp",
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-022",
    },
    // {
    //   name: "FlyX",
    //   img: "/assets/Casino/MG0436.webp",
    //   vendor: "/assets/Platform/MG-COLOR.webp",
    // },
    {
      name: "Mega Wheel",
      img: "/assets/Casino/PP0179.webp",
      vendor: "/assets/Platform/PP-COLOR.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-038",
    },
    {
      name: "Golden Empire",
      img: "/assets/Casino/JL0044.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-042",
    },
    // {
    //   name: "Wildfire Wins",
    //   img: "/assets/Casino/MG0416.webp",
    //   vendor: "/assets/Platform/MG-COLOR.webp",
    // },
    {
      name: "Treasures of Aztec",
      img: "/assets/Casino/PG0066.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
    },
    {
      name: "Coin Tree",
      img: "/assets/Casino/JL0202.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-125",
    },
    // {
    //   name: "Coin Up: Hot Fire",
    //   img: "/assets/Casino/BNG084.webp",
    //   vendor: "/assets/Platform/BNG-COLOR.webp",
    // },
    {
      name: "Golden Bank",
      img: "/assets/Casino/JL0029.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-023",
    },
    // {
    //   name: "Golden Basin",
    //   img: "/assets/Casino/BT0082.webp",
    //   vendor: "/assets/Platform/BT-COLOR.webp",
    // },
    {
      name: "Mega Ace",
      img: "/assets/Casino/JL0093.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-051",
    },
    {
      name: "Fortune Roulette",
      img: "/assets/Casino/JL0190.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-066",
    },
    {
      name: "Wild Ace",
      img: "/assets/Casino/JL0116.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-075",
    },
    {
      name: "Fruity Bonanza",
      img: "/assets/Casino/JDB189.webp",
      vendor: "/assets/Platform/JDB-COLOR.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-114",
    },
    {
      name: "Lucky Jaguar",
      img: "/assets/Casino/JL0189.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-115",
    },
    {
      name: "Crazy777",
      img: "/assets/Casino/JL0021.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-014",
    },
    {
      name: "High Flyer",
      img: "/assets/Casino/PP0841.webp",
      vendor: "/assets/Platform/PP-COLOR.webp",
      gameType: "EGAME",
      casinoType: "PP-EGAME-008",
      platFormCode: "PP",
    },
    {
      name: "Diamond Party",
      img: "/assets/Casino/JL0200.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-021",
    },
    {
      name: "Pharaoh Treasure",
      img: "/assets/Casino/JL0040.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-038",
    },
    {
      name: "Lucky Neko",
      img: "/assets/Casino/PG0073.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-065",
    },
    {
      name: "3 Coin Treasures 2",
      img: "/assets/Casino/JL0193.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-134",
    },
    {
      name: "3 Coin Wild Horse",
      img: "/assets/Casino/JL0206.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-126",
    },
    {
      name: "Crash Cricket",
      img: "/assets/Casino/JL0170.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-058",
    },
    {
      name: "Funky Time",
      img: "/assets/Casino/EG4326.webp?t=1762230960632",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-183",
    },
    {
      name: "Jili Caishen",
      img: "/assets/Casino/JL0083.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-060",
    },
    {
      name: "Fortune Tree",
      img: "/assets/Casino/JL0014.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-005",
    },
    {
      name: "Mahjong Ways",
      img: "/assets/Casino/PG0046.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-041",
    },
    {
      name: "Golden Bank 2",
      img: "/assets/Casino/JL0192.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-116",
    },
    {
      name: "Roma X Deluxe",
      img: "/assets/Casino/JL0209.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-124",
    },
    {
      name: "Egypt's Glow",
      img: "/assets/Casino/JL0174.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-108",
    },
    {
      name: "Legacy of Egypt",
      img: "/assets/Casino/JL0166.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-105",
    },
    {
      name: "Treasure Quest",
      img: "/assets/Casino/JL0203.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-114",
    },
    {
      name: "Egypt's Book of Mystery",
      img: "/assets/Casino/PG0056.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-051",
    },
    {
      name: "Ali Baba",
      img: "/assets/Casino/JL0094.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-247",
    },
    {
      name: "Fortune King Jackpot",
      img: "/assets/Casino/JL0183.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-013",
    },
    {
      name: "Happy Fishing",
      img: "/assets/Casino/JL0009.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-005",
    },
    {
      name: "Fortune Tiger",
      img: "/assets/Casino/PG0101.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-093",
    },
    {
      name: "Super Elements",
      img: "/assets/Casino/FC0045.webp",
      vendor: "/assets/Platform/FC-COLOR.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
    },
    {
      name: "Pinata Wins",
      img: "/assets/Casino/PG0144.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-136",
    },
    {
      name: "Cricket",
      img: "/assets/Casino/U9W004.webp",
      vendor: "/assets/Platform/U9W-COLOR.webp",
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-005",
    },
    {
      name: "Go Go Rise",
      img: "/assets/Casino/FC0047.webp",
      vendor: "/assets/Platform/FC-COLOR.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-006",
    },
    {
      name: "Super Sic Bo",
      img: "/assets/Casino/EG4189.webp?t=1762232971317",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-005",
    },
  ],
  JiliSlots: [
    {
      name: "Chicken Dash",
      img: "/assets/Casino/JL0242.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-082",
    },
    // {
    //   name: "3 Super Ace",
    //   img: "/assets/Casino/JL0237.webp",
    //   vendor: "/assets/Platform/JL-COLOR.webp",
    // },
    {
      name: "Dice & Drop",
      img: "/assets/Casino/JL0236.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-057",
    },
    {
      name: "Sweet Magic",
      img: "/assets/Casino/JL0235.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-150",
    },
    {
      name: "3 Lucky Baozhu",
      img: "/assets/Casino/JL0234.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-168",
    },
    {
      name: "Crazy777 2",
      img: "/assets/Casino/JL0233.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-149",
    },
    {
      name: "40 Sparkling Crown",
      img: "/assets/Casino/JL0229.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-145",
    },
    {
      name: "Circus Joker 4096",
      img: "/assets/Casino/JL0232.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-136",
    },
    {
      name: "Golden Empire 2",
      img: "/assets/Casino/JL0228.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-143",
    },
    {
      name: "Bikini Lady",
      img: "/assets/Casino/JL0227.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-127",
    },
    {
      name: "Mines Grand",
      img: "/assets/Casino/JL0226.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-076",
    },
    {
      name: "3 Witch's Lamp",
      img: "/assets/Casino/JL0224.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-054",
    },
    {
      name: "Clover Coins 3x3",
      img: "/assets/Casino/JL0223.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-148",
    },
    {
      name: "Money Pot Deluxe",
      img: "/assets/Casino/JL0222.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-044",
    },
    {
      name: "Pirate Queen 2",
      img: "/assets/Casino/JL0221.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-073",
    },
    {
      name: "Golden Treasure",
      img: "/assets/Casino/JL0220.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-077",
    },
    {
      name: "Penalty Kick",
      img: "/assets/Casino/JL0219.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-072",
    },
    {
      name: "Joker Coins",
      img: "/assets/Casino/JL0218.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-137",
    },
    {
      name: "10 Sparkling Crown",
      img: "/assets/Casino/JL0217.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-133",
    },
    {
      name: "Money Coming 2",
      img: "/assets/Casino/JL0215.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-146",
    },
    {
      name: "Super Ace II",
      img: "/assets/Casino/JL0214.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-130",
    },
    {
      name: "3 Charge Buffalo",
      img: "/assets/Casino/JL0213.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-131",
    },
    {
      name: "Super Ace Joker",
      img: "/assets/Casino/JL0212.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-118",
    },
    {
      name: "Fortune Coins",
      img: "/assets/Casino/JL0211.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-129",
    },
    {
      name: "Crash Touchdown",
      img: "/assets/Casino/JL0210.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-070",
    },
    {
      name: "Roma X Deluxe",
      img: "/assets/Casino/JL0209.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-124",
    },
    {
      name: "3 LUCKY LION",
      img: "/assets/Casino/JL0208.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-140",
    },
    {
      name: "Cricket War",
      img: "/assets/Casino/JL0207.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-069",
    },
    {
      name: "3 Coin Wild Horse",
      img: "/assets/Casino/JL0206.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-126",
    },
    {
      name: "Keno Extra Bet",
      img: "/assets/Casino/JL0205.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-074",
    },
    {
      name: "Keno Super Chance",
      img: "/assets/Casino/JL0204.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-071",
    },
    {
      name: "Treasure Quest",
      img: "/assets/Casino/JL0203.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-114",
    },
    {
      name: "Coin Tree",
      img: "/assets/Casino/JL0202.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-125",
    },
    {
      name: "Diamond Party",
      img: "/assets/Casino/JL0200.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-021",
    },
    {
      name: "Color Game Extreme",
      img: "/assets/Casino/JL0201.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-078",
    },
    {
      name: "Hawaii Beauty",
      img: "/assets/Casino/JL0199.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-012",
    },
    {
      name: "Coin Infinity Surge Reel",
      img: "/assets/Casino/JL0198.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-122",
    },
    {
      name: "Safari Mystery",
      img: "/assets/Casino/JL0197.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-123",
    },
    {
      name: "Fortune Gems Scratch",
      img: "/assets/Casino/JL0195.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-068",
    },
    {
      name: "Go For Champion",
      img: "/assets/Casino/JL0194.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-067",
    },
    {
      name: "3 Coin Treasures 2",
      img: "/assets/Casino/JL0193.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-134",
    },
    {
      name: "Golden Bank 2",
      img: "/assets/Casino/JL0192.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-116",
    },
    {
      name: "Safari King",
      img: "/assets/Casino/JL0191.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-154",
    },
    {
      name: "Fortune Roulette",
      img: "/assets/Casino/JL0190.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-066",
    },
    {
      name: "Lucky Jaguar",
      img: "/assets/Casino/JL0189.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-115",
    },
    {
      name: "Nightfall Hunting",
      img: "/assets/Casino/JL0187.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-113",
    },
    {
      name: "Thai Hilo",
      img: "/assets/Casino/JL0186.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-063",
    },
    {
      name: "Boxing Extravaganza",
      img: "/assets/Casino/JL0185.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-062",
    },
    {
      name: "Shōgun",
      img: "/assets/Casino/JL0184.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-110",
    },
    {
      name: "Money Pot",
      img: "/assets/Casino/JL0182.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-112",
    },
    {
      name: "Cricket Roulette",
      img: "/assets/Casino/JL0181.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-060",
    },
    {
      name: "3 Pot Dragons",
      img: "/assets/Casino/JL0180.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-106",
    },
    {
      name: "Lucky Doggy",
      img: "/assets/Casino/JL0179.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-117",
    },
    {
      name: "Fruity Wheel",
      img: "/assets/Casino/JL0178.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-111",
    },
    {
      name: "Keno Bonus Number",
      img: "/assets/Casino/JL0177.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-065",
    },
    {
      name: "Poseidon",
      img: "/assets/Casino/JL0176.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-121",
    },
    {
      name: "Super E-Sabong",
      img: "/assets/Casino/JL0175.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-064",
    },
    {
      name: "Egypt's Glow",
      img: "/assets/Casino/JL0174.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-108",
    },
    {
      name: "3 Lucky Piggy",
      img: "/assets/Casino/JL0173.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-109",
    },
    {
      name: "Candyland Bingo",
      img: "/assets/Casino/JL0172.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-043",
    },
    {
      name: "Party Star",
      img: "/assets/Casino/JL0171.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-104",
    },
    {
      name: "Crash Cricket",
      img: "/assets/Casino/JL0170.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-058",
    },
    {
      name: "Jhandi Munda",
      img: "/assets/Casino/JL0169.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-056",
    },
    {
      name: "Super Ace Scratch",
      img: "/assets/Casino/JL0168.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-059",
    },
    {
      name: "Money Coming Expand Bets",
      img: "/assets/Casino/JL0167.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-107",
    },
    {
      name: "Legacy of Egypt",
      img: "/assets/Casino/JL0166.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-105",
    },
    {
      name: "The Pig House",
      img: "/assets/Casino/JL0165.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-103",
    },
    {
      name: "Crazy Hunter2",
      img: "/assets/Casino/JL0164.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-099",
    },
    {
      name: "Crash Goal",
      img: "/assets/Casino/JL0163.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-055",
    },
    {
      name: "Super Ace Deluxe",
      img: "/assets/Casino/JL0162.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
    },
    {
      name: "Potion Wizard",
      img: "/assets/Casino/JL0161.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-098",
    },
    {
      name: "Fish Prawn Crab",
      img: "/assets/Casino/JL0160.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-057",
    },
    {
      name: "Jogo Do Bicho",
      img: "/assets/Casino/JL0159.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-052",
    },
    {
      name: "Video Poker",
      img: "/assets/Casino/JL0158.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-050",
    },
    {
      name: "European Roulette",
      img: "/assets/Casino/JL0157.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-053",
    },
    {
      name: "Fortune Gems 3",
      img: "/assets/Casino/JL0156.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
    },
    {
      name: "Speed Baccarat",
      img: "/assets/Casino/JL0155.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-054",
    },
    {
      name: "3 Coin Treasures",
      img: "/assets/Casino/JL0154.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-101",
    },
    {
      name: "Jackpot Joker",
      img: "/assets/Casino/JL0153.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-100",
    },
    {
      name: "Zeus",
      img: "/assets/Casino/JL0152.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-097",
    },
    {
      name: "Trial of Phoenix",
      img: "/assets/Casino/JL0151.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-084",
    },
    {
      name: "Devil Fire 2",
      img: "/assets/Casino/JL0150.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-094",
    },
    {
      name: "Arena Fighter",
      img: "/assets/Casino/JL0149.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-092",
    },
    {
      name: "Charge Buffalo Ascent",
      img: "/assets/Casino/JL0148.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-093",
    },
    {
      name: "Witches Night",
      img: "/assets/Casino/JL0147.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-095",
    },
    {
      name: "Pearls of Bingo",
      img: "/assets/Casino/JL0146.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-051",
    },
    {
      name: "King Arthur",
      img: "/assets/Casino/JL0145.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-091",
    },
    {
      name: "Night City",
      img: "/assets/Casino/JL0144.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-090",
    },
    {
      name: "Sin City",
      img: "/assets/Casino/JL0142.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-089",
    },
    {
      name: "Dabanggg",
      img: "/assets/Casino/JL0140.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-088",
    },
    {
      name: "Fortune Monkey",
      img: "/assets/Casino/JL0139.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-087",
    },
    {
      name: "Devil Fire",
      img: "/assets/Casino/JL0138.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-085",
    },
    {
      name: "Aztec Priestess",
      img: "/assets/Casino/JL0137.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-083",
    },
    {
      name: "Bangla Beauty",
      img: "/assets/Casino/JL0134.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-086",
    },
    {
      name: "Magic Lamp Bingo",
      img: "/assets/Casino/JL0132.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-045",
    },
    {
      name: "Cricket Sah 75",
      img: "/assets/Casino/JL0131.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-082",
    },
    {
      name: "Color Prediction",
      img: "/assets/Casino/JL0130.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-039",
    },
    {
      name: "Plinko",
      img: "/assets/Casino/JL0128.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-041",
    },
    {
      name: "Crash Bonus",
      img: "/assets/Casino/JL0127.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-047",
    },
    {
      name: "Cricket King 18",
      img: "/assets/Casino/JL0126.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-078",
    },
    {
      name: "Fortune Gems 2",
      img: "/assets/Casino/JL0125.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
    },
    {
      name: "Golden Temple",
      img: "/assets/Casino/JL0124.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-080",
    },
    {
      name: "Elf Bingo",
      img: "/assets/Casino/JL0123.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-081",
    },
    {
      name: "Keno",
      img: "/assets/Casino/JL0122.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-040",
    },
    {
      name: "Mines Gold",
      img: "/assets/Casino/JL0119.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-037",
    },
    {
      name: "Wheel",
      img: "/assets/Casino/JL0118.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-036",
    },
    {
      name: "Golden Land",
      img: "/assets/Casino/JL0117.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-027",
    },
    {
      name: "Wild Ace",
      img: "/assets/Casino/JL0116.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-075",
    },
    {
      name: "Limbo",
      img: "/assets/Casino/JL0115.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-035",
    },
    {
      name: "Bingo Adventure",
      img: "/assets/Casino/JL0114.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-034",
    },
    {
      name: "Sweet Land",
      img: "/assets/Casino/JL0113.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-079",
    },
    {
      name: "Hilo",
      img: "/assets/Casino/JL0112.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-032",
    },
    {
      name: "Mines",
      img: "/assets/Casino/JL0110.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-033",
    },
    {
      name: "Tower",
      img: "/assets/Casino/JL0109.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-031",
    },
    {
      name: "Go Rush",
      img: "/assets/Casino/JL0108.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-030",
    },
    {
      name: "Master Tiger",
      img: "/assets/Casino/JL0107.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-077",
    },
    {
      name: "Pirate Queen",
      img: "/assets/Casino/JL0106.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-073",
    },
    {
      name: "Pappu",
      img: "/assets/Casino/JL0105.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-028",
    },
    {
      name: "West Hunter Bingo",
      img: "/assets/Casino/JL0104.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-029",
    },
    {
      name: "Golden Joker",
      img: "/assets/Casino/JL0103.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-074",
    },
    {
      name: "Wild Racer",
      img: "/assets/Casino/JL0102.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-072",
    },
    {
      name: "Neko Fortune",
      img: "/assets/Casino/JL0101.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-071",
    },
    {
      name: "Twin Wins",
      img: "/assets/Casino/JL0100.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-047",
    },
    {
      name: "Magic Lamp",
      img: "/assets/Casino/JL0099.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-046",
    },
    {
      name: "Party Night",
      img: "/assets/Casino/JL0098.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-044",
    },
    {
      name: "Agent Ace",
      img: "/assets/Casino/JL0097.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-048",
    },
    {
      name: "Calaca Bingo",
      img: "/assets/Casino/JL0096.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-026",
    },
    {
      name: "Samba",
      img: "/assets/Casino/JL0095.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-070",
    },
    // {
    //   name: "Ali Baba",
    //   img: "/assets/Casino/JL0094.webp",
    //   vendor: "/assets/Platform/JL-COLOR.webp",
    // },
    {
      name: "Mega Ace",
      img: "/assets/Casino/JL0093.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-051",
    },
    {
      name: "World Cup",
      img: "/assets/Casino/JL0090.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-063",
    },
    {
      name: "Go Goal Bingo",
      img: "/assets/Casino/JL0089.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-022",
    },
    {
      name: "Jackpot Bingo",
      img: "/assets/Casino/JL0088.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-024",
    },
    {
      name: "Color Game",
      img: "/assets/Casino/JL0087.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-023",
    },
    {
      name: "Win Drop",
      img: "/assets/Casino/JL0086.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-061",
    },
    {
      name: "Bonus Hunter",
      img: "/assets/Casino/JL0085.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-062",
    },
    {
      name: "Lucky Bingo",
      img: "/assets/Casino/JL0084.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-020",
    },
    {
      name: "Jili Caishen",
      img: "/assets/Casino/JL0083.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-060",
    },
    {
      name: "Bingo Carnaval",
      img: "/assets/Casino/JL0074.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-019",
    },
    {
      name: "Super Bingo",
      img: "/assets/Casino/JL0073.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-018",
    },
    {
      name: "Sic Bo",
      img: "/assets/Casino/JL0072.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-017",
    },
    {
      name: "Fortune Bingo",
      img: "/assets/Casino/JL0071.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-015",
    },
    {
      name: "Baccarat",
      img: "/assets/Casino/JL0070.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-014",
    },
    {
      name: "7up7down",
      img: "/assets/Casino/JL0069.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-011",
    },
    {
      name: "Poker King",
      img: "/assets/Casino/JL0066.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-006",
    },
    // {
    //   name: "Journey West M",
    //   img: "/assets/Casino/JL0065.webp",
    //   vendor: "/assets/Platform/JL-COLOR.webp",
    // },
    // {
    //   name: "Number King",
    //   img: "/assets/Casino/JL0064.webp",
    //   vendor: "/assets/Platform/JL-COLOR.webp",
    // },
    {
      name: "Big Small",
      img: "/assets/Casino/JL0063.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-007",
    },
    {
      name: "Irich Bingo",
      img: "/assets/Casino/JL0058.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-008",
    },
    {
      name: "Bone Fortune",
      img: "/assets/Casino/JL0057.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-059",
    },
    {
      name: "Crazy Pusher",
      img: "/assets/Casino/JL0056.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-054",
    },
    {
      name: "Mayan Empire",
      img: "/assets/Casino/JL0055.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-058",
    },
    {
      name: "Gold Rush",
      img: "/assets/Casino/JL0054.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-057",
    },
    {
      name: "Happy Taxi",
      img: "/assets/Casino/JL0053.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-056",
    },
    {
      name: "Thor X",
      img: "/assets/Casino/JL0051.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-052",
    },
    {
      name: "Dragon & Tiger",
      img: "/assets/Casino/JL0049.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-012",
    },
    {
      name: "Book of Gold",
      img: "/assets/Casino/JL0048.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-053",
    },
    {
      name: "Medusa",
      img: "/assets/Casino/JL0047.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-050",
    },
    {
      name: "Crazy Hunter",
      img: "/assets/Casino/JL0046.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-045",
    },
    {
      name: "Fortune Gems",
      img: "/assets/Casino/JL0045.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
    },
    {
      name: "Golden Empire",
      img: "/assets/Casino/JL0044.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-042",
    },
    {
      name: "RomaX",
      img: "/assets/Casino/JL0043.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-040",
    },
    {
      name: "Super Rich",
      img: "/assets/Casino/JL0042.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-041",
    },
    {
      name: "Lucky Coming",
      img: "/assets/Casino/JL0041.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-037",
    },
    {
      name: "Pharaoh Treasure",
      img: "/assets/Casino/JL0040.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-038",
    },
    {
      name: "Secret Treasure",
      img: "/assets/Casino/JL0039.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-039",
    },
    {
      name: "Boxing King",
      img: "/assets/Casino/JL0038.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
    },
    {
      name: "Jungle King",
      img: "/assets/Casino/JL0037.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-028",
    },
    {
      name: "Money Coming",
      img: "/assets/Casino/JL0036.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
    },
    // {
    //   name: "Monkey Party",
    //   img: "/assets/Casino/JL0035.webp",
    //   vendor: "/assets/Platform/JL-COLOR.webp",
    // },
    {
      name: "Golden Queen",
      img: "/assets/Casino/JL0034.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-030",
    },
    {
      name: "Super Ace",
      img: "/assets/Casino/JL0033.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
    },
    {
      name: "Charge Buffalo",
      img: "/assets/Casino/JL0032.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-026",
    },
    {
      name: "Dragon Treasure",
      img: "/assets/Casino/JL0031.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-025",
    },
    {
      name: "Lucky Goldbricks",
      img: "/assets/Casino/JL0030.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-024",
    },
    {
      name: "Golden Bank",
      img: "/assets/Casino/JL0029.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-023",
    },
    {
      name: "Fengshen",
      img: "/assets/Casino/JL0028.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-022",
    },
    {
      name: "Candy Baby",
      img: "/assets/Casino/JL0027.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-020",
    },
    {
      name: "Fortune Pig",
      img: "/assets/Casino/JL0026.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      gameType: "SLOT",
      casinoType: "PP-SLOT-547",
      platFormCode: "PP",
    },
    {
      name: "Xi Yang Yang",
      img: "/assets/Casino/JL0025.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-054",
    },
    {
      name: "Crazy FaFaFa",
      img: "/assets/Casino/JL0024.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-017",
    },
    {
      name: "Bao Boon Chin",
      img: "/assets/Casino/JL0023.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-016",
    },
    {
      name: "Bubble Beauty",
      img: "/assets/Casino/JL0022.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-015",
    },
    {
      name: "Crazy777",
      img: "/assets/Casino/JL0021.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-014",
    },
    {
      name: "Seven Seven Seven",
      img: "/assets/Casino/JL0020.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-014",
    },
    {
      name: "God Of Martial",
      img: "/assets/Casino/JL0019.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-010",
    },
    {
      name: "Fa Fa Fa",
      img: "/assets/Casino/JL0018.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-009",
    },
    {
      name: "Shanghai Beauty",
      img: "/assets/Casino/JL0017.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-008",
    },
    {
      name: "Hyper Burst",
      img: "/assets/Casino/JL0016.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-007",
    },
    {
      name: "Lucky Ball",
      img: "/assets/Casino/JL0015.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-006",
    },
    {
      name: "Fortune Tree",
      img: "/assets/Casino/JL0014.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-005",
    },
    {
      name: "War Of Dragons",
      img: "/assets/Casino/JL0013.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-004",
    },
    {
      name: "Chin Shi Huang",
      img: "/assets/Casino/JL0012.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-003",
    },
    {
      name: "Hot Chilli",
      img: "/assets/Casino/JL0011.webp",
      vendor: "/assets/Platform/JL-COLOR.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-002",
    },
  ],
  PGSlots: [
    {
      name: "Pharaoh Royals",
      img: "/assets/Casino/PG0173.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-165",
    },
    {
      name: "Kraken Gold Rush",
      img: "/assets/Casino/PG0172.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-164",
    },
    {
      name: "Majestic Empire",
      img: "/assets/Casino/PG0171.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-163",
    },
    {
      name: "Grimms' Bounty: Hansel & Gretel",
      img: "/assets/Casino/PG0170.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-162",
    },
    {
      name: "Galaxy Miner",
      img: "/assets/Casino/PG0169.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-161",
    },
    {
      name: "Dragon's Treasure Quest",
      img: "/assets/Casino/PG0168.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-160",
    },
    {
      name: "Diner Frenzy Spins",
      img: "/assets/Casino/PG0167.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-159",
    },
    {
      name: "Jack the Giant Hunter",
      img: "/assets/Casino/PG0166.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-158",
    },
    {
      name: "Dead Man's Riches",
      img: "/assets/Casino/PG0165.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-157",
    },
    {
      name: "Knockout Riches",
      img: "/assets/Casino/PG0164.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-156",
    },
    {
      name: "Doomsday Rampage",
      img: "/assets/Casino/PG0163.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-155",
    },
    {
      name: "Graffiti Rush",
      img: "/assets/Casino/PG0162.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-154",
    },
    {
      name: "Mr. Treasure’s Fortune",
      img: "/assets/Casino/PG0161.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-153",
    },
    {
      name: "Incan Wonders",
      img: "/assets/Casino/PG0160.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-152",
    },
    {
      name: "Fortune Snake",
      img: "/assets/Casino/PG0159.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-151",
    },
    {
      name: "Geisha's Revenge",
      img: "/assets/Casino/PG0158.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-150",
    },
    {
      name: "Chocolate Deluxe",
      img: "/assets/Casino/PG0157.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-149",
    },
    {
      name: "Rio Fantasia",
      img: "/assets/Casino/PG0156.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-148",
    },
    {
      name: "Museum Wonders",
      img: "/assets/Casino/PG0155.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-147",
    },
    {
      name: "Oishi Delights",
      img: "/assets/Casino/PG0154.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-146",
    },
    {
      name: "Three Crazy Piggies",
      img: "/assets/Casino/PG0153.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-145",
    },
    {
      name: "Wings of Iguazu",
      img: "/assets/Casino/PG0152.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-144",
    },
    {
      name: "Yakuza Honor",
      img: "/assets/Casino/PG0151.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-143",
    },
    {
      name: "Shark Bounty",
      img: "/assets/Casino/PG0150.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-142",
    },
    {
      name: "Futebol Fever",
      img: "/assets/Casino/PG0149.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-141",
    },
    {
      name: "Zombie Outbreak",
      img: "/assets/Casino/PG0148.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-139",
    },
    {
      name: "Chicky Run",
      img: "/assets/Casino/PG0147.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-140",
    },
    {
      name: "Anubis Wrath",
      img: "/assets/Casino/PG0146.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-138",
    },
    {
      name: "Mystic Potion",
      img: "/assets/Casino/PG0145.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-137",
    },
    {
      name: "Pinata Wins",
      img: "/assets/Casino/PG0144.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-136",
    },
    {
      name: "Wild Ape#3258",
      img: "/assets/Casino/PG0143.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-135",
    },
    {
      name: "Cash Mania",
      img: "/assets/Casino/PG0142.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-134",
    },
    {
      name: "Gemstones Gold",
      img: "/assets/Casino/PG0141.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-133",
    },
    {
      name: "Fortune Dragon",
      img: "/assets/Casino/PG0140.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-132",
    },
    {
      name: "Dragon Hatch 2",
      img: "/assets/Casino/PG0139.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-131",
    },
    {
      name: "Werewolf's Hunt",
      img: "/assets/Casino/PG0138.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-130",
    },
    {
      name: "Tsar Treasures",
      img: "/assets/Casino/PG0137.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-129",
    },
    {
      name: "Mafia Mayhem",
      img: "/assets/Casino/PG0136.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-128",
    },
    {
      name: "Forge of Wealth",
      img: "/assets/Casino/PG0135.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-127",
    },
    {
      name: "Wild Heist Cashout",
      img: "/assets/Casino/PG0134.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-126",
    },
    {
      name: "Ultimate Striker",
      img: "/assets/Casino/PG0133.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-125",
    },
    {
      name: "Ninja Raccoon Frenzy",
      img: "/assets/Casino/PG0132.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-124",
    },
    {
      name: "Gladiator's Glory",
      img: "/assets/Casino/PG0131.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-123",
    },
    {
      name: "Safari Wilds",
      img: "/assets/Casino/PG0130.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-122",
    },
    {
      name: "Cruise Royale",
      img: "/assets/Casino/PG0129.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-121",
    },
    {
      name: "Fruit Candy",
      img: "/assets/Casino/PG0128.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
    },
    {
      name: "Lucky Clover Riches",
      img: "/assets/Casino/PG0127.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-119",
    },
    {
      name: "Super Golf Drive",
      img: "/assets/Casino/PG0126.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-118",
    },
    {
      name: "Mystical Spirits",
      img: "/assets/Casino/PG0125.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-117",
    },
    {
      name: "Songkran Splash",
      img: "/assets/Casino/PG0124.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-116",
    },
    {
      name: "Bakery Bonanza",
      img: "/assets/Casino/PG0123.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-115",
    },
    {
      name: "Hawaiian Tiki",
      img: "/assets/Casino/PG0122.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-114",
    },
    {
      name: "Rave Party Fever",
      img: "/assets/Casino/PG0121.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-113",
    },
    {
      name: "Fortune Rabbit",
      img: "/assets/Casino/PG0120.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-112",
    },
    {
      name: "Midas Fortune",
      img: "/assets/Casino/PG0119.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-111",
    },
    {
      name: "Asgardian Rising",
      img: "/assets/Casino/PG0118.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-110",
    },
    {
      name: "Diner Delights",
      img: "/assets/Casino/PG0117.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-109",
    },
    {
      name: "Alchemy Gold",
      img: "/assets/Casino/PG0116.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-108",
    },
    {
      name: "Totem Wonders",
      img: "/assets/Casino/PG0115.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-107",
    },
    {
      name: "Prosperity Fortune Tree",
      img: "/assets/Casino/PG0114.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-106",
    },
    {
      name: "Wild Bounty Showdown",
      img: "/assets/Casino/PG0113.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
    },
    {
      name: "Wild Coaster",
      img: "/assets/Casino/PG0112.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-104",
    },
    {
      name: "Legend of Perseus",
      img: "/assets/Casino/PG0111.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-103",
    },
    {
      name: "Speed Winner",
      img: "/assets/Casino/PG0110.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-102",
    },
    {
      name: "Lucky Piggy",
      img: "/assets/Casino/PG0109.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-101",
    },
    {
      name: "Win Win Fish Prawn Crab",
      img: "/assets/Casino/PG0108.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-100",
    },
    {
      name: "Battleground Royale",
      img: "/assets/Casino/PG0107.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-099",
    },
    {
      name: "The Queen's Banquet",
      img: "/assets/Casino/PG0106.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-098",
    },
    {
      name: "Rooster Rumble",
      img: "/assets/Casino/PG0105.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-097",
    },
    {
      name: "Butterfly Blossom",
      img: "/assets/Casino/PG0104.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-096",
    },
    {
      name: "Destiny of Sun & Moon",
      img: "/assets/Casino/PG0103.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-095",
    },
    {
      name: "Garuda Gems",
      img: "/assets/Casino/PG0102.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-094",
    },
    {
      name: "Fortune Tiger",
      img: "/assets/Casino/PG0101.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-093",
    },
    {
      name: "Oriental Prosperity",
      img: "/assets/Casino/PG0100.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-092",
    },
    {
      name: "Mask Carnival",
      img: "/assets/Casino/PG0099.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-091",
    },
    {
      name: "Cocktail Nights",
      img: "/assets/Casino/PG0098.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-090",
    },
    {
      name: "Emoji Riches",
      img: "/assets/Casino/PG0097.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-089",
    },
    {
      name: "Spirited Wonders",
      img: "/assets/Casino/PG0095.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-087",
    },
    {
      name: "Legendary Monkey King",
      img: "/assets/Casino/PG0094.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-086",
    },
    {
      name: "Buffalo Win",
      img: "/assets/Casino/PG0093.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-085",
    },
    {
      name: "Supermarket Spree",
      img: "/assets/Casino/PG0092.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-084",
    },
    {
      name: "Raider Jane's Crypt of Fortune",
      img: "/assets/Casino/PG0091.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-083",
    },
    {
      name: "Mermaid Riches",
      img: "/assets/Casino/PG0089.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-081",
    },
    {
      name: "Jurassic Kingdom",
      img: "/assets/Casino/PG0088.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-079",
    },
    {
      name: "Rise of Apollo",
      img: "/assets/Casino/PG0086.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-078",
    },
    // {
    //   name: "Heist of Stakes",
    //   img: "/assets/Casino/PG0085.webp",
    //   vendor: "/assets/Platform/PG-COLOR.webp",
    // },
    // {
    //   name: "Ways of Qilin",
    //   img: "/assets/Casino/PG0084.webp",
    //   vendor: "/assets/Platform/PG-COLOR.webp",
    // },
    {
      name: "Wild Bandito",
      img: "/assets/Casino/PG0083.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-075",
    },
    {
      name: "Candy Bonanza",
      img: "/assets/Casino/PG0082.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-074",
    },
    {
      name: "Majestic Treasures",
      img: "/assets/Casino/PG0081.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-073",
    },
    {
      name: "Crypto Gold",
      img: "/assets/Casino/PG0080.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-072",
    },
    {
      name: "Bali Vacation",
      img: "/assets/Casino/PG0079.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-071",
    },
    {
      name: "Fortune Ox",
      img: "/assets/Casino/PG0078.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-070",
    },
    {
      name: "Opera Dynasty",
      img: "/assets/Casino/PG0077.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-069",
    },
    {
      name: "Guardians of Ice and Fire",
      img: "/assets/Casino/PG0076.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-068",
    },
    {
      name: "Galactic Gems",
      img: "/assets/Casino/PG0075.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-067",
    },
    {
      name: "Jack Frost's Winter",
      img: "/assets/Casino/PG0074.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-066",
    },
    {
      name: "Lucky Neko",
      img: "/assets/Casino/PG0073.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-065",
    },
    {
      name: "Jewels of Prosperity",
      img: "/assets/Casino/PG0072.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-064",
    },
    {
      name: "Queen of Bounty",
      img: "/assets/Casino/PG0071.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-063",
    },
    {
      name: "Vampire's Charm",
      img: "/assets/Casino/PG0070.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-062",
    },
    {
      name: "Secret of Cleopatra",
      img: "/assets/Casino/PG0069.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-061",
    },
    {
      name: "Thai River Wonders",
      img: "/assets/Casino/PG0068.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-060",
    },
    {
      name: "Circus Delight",
      img: "/assets/Casino/PG0067.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-059",
    },
    {
      name: "Treasures of Aztec",
      img: "/assets/Casino/PG0066.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
    },
    {
      name: "Genie's 3 Wishes",
      img: "/assets/Casino/PG0065.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-057",
    },
    {
      name: "Wild Fireworks",
      img: "/assets/Casino/PG0063.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-055",
    },
    {
      name: "Dreams of Macau",
      img: "/assets/Casino/PG0060.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-054",
    },
    {
      name: "Phoenix Rises",
      img: "/assets/Casino/PG0059.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-053",
    },
    {
      name: "Ganesha Fortune",
      img: "/assets/Casino/PG0057.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-052",
    },
    {
      name: "Egypt's Book of Mystery",
      img: "/assets/Casino/PG0056.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-051",
    },
    {
      name: "Mahjong Ways 2",
      img: "/assets/Casino/PG0055.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-050",
    },
    {
      name: "Bikini Paradise",
      img: "/assets/Casino/PG0054.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-049",
    },
    {
      name: "Candy Burst",
      img: "/assets/Casino/PG0053.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-048",
    },
    {
      name: "Caishen Wins",
      img: "/assets/Casino/PG0052.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-047",
    },
    {
      name: "Gem Saviour Conquest",
      img: "/assets/Casino/PG0051.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-045",
    },
    {
      name: "Shaolin Soccer",
      img: "/assets/Casino/PG0050.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-046",
    },
    {
      name: "Reel Love",
      img: "/assets/Casino/PG0049.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-044",
    },
    {
      name: "Fortune Mouse",
      img: "/assets/Casino/PG0048.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-043",
    },
    {
      name: "Dragon Hatch",
      img: "/assets/Casino/PG0047.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-042",
    },
    {
      name: "Mahjong Ways",
      img: "/assets/Casino/PG0046.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-041",
    },
    {
      name: "Dragon Tiger Luck",
      img: "/assets/Casino/PG0045.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-035",
    },
    {
      name: "Muay Thai Champion",
      img: "/assets/Casino/PG0044.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-039",
    },
    {
      name: "Ninja vs Samurai",
      img: "/assets/Casino/PG0043.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-040",
    },
    {
      name: "Flirting Scholar",
      img: "/assets/Casino/PG0042.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-036",
    },
    {
      name: "Leprechaun Riches",
      img: "/assets/Casino/PG0041.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-038",
    },
    {
      name: "Captain's Bounty",
      img: "/assets/Casino/PG0039.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-034",
    },
    {
      name: "Journey to the Wealth",
      img: "/assets/Casino/PG0038.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-037",
    },
    {
      name: "The Great Icescape",
      img: "/assets/Casino/PG0037.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-032",
    },
    {
      name: "Double Fortune",
      img: "/assets/Casino/PG0035.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-030",
    },
    {
      name: "Jungle Delight",
      img: "/assets/Casino/PG0033.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-024",
    },
    {
      name: "Ganesha Gold",
      img: "/assets/Casino/PG0031.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-026",
    },
    {
      name: "Emperor's Favour",
      img: "/assets/Casino/PG0030.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
    },
    {
      name: "Symbols of Egypt",
      img: "/assets/Casino/PG0029.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-025",
    },
    {
      name: "Piggy Gold",
      img: "/assets/Casino/PG0028.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-023",
    },
    {
      name: "Gem Saviour Sword",
      img: "/assets/Casino/PG0027.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-022",
    },
    {
      name: "Santa's Gift Rush",
      img: "/assets/Casino/PG0025.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
    },
    {
      name: "Hip Hop Panda",
      img: "/assets/Casino/PG0024.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-017",
    },
    {
      name: "Prosperity Lion",
      img: "/assets/Casino/PG0023.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-020",
    },
    {
      name: "Legend of Hou Yi",
      img: "/assets/Casino/PG0021.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-018",
    },
    {
      name: "Mr. Hallow-Win",
      img: "/assets/Casino/PG0020.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-019",
    },
    {
      name: "Dragon Legend",
      img: "/assets/Casino/PG0019.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-016",
    },
    {
      name: "Hood vs Wolf",
      img: "/assets/Casino/PG0017.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-009",
    },
    {
      name: "Gem Saviour",
      img: "/assets/Casino/PG0014.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-002",
    },
    {
      name: "Plushie Frenzy",
      img: "/assets/Casino/PG0012.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-012",
    },
    {
      name: "Medusa",
      img: "/assets/Casino/PG0009.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-006",
    },
    {
      name: "Tree of Fortune",
      img: "/assets/Casino/PG0007.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-013",
    },
    {
      name: "Medusa II",
      img: "/assets/Casino/PG0005.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-005",
    },
    {
      name: "Win Win Won",
      img: "/assets/Casino/PG0004.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-011",
    },
    {
      name: "Fortune Gods",
      img: "/assets/Casino/PG0003.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-003",
    },
    {
      name: "Honey Trap of Diao Chan",
      img: "/assets/Casino/PG0002.webp",
      vendor: "/assets/Platform/PG-COLOR.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-001",
    },
  ],
  Live: [
    {
      name: "Baccarat",
      img: "/assets/Casino/SEX055.webp",
      vendor: "/assets/Platform/SEX-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-017",
    },
    // {
    //   name: "Imperial Fortune",
    //   img: "/assets/Casino/EZ0132.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Manga Madness",
    //   img: "/assets/Casino/EZ0131.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Coin Rush",
    //   img: "/assets/Casino/EZ0130.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Coin Rush Pro",
    //   img: "/assets/Casino/EZ0129.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "EZ Dealer Roulette Diwali",
    //   img: "/assets/Casino/EZ0128.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Halloween Auto Roulette",
    //   img: "/assets/Casino/EZ0127.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Diwali Auto Roulette",
    //   img: "/assets/Casino/EZ0126.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    {
      name: "Bet with Streamers",
      img: "/assets/Casino/EZ0125.webp",
      vendor: "/assets/Platform/EZ-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-408",
    },
    // {
    //   name: "Ultimate Flip",
    //   img: "/assets/Casino/EZ0124.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    // {
    //   name: "Canada Blackjack",
    //   img: "/assets/Casino/EZ0123.webp",
    //   vendor: "/assets/Platform/EZ-COLOR.webp",
    // },
    {
      name: "Money Time",
      img: "/assets/Casino/PP1069.webp",
      vendor: "/assets/Platform/PP-COLOR.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-188",
      platFormCode: "PP",
    },
    {
      name: "Always 9 Baccarat",
      img: "/assets/Casino/EG4622.webp?t=1762232674103",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-454",
    },
    {
      name: "Lucky Tree Baccarat",
      img: "/assets/Casino/PT0825.webp",
      vendor: "/assets/Platform/PT-COLOR.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-148",
    },
    {
      name: "Mega Fire Blaze Roleta Brasileira Live",
      img: "/assets/Casino/PT0826.webp",
      vendor: "/assets/Platform/PT-COLOR.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-028",
    },
    {
      name: "Dragon Tiger Phoenix",
      img: "/assets/Casino/EG4621.webp?t=1762233538628",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-453",
    },
    // {
    //   name: "Insurance Baccarat",
    //   img: "/assets/Casino/EG4620.webp?t=1762231976704",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Korean Salon Prive Baccarat",
    //   img: "/assets/Casino/EG4619.webp?t=1762231465491",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Blackjack em Português Ouro",
    //   img: "/assets/Casino/EG4618.webp?t=1762231761874",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Korean Platinum Private Blackjack 2",
    //   img: "/assets/Casino/EG4617.webp?t=1762237233438",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Korean Platinum Private Blackjack 1",
    //   img: "/assets/Casino/EG4616.webp?t=1762233121418",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    {
      name: "Super Speed Dragon Tiger",
      img: "/assets/Casino/EG4615.webp?t=1762237280362",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-451",
    },
    // {
    //   name: "Perya Speed Baccarat 8",
    //   img: "/assets/Casino/EG4614.webp?t=1762231708885",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Perya Speed Baccarat 7",
    //   img: "/assets/Casino/EG4613.webp?t=1762230612657",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Perya Speed Baccarat 6",
    //   img: "/assets/Casino/EG4612.webp?t=1762237073213",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Perya Speed Baccarat 5",
    //   img: "/assets/Casino/EG4611.webp?t=1762233131168",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Perya Lightning Roulette",
    //   img: "/assets/Casino/EG4610.webp?t=1762233029798",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    {
      name: "Salon Privé Auto-Roulette A",
      img: "/assets/Casino/EG4609.webp?t=1762237439345",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-081",
    },
    // {
    //   name: "Blackjack em Português 1",
    //   img: "/assets/Casino/EG4606.webp?t=1762231987311",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Blackjack Ilimitado Ao Vivo",
    //   img: "/assets/Casino/EG4605.webp?t=1762232368838",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    // {
    //   name: "Speed Blackjack Italiano",
    //   img: "/assets/Casino/PT0811.webp",
    //   vendor: "/assets/Platform/PT-COLOR.webp",
    // },
    // {
    //   name: "Ruleta Bola Rápida en Vivo",
    //   img: "/assets/Casino/EG4603.webp?t=1762230675516",
    //   vendor: "/assets/Platform/EG4-COLOR.webp",
    // },
    {
      name: "Ice Fishing",
      img: "/assets/Casino/EG4601.webp?t=1762231010104",
      vendor: "/assets/Platform/EG4-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-449",
    },
    {
      name: "Indonesian BlackjackX 17",
      img: "/assets/Casino/PP1045.webp",
      vendor: "/assets/Platform/PP-COLOR.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-147",
      platFormCode: "PP",
    },
    // {
    //   name: "Korean Mega Sic Bo",
    //   img: "/assets/Casino/PP1044.webp",
    //   vendor: "/assets/Platform/PP-COLOR.webp",
    // },
    {
      name: "Privé Lounge Roulette Deluxe",
      img: "/assets/Casino/PP1031.webp",
      vendor: "/assets/Platform/PP-COLOR.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-184",
      platFormCode: "PP",
    },
  ],
  LiveHome: [
    {
      name: "LIVE EG4",
      key: "EVO",
      img: "/assets/Platform/gcs__live-eg4_1747975399310.png",
    },
    {
      name: "LIVE PP",
      key: "PP",
      img: "/assets/Platform/gcs__live-pp_1747975348658.png",
    },
    {
      name: "LIVE SEX",
      key: "SEXYBCRT",
      img: "/assets/Platform/gcs__live-sex_1747975352786.png",
    },

    {
      name: "LIVE VIA",
      key: "VIACASINO",
      img: "/assets/Platform/gcs__live-via_1747975377984.png",
    },
  ],

  Poker: [
    {
      name: "Andar Bahar",
      img: "/assets/Casino/BSP051.webp",
      vendor: "/assets/bdtwin/BSP-WHITE.png",
      platFormCode: "BSP",
      gameType: "TABLE",
      casinoType: "BSP-TABLE-051",
    },
    {
      name: "7 Up 7 Down Rush",
      img: "/assets/Casino/KM0092.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-092",
    },
    {
      name: "Black Jack",
      img: "/assets/Casino/KP0011.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-016",
    },
    {
      name: "Fan Tan",
      img: "/assets/Casino/KP0010.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-178",
    },
    {
      name: "Fish Prawn Crab",
      img: "/assets/Casino/KP0009.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-057",
    },
    {
      name: "Hi-Lo",
      img: "/assets/Casino/KP0008.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-037",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Xocdia",
      img: "/assets/Casino/KP0007.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-023",
      platFormCode: "KINGMAKER",
    },
    // {
    //   name: "Lieng",
    //   img: "/assets/Casino/KP0006.webp",
    //   vendor: "/assets/Platform/KP-COLOR.webp",
    // },
    // {
    //   name: "Horoscope",
    //   img: "/assets/Casino/KP0005.webp",
    //   vendor: "/assets/Platform/KP-COLOR.webp",
    // },
    // {
    //   name: "13 Killer",
    //   img: "/assets/Casino/KP0004.webp",
    //   vendor: "/assets/Platform/KP-COLOR.webp",
    // },
    {
      name: "Pok Deng",
      img: "/assets/Casino/KP0003.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-034",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Bai Cao",
      img: "/assets/Casino/KP0002.webp",
      vendor: "/assets/Platform/KP-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-093",
      platFormCode: "KINGMAKER",
    },
    // {
    //   name: "Game Lobby",
    //   img: "/assets/Casino/KP0001.webp",
    //   vendor: "/assets/Platform/KP-COLOR.webp",
    // },

    {
      name: "Teen Patti Blitz",
      img: "/assets/Casino/KM0091.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-085",
      platFormCode: "KINGMAKER",
    },
    // {
    //   name: "Jogo De Bozo",
    //   img: "/assets/Casino/KM0088.webp",
    //   vendor: "/assets/Platform/KM-COLOR.webp",
    // },
    {
      name: "Egyptian Mines",
      img: "/assets/Casino/KM0087.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-081",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Bicho",
      img: "/assets/Casino/KM0086.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-082",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Speedy Andar Bahar",
      img: "/assets/Casino/KM0083.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-084",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Burmese 6 Animals",
      img: "/assets/Casino/KM0081.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-083",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Ladder Game",
      img: "/assets/Casino/KM0079.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-079",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Dice Duet",
      img: "/assets/Casino/KM0072.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-078",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Iron Dome",
      img: "/assets/Casino/KM0071.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-075",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Toon Crash",
      img: "/assets/Casino/KM0070.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-076",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Video Poker",
      img: "/assets/Casino/KM0068.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-227",
    },
    {
      name: "Interstellar Run",
      img: "/assets/Casino/KM0057.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-070",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Tongits",
      img: "/assets/Casino/KM0052.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-002",
    },
    {
      name: "Km Virtual Animal Race",
      img: "/assets/Casino/KM0051.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-062",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Ludo",
      img: "/assets/Casino/KM0050.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-060",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Km Virtual Treadmill Racing",
      img: "/assets/Casino/KM0049.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-058",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Km Virtual Hound Racing",
      img: "/assets/Casino/KM0047.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
    },
    {
      name: "Km Marble Knockout",
      img: "/assets/Casino/KM0046.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-053",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Km Power Ball",
      img: "/assets/Casino/KM0045.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-051",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Color Game",
      img: "/assets/Casino/KM0044.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-010",
      platFormCode: "VIACASINO",
    },
    // {
    //   name: "Bola Tangkas",
    //   img: "/assets/Casino/KM0043.webp",
    //   vendor: "/assets/Platform/KM-COLOR.webp",
    // },
    {
      name: "Km Virtual Horse Racing",
      img: "/assets/Casino/KM0042.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "EGAME",
      casinoType: "PP-EGAME-003",
      platFormCode: "PP",
    },
    {
      name: "5 Card Poker",
      img: "/assets/Casino/KM0041.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-049",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Heist",
      img: "/assets/Casino/KM0040.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-047",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Monkey King Roulette",
      img: "/assets/Casino/KM0039.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-045",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Teen Patti",
      img: "/assets/Casino/KM0038.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-026",
    },
    {
      name: "Dota Hi-Lo",
      img: "/assets/Casino/KM0037.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-044",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Minesweeper",
      img: "/assets/Casino/KM0036.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-042",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Bonus Dice",
      img: "/assets/Casino/KM0035.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-043",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Cash Rocket",
      img: "/assets/Casino/KM0034.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-041",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Plinko",
      img: "/assets/Casino/KM0033.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-040",
      platFormCode: "KINGMAKER",
    },
    {
      name: "32 Cards",
      img: "/assets/Casino/KM0032.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-039",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Blackjack",
      img: "/assets/Casino/KM0031.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-082",
      platFormCode: "PP",
    },
    {
      name: "Cards Hi Lo",
      img: "/assets/Casino/KM0030.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-037",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Coin Toss",
      img: "/assets/Casino/KM0029.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-036",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Pai Kang",
      img: "/assets/Casino/KM0028.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-033",
    },
    {
      name: "Km Pok Deng",
      img: "/assets/Casino/KM0027.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-034",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Bola Golek",
      img: "/assets/Casino/KM0026.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-035",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Baccarat",
      img: "/assets/Casino/KM0025.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-026",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Andar Bahar",
      img: "/assets/Casino/KM0024.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-032",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Jhandi Munda",
      img: "/assets/Casino/KM0023.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-008",
      gameType: "TABLE",
    },
    {
      name: "7 Up 7 Down",
      img: "/assets/Casino/KM0021.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-028",
      platFormCode: "KINGMAKER",
    },
    {
      name: "European Roulette",
      img: "/assets/Casino/KM0020.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-027",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Bai Buu",
      img: "/assets/Casino/KM0019.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-029",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Fruit Roulette",
      img: "/assets/Casino/KM0016.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-025",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Triple Chance",
      img: "/assets/Casino/KM0015.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-025",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Fan Tan Classic",
      img: "/assets/Casino/KM0014.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-024",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Xoc Dia Lightning",
      img: "/assets/Casino/KM0013.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-023",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Thai Fish Prawn Crab",
      img: "/assets/Casino/KM0012.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-089",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Poker Roulette",
      img: "/assets/Casino/KM0011.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-022",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Max Keno",
      img: "/assets/Casino/KM0010.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "TABLE",
      casinoType: "KM-TABLE-018",
      platFormCode: "KINGMAKER",
    },
    {
      name: "Tai Xiu",
      img: "/assets/Casino/KM0009.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-009",
      platFormCode: "VIACASINO",
    },
    {
      name: "Sic Bo",
      img: "/assets/Casino/KM0008.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-007",
      platFormCode: "VIACASINO",
    },
    {
      name: "Vietnam Fish Prawn Crab",
      img: "/assets/Casino/KM0007.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-012",
      platFormCode: "VIACASINO",
    },
    {
      name: "Dragon Tiger 2",
      img: "/assets/Casino/KM0005.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-054",
    },
    // {
    //   name: "Belangkai 2",
    //   img: "/assets/Casino/KM0004.webp",
    //   vendor: "/assets/Platform/KM-COLOR.webp",
    // },
    {
      name: "Fish Prawn Crab 2",
      img: "/assets/Casino/KM0003.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-057",
    },
    {
      name: "Thai Hi Lo 2",
      img: "/assets/Casino/KM0002.webp",
      vendor: "/assets/Platform/KM-COLOR.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-008",
      platFormCode: "VIACASINO",
    },
    // {
    //   name: "Km Game Lobby",
    //   img: "/assets/Casino/KM0001.webp",
    //   vendor: "/assets/Platform/KM-COLOR.webp",
    // },
  ],
  Slots: [
    { key: "FC", img: "/assets/Platform/gcs__rng-fc_1719220287111.webp" },
    {
      key: "SPRIBE",
      img: "/assets/Platform/gcs__rng-spb_1692248602713.webp",
    },
    {
      key: "JDB",
      img: "/assets/Platform/gcs__rng-jdb.webp",
    },
    ,
    {
      key: "JILI",
      img: "/assets/Platform/gcs__rng-jl_1720148908774.webp",
    },
    ,
    {
      key: "PG",
      img: "/assets/Platform/gcs__rng-pg_1692249585882.webp",
    },
    ,
    {
      key: "PP",
      img: "/assets/Platform/gcs__rng-pp_1719222797039.webp",
    },
    ,
    {
      key: "BTG",
      img: "/assets/Platform/gcs__rng-bt_1693464255624.webp",
    },
    {
      key: "RT",
      img: "/assets/Platform/gcs__rng-RT_1686905877695.webp",
    },

    ,
    {
      key: "EVO",
      img: "/assets/Platform/gcs__rng-ep_1726123996550.webp",
    },
    {
      key: "SPADE",
      img: "/assets/Platform/gcs__rng-sg_1719217006956.webp",
    },
    {
      key: "YB",
      img: "/assets/Platform/gcs__rng-yb_1683254174546.webp",
    },
    // {
    //   key: "NEXTSPIN",
    //   img: "/assets/Platform/gcs__rng-ns_1719217005409.webp",
    // },
    {
      key: "JOKER",
      img: "/assets/Platform/gcs__rng-jk_1720148906725.webp",
    },
    {
      key: "NLC",
      img: "/assets/Platform/gcs__rng-NLC_1683780848856.webp",
    },
    {
      key: "FASTSPIN",
      img: "/assets/Platform/gcs__rng-fs_1709691500846.webp",
    },
    {
      key: "KM",
      img: "/assets/Platform/gcs__rng-km_1706608720510.webp",
    },
    {
      key: "PT",
      img: "/assets/Platform/gcs__rng-pt_1718358323355.webp",
    },
  ],
  SlotsWeb: [
    {
      name: "RNG FC",
      key: "FC",
      img: "/assets/Platform/gcs__rng-fc_1747974283344.webp",
    },
    {
      name: "RNG SPB",
      key: "SPRIBE",
      img: "/assets/Platform/gcs__rng-spb_1747974350657.webp",
    },
    {
      name: "RNG JDB",
      key: "JDB",
      img: "/assets/Platform/gcs__rng-jdb_1747974291671.webp",
    },
    {
      name: "RNG JL",
      key: "JILI",
      img: "/assets/Platform/gcs__rng-jl_1747974305988.webp",
    },
    {
      name: "RNG PG",
      key: "PG",
      img: "/assets/Platform/gcs__rng-pg_1747974333811.webp",
    },
    {
      name: "RNG PP",
      key: "PP",
      img: "/assets/Platform/gcs__rng-pp_1747974372631.webp",
    },
    {
      name: "RNG BT",
      key: "BTG",
      img: "/assets/Platform/gcs__rng-bt_1747974272667.webp",
    },
    {
      name: "RNG RT",
      key: "RT",
      img: "/assets/Platform/gcs__rng-rt_1747974341339.webp",
    },
    {
      name: "DS",
      key: "DS",
      img: "/assets/Platform/dragon-soft-vendor.webp",
    },
    {
      name: "I Love U",
      key: "ILU",
      img: "/assets/Platform/iloveu-vendor.webp",
    },

    {
      name: "NETENT",
      key: "NETENT",
      img: "/assets/Platform/netent-vendor.webp",
    },
    {
      name: "NLC",
      key: "NLC",
      img: "/assets/Platform/nolimit-city-vendor.webp",
    },
    {
      name: "PLAY8",
      key: "PLAY8",
      img: "/assets/Platform/play8-vendor.webp",
    },

    {
      name: "PT",
      key: "PT",
      img: "/assets/Platform/playtech-vendor.webp",
    },

    {
      name: "JOKER",
      key: "JOKER",
      img: "/assets/Platform/joker-vendor.webp",
    },
    {
      name: "LADYLUCK",
      key: "LADYLUCK",
      img: "/assets/Platform/ladyluck-vendor.webp",
    },

    {
      name: "CG",
      key: "CG",
      img: "/assets/Platform/cg-vendor.webp",
    },
    {
      name: "KM",
      key: "KM",
      img: "/assets/Platform/KM-vendor.webp",
    },
    {
      name: "SPADE",
      key: "SPADE",
      img: "/assets/Platform/sg-vendor.webp",
    },
  ],
  Sports: [
    "/assets/Images/velkie-bg-sports.png",
    "/assets/Images/gcs__sports-u9w_1719217004910.webp",
  ],
};

export const Slots = [
  {
    name: "CATLA'S MONEY MACHINE",
    img: "/assets/Casino/FC0070.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-056",
  },
  {
    name: "CYBER GOD OF FORTUNE",
    img: "/assets/Casino/FC0069.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-055",
  },
  {
    name: "SWORD OF KING",
    img: "/assets/Casino/FC0068.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-053",
  },
  {
    name: "BUFFALO WAYS",
    img: "/assets/Casino/FC0067.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-054",
  },
  {
    name: "JUNGLE BANG BANG",
    img: "/assets/Casino/FC0065.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-051",
  },
  {
    name: "TREASURES OF ODIN",
    img: "/assets/Casino/FC0064.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-052",
  },
  {
    name: "PHOENIX FEVER",
    img: "/assets/Casino/FC0063.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-050",
  },
  {
    name: "Sugar Bang Bang 2",
    img: "/assets/Casino/FC0062.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-048",
  },
  {
    name: "Boxing Riches",
    img: "/assets/Casino/FC0061.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-045",
  },
  {
    name: "Poker Win",
    img: "/assets/Casino/FC0060.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-044",
  },
  {
    name: "Chinese New Year Moreways",
    img: "/assets/Casino/FC0059.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-043",
  },
  {
    name: "Roma Gladiatrix",
    img: "/assets/Casino/FC0058.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-042",
  },
  {
    name: "Fortune Goddess",
    img: "/assets/Casino/FC0057.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-041",
  },
  {
    name: "Queen of Inca",
    img: "/assets/Casino/FC0056.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-040",
  },
  {
    name: "Fortune Money Boom",
    img: "/assets/Casino/FC0055.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-039",
  },
  {
    name: "Fortune Sheep 3x3",
    img: "/assets/Casino/FC0054.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
  },
  {
    name: "Lucky Fortunes 3x3",
    img: "/assets/Casino/FC0052.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
  },
  {
    name: "Tower",
    img: "/assets/Casino/FC0051.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-008",
  },
  {
    name: "Egypt Bonanza",
    img: "/assets/Casino/FC0050.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-035",
  },
  {
    name: "Mines",
    img: "/assets/Casino/FC0049.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-007",
  },
  {
    name: "Chilihuahua",
    img: "/assets/Casino/FC0048.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-036",
  },
  {
    name: "Go Go Rise",
    img: "/assets/Casino/FC0047.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-006",
  },
  {
    name: "Legend of Inca",
    img: "/assets/Casino/FC0046.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-034",
  },
  {
    name: "Super Elements",
    img: "/assets/Casino/FC0045.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-033",
  },
  {
    name: "Night Market 2",
    img: "/assets/Casino/FC0044.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-032",
  },
  {
    name: "Fortune Egg",
    img: "/assets/Casino/FC0043.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-031",
  },
  {
    name: "Win Win Neko",
    img: "/assets/Casino/FC0042.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-030",
  },
  {
    name: "Zeus",
    img: "/assets/Casino/FC0040.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-029",
  },
  {
    name: "Super Color Game",
    img: "/assets/Casino/FC0039.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-005",
  },
  {
    name: "Golden Genie",
    img: "/assets/Casino/FC0038.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-028",
  },
  {
    name: "Merge Magic",
    img: "/assets/Casino/FC0037.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-027",
  },
  {
    name: "Crazy Buffalo",
    img: "/assets/Casino/FC0036.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-026",
  },
  {
    name: "Sugar Bang Bang",
    img: "/assets/Casino/FC0035.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-025",
  },
  {
    name: "Treasure Raiders",
    img: "/assets/Casino/FC0034.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-024",
  },
  {
    name: "Grand Blue",
    img: "/assets/Casino/FC0033.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-023",
  },
  {
    name: "Chinese New Year 2",
    img: "/assets/Casino/FC0032.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-022",
  },
  {
    name: "Lucky Fortunes",
    img: "/assets/Casino/FC0031.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-021",
  },
  {
    name: "Robin Hood",
    img: "/assets/Casino/FC0030.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-020",
  },
  {
    name: "Gold Rush",
    img: "/assets/Casino/FC0029.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-017",
  },
  {
    name: "Glory Of Rome",
    img: "/assets/Casino/FC0028.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-019",
  },
  {
    name: "Rich Man",
    img: "/assets/Casino/FC0026.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-018",
  },
  {
    name: "Lightning Bomb",
    img: "/assets/Casino/FC0025.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-004",
  },
  {
    name: "Fa Chai Dozer",
    img: "/assets/Casino/FC0024.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-002",
  },
  {
    name: "Circus Dozer",
    img: "/assets/Casino/FC0023.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-003",
  },
  {
    name: "Money Tree Dozer",
    img: "/assets/Casino/FC0022.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-001",
  },
  {
    name: "Magic Beans",
    img: "/assets/Casino/FC0017.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-013",
  },
  {
    name: "War Of The Universe",
    img: "/assets/Casino/FC0016.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-015",
  },
  {
    name: "Luxury Golden Panther",
    img: "/assets/Casino/FC0015.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-012",
  },
  {
    name: "Cowboys",
    img: "/assets/Casino/FC0014.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-014",
  },
  {
    name: "Treasure Cruise",
    img: "/assets/Casino/FC0013.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-016",
  },
  {
    name: "Happy Duo Bao",
    img: "/assets/Casino/FC0012.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-009",
  },
  {
    name: "Hot Pot Party",
    img: "/assets/Casino/FC0011.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-003",
  },
  {
    name: "Animal Racing",
    img: "/assets/Casino/FC0010.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-011",
  },
  {
    name: "Da Le Men",
    img: "/assets/Casino/FC0009.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-010",
  },
  {
    name: "Fortune Koi",
    img: "/assets/Casino/FC0008.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-008",
  },
  {
    name: "Pong Pong Hu",
    img: "/assets/Casino/FC0007.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-005",
  },
  {
    name: "Chinese New Year",
    img: "/assets/Casino/FC0006.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-007",
  },
  {
    name: "Panda Dragon Boat",
    img: "/assets/Casino/FC0005.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-006",
  },
  {
    name: "Night Market",
    img: "/assets/Casino/FC0004.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-004",
  },
  {
    name: "Three Little Pigs",
    img: "/assets/Casino/FC0003.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-002",
  },
  {
    name: "Golden Panther",
    img: "/assets/Casino/FC0002.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-001",
  },
  {
    name: "Hotline",
    img: "/assets/Casino/SPB010.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-009",
  },
  {
    name: "Mini Roulette",
    img: "/assets/Casino/SPB009.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
  },
  {
    name: "Keno",
    img: "/assets/Casino/SPB008.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-007",
  },
  {
    name: "Hilo",
    img: "/assets/Casino/SPB007.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
  },
  {
    name: "Mines",
    img: "/assets/Casino/SPB006.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-007",
  },
  {
    name: "Plinko",
    img: "/assets/Casino/SPB005.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
  },
  {
    name: "Goal",
    img: "/assets/Casino/SPB004.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
  },
  {
    name: "Dice",
    img: "/assets/Casino/SPB003.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-003",
  },
  {
    name: "Aviator",
    img: "/assets/Casino/SPB002.webp",
    vendor: "/assets/Platform/SPB-COLOR.webp",
    platForm: "SPRIBE",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    name: "Plinko of Mine",
    img: "/assets/Casino/JDB243.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-085",
  },
  {
    name: "Jackpot Joker Fever",
    img: "/assets/Casino/JDB239.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-153",
  },
  {
    name: "Chicken Dash",
    img: "/assets/Casino/JDB238.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-082",
  },
  {
    name: "Cash Coin",
    img: "/assets/Casino/JDB236.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-157",
  },
  {
    name: "Drop Ball",
    img: "/assets/Casino/JDB235.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-086",
  },
  {
    name: "Cash Stack",
    img: "/assets/Casino/JDB233.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-090",
  },
  {
    name: "100 Blazing Clover",
    img: "/assets/Casino/JDB231.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
  },
  {
    name: "3 Super Ace",
    img: "/assets/Casino/JDB229.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
  },
  {
    name: "Dice & Drop",
    img: "/assets/Casino/JDB228.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-061",
  },
  {
    name: "Sweet Magic",
    img: "/assets/Casino/JDB227.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-150",
  },
  {
    name: "3 Lucky Baozhu",
    img: "/assets/Casino/JDB226.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-168",
  },
  {
    name: "Crazy777 2",
    img: "/assets/Casino/JDB225.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-149",
  },
  {
    name: "40 Sparkling Crown",
    img: "/assets/Casino/JDB224.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-145",
  },
  {
    name: "Circus Joker 4096",
    img: "/assets/Casino/JDB223.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-136",
  },
  {
    name: "Golden Empire 2",
    img: "/assets/Casino/JDB222.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-143",
  },
  {
    name: "Bikini Lady",
    img: "/assets/Casino/JDB221.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-127",
  },
  {
    name: "Mines Grand",
    img: "/assets/Casino/JDB220.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-076",
  },
  {
    name: "3 Witch's Lamp",
    img: "/assets/Casino/JDB219.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "TADA",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-054",
  },
  {
    name: "Clover Coins 3x3",
    img: "/assets/Casino/JDB218.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-148",
  },
  {
    name: "Money Pot Deluxe",
    img: "/assets/Casino/JDB217.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
  },
  {
    name: "Pirate Queen 2",
    img: "/assets/Casino/JDB214.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-135",
  },
  {
    name: "Golden Treasure",
    img: "/assets/Casino/JDB212.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-077",
  },
  {
    name: "Penalty Kick",
    img: "/assets/Casino/JDB205.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-072",
  },
  {
    name: "Joker Coins",
    img: "/assets/Casino/JDB204.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-137",
  },
  {
    name: "10 Sparkling Crown",
    img: "/assets/Casino/JL0217.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-133",
  },
  {
    name: "Money Coming 2",
    img: "/assets/Casino/JL0215.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-146",
  },
  {
    name: "Super Ace II",
    img: "/assets/Casino/JL0214.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-130",
  },
  {
    name: "3 Charge Buffalo",
    img: "/assets/Casino/JL0213.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-131",
  },
  {
    name: "Super Ace Joker",
    img: "/assets/Casino/JL0212.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-118",
  },
  {
    name: "Fortune Coins",
    img: "/assets/Casino/JL0211.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-129",
  },
  {
    name: "Crash Touchdown",
    img: "/assets/Casino/JL0210.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-070",
  },
  {
    name: "Roma X Deluxe",
    img: "/assets/Casino/JL0209.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-124",
  },
  {
    name: "3 LUCKY LION",
    img: "/assets/Casino/JL0208.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-140",
  },
  {
    name: "Cricket War",
    img: "/assets/Casino/JL0207.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-069",
  },
  {
    name: "3 Coin Wild Horse",
    img: "/assets/Casino/JL0206.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-126",
  },
  {
    name: "Keno Extra Bet",
    img: "/assets/Casino/JL0205.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-074",
  },
  {
    name: "Keno Super Chance",
    img: "/assets/Casino/JL0204.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-071",
  },
  {
    name: "Treasure Quest",
    img: "/assets/Casino/JL0203.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-114",
  },
  {
    name: "Coin Tree",
    img: "/assets/Casino/JL0202.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-125",
  },
  {
    name: "Diamond Party",
    img: "/assets/Casino/JL0200.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-021",
  },
  {
    name: "Color Game Extreme",
    img: "/assets/Casino/JL0201.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-078",
  },
  {
    name: "Hawaii Beauty",
    img: "/assets/Casino/JL0199.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-012",
  },
  {
    name: "Coin Infinity Surge Reel",
    img: "/assets/Casino/JL0198.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-122",
  },
  {
    name: "Safari Mystery",
    img: "/assets/Casino/JL0197.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-123",
  },
  {
    name: "Fortune Gems Scratch",
    img: "/assets/Casino/JL0195.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-068",
  },
  {
    name: "Go For Champion",
    img: "/assets/Casino/JL0194.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-067",
  },
  {
    name: "3 Coin Treasures 2",
    img: "/assets/Casino/JL0193.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-134",
  },
  {
    name: "Golden Bank 2",
    img: "/assets/Casino/JL0192.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-116",
  },
  {
    name: "Safari King",
    img: "/assets/Casino/JL0191.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-154",
  },
  {
    name: "Fortune Roulette",
    img: "/assets/Casino/JL0190.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-066",
  },
  {
    name: "Lucky Jaguar",
    img: "/assets/Casino/JL0189.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-115",
  },
  {
    name: "Nightfall Hunting",
    img: "/assets/Casino/JL0187.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-113",
  },
  {
    name: "Thai Hilo",
    img: "/assets/Casino/JL0186.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-063",
  },
  {
    name: "Boxing Extravaganza",
    img: "/assets/Casino/JL0185.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-062",
  },
  {
    name: "Shōgun",
    img: "/assets/Casino/JL0184.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-110",
  },
  {
    name: "Money Pot",
    img: "/assets/Casino/JL0182.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
  },
  {
    name: "Cricket Roulette",
    img: "/assets/Casino/JL0181.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-060",
  },
  {
    name: "3 Pot Dragons",
    img: "/assets/Casino/JL0180.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-106",
  },
  {
    name: "Lucky Doggy",
    img: "/assets/Casino/JL0179.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-117",
  },
  {
    name: "Fruity Wheel",
    img: "/assets/Casino/JL0178.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-111",
  },
  {
    name: "Keno Bonus Number",
    img: "/assets/Casino/JL0177.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-065",
  },
  {
    name: "Poseidon",
    img: "/assets/Casino/JL0176.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-121",
  },
  {
    name: "Super E-Sabong",
    img: "/assets/Casino/JL0175.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-064",
  },
  {
    name: "Egypt's Glow",
    img: "/assets/Casino/JL0174.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-108",
  },
  {
    name: "3 Lucky Piggy",
    img: "/assets/Casino/JL0173.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-109",
  },
  {
    name: "Candyland Bingo",
    img: "/assets/Casino/JL0172.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-043",
  },
  {
    name: "Party Star",
    img: "/assets/Casino/JL0171.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-104",
  },
  {
    name: "Crash Cricket",
    img: "/assets/Casino/JL0170.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
  },
  {
    name: "Jhandi Munda",
    img: "/assets/Casino/JL0169.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-056",
  },
  {
    name: "Super Ace Scratch",
    img: "/assets/Casino/JL0168.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-059",
  },
  {
    name: "Money Coming Expand Bets",
    img: "/assets/Casino/JL0167.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-107",
  },
  {
    name: "Legacy of Egypt",
    img: "/assets/Casino/JL0166.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-105",
  },
  {
    name: "The Pig House",
    img: "/assets/Casino/JL0165.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-103",
  },
  {
    name: "Crazy Hunter2",
    img: "/assets/Casino/JL0164.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
  },
  {
    name: "Crash Goal",
    img: "/assets/Casino/JL0163.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-055",
  },
  {
    name: "Super Ace Deluxe",
    img: "/assets/Casino/JL0162.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
  },
  {
    name: "Potion Wizard",
    img: "/assets/Casino/JL0161.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-098",
  },
  {
    name: "Fish Prawn Crab",
    img: "/assets/Casino/JL0160.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-057",
  },
  {
    name: "Jogo Do Bicho",
    img: "/assets/Casino/JL0159.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
  },
  {
    name: "Video Poker",
    img: "/assets/Casino/JL0158.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-050",
  },
  {
    name: "European Roulette",
    img: "/assets/Casino/JL0157.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
  },
  {
    name: "Fortune Gems 3",
    img: "/assets/Casino/JL0156.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-096",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/JL0155.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-054",
  },
  {
    name: "3 Coin Treasures",
    img: "/assets/Casino/JL0154.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-101",
  },
  {
    name: "Jackpot Joker",
    img: "/assets/Casino/JL0153.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-100",
  },
  {
    name: "Zeus",
    img: "/assets/Casino/JL0152.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-029",
  },
  {
    name: "Trial of Phoenix",
    img: "/assets/Casino/JL0151.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-084",
  },
  {
    name: "Devil Fire 2",
    img: "/assets/Casino/JL0150.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-094",
  },
  {
    name: "Arena Fighter",
    img: "/assets/Casino/JL0149.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-092",
  },
  {
    name: "Charge Buffalo Ascent",
    img: "/assets/Casino/JL0148.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-093",
  },
  {
    name: "Witches Night",
    img: "/assets/Casino/JL0147.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-095",
  },
  {
    name: "Pearls of Bingo",
    img: "/assets/Casino/JL0146.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-051",
  },
  {
    name: "King Arthur",
    img: "/assets/Casino/JL0145.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-091",
  },
  {
    name: "Night City",
    img: "/assets/Casino/JL0144.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-090",
  },
  {
    name: "Sin City",
    img: "/assets/Casino/JL0142.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-089",
  },
  {
    name: "Dabanggg",
    img: "/assets/Casino/JL0140.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-088",
  },
  {
    name: "Fortune Monkey",
    img: "/assets/Casino/JL0139.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-087",
  },
  {
    name: "Devil Fire",
    img: "/assets/Casino/JL0138.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-085",
  },
  {
    name: "Aztec Priestess",
    img: "/assets/Casino/JL0137.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-083",
  },
  {
    name: "Bangla Beauty",
    img: "/assets/Casino/JL0134.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-086",
  },
  {
    name: "Magic Lamp Bingo",
    img: "/assets/Casino/JL0132.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-045",
  },
  {
    name: "Cricket Sah 75",
    img: "/assets/Casino/JL0131.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-082",
  },
  {
    name: "Color Prediction",
    img: "/assets/Casino/JL0130.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
  },
  {
    name: "Plinko",
    img: "/assets/Casino/JL0128.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
  },
  {
    name: "Crash Bonus",
    img: "/assets/Casino/JL0127.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
  },
  {
    name: "Cricket King 18",
    img: "/assets/Casino/JL0126.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-078",
  },
  {
    name: "Fortune Gems 2",
    img: "/assets/Casino/JL0125.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-076",
  },
  {
    name: "Golden Temple",
    img: "/assets/Casino/JL0124.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-080",
  },
  {
    name: "Elf Bingo",
    img: "/assets/Casino/JL0123.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-081",
  },
  {
    name: "Keno",
    img: "/assets/Casino/JL0122.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-007",
  },
  {
    name: "Mines Gold",
    img: "/assets/Casino/JL0119.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-037",
  },
  {
    name: "Wheel",
    img: "/assets/Casino/JL0118.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-036",
  },
  {
    name: "Golden Land",
    img: "/assets/Casino/JL0117.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-027",
  },
  {
    name: "Wild Ace",
    img: "/assets/Casino/JL0116.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-075",
  },
  {
    name: "Limbo",
    img: "/assets/Casino/JL0115.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-035",
  },
  {
    name: "Bingo Adventure",
    img: "/assets/Casino/JL0114.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-034",
  },
  {
    name: "Sweet Land",
    img: "/assets/Casino/JL0113.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-079",
  },
  {
    name: "Hilo",
    img: "/assets/Casino/JL0112.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
  },
  {
    name: "Mines",
    img: "/assets/Casino/JL0110.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-007",
  },
  {
    name: "Tower",
    img: "/assets/Casino/JL0109.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-008",
  },
  {
    name: "Piggy Bank TapTap",
    img: "/assets/Casino/JDB243.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-023",
  },
  {
    name: "Lucky Elephant X-Huge",
    img: "/assets/Casino/JDB239.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-135",
  },
  {
    name: "Olympig",
    img: "/assets/Casino/JDB238.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-134",
  },
  {
    name: "Ragnarok: Thor VS Loki",
    img: "/assets/Casino/JDB236.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
  },
  {
    name: "Koi Trio",
    img: "/assets/Casino/JDB235.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-132",
  },
  {
    name: "Fishin' Fever X-Huge",
    img: "/assets/Casino/JDB233.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-131",
  },
  {
    name: "Cai Shen Bingo",
    img: "/assets/Casino/JDB231.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-008",
  },
  {
    name: "Pop Pop Candy 1000",
    img: "/assets/Casino/JDB229.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-129",
  },
  {
    name: "Fruity Bonanza Combo",
    img: "/assets/Casino/JDB228.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-130",
  },
  {
    name: "Aviator Extra Bet",
    img: "/assets/Casino/JDB227.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-022",
  },
  {
    name: "Fortune Jewel",
    img: "/assets/Casino/JDB226.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-128",
  },
  {
    name: "Magic Ace WILD LOCK",
    img: "/assets/Casino/JDB225.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
  },
  {
    name: "Dice",
    img: "/assets/Casino/JDB224.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-003",
  },
  {
    name: "Piggy Bank",
    img: "/assets/Casino/JDB223.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-123",
  },
  {
    name: "Dragon Soar - Hyper Wild",
    img: "/assets/Casino/JDB222.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-125",
  },
  {
    name: "Magic Ace",
    img: "/assets/Casino/JDB221.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-124",
  },
  {
    name: "Cricket Burst",
    img: "/assets/Casino/JDB220.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-021",
  },
  {
    name: "Bull Treasure X-Huge",
    img: "/assets/Casino/JDB219.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-126",
  },
  {
    name: "Plinko",
    img: "/assets/Casino/JDB218.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
  },
  {
    name: "Dragon Soar",
    img: "/assets/Casino/JDB217.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-121",
  },
  {
    name: "Mole Crash",
    img: "/assets/Casino/JDB214.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-020",
  },
  {
    name: "Mines 2",
    img: "/assets/Casino/JDB212.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-019",
  },
  {
    name: "HiLo",
    img: "/assets/Casino/JDB205.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
  },
  {
    name: "Goal",
    img: "/assets/Casino/JDB204.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
  },
  {
    name: "Firework Burst",
    img: "/assets/Casino/JDB203.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
  },
  {
    name: "Pop Pop Candy",
    img: "/assets/Casino/JDB202.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-120",
  },
  {
    name: "Open Sesame Mega",
    img: "/assets/Casino/JDB201.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-119",
  },
  {
    name: "Mines",
    img: "/assets/Casino/JDB199.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-007",
  },
  {
    name: "Galaxy Burst",
    img: "/assets/Casino/JDB193.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
  },
  {
    name: "Jogo Do Bicho",
    img: "/assets/Casino/JDB190.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
  },
  {
    name: "Fruity Bonanza",
    img: "/assets/Casino/JDB189.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-114",
  },
  // {
  //   name: "Coo Coo Farm",
  //   img: "/assets/Casino/JDB183.webp",
  //   vendor: "/assets/Platform/JDB-COLOR.webp",
  //   platForm: "JDB",
  //   type: "SLOTS",
  // },
  {
    name: "Elemental Link Water",
    img: "/assets/Casino/JDB182.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-111",
  },
  {
    name: "Elemental Link Fire",
    img: "/assets/Casino/JDB181.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-110",
  },
  {
    name: "Birds Party Deluxe",
    img: "/assets/Casino/JDB180.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-109",
  },
  {
    name: "Lucky Color Game",
    img: "/assets/Casino/JDB179.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-002",
  },
  {
    name: "Moneybags Man 2",
    img: "/assets/Casino/JDB177.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-108",
  },
  {
    name: "Trump Card",
    img: "/assets/Casino/JDB176.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-107",
  },
  {
    name: "Fortune Neko",
    img: "/assets/Casino/JDB175.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-128",
  },
  {
    name: "Book of Mystery",
    img: "/assets/Casino/JDB174.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-105",
  },
  {
    name: "King Of Football",
    img: "/assets/Casino/JDB171.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-006",
  },
  {
    name: "Prosperity Tiger",
    img: "/assets/Casino/JDB170.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-100",
  },
  {
    name: "Glamorous Girl",
    img: "/assets/Casino/JDB169.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-103",
  },
  {
    name: "Blossom Of Wealth",
    img: "/assets/Casino/JDB167.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-101",
  },
  {
    name: "Lantern Wealth",
    img: "/assets/Casino/JDB163.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-115",
  },
  {
    name: "Maya Gold Crazy",
    img: "/assets/Casino/JDB162.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-099",
  },
  {
    name: "Marvelous IV",
    img: "/assets/Casino/JDB161.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-098",
  },
  {
    name: "Wonder Elephant",
    img: "/assets/Casino/JDB160.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-097",
  },
  {
    name: "Kong",
    img: "/assets/Casino/JDB153.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-094",
  },
  {
    name: "Lucky Diamond",
    img: "/assets/Casino/JDB150.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-093",
  },
  // {
  //   name: "Dragon's Gate",
  //   img: "/assets/Casino/JDB149.webp",
  //   vendor: "/assets/Platform/JDB-COLOR.webp",
  //   platForm: "JDB",
  //   type: "SLOTS",
  // },
  {
    name: "Spindrift2",
    img: "/assets/Casino/JDB148.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-090",
  },
  {
    name: "Spindrift",
    img: "/assets/Casino/JDB146.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-089",
  },
  {
    name: "Miner Babe",
    img: "/assets/Casino/JDB144.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-085",
  },
  {
    name: "Crazy King Kong",
    img: "/assets/Casino/JDB143.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-001",
  },
  {
    name: "Moneybags Man",
    img: "/assets/Casino/JDB142.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-086",
  },
  {
    name: "Golden Disco",
    img: "/assets/Casino/JDB140.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-084",
  },
  {
    name: "Super Niubi Deluxe",
    img: "/assets/Casino/JDB137.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-077",
  },
  {
    name: "Funky King Kong",
    img: "/assets/Casino/JDB136.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-076",
  },
  {
    name: "MJOLNIR",
    img: "/assets/Casino/JDB132.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-074",
  },
  {
    name: "Treasure Bowl X-Huge",
    img: "/assets/Casino/JDB131.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
  },
  {
    name: "Fortune Treasure",
    img: "/assets/Casino/JDB112.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-072",
  },
  {
    name: "Super Super Fruit",
    img: "/assets/Casino/JDB089.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-007",
  },
  {
    name: "Beer Tycoon",
    img: "/assets/Casino/JDB087.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-010",
  },
  {
    name: "Birds and Animals",
    img: "/assets/Casino/JDB086.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-003",
  },
  {
    name: "Classic Mario",
    img: "/assets/Casino/JDB084.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-009",
  },
  {
    name: "Legendary5",
    img: "/assets/Casino/JDB078.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-044",
  },
  {
    name: "Rooster In Love",
    img: "/assets/Casino/JDB070.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-026",
  },
  {
    name: "Super Niubi",
    img: "/assets/Casino/JDB069.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-070",
  },
  {
    name: "Go Lai Fu",
    img: "/assets/Casino/JDB067.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-067",
  },
  {
    name: "Birds Party",
    img: "/assets/Casino/JDB066.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-066",
  },
  {
    name: "Triple King Kong",
    img: "/assets/Casino/JDB065.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-043",
  },
  {
    name: "Skylight Wonders",
    img: "/assets/Casino/PG0174.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-166",
  },
  {
    name: "Pharaoh Royals",
    img: "/assets/Casino/PG0173.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-165",
  },
  {
    name: "Kraken Gold Rush",
    img: "/assets/Casino/PG0172.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-164",
  },
  {
    name: "Majestic Empire",
    img: "/assets/Casino/PG0171.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-163",
  },
  {
    name: "Grimms' Bounty: Hansel & Gretel",
    img: "/assets/Casino/PG0170.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-162",
  },
  {
    name: "Galaxy Miner",
    img: "/assets/Casino/PG0169.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-161",
  },
  {
    name: "Dragon's Treasure Quest",
    img: "/assets/Casino/PG0168.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-160",
  },
  {
    name: "Diner Frenzy Spins",
    img: "/assets/Casino/PG0167.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-159",
  },
  {
    name: "Jack the Giant Hunter",
    img: "/assets/Casino/PG0166.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-158",
  },
  {
    name: "Dead Man's Riches",
    img: "/assets/Casino/PG0165.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-157",
  },
  {
    name: "Knockout Riches",
    img: "/assets/Casino/PG0164.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-156",
  },
  {
    name: "Doomsday Rampage",
    img: "/assets/Casino/PG0163.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-155",
  },
  {
    name: "Graffiti Rush",
    img: "/assets/Casino/PG0162.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-154",
  },
  {
    name: "Mr. Treasure’s Fortune",
    img: "/assets/Casino/PG0161.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-153",
  },
  {
    name: "Incan Wonders",
    img: "/assets/Casino/PG0160.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-152",
  },
  {
    name: "Fortune Snake",
    img: "/assets/Casino/PG0159.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-151",
  },
  {
    name: "Geisha's Revenge",
    img: "/assets/Casino/PG0158.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-150",
  },
  {
    name: "Chocolate Deluxe",
    img: "/assets/Casino/PG0157.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-149",
  },
  {
    name: "Rio Fantasia",
    img: "/assets/Casino/PG0156.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-148",
  },
  {
    name: "Museum Wonders",
    img: "/assets/Casino/PG0155.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-147",
  },
  {
    name: "Oishi Delights",
    img: "/assets/Casino/PG0154.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-146",
  },
  {
    name: "Three Crazy Piggies",
    img: "/assets/Casino/PG0153.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-145",
  },
  {
    name: "Wings of Iguazu",
    img: "/assets/Casino/PG0152.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-144",
  },
  {
    name: "Yakuza Honor",
    img: "/assets/Casino/PG0151.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-143",
  },
  {
    name: "Shark Bounty",
    img: "/assets/Casino/PG0150.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-142",
  },
  {
    name: "Futebol Fever",
    img: "/assets/Casino/PG0149.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-141",
  },
  {
    name: "Zombie Outbreak",
    img: "/assets/Casino/PG0148.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-139",
  },
  {
    name: "Chicky Run",
    img: "/assets/Casino/PG0147.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-140",
  },
  {
    name: "Anubis Wrath",
    img: "/assets/Casino/PG0146.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-138",
  },
  {
    name: "Mystic Potion",
    img: "/assets/Casino/PG0145.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-137",
  },
  {
    name: "Pinata Wins",
    img: "/assets/Casino/PG0144.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-136",
  },
  {
    name: "Wild Ape",
    img: "/assets/Casino/PG0143.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-135",
  },
  {
    name: "Cash Mania",
    img: "/assets/Casino/PG0142.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-134",
  },
  {
    name: "Gemstones Gold",
    img: "/assets/Casino/PG0141.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-133",
  },
  {
    name: "Fortune Dragon",
    img: "/assets/Casino/PG0140.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-132",
  },
  {
    name: "Dragon Hatch 2",
    img: "/assets/Casino/PG0139.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-131",
  },
  {
    name: "Werewolf's Hunt",
    img: "/assets/Casino/PG0138.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-130",
  },
  {
    name: "Tsar Treasures",
    img: "/assets/Casino/PG0137.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-129",
  },
  {
    name: "Mafia Mayhem",
    img: "/assets/Casino/PG0136.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-128",
  },
  {
    name: "Forge of Wealth",
    img: "/assets/Casino/PG0135.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-127",
  },
  {
    name: "Wild Heist Cashout",
    img: "/assets/Casino/PG0134.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-126",
  },
  {
    name: "Ultimate Striker",
    img: "/assets/Casino/PG0133.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-125",
  },
  {
    name: "Ninja Raccoon Frenzy",
    img: "/assets/Casino/PG0132.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-124",
  },
  {
    name: "Gladiator's Glory",
    img: "/assets/Casino/PG0131.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-123",
  },
  {
    name: "Safari Wilds",
    img: "/assets/Casino/PG0130.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-122",
  },
  {
    name: "Cruise Royale",
    img: "/assets/Casino/PG0129.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-121",
  },
  // {
  //   name: "Fruit Candy",
  //   img: "/assets/Casino/PG0128.webp",
  //   vendor: "/assets/Platform/PG-COLOR.webp",
  //   platForm: "PG",
  //   type: "SLOTS",
  // },
  {
    name: "Lucky Clover Riches",
    img: "/assets/Casino/PG0127.webp",
    vendor: "/assets/Platform/PG-COLOR.webp",
    platForm: "PG",
    type: "SLOTS",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-119",
  },
  {
    name: "Gates of Olympus Super Scatter",
    img: "/assets/Casino/PP0992.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-562",
  },
  {
    name: "Sweet Rush Bonanza",
    img: "/assets/Casino/PP1064.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-601",
  },
  {
    name: "Gates of Olympus",
    img: "/assets/Casino/PP0218.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
  },
  {
    name: "Sweet Bonanza Super Scatter",
    img: "/assets/Casino/PP1029.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-586",
  },
  {
    name: "Wild West Gold Blazing Bounty",
    img: "/assets/Casino/PP1009.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-576",
  },
  {
    name: "Gates of Hades",
    img: "/assets/Casino/PP1006.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-569",
  },
  {
    name: "Spaceman",
    img: "/assets/Casino/PP0577.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-001",
  },
  {
    name: "888 Gold",
    img: "/assets/Casino/PP0847.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-169",
  },
  {
    name: "Sweet Bonanza 1000",
    img: "/assets/Casino/PP0739.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-464",
  },
  {
    name: "Sweet Bonanza",
    img: "/assets/Casino/PP0086.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-082",
  },
  {
    name: "Fortune Ace Super Scatter",
    img: "/assets/Casino/PP1066.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-598",
  },
  {
    name: "Sugar Rush 1000",
    img: "/assets/Casino/PP0696.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-443",
  },
  {
    name: "Fire Strike",
    img: "/assets/Casino/PP0113.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-069",
  },
  {
    name: "Triple Tigers",
    img: "/assets/Casino/PP0012.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-164",
  },
  {
    name: "Starlight Princess 1000",
    img: "/assets/Casino/PP0555.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-364",
  },
  {
    name: "Plinko+",
    img: "/assets/Casino/PP1035.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-012",
  },
  {
    name: "5 Lions Megaways",
    img: "/assets/Casino/PP0228.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-183",
  },
  {
    name: "Aztec Gems",
    img: "/assets/Casino/PP0009.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-111",
  },
  {
    name: "Wild Wild Riches Returns",
    img: "/assets/Casino/PP1085.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-655",
  },
  {
    name: "Oracle of Gold",
    img: "/assets/Casino/PP1084.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-611",
  },
  {
    name: "Starlight Princess Super Scatter",
    img: "/assets/Casino/PP1082.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-610",
  },
  {
    name: "Pandemic Rising",
    img: "/assets/Casino/PP1081.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-609",
  },
  {
    name: "Mines+",
    img: "/assets/Casino/PP1080.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-014",
  },
  {
    name: "Lucky Panda",
    img: "/assets/Casino/PP1079.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-635",
  },
  {
    name: "Frightening Frankie",
    img: "/assets/Casino/PP1077.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-608",
  },
  {
    name: "Bingo Mania",
    img: "/assets/Casino/PP1076.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-607",
  },
  {
    name: "Lava Balls",
    img: "/assets/Casino/PP1075.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-606",
  },
  {
    name: "Chests of Cai Shen 2",
    img: "/assets/Casino/PP1074.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-605",
  },
  {
    name: "Big Bass Halloween 3",
    img: "/assets/Casino/PP1072.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-603",
  },
  {
    name: "Mermaid's Treasure Trove",
    img: "/assets/Casino/PP1071.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-602",
    platFormCode: "PP",
  },
  {
    name: "Happy Nets",
    img: "/assets/Casino/PP1070.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-634",
  },
  {
    name: "Hundreds and Thousands",
    img: "/assets/Casino/PP1068.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-600",
  },
  {
    name: "Bigger Barn House Bonanza",
    img: "/assets/Casino/PP1067.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-599",
  },
  {
    name: "Bounty Hunter",
    img: "/assets/Casino/PP1065.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-597",
  },
  {
    name: "Lucky Dice",
    img: "/assets/Casino/PP1063.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-633",
  },
  {
    name: "Bee Keeper",
    img: "/assets/Casino/PP1062.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-596",
  },
  {
    name: "Genie's Gem Bonanza",
    img: "/assets/Casino/PP1061.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-593",
  },
  {
    name: "Lobster House",
    img: "/assets/Casino/PP1059.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-595",
  },
  {
    name: "Captain Kraken Megaways",
    img: "/assets/Casino/PP1058.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-594",
  },
  {
    name: "Jackpot Blaze",
    img: "/assets/Casino/PP1057.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-592",
  },
  {
    name: "Fire Stampede 2",
    img: "/assets/Casino/PP1055.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-591",
  },
  {
    name: "Spell master",
    img: "/assets/Casino/PP1054.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-589",
    platFormCode: "PP",
  },
  {
    name: "Ice Mints",
    img: "/assets/Casino/PP1048.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-588",
  },
  {
    name: "Code of Cairo",
    img: "/assets/Casino/PP1047.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-631",
  },
  {
    name: "Big Bass Reel Repeat",
    img: "/assets/Casino/PP1046.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-585",
  },
  {
    name: "Zombie School Megaways",
    img: "/assets/Casino/PP1043.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-590",
  },
  {
    name: "Argonauts",
    img: "/assets/Casino/PP1042.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-587",
  },
  {
    name: "Wolf Gold 4 Pack",
    img: "/assets/Casino/PP1040.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-584",
  },
  {
    name: "Dino Drop",
    img: "/assets/Casino/PP1039.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-630",
  },
  {
    name: "Gem Trio",
    img: "/assets/Casino/PP1037.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-583",
  },
  {
    name: "Chilli Heat Spicy Spins",
    img: "/assets/Casino/PP1033.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-582",
  },
  {
    name: "You Can Piggy Bank On It",
    img: "/assets/Casino/PP1032.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-581",
  },
  {
    name: "777 Rush",
    img: "/assets/Casino/PP1030.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-629",
  },
  {
    name: "Alien Invaders",
    img: "/assets/Casino/PP1028.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-580",
  },
  {
    name: "Club Tropicana – Happy Hour",
    img: "/assets/Casino/PP1027.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-579",
  },
  {
    name: "Waves of Poseidon",
    img: "/assets/Casino/PP1025.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-578",
  },
  {
    name: "Gem Fire Fortune",
    img: "/assets/Casino/PP1024.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-577",
  },
  {
    name: "Master Gems",
    img: "/assets/Casino/PP1023.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-628",
  },
  {
    name: "Finger Lick’n Free Spins",
    img: "/assets/Casino/PP1022.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-575",
  },
  {
    name: "Gold Party 2 After Hours",
    img: "/assets/Casino/PP1020.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
  },
  {
    name: "Temple Guardians",
    img: "/assets/Casino/PP1019.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-573",
  },
  {
    name: "Big Bass Boxing Bonus Round",
    img: "/assets/Casino/PP1018.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-572",
  },
  {
    name: "Fortune of Aztec",
    img: "/assets/Casino/PP1015.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-626",
  },
  {
    name: "Mahjong Wins Super Scatter",
    img: "/assets/Casino/PP1014.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
  },
  {
    name: "Mummy’s Jewels",
    img: "/assets/Casino/PP1010.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-571",
  },
  {
    name: "Olympus Wins",
    img: "/assets/Casino/PP1008.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-627",
  },
  {
    name: "Majestic Express Gold Run",
    img: "/assets/Casino/PP1007.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
  },
  {
    name: "Pig Farm",
    img: "/assets/Casino/PP1005.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-625",
  },
  {
    name: "Jumbo Safari",
    img: "/assets/Casino/PP1001.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-566",
  },
  {
    name: "Starlight Wins",
    img: "/assets/Casino/PP0999.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-624",
  },
  {
    name: "Fiesta Fortune",
    img: "/assets/Casino/PP0998.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-565",
  },
  {
    name: "Sleeping Dragon",
    img: "/assets/Casino/PP0997.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-564",
  },
  {
    name: "Bloody Murder",
    img: "/assets/Casino/RT0511.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-371",
  },
  {
    name: "Arc Of Zeus",
    img: "/assets/Casino/RT0510.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-369",
  },
  {
    name: "Land of Riches",
    img: "/assets/Casino/RT0509.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-368",
  },
  {
    name: "Book Of Desert Legends",
    img: "/assets/Casino/RT0508.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-367",
  },
  {
    name: "Cash Lamps",
    img: "/assets/Casino/RT0507.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-366",
  },
  {
    name: "Take the Money",
    img: "/assets/Casino/RT0506.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-365",
  },
  {
    name: "Lava Joker",
    img: "/assets/Casino/RT0505.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-364",
  },
  {
    name: "Aztec Shamans MegaWays",
    img: "/assets/Casino/RT0504.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-361",
  },
  {
    name: "Big Gains",
    img: "/assets/Casino/RT0503.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-358",
  },
  // {
  //   name: "Rumble Mutts",
  //   img: "/assets/Casino/RT0502.webp",
  //   vendor: "/assets/Platform/RT-COLOR.webp",
  //   platForm: "RT",
  //   type: "SLOTS",
  // },
  {
    name: "Rise of Cleopatra",
    img: "/assets/Casino/RT0501.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-351",
  },
  {
    name: "777 Diamond Strike",
    img: "/assets/Casino/RT0500.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-352",
  },
  {
    name: "Cash Goddess",
    img: "/assets/Casino/RT0499.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-353",
  },
  {
    name: "Miami Rise",
    img: "/assets/Casino/RT0498.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-354",
  },
  {
    name: "Zillard King MegaWays",
    img: "/assets/Casino/RT0497.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-355",
  },
  {
    name: "Gods of Troy MegaWays",
    img: "/assets/Casino/RT0496.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-349",
  },
  {
    name: "Jackrabbit Jackpots",
    img: "/assets/Casino/RT0492.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-356",
  },
  {
    name: "Farmtastic™",
    img: "/assets/Casino/RT0490.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-357",
  },
  {
    name: "Legends of Forbidden Love Megaways",
    img: "/assets/Casino/RT0488.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-347",
  },
  {
    name: "Bass Boss MegaWays™",
    img: "/assets/Casino/RT0486.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-350",
  },
  {
    name: "Diamonds Up",
    img: "/assets/Casino/RT0485.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-346",
  },
  {
    name: "Serpent King",
    img: "/assets/Casino/RT0481.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-348",
  },
  {
    name: "Trillionaire Megaways",
    img: "/assets/Casino/RT0479.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-345",
  },
  {
    name: "Trophy Fish",
    img: "/assets/Casino/RT0477.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-343",
  },
  {
    name: "Wild Touchdown Megaways",
    img: "/assets/Casino/RT0475.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-340",
  },
  {
    name: "Cash Explorer",
    img: "/assets/Casino/RT0473.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-339",
  },
  {
    name: "Trick of the Dead Wild Candies Megaways",
    img: "/assets/Casino/RT0471.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-341",
  },
  {
    name: "Wild Hot Chilli Reels 2",
    img: "/assets/Casino/RT0469.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-342",
  },
  {
    name: "Fish N Fish",
    img: "/assets/Casino/RT0467.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-363",
  },
  {
    name: "Astronaut",
    img: "/assets/Casino/RT0463.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-253",
  },
  {
    name: "Gems Inferno MegaWays",
    img: "/assets/Casino/RT0461.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-260",
  },
  {
    name: "Magic Tricks",
    img: "/assets/Casino/RT0459.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-265",
  },
  {
    name: "London Tube",
    img: "/assets/Casino/RT0457.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-264",
  },
  {
    name: "Monsters Unchained",
    img: "/assets/Casino/RT0455.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-266",
  },
  {
    name: "Here Kitty Kitty",
    img: "/assets/Casino/RT0453.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-262",
  },
  {
    name: "Bounty Raid 2",
    img: "/assets/Casino/RT0451.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-254",
  },
  {
    name: "Case Closed",
    img: "/assets/Casino/RT0449.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-255",
  },
  {
    name: "Easy Gold",
    img: "/assets/Casino/RT0447.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-258",
  },
  {
    name: "Year-Round Riches CLUSTERBUSTER",
    img: "/assets/Casino/RT0445.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-269",
  },
  {
    name: "Spooky Carnival",
    img: "/assets/Casino/RT0443.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-272",
  },
  {
    name: "Sugarlicious EVERYWAY",
    img: "/assets/Casino/RT0441.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-268",
  },
  {
    name: "Wanted Wildz Extreme",
    img: "/assets/Casino/RT0439.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-310",
  },
  {
    name: "Christmas MULTIHOPS",
    img: "/assets/Casino/RT0436.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-251",
  },
  {
    name: "Sea Boat Adventure",
    img: "/assets/Casino/RT0434.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-252",
  },
  {
    name: "Christmas Morning",
    img: "/assets/Casino/RT0432.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-250",
  },
  {
    name: "Clover Craze",
    img: "/assets/Casino/RT0430.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-287",
  },
  {
    name: "Astros",
    img: "/assets/Casino/RT0428.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-281",
  },
  {
    name: "Play With The Devil",
    img: "/assets/Casino/RT0426.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-282",
  },
  {
    name: "Ultra Rich",
    img: "/assets/Casino/RT0424.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-320",
  },
  {
    name: "Turtle Paradise",
    img: "/assets/Casino/RT0420.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-325",
  },
  {
    name: "Roman Emperors",
    img: "/assets/Casino/RT0418.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-326",
  },
  {
    name: "Egypt Clusterbuster",
    img: "/assets/Casino/RT0416.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
  },
  {
    name: "Gladiator Ways",
    img: "/assets/Casino/RT0408.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-359",
  },
  {
    name: "Dear Santa",
    img: "/assets/Casino/RT0406.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-336",
  },
  {
    name: "Diamond Doggies",
    img: "/assets/Casino/RT0404.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-332",
  },
  {
    name: "Sea Boat Adventure MegaWays™",
    img: "/assets/Casino/RT0403.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-333",
  },
  {
    name: "The Good, The Bad and The Rich",
    img: "/assets/Casino/RT0402.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-331",
  },
  {
    name: "Zeus Lightning MegaWays™",
    img: "/assets/Casino/RT0401.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-334",
  },
  {
    name: "Moon Spell",
    img: "/assets/Casino/RT0400.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-330",
  },
  {
    name: "Los Muertos Locos",
    img: "/assets/Casino/RT0399.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-329",
  },
  {
    name: "Savannah Pride",
    img: "/assets/Casino/RT0398.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-328",
  },
  {
    name: "Glow Dig",
    img: "/assets/Casino/RT0397.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-324",
  },
  {
    name: "Diamond Blitz 2",
    img: "/assets/Casino/RT0396.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-323",
  },
  {
    name: "Fishtastic",
    img: "/assets/Casino/RT0395.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-299",
  },
  // {
  //   name: "Don't Hit Plz",
  //   img: "/assets/Casino/RT0394.webp",
  //   vendor: "/assets/Platform/RT-COLOR.webp",
  //   platForm: "RT",
  //   type: "SLOTS",
  // },
  {
    name: "Primate King Megaways™",
    img: "/assets/Casino/RT0393.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-308",
  },
  {
    name: "Gold Mine Mistress",
    img: "/assets/Casino/RT0392.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-289",
  },
  {
    name: "Viking's Legacy Everyway™",
    img: "/assets/Casino/RT0391.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-311",
  },
  {
    name: "Fruit Flash",
    img: "/assets/Casino/RT0390.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-312",
  },
  {
    name: "Cannonball Cash",
    img: "/assets/Casino/RT0389.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-314",
  },
  {
    name: "Purr Power",
    img: "/assets/Casino/RT0388.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-317",
  },
  {
    name: "Piggy Riches 2™ Megaways™",
    img: "/assets/Casino/RT0387.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-316",
  },
  {
    name: "Emperor of India",
    img: "/assets/Casino/RT0386.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-315",
  },
  {
    name: "Buffalo Collector",
    img: "/assets/Casino/RT0385.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-321",
  },
  {
    name: "Fa Fa Babies 2",
    img: "/assets/Casino/RT0384.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-322",
  },
  {
    name: "Sword Stomp",
    img: "/assets/Casino/RT0383.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-318",
  },
  {
    name: "Rainbow Jackpots Megaways",
    img: "/assets/Casino/RT0382.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-313",
  },
  {
    name: "Midnight Thirst",
    img: "/assets/Casino/RT0381.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-306",
  },
  {
    name: "Sakura Masks",
    img: "/assets/Casino/RT0380.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-283",
  },
  // {
  //   name: "Dr. Francashstein MULTIHOPS",
  //   img: "/assets/Casino/RT0379.webp",
  //   vendor: "/assets/Platform/RT-COLOR.webp",
  //   platForm: "RT",
  //   type: "SLOTS",
  // },
  {
    name: "The Wild Kiss",
    img: "/assets/Casino/RT0378.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-284",
  },
  {
    name: "Redline Rush",
    img: "/assets/Casino/RT0377.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-285",
  },
  {
    name: "Midnight Romance",
    img: "/assets/Casino/RT0376.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-288",
  },
  {
    name: "777 Super Strike",
    img: "/assets/Casino/RT0375.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-286",
  },
  {
    name: "Vault Cracker Megaways™",
    img: "/assets/Casino/RT0374.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-274",
  },
  {
    name: "Dragon's Mirror",
    img: "/assets/Casino/RT0372.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-273",
  },
  {
    name: "Siren's Riches",
    img: "/assets/Casino/RT0371.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-271",
  },
  {
    name: "Nightmare Family Megaway",
    img: "/assets/Casino/RT0369.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-307",
  },
  {
    name: "Hansel & Gretel Candyhouse",
    img: "/assets/Casino/RT0368.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-270",
  },
  {
    name: "Goddess of the Moon Megaways",
    img: "/assets/Casino/RT0367.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-261",
  },
  {
    name: "Sugar Monster",
    img: "/assets/Casino/RT0366.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-267",
  },
  {
    name: "Desert Legends Spins",
    img: "/assets/Casino/RT0365.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-257",
  },
  {
    name: "Wolfkin",
    img: "/assets/Casino/RT0363.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-244",
  },
  {
    name: "Wanted Wildz",
    img: "/assets/Casino/RT0362.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-280",
  },
  {
    name: "Red Hot Slot",
    img: "/assets/Casino/RT0361.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-309",
  },
  {
    name: "Red Hot BBQ",
    img: "/assets/Casino/RT0360.webp",
    vendor: "/assets/Platform/RT-COLOR.webp",
    platForm: "RT",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-241",
  },

  {
    name: "Vegas Nights",
    img: "/assets/Casino/EP0214.webp",
    vendor: "/assets/Platform/EP-COLOR.webp",
    platForm: "EVO",
    type: "SLOTS",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-119",
  },

  {
    name: "Robin Hood",
    img: "/assets/Casino/EP0178.webp",
    vendor: "/assets/Platform/EP-COLOR.webp",
    platForm: "EVO",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-020",
  },
  {
    name: "Chinese New Year",
    img: "/assets/Casino/EP0094.webp",
    vendor: "/assets/Platform/EP-COLOR.webp",
    platForm: "EVO",
    type: "SLOTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-007",
  },

  {
    name: "Hallo Win Party",
    img: "/assets/Casino/SG0187.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-163",
  },
  {
    name: "Mister Cashmore",
    img: "/assets/Casino/SG0186.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-162",
  },
  {
    name: "Pirates Gold Rush",
    img: "/assets/Casino/SG0185.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-161",
  },
  {
    name: "Legacy of Ramakien",
    img: "/assets/Casino/SG0184.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-160",
  },
  {
    name: "Alchemy Quest Jackpot",
    img: "/assets/Casino/SG0183.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-145",
  },
  {
    name: "Juicy Market",
    img: "/assets/Casino/SG0182.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-159",
  },
  {
    name: "Golden Pixiu",
    img: "/assets/Casino/SG0181.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-158",
  },
  {
    name: "Mahjong Riches",
    img: "/assets/Casino/SG0180.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-157",
  },
  {
    name: "Fiery Sevens Hot 100",
    img: "/assets/Casino/SG0178.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-156",
  },
  {
    name: "Fiery Sevens Hot 50",
    img: "/assets/Casino/SG0177.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-155",
  },
  {
    name: "Fiery Sevens Hot 5",
    img: "/assets/Casino/SG0176.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-153",
  },
  {
    name: "Santa Wild Drop",
    img: "/assets/Casino/SG0175.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-151",
  },
  {
    name: "Fruit Ninja Fury",
    img: "/assets/Casino/SG0174.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-150",
  },
  // {
  //   name: "Happy Cat",
  //   img: "/assets/Casino/SG0173.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  {
    name: "Lucky Snake Wheel",
    img: "/assets/Casino/SG0172.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-152",
  },
  {
    name: "Lucky Twin Sea",
    img: "/assets/Casino/SG0171.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-147",
  },
  {
    name: "Gold West",
    img: "/assets/Casino/SG0170.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-148",
  },
  {
    name: "Space Crasher",
    img: "/assets/Casino/SG0169.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "EGAME",
    casinoType: "SG-EGAME-003",
  },
  {
    name: "Fury Max Lucky Road",
    img: "/assets/Casino/SG0168.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-146",
  },
  {
    name: "Secrets of Anubis",
    img: "/assets/Casino/SG0167.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-144",
  },
  {
    name: "Dragon Wish",
    img: "/assets/Casino/SG0166.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-141",
  },
  {
    name: "Candy Candy",
    img: "/assets/Casino/SG0164.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-101",
  },
  {
    name: "Galaxy Guardian",
    img: "/assets/Casino/SG0163.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-142",
  },
  {
    name: "Clash of the Giants",
    img: "/assets/Casino/SG0162.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-139",
  },
  {
    name: "Moji Mania",
    img: "/assets/Casino/SG0160.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-127",
  },
  {
    name: "Gemstone Rush",
    img: "/assets/Casino/SG0158.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-126",
  },
  {
    name: "Candy Pop 2",
    img: "/assets/Casino/SG0157.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-123",
  },
  {
    name: "Hammer of Thunder",
    img: "/assets/Casino/SG0156.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-124",
  },
  {
    name: "Roma",
    img: "/assets/Casino/SG0155.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-102",
  },
  {
    name: "Sexy Vegas",
    img: "/assets/Casino/SG0153.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
  },
  {
    name: "Farmland Frenzy Maxways",
    img: "/assets/Casino/SG0152.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-122",
  },
  // {
  //   name: "Panda Opera",
  //   img: "/assets/Casino/SG0151.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  {
    name: "Caishen Deluxe Maxways",
    img: "/assets/Casino/SG0150.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-121",
  },
  {
    name: "Rabbit Riches",
    img: "/assets/Casino/SG0149.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-120",
  },
  {
    name: "Christmas Miracles",
    img: "/assets/Casino/SG0148.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-119",
  },
  {
    name: "Halloween Vacation",
    img: "/assets/Casino/SG0147.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-117",
  },
  {
    name: "Gold Rush Cowboys",
    img: "/assets/Casino/SG0146.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-100",
  },
  {
    name: "Legacy of Kong Maxways",
    img: "/assets/Casino/SG0145.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-116",
  },
  {
    name: "Sugar Party",
    img: "/assets/Casino/SG0144.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-115",
  },
  {
    name: "Captain Golds Fortune",
    img: "/assets/Casino/SG0143.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-114",
  },
  {
    name: "Journey to the Wild",
    img: "/assets/Casino/SG0142.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-113",
  },
  {
    name: "Fruits Mania",
    img: "/assets/Casino/SG0140.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-112",
  },
  {
    name: "Gold Panther Maxways",
    img: "/assets/Casino/SG0139.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-111",
  },
  {
    name: "Space Conquest",
    img: "/assets/Casino/SG0138.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-110",
  },
  {
    name: "Caishen",
    img: "/assets/Casino/SG0137.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-109",
  },
  {
    name: "Jokers Treasure Exclusive",
    img: "/assets/Casino/SG0136.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-108",
  },
  {
    name: "Lucky Koi Exclusive",
    img: "/assets/Casino/SG0135.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
  },
  {
    name: "Fiery Sevens Exclusive",
    img: "/assets/Casino/SG0134.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-106",
  },
  {
    name: "Royale House",
    img: "/assets/Casino/SG0133.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
  },
  {
    name: "Tiger Dance",
    img: "/assets/Casino/SG0132.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-104",
  },
  {
    name: "Lucky Meow",
    img: "/assets/Casino/SG0095.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
  },
  {
    name: "Golden Whale",
    img: "/assets/Casino/SG0094.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-058",
  },
  {
    name: "Da Fu Xiao Fu",
    img: "/assets/Casino/SG0091.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-055",
  },
  {
    name: "Lucky Feng Shui",
    img: "/assets/Casino/SG0086.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-046",
  },
  {
    name: "Highway Fortune",
    img: "/assets/Casino/SG0085.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-049",
  },
  {
    name: "Fa Fa Fa",
    img: "/assets/Casino/SG0082.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-009",
  },
  {
    name: "Great Stars",
    img: "/assets/Casino/SG0080.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-022",
  },
  // {
  //   name: "Emperor Gate",
  //   img: "/assets/Casino/SG0079.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  {
    name: "Dragon Gold",
    img: "/assets/Casino/SG0078.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-019",
  },
  {
    name: "Big Prosperity",
    img: "/assets/Casino/SG0077.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-021",
  },
  {
    name: "5 Fortune",
    img: "/assets/Casino/SG0075.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-030",
  },
  {
    name: "Lucky Koi",
    img: "/assets/Casino/SG0074.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
  },
  {
    name: "Double Fortunes",
    img: "/assets/Casino/SG0072.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-038",
  },
  {
    name: "Cai Shen 888",
    img: "/assets/Casino/SG0071.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-037",
  },
  {
    name: "5 Fortune Dragons",
    img: "/assets/Casino/SG0069.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-039",
  },
  // {
  //   name: "Adventure Iceland",
  //   img: "/assets/Casino/SG0068.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Pocket Mon Go",
  //   img: "/assets/Casino/SG0067.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  {
    name: "King Pharaoh",
    img: "/assets/Casino/SG0064.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-034",
  },
  {
    name: "Golden Lotus SE",
    img: "/assets/Casino/SG0063.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-091",
  },
  {
    name: "Baby Cai Shen",
    img: "/assets/Casino/SG0062.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-031",
  },
  // {
  //   name: "168 Fortunes",
  //   img: "/assets/Casino/SG0061.webp",
  //   vendor: "/assets/Platform/SG-COLOR.webp",
  //   platForm: "SPADE",
  //   type: "SLOTS",
  // },
  {
    name: "Iceland SA",
    img: "/assets/Casino/SG0059.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-023",
  },
  {
    name: "Golden X Ace",
    img: "/assets/Casino/YB0055.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-042",
  },
  {
    name: "Fortune X Ace",
    img: "/assets/Casino/YB0054.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-043",
  },
  {
    name: "Dragon Gems Wheel",
    img: "/assets/Casino/YB0053.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-038",
  },
  {
    name: "Dragon Gems Super Buy",
    img: "/assets/Casino/YB0052.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-036",
  },
  {
    name: "Magical Alchemist",
    img: "/assets/Casino/YB0051.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-035",
  },
  {
    name: "Pirate Legends",
    img: "/assets/Casino/YB0050.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-037",
  },
  {
    name: "Light of Apollo",
    img: "/assets/Casino/YB0049.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-034",
  },
  {
    name: "Super 30 Bingo",
    img: "/assets/Casino/YB0048.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-012",
  },
  {
    name: "Dragon Gems",
    img: "/assets/Casino/YB0047.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-032",
  },
  // {
  //   name: "ZHAO CAI PAO",
  //   img: "/assets/Casino/YB0046.webp",
  //   vendor: "/assets/Platform/YB-COLOR.webp",
  //   platForm: "YB",
  //   type: "SLOTS",
  // },
  {
    name: "Royal Hunter",
    img: "/assets/Casino/YB0045.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
  },
  {
    name: "Lucky Meow",
    img: "/assets/Casino/YB0044.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
  },
  {
    name: "Crazy Money",
    img: "/assets/Casino/YB0043.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
  },
  {
    name: "Sugar Crush",
    img: "/assets/Casino/YB0041.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
  },
  {
    name: "Super Egypt",
    img: "/assets/Casino/YB0040.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
  },
  {
    name: "EZ Bingo",
    img: "/assets/Casino/YB0038.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
  },
  {
    name: "Golden Aztec Mega",
    img: "/assets/Casino/YB0037.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
  },
  {
    name: "Royal Ace",
    img: "/assets/Casino/YB0036.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
  },
  {
    name: "Mermaid Slingo",
    img: "/assets/Casino/YB0035.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
  },
  {
    name: "Money Blast",
    img: "/assets/Casino/YB0034.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-003",
  },
  {
    name: "Joy Bingo",
    img: "/assets/Casino/YB0033.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-010",
  },
  {
    name: "Diamond Mines",
    img: "/assets/Casino/YB0032.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-002",
  },
  {
    name: "Crazy Color",
    img: "/assets/Casino/YB0031.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "EGAME",
    casinoType: "YesBingo-EGAME-001",
  },
  {
    name: "Rolling Fortune",
    img: "/assets/Casino/YB0030.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
  },
  {
    name: "Golden Aztec",
    img: "/assets/Casino/YB0029.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
  },
  {
    name: "Boom Boom Marmot",
    img: "/assets/Casino/YB0028.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
  },
  {
    name: "King Arthur Gold",
    img: "/assets/Casino/YB0027.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
  },
  {
    name: "Thor Fortune",
    img: "/assets/Casino/YB0026.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
  },
  // {
  //   name: "Fa Fa Dragon",
  //   img: "/assets/Casino/YB0025.webp",
  //   vendor: "/assets/Platform/YB-COLOR.webp",
  //   platForm: "YB",
  //   type: "SLOTS",
  // },
  {
    name: "Golden Bunny",
    img: "/assets/Casino/YB0024.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-016",
  },
  {
    name: "Power Mask",
    img: "/assets/Casino/YB0023.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
  },
  {
    name: "Power Lion",
    img: "/assets/Casino/YB0022.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-005",
  },
  {
    name: "Lightning Bingo",
    img: "/assets/Casino/YB0021.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-009",
  },
  {
    name: "Heat Bingo",
    img: "/assets/Casino/YB0020.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-008",
  },
  {
    name: "Money Bingo",
    img: "/assets/Casino/YB0019.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-007",
  },
  {
    name: "Beasty Bingo",
    img: "/assets/Casino/YB0018.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-006",
  },
  // {
  //   name: "Bingo Bonanza",
  //   img: "/assets/Casino/YB0017.webp",
  //   vendor: "/assets/Platform/YB-COLOR.webp",
  //   platForm: "YB",
  //   type: "SLOTS",
  // },
  {
    name: "Atlantis",
    img: "/assets/Casino/YB0016.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-113",
  },
  // {
  //   name: "Bingo Bingo",
  //   img: "/assets/Casino/YB0015.webp",
  //   vendor: "/assets/Platform/YB-COLOR.webp",
  //   platForm: "YB",
  //   type: "SLOTS",
  // },
  {
    name: "Open Sesame",
    img: "/assets/Casino/YB0014.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
  },
  {
    name: "Win Cai Shen",
    img: "/assets/Casino/YB0013.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-001",
  },
  {
    name: "Fortune Cat",
    img: "/assets/Casino/YB0012.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-014",
  },
  {
    name: "Fancy Egypt",
    img: "/assets/Casino/YB0011.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
  },
  {
    name: "Lucky Star",
    img: "/assets/Casino/YB0010.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-010",
  },
  {
    name: "Rolling 7",
    img: "/assets/Casino/YB0009.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
  },
  {
    name: "Gladiator",
    img: "/assets/Casino/YB0008.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
  },
  {
    name: "Magic Lamp",
    img: "/assets/Casino/YB0007.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-046",
  },
  {
    name: "Casino Fantasy",
    img: "/assets/Casino/YB0006.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-015",
  },
  {
    name: "Money Horse",
    img: "/assets/Casino/YB0005.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-002",
  },
  {
    name: "Fortune Treasure",
    img: "/assets/Casino/YB0004.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-072",
  },
  {
    name: "Power Fortune",
    img: "/assets/Casino/YB0003.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-004",
  },
  {
    name: "Drago Nova",
    img: "/assets/Casino/YB0002.webp",
    vendor: "/assets/Platform/YB-COLOR.webp",
    platForm: "YB",
    type: "SLOTS",
    platFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-003",
  },
  {
    name: "Big Bucks Deluxe",
    img: "/assets/Casino/BTG090.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-061",
  },
  {
    name: "Temple Quest Spinfinity",
    img: "/assets/Casino/BTG085.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-059",
  },
  {
    name: "Burgers",
    img: "/assets/Casino/BTG083.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-058",
  },
  {
    name: "Big Bad Bison",
    img: "/assets/Casino/BTG081.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-017",
  },
  {
    name: "Millionaire Rush",
    img: "/assets/Casino/BTG079.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-018",
  },
  {
    name: "Vegas Megaways",
    img: "/assets/Casino/BTG077.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-024",
  },
  {
    name: "Outlaw",
    img: "/assets/Casino/BTG075.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-023",
  },
  {
    name: "Wild Portals",
    img: "/assets/Casino/BTG073.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-026",
  },
  {
    name: "Star Clusters",
    img: "/assets/Casino/BTG071.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-025",
  },
  {
    name: "Wild Unicorns",
    img: "/assets/Casino/BTG068.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-033",
  },
  {
    name: "Opal Fruits",
    img: "/assets/Casino/BTG066.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-038",
  },
  {
    name: "Sanctuary",
    img: "/assets/Casino/BTG064.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-039",
  },
  {
    name: "Golden Goose Megaways",
    img: "/assets/Casino/BTG060.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-057",
  },
  {
    name: "Dragon Born",
    img: "/assets/Casino/BTG059.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-067",
  },
  {
    name: "Queen of Riches",
    img: "/assets/Casino/BTG057.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-055",
  },
  {
    name: "Boo",
    img: "/assets/Casino/BTG056.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-054",
  },
  {
    name: "Book of Gods",
    img: "/assets/Casino/BTG055.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-053",
  },
  {
    name: "Trigger Happy",
    img: "/assets/Casino/BTG054.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-047",
  },
  {
    name: "Holy Diver Megaways",
    img: "/assets/Casino/BTG053.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-051",
  },
  {
    name: "Millionaire Mystery Box",
    img: "/assets/Casino/BTG052.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-052",
  },
  {
    name: "Fizzy Pennyslot",
    img: "/assets/Casino/BTG051.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-050",
  },
  {
    name: "The Final Countdown",
    img: "/assets/Casino/BTG050.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-042",
  },
  {
    name: "Spicy Meatballs",
    img: "/assets/Casino/BTG049.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-043",
  },
  {
    name: "Fireworks Megaways",
    img: "/assets/Casino/BTG048.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-041",
  },
  {
    name: "Kingmaker Fully Loaded",
    img: "/assets/Casino/BTG047.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-032",
  },
  {
    name: "Lucky Streak Mk2",
    img: "/assets/Casino/BTG045.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-048",
  },
  {
    name: "Cyberslot Megaclusters",
    img: "/assets/Casino/BTG044.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-049",
  },
  {
    name: "Panda Money",
    img: "/assets/Casino/BTG043.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-040",
  },
  {
    name: "Chocolates",
    img: "/assets/Casino/BTG042.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-044",
  },
  {
    name: "King of Cats",
    img: "/assets/Casino/BTG041.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-045",
  },
  {
    name: "Bonanza Falls",
    img: "/assets/Casino/BTG040.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-022",
  },
  {
    name: "Royal Mint",
    img: "/assets/Casino/BTG038.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-020",
  },
  {
    name: "Christmas Catch",
    img: "/assets/Casino/BTG036.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-021",
  },
  {
    name: "Lil Devil",
    img: "/assets/Casino/BTG035.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-036",
  },
  {
    name: "Donuts",
    img: "/assets/Casino/BTG034.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-035",
  },
  {
    name: "Diamond Fruits",
    img: "/assets/Casino/BTG033.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-034",
  },
  {
    name: "More Turkey",
    img: "/assets/Casino/BTG032.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-046",
  },
  {
    name: "Pop",
    img: "/assets/Casino/BTG031.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-031",
  },
  {
    name: "Wild Flower",
    img: "/assets/Casino/BTG030.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-030",
  },
  {
    name: "Pirate Pays",
    img: "/assets/Casino/BTG029.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-029",
  },
  {
    name: "Slot Vegas Fully Loaded",
    img: "/assets/Casino/BTG028.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-028",
  },
  {
    name: "Max Megaways 2",
    img: "/assets/Casino/BTG027.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-027",
  },
  {
    name: "Gold Megaways",
    img: "/assets/Casino/BTG026.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-016",
  },
  {
    name: "Beef Lightning",
    img: "/assets/Casino/BTG025.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-015",
  },
  {
    name: "Vegas Rush",
    img: "/assets/Casino/BTG024.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-014",
  },
  {
    name: "Apollo Pays",
    img: "/assets/Casino/BTG023.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-001",
  },
  {
    name: "Rasputin Megaways",
    img: "/assets/Casino/BTG022.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-003",
  },
  {
    name: "Castle of Terror",
    img: "/assets/Casino/BTG021.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-002",
  },
  {
    name: "Over the Moon",
    img: "/assets/Casino/BTG020.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-013",
  },
  {
    name: "The Race",
    img: "/assets/Casino/BTG010.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-012",
  },
  {
    name: "Gifts of Fortune",
    img: "/assets/Casino/BTG009.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-011",
  },
  {
    name: "Danger High Voltage",
    img: "/assets/Casino/BTG008.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-009",
  },
  {
    name: "Golden Catch",
    img: "/assets/Casino/BTG007.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-008",
  },
  {
    name: "Millionaire Megaways",
    img: "/assets/Casino/BTG006.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-007",
  },
  {
    name: "White Rabbit",
    img: "/assets/Casino/BTG005.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-006",
  },
  {
    name: "Extra Chili",
    img: "/assets/Casino/BTG004.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-005",
  },
  {
    name: "Christmas Bonanza",
    img: "/assets/Casino/BTG003.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-010",
  },
  {
    name: "Bonanza",
    img: "/assets/Casino/BTG002.webp",
    vendor: "/assets/Platform/BTG-COLOR.webp",
    platForm: "BTG",
    type: "SLOTS",
    platFormCode: "BTG",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-004",
  },
  {
    name: "Jiang Shi Night",
    img: "/assets/Casino/JK0378.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-237",
  },
  {
    name: "Super Fortune Crown",
    img: "/assets/Casino/JK0377.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-236",
  },
  {
    name: "Moon Goddess",
    img: "/assets/Casino/JK0376.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-235",
  },
  {
    name: "Leprechaun",
    img: "/assets/Casino/JK0375.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-188",
  },
  // {
  //   name: "Football Fever",
  //   img: "/assets/Casino/JK0374.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Bau Cua",
  //   img: "/assets/Casino/JK0373.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Tai Xiu",
  //   img: "/assets/Casino/JK0372.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Virtual Roulette",
  //   img: "/assets/Casino/JK0371.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Number Game - King of Numbers",
  //   img: "/assets/Casino/JK0370.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Basketball Strike",
  //   img: "/assets/Casino/JK0369.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Virtual Sic Bo",
  //   img: "/assets/Casino/JK0368.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Baccarat Babes",
  //   img: "/assets/Casino/JK0367.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Thai HiLo",
    img: "/assets/Casino/JK0366.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-063",
  },
  {
    name: "Tropical Crush",
    img: "/assets/Casino/JK0365.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-167",
  },
  {
    name: "Shaolin",
    img: "/assets/Casino/JK0364.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-148",
  },
  {
    name: "Pharaoh's Tomb",
    img: "/assets/Casino/JK0363.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-131",
  },
  {
    name: "Ong Bak 2",
    img: "/assets/Casino/JK0362.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-125",
  },
  {
    name: "Mythological",
    img: "/assets/Casino/JK0361.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-116",
  },
  {
    name: "Immortals",
    img: "/assets/Casino/JK0360.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-087",
  },
  {
    name: "Haunted House",
    img: "/assets/Casino/JK0359.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-079",
  },
  {
    name: "Gold Trail",
    img: "/assets/Casino/JK0358.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-071",
  },
  {
    name: "Forest Treasure",
    img: "/assets/Casino/JK0357.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-063",
  },
  {
    name: "Feng Huang",
    img: "/assets/Casino/JK0356.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-055",
  },
  {
    name: "Enchanted Forest",
    img: "/assets/Casino/JK0355.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-050",
  },
  {
    name: "Dragon Ball",
    img: "/assets/Casino/JK0354.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-231",
  },
  {
    name: "Fire Master Hold And Win",
    img: "/assets/Casino/JK0353.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-232",
  },
  {
    name: "Super Seven Seas",
    img: "/assets/Casino/JK0352.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-233",
  },
  {
    name: "Maya Ways",
    img: "/assets/Casino/JK0351.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-234",
  },
  // {
  //   name: "Baccarat VVIP",
  //   img: "/assets/Casino/JK0350.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Speed Lotto",
  //   img: "/assets/Casino/JK0349.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "7 Up Down",
  //   img: "/assets/Casino/JK0348.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Jogo Do Bicho",
    img: "/assets/Casino/JK0347.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
  },
  // {
  //   name: "Mines or Treat",
  //   img: "/assets/Casino/JK0346.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Mines or Gifts",
  //   img: "/assets/Casino/JK0345.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Mines or Cash",
  //   img: "/assets/Casino/JK0344.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Football Mines",
  //   img: "/assets/Casino/JK0343.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Limbo Football",
  //   img: "/assets/Casino/JK0342.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Cash or Crash 2",
  //   img: "/assets/Casino/JK0341.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Fortune Crown Gold Gift",
    img: "/assets/Casino/JK0340.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-230",
  },
  {
    name: "Mahjong King",
    img: "/assets/Casino/JK0339.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-229",
  },
  {
    name: "Chilli Hunter Bandidos",
    img: "/assets/Casino/JK0338.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-228",
  },
  {
    name: "Fan Tan",
    img: "/assets/Casino/JK0337.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
  },
  {
    name: "Ramesses Relics",
    img: "/assets/Casino/JK0336.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-221",
  },
  {
    name: "Roma Deluxe",
    img: "/assets/Casino/JK0335.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-220",
  },
  {
    name: "Steamboat Ride: Hold And Win",
    img: "/assets/Casino/JK0334.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-227",
    platFormCode: "JOKER",
  },
  // {
  //   name: "Thai Hi-Lo",
  //   img: "/assets/Casino/JK0333.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Plinko",
    img: "/assets/Casino/JK0332.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
  },
  {
    name: "Legend Of Persia",
    img: "/assets/Casino/JK0331.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-216",
  },
  {
    name: "Seven Seas",
    img: "/assets/Casino/JK0330.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-226",
  },
  {
    name: "Fortune Crown 25",
    img: "/assets/Casino/JK0329.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-225",
  },
  {
    name: "Winds Of Wealth",
    img: "/assets/Casino/JK0328.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-217",
  },
  {
    name: "Savage Frontier: Hold And Win",
    img: "/assets/Casino/JK0327.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-224",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Crown",
    img: "/assets/Casino/JK0326.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-218",
  },
  {
    name: "Fire Temple",
    img: "/assets/Casino/JK0325.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-219",
  },
  {
    name: "Super Wild Watermelon",
    img: "/assets/Casino/JK0324.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-223",
  },
  {
    name: "Inca",
    img: "/assets/Casino/JK0323.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-222",
  },
  // {
  //   name: "Out Run",
  //   img: "/assets/Casino/JK0322.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Nyan Cat",
  //   img: "/assets/Casino/JK0321.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "World Of Emoji",
    img: "/assets/Casino/JK0320.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-215",
  },
  {
    name: "Carnaval Do Rio",
    img: "/assets/Casino/JK0319.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-214",
  },
  {
    name: "Black Knight",
    img: "/assets/Casino/JK0318.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-213",
  },
  {
    name: "Chocolate Shop",
    img: "/assets/Casino/JK0317.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-212",
  },
  {
    name: "Snake Of Fortune",
    img: "/assets/Casino/JK0316.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-211",
  },
  {
    name: "Hawaii Vacay",
    img: "/assets/Casino/JK0315.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-210",
  },
  {
    name: "Christmas Eve",
    img: "/assets/Casino/JK0314.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-209",
  },
  {
    name: "Mahjong Reactor",
    img: "/assets/Casino/JK0313.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-208",
  },
  {
    name: "Hot Wheels",
    img: "/assets/Casino/JK0312.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-207",
  },
  {
    name: "Wild Watermelon",
    img: "/assets/Casino/JK0311.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-206",
  },
  {
    name: "Bull Street",
    img: "/assets/Casino/JK0310.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-205",
  },
  {
    name: "Trick Or Treat",
    img: "/assets/Casino/JK0309.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-204",
  },
  {
    name: "Big Game Safari",
    img: "/assets/Casino/JK0308.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-017",
  },
  // {
  //   name: "Koi Bingo",
  //   img: "/assets/Casino/JK0307.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Golden Sea",
    img: "/assets/Casino/JK0306.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-203",
  },
  {
    name: "Masquerade",
    img: "/assets/Casino/JK0305.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-044",
  },
  {
    name: "Gates of Wealth",
    img: "/assets/Casino/JK0304.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-201",
  },
  {
    name: "Huang Fei Hong",
    img: "/assets/Casino/JK0303.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-200",
  },
  // {
  //   name: "Zodiac Bingo",
  //   img: "/assets/Casino/JK0302.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Pubg",
    img: "/assets/Casino/JK0301.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-197",
  },
  {
    name: "Silver Hand",
    img: "/assets/Casino/JK0300.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-199",
  },
  {
    name: "Sour Candy",
    img: "/assets/Casino/JK0299.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-195",
  },
  {
    name: "Sweetie Crush",
    img: "/assets/Casino/JK0298.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-198",
  },
  {
    name: "Love Letter",
    img: "/assets/Casino/JK0297.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-196",
  },
  {
    name: "Safari Life 2",
    img: "/assets/Casino/JK0296.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-194",
    platFormCode: "JOKER",
  },
  {
    name: "Panda Chef",
    img: "/assets/Casino/JK0295.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-193",
  },
  {
    name: "Mermaid Treasure",
    img: "/assets/Casino/JK0294.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-192",
  },
  {
    name: "Lion of the East",
    img: "/assets/Casino/JK0293.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-191",
  },
  {
    name: "Sweet Tooth",
    img: "/assets/Casino/JK0292.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-190",
  },
  {
    name: "Warrior",
    img: "/assets/Casino/JK0291.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-189",
  },
  // {
  //   name: "Big Bang Boxing",
  //   img: "/assets/Casino/JK0290.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Easter Run",
  //   img: "/assets/Casino/JK0289.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Thunder Blackjack",
  //   img: "/assets/Casino/JK0288.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Odds HiLo",
  //   img: "/assets/Casino/JK0287.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Thunder Dice",
  //   img: "/assets/Casino/JK0286.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  {
    name: "Kraken Hunter",
    img: "/assets/Casino/JK0285.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-187",
  },
  {
    name: "Date With Miyo",
    img: "/assets/Casino/JK0284.webp",
    vendor: "/assets/Platform/JK-COLOR.webp",
    platForm: "JOKER",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-186",
  },
  // {
  //   name: "Midnight Robbery",
  //   img: "/assets/Casino/JK0283.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Piggy Riches 3: Hog Heaven",
  //   img: "/assets/Casino/NE0263.webp",
  //   vendor: "/assets/Platform/NE-COLOR.webp",
  //   platForm: "NETENT",
  //   type: "SLOTS",
  // },
  {
    name: "Golden Egg Invaders",
    img: "/assets/Casino/NE0261.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-227",
  },
  {
    name: "Reel Rush XXXtreme",
    img: "/assets/Casino/NE0259.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-229",
  },
  {
    name: "Divine Fortune Black",
    img: "/assets/Casino/NE0258.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-230",
  },
  // {
  //   name: "Dazzle Me Christmas",
  //   img: "/assets/Casino/NE0251.webp",
  //   vendor: "/assets/Platform/NE-COLOR.webp",
  //   platForm: "NETENT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Fruit Blaze",
  //   img: "/assets/Casino/NE0250.webp",
  //   vendor: "/assets/Platform/NE-COLOR.webp",
  //   platForm: "NETENT",
  //   type: "SLOTS",
  // },
  {
    name: "The Wish Master Megaways",
    img: "/assets/Casino/NE0249.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-147",
  },
  {
    name: "Jack and the Beanstalk Remastered",
    img: "/assets/Casino/NE0248.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
  },
  {
    name: "Wild Turkey Megaways",
    img: "/assets/Casino/NE0247.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-148",
  },
  {
    name: "Crab Trap",
    img: "/assets/Casino/NE0246.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-179",
  },
  {
    name: "101 Candies",
    img: "/assets/Casino/NE0245.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
  },
  {
    name: "Big Bang Boom",
    img: "/assets/Casino/NE0244.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
  },
  {
    name: "Finn and The Candy Spin",
    img: "/assets/Casino/NE0243.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-186",
  },
  {
    name: "Don’t Eat the Candy",
    img: "/assets/Casino/NE0242.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-199",
  },
  {
    name: "Jingle Bells Bonanza",
    img: "/assets/Casino/NE0241.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-202",
  },
  {
    name: "Gem Crush",
    img: "/assets/Casino/NE0240.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-201",
  },
  {
    name: "Jelly Belly Megaways",
    img: "/assets/Casino/NE0239.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-183",
  },
  {
    name: "Pirates Party",
    img: "/assets/Casino/NE0238.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-182",
  },
  {
    name: "Casino Night",
    img: "/assets/Casino/NE0237.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-214",
  },
  {
    name: "Mermaids",
    img: "/assets/Casino/NE0236.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-215",
  },
  {
    name: "Cornelius Milk Hunter Megaways",
    img: "/assets/Casino/NE0235.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-221",
  },
  {
    name: "Dragons Playground",
    img: "/assets/Casino/NE0234.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-222",
  },
  {
    name: "Starburst Galaxy",
    img: "/assets/Casino/NE0233.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-220",
  },
  {
    name: "Wild Mining XXXtreme",
    img: "/assets/Casino/NE0253.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-225",
  },
  {
    name: "Finn and the Dragon Tales",
    img: "/assets/Casino/NE0252.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-226",
  },
  {
    name: "Mummy™ MegaWays™",
    img: "/assets/Casino/NE0232.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-219",
  },
  {
    name: "Mine Blown™",
    img: "/assets/Casino/NE0231.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-218",
  },
  {
    name: "Ms Robin Hood™",
    img: "/assets/Casino/NE0230.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-217",
  },
  {
    name: "Rabid Randy",
    img: "/assets/Casino/NE0229.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-216",
  },
  {
    name: "Twister",
    img: "/assets/Casino/NE0228.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-223",
  },
  {
    name: "Ticket To Wild™",
    img: "/assets/Casino/NE0227.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-213",
  },
  {
    name: "Space Wars Megaways Xxxtreme",
    img: "/assets/Casino/NE0226.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-211",
  },
  {
    name: "Babylon Riches",
    img: "/assets/Casino/NE0225.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-212",
  },
  {
    name: "Good Old 7's",
    img: "/assets/Casino/NE0224.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-194",
  },
  {
    name: "Jack Hammer™ 3: Diamond Affair",
    img: "/assets/Casino/NE0223.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-188",
  },
  {
    name: "Magic Lab",
    img: "/assets/Casino/NE0222.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-193",
  },
  {
    name: "Golden Realms",
    img: "/assets/Casino/NE0221.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-191",
  },
  {
    name: "Pandora's Treasure™",
    img: "/assets/Casino/NE0220.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-196",
  },
  {
    name: "Jungle Spirit Megaways",
    img: "/assets/Casino/NE0219.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-192",
  },
  {
    name: "Big Money Wheel",
    img: "/assets/Casino/NE0218.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-209",
  },
  {
    name: "Royal Nuts",
    img: "/assets/Casino/NE0217.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-207",
  },
  {
    name: "Gladiator Clash™",
    img: "/assets/Casino/NE0216.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-208",
  },
  {
    name: "Lock and Pop",
    img: "/assets/Casino/NE0215.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-210",
  },
  {
    name: "Leprechaun Joy™",
    img: "/assets/Casino/NE0214.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-197",
  },
  {
    name: "Golden Wheels of Egypt",
    img: "/assets/Casino/NE0213.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-190",
  },
  {
    name: "Rainforest Gold™",
    img: "/assets/Casino/NE0212.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-195",
  },
  {
    name: "Cursed Treasure",
    img: "/assets/Casino/NE0211.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-187",
  },
  {
    name: "Rage",
    img: "/assets/Casino/NE0210.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-189",
  },
  {
    name: "Buckshot Wilds",
    img: "/assets/Casino/NE0209.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-184",
  },
  {
    name: "Lights, Camera, Cash!™",
    img: "/assets/Casino/NE0208.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-203",
  },
  {
    name: "Druid's Magic",
    img: "/assets/Casino/NE0207.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-206",
  },
  {
    name: "Elk Hunter",
    img: "/assets/Casino/NE0206.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-185",
  },
  {
    name: "Beach Invaders",
    img: "/assets/Casino/NE0205.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-198",
  },
  {
    name: "Fruit Shop Frenzy",
    img: "/assets/Casino/NE0204.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-200",
  },
  {
    name: "Thrill To Grill",
    img: "/assets/Casino/NE0203.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
  },
  {
    name: "Wonderland Protector",
    img: "/assets/Casino/NE0199.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-171",
  },
  {
    name: "Twin Spin Xxxtreme",
    img: "/assets/Casino/NE0198.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-175",
  },
  {
    name: "Taco Fury Xxxtreme",
    img: "/assets/Casino/NE0197.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-174",
  },
  {
    name: "Pirate From the East",
    img: "/assets/Casino/NE0196.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-172",
  },
  {
    name: "Moonshine Riches",
    img: "/assets/Casino/NE0195.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-170",
  },
  {
    name: "Buster's Bones",
    img: "/assets/Casino/NE0194.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-173",
  },
  {
    name: "Sparks",
    img: "/assets/Casino/NE0170.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-167",
  },
  {
    name: "Fire Siege Fortress",
    img: "/assets/Casino/NE0169.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-169",
  },
  {
    name: "Lucky Angler: A Snowy Catch",
    img: "/assets/Casino/NE0168.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-168",
  },
  {
    name: "Hook's Heroes",
    img: "/assets/Casino/NE0167.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-164",
  },
  {
    name: "Swipe & Roll",
    img: "/assets/Casino/NE0166.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-165",
  },
  {
    name: "Berry Burst Max",
    img: "/assets/Casino/NE0165.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-166",
  },
  {
    name: "Go Bananas!",
    img: "/assets/Casino/NE0164.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-163",
  },
  {
    name: "Flowers Christmas Edition",
    img: "/assets/Casino/NE0163.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-162",
  },
  {
    name: "Copy Cats",
    img: "/assets/Casino/NE0162.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-159",
  },
  {
    name: "Theme Park Tickets of Fortune",
    img: "/assets/Casino/NE0161.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-160",
  },
  {
    name: "Witchcraft Academy",
    img: "/assets/Casino/NE0160.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-161",
  },
  {
    name: "East Sea Dragon King™",
    img: "/assets/Casino/NE0159.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-154",
  },
  {
    name: "Strolling Staxx: Cubic Fruits™",
    img: "/assets/Casino/NE0158.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-158",
  },
  {
    name: "Happy Riches™",
    img: "/assets/Casino/NE0157.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-152",
  },
  {
    name: "Arcane: Reel Chaos™",
    img: "/assets/Casino/NE0156.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-144",
  },
  {
    name: "Who's the Bride™",
    img: "/assets/Casino/NE0155.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-143",
  },
  {
    name: "Robin Hood: Shifting Riches™",
    img: "/assets/Casino/NE0154.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-145",
  },
  {
    name: "King of 3 Kingdoms™",
    img: "/assets/Casino/NE0153.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-142",
  },
  {
    name: "Wild-O-Tron 3000™",
    img: "/assets/Casino/NE0152.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-157",
  },
  {
    name: "Archangels: Salvation™",
    img: "/assets/Casino/NE0151.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-156",
  },
  {
    name: "Stickers™",
    img: "/assets/Casino/NE0150.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-146",
  },
  {
    name: "Twin Happiness™",
    img: "/assets/Casino/NE0149.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-149",
  },
  {
    name: "Long Pao™",
    img: "/assets/Casino/NE0148.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-140",
  },
  {
    name: "Fruit Spin™",
    img: "/assets/Casino/NE0147.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-062",
  },
  {
    name: "Santa vs Rudolf™",
    img: "/assets/Casino/NE0146.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-151",
  },
  {
    name: "Wild Turkey™",
    img: "/assets/Casino/NE0145.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-148",
  },
  {
    name: "Coins of Egypt™",
    img: "/assets/Casino/NE0144.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-139",
  },
  {
    name: "The Wish Master™",
    img: "/assets/Casino/NE0143.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-147",
  },
  {
    name: "Ghost Pirates™",
    img: "/assets/Casino/NE0142.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-141",
  },
  {
    name: "Berry Burst™",
    img: "/assets/Casino/NE0141.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-153",
  },
  {
    name: "Fortune Rangers™",
    img: "/assets/Casino/NE0140.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-155",
  },
  {
    name: "Bollywood Story",
    img: "/assets/Casino/NE0139.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-137",
  },
  {
    name: "Spellcast",
    img: "/assets/Casino/NE0138.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-138",
  },
  {
    name: "Twin Spin Deluxe",
    img: "/assets/Casino/NE0137.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-136",
  },
  {
    name: "Magic Portals",
    img: "/assets/Casino/NE0136.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-135",
  },
  {
    name: "Let It Burn",
    img: "/assets/Casino/NE0135.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-134",
  },
  {
    name: "Milkshake™ Xxxtreme",
    img: "/assets/Casino/NE0134.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-133",
  },
  {
    name: "Cupcakes™",
    img: "/assets/Casino/NE0133.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-016",
  },
  // {
  //   name: "Wonder of Christmas",
  //   img: "/assets/Casino/NE0132.webp",
  //   vendor: "/assets/Platform/NE-COLOR.webp",
  //   platForm: "NETENT",
  //   type: "SLOTS",
  // },
  {
    name: "Superstars",
    img: "/assets/Casino/NE0131.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-131",
  },
  {
    name: "Temple of Nudges",
    img: "/assets/Casino/NE0130.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-130",
  },
  {
    name: "Cornelius",
    img: "/assets/Casino/NE0129.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-129",
  },
  {
    name: "Bee Hive Bonanza",
    img: "/assets/Casino/NE0128.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-128",
  },
  {
    name: "Space Wars 2: Powerpoints™",
    img: "/assets/Casino/NE0127.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-127",
  },
  {
    name: "Funk Master™",
    img: "/assets/Casino/NE0126.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-126",
  },
  {
    name: "Spinsane™",
    img: "/assets/Casino/NE0125.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-125",
  },
  {
    name: "Golden Grimoire™",
    img: "/assets/Casino/NE0124.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-124",
  },
  {
    name: "Reel Rush 2",
    img: "/assets/Casino/NE0123.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-123",
  },
  {
    name: "Blackjack Classic",
    img: "/assets/Casino/NE0122.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "TABLE",
    casinoType: "NETENT-TABLE-001",
  },
  {
    name: "Roulette Touch",
    img: "/assets/Casino/NE0121.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-122",
  },
  {
    name: "Knight Rider™",
    img: "/assets/Casino/NE0120.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-121",
  },
  {
    name: "Wolf Cub™",
    img: "/assets/Casino/NE0119.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-115",
  },
  {
    name: "Wings of Riches™",
    img: "/assets/Casino/NE0118.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-114",
  },
  {
    name: "Wilderland™",
    img: "/assets/Casino/NE0117.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-117",
  },
  {
    name: "Wild Bazaar™",
    img: "/assets/Casino/NE0116.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-118",
  },
  {
    name: "Trollpot 5000™",
    img: "/assets/Casino/NE0115.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-116",
  },
  {
    name: "The Wolf's Bane™",
    img: "/assets/Casino/NE0114.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-111",
  },
  {
    name: "Sweety Honey Fruity™",
    img: "/assets/Casino/NE0113.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-113",
  },
  {
    name: "Super Striker™",
    img: "/assets/Casino/NE0112.webp",
    vendor: "/assets/Platform/NE-COLOR.webp",
    platForm: "NETENT",
    type: "SLOTS",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-110",
  },
  {
    name: "Kill Em All",
    img: "/assets/Casino/NLC216.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-111",
  },
  {
    name: "Blood Diamond",
    img: "/assets/Casino/NLC214.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-109",
  },
  {
    name: "Mental 2",
    img: "/assets/Casino/NLC212.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-107",
  },
  {
    name: "Highway to Hell",
    img: "/assets/Casino/NLC210.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-110",
  },
  {
    name: "Home of the Brave",
    img: "/assets/Casino/NLC208.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-108",
  },
  {
    name: "Duck Hunters",
    img: "/assets/Casino/NLC206.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-103",
  },
  {
    name: "Dead, Dead, or Deader",
    img: "/assets/Casino/NLC204.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-106",
  },
  {
    name: "xWays Hoarder 2",
    img: "/assets/Casino/NLC202.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-105",
  },
  {
    name: "Tanked",
    img: "/assets/Casino/NLC200.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-102",
  },
  // {
  //   name: "Oktoberfest",
  //   img: "/assets/Casino/NLC198.webp",
  //   vendor: "/assets/Platform/NLC-COLOR.webp",
  //   platForm: "NLC",
  //   type: "SLOTS",   platFormCode: "RT",
  //     gameType: "SLOT",
  //     casinoType: "RT-SLOT-157",
  // },
  // {
  //   name: "Kitchen Drama: Sushi Mania",
  //   img: "/assets/Casino/NLC196.webp",
  //   vendor: "/assets/Platform/NLC-COLOR.webp",
  //   platForm: "NLC",
  //   type: "SLOTS",
  // },
  {
    name: "The Cage",
    img: "/assets/Casino/NLC194.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-072",
  },
  {
    name: "DJ Psycho",
    img: "/assets/Casino/NLC190.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-071",
  },
  {
    name: "The Crypt",
    img: "/assets/Casino/NLC188.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-073",
  },
  {
    name: "Space Donkey",
    img: "/assets/Casino/NLC186.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-085",
  },
  {
    name: "Ugliest Catch",
    img: "/assets/Casino/NLC184.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-086",
  },
  {
    name: "Nine To Five",
    img: "/assets/Casino/NLC182.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-083",
  },
  {
    name: "Devil's Crossroad",
    img: "/assets/Casino/NLC180.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-077",
  },
  {
    name: "Land Of The Free",
    img: "/assets/Casino/NLC178.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-080",
  },
  {
    name: "Punk Rocker 2",
    img: "/assets/Casino/NLC176.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-089",
  },
  {
    name: "San Quentin 2: Death Row",
    img: "/assets/Casino/NLC172.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-096",
  },
  {
    name: "Munchies",
    img: "/assets/Casino/NLC170.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-099",
  },
  {
    name: "Blood & Shadow 2",
    img: "/assets/Casino/NLC166.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-100",
  },
  {
    name: "Brute Force",
    img: "/assets/Casino/NLC164.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-097",
  },
  {
    name: "Stockholm Syndrome",
    img: "/assets/Casino/NLC162.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-094",
  },
  {
    name: "Outsourced",
    img: "/assets/Casino/NLC160.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-093",
  },
  {
    name: "Apocalypse Super xNudge®",
    img: "/assets/Casino/NLC158.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-092",
  },
  {
    name: "Brick Snake 2000",
    img: "/assets/Casino/NLC156.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-075",
  },
  {
    name: "Kenneth Must Die",
    img: "/assets/Casino/NLC154.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-087",
  },
  {
    name: "Deadwood R.I.P",
    img: "/assets/Casino/NLC152.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-091",
  },
  {
    name: "Beheaded",
    img: "/assets/Casino/NLC150.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-090",
  },
  {
    name: "Loner",
    img: "/assets/Casino/NLC148.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-088",
  },
  {
    name: "Tombstone: No Mercy",
    img: "/assets/Casino/NLC146.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-082",
  },
  {
    name: "Possessed",
    img: "/assets/Casino/NLC145.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-081",
  },
  {
    name: "Fire in the Hole 2",
    img: "/assets/Casino/NLC144.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-078",
  },
  {
    name: "D Day",
    img: "/assets/Casino/NLC143.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-076",
  },
  {
    name: "Jingle Balls",
    img: "/assets/Casino/NLC141.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-079",
  },
  {
    name: "Roadkill",
    img: "/assets/Casino/NLC140.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-084",
  },
  {
    name: "Bounty Hunters",
    img: "/assets/Casino/NLC137.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-070",
  },
  {
    name: "Whacked!",
    img: "/assets/Casino/NLC136.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-068",
  },
  {
    name: "Gluttony",
    img: "/assets/Casino/NLC135.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-069",
  },
  {
    name: "Disturbed",
    img: "/assets/Casino/NLC134.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-067",
  },
  {
    name: "xWays Hoarder xSplit",
    img: "/assets/Casino/NLC067.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-013",
  },
  {
    name: "WiXX",
    img: "/assets/Casino/NLC066.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-060",
  },
  {
    name: "Warrior Graveyard xNudge",
    img: "/assets/Casino/NLC065.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-031",
  },
  {
    name: "Walk of Shame",
    img: "/assets/Casino/NLC064.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-063",
  },
  {
    name: "True Grit Redemption",
    img: "/assets/Casino/NLC063.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-025",
  },
  {
    name: "Tractor Beam",
    img: "/assets/Casino/NLC062.webp",
    vendor: "/assets/Platform/NLC-COLOR.webp",
    platForm: "NLC",
    type: "SLOTS",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-047",
  },
  {
    name: "Boxing Fury",
    img: "/assets/Casino/FS0063.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-063",
  },
  {
    name: "Golden Moon Empire",
    img: "/assets/Casino/FS0062.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-062",
  },
  {
    name: "Fortune Jewels I",
    img: "/assets/Casino/FS0061.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-061",
  },
  {
    name: "Wild Calavera",
    img: "/assets/Casino/FS0060.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-060",
  },
  {
    name: "Candy Super Tumble",
    img: "/assets/Casino/FS0059.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-059",
  },
  {
    name: "Jungle Quest",
    img: "/assets/Casino/FS0058.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-058",
  },
  {
    name: "Apollo Ray of Luck",
    img: "/assets/Casino/FS0057.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-050",
  },
  {
    name: "Farm of Fortune",
    img: "/assets/Casino/FS0056.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-045",
    platFormCode: "FASTSPIN",
  },
  {
    name: "Blade of Fortune",
    img: "/assets/Casino/FS0055.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-057",
  },
  {
    name: "Snake Treasure",
    img: "/assets/Casino/FS0054.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-054",
  },
  {
    name: "Beasts Of Luck",
    img: "/assets/Casino/FS0052.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-052",
  },
  {
    name: "Alien Smash",
    img: "/assets/Casino/FS0053.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-055",
  },
  {
    name: "Wild Mafia",
    img: "/assets/Casino/FS0051.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-056",
  },
  {
    name: "Pai Gow Ways",
    img: "/assets/Casino/FS0050.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-048",
  },
  {
    name: "Guardian of the Museum",
    img: "/assets/Casino/FS0049.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-053",
  },
  {
    name: "Adventure to the West",
    img: "/assets/Casino/FS0048.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-044",
  },
  {
    name: "Mahjong Princess",
    img: "/assets/Casino/FS0047.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-047",
  },
  {
    name: "Caribbean Riches",
    img: "/assets/Casino/FS0046.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-046",
  },
  {
    name: "Money Dragon",
    img: "/assets/Casino/FS0044.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-043",
  },
  {
    name: "Yeti Boom",
    img: "/assets/Casino/FS0043.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-041",
  },
  {
    name: "Wild Wet Win",
    img: "/assets/Casino/FS0042.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-099",
  },
  {
    name: "Sexy Vegas",
    img: "/assets/Casino/FS0041.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
  },
  {
    name: "Tiki Rush",
    img: "/assets/Casino/FS0040.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-033",
  },
  {
    name: "The Nutcrackers",
    img: "/assets/Casino/FS0039.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-030",
  },
  {
    name: "Triple Happiness",
    img: "/assets/Casino/FS0038.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-010",
  },
  {
    name: "Spin and Win",
    img: "/assets/Casino/FS0037.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-023",
  },
  {
    name: "Sweet Frenzy",
    img: "/assets/Casino/FS0036.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-038",
  },
  {
    name: "Space Conquest",
    img: "/assets/Casino/FS0035.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-110",
  },
  {
    name: "Safari Blitz",
    img: "/assets/Casino/FS0034.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-024",
  },
  {
    name: "Ranger Showdown",
    img: "/assets/Casino/FS0033.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-042",
  },
  {
    name: "Roma",
    img: "/assets/Casino/FS0032.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-102",
  },
  {
    name: "Royal Katt",
    img: "/assets/Casino/FS0031.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-098",
  },
  {
    name: "Royale House",
    img: "/assets/Casino/FS0030.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
  },
  {
    name: "Rich Caishen",
    img: "/assets/Casino/FS0029.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-096",
  },
  {
    name: "Poker Ways",
    img: "/assets/Casino/FS0028.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-095",
  },
  {
    name: "Oceanic Melodies",
    img: "/assets/Casino/FS0027.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-021",
  },
  {
    name: "Neko Riches",
    img: "/assets/Casino/FS0026.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-034",
  },
  {
    name: "Neon Fantasy",
    img: "/assets/Casino/FS0025.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-016",
  },
  {
    name: "Muay Thai Fighter",
    img: "/assets/Casino/FS0024.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-097",
  },
  {
    name: "Mighty Sevens",
    img: "/assets/Casino/FS0023.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-035",
  },
  {
    name: "The Maya Myth",
    img: "/assets/Casino/FS0022.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-022",
  },
  {
    name: "Money Empire",
    img: "/assets/Casino/FS0021.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-040",
  },
  {
    name: "Mushroom Bandit",
    img: "/assets/Casino/FS0020.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-036",
  },
  {
    name: "Mining Bonanza",
    img: "/assets/Casino/FS0019.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-029",
  },
  {
    name: "Loki",
    img: "/assets/Casino/FS0018.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-018",
  },
  {
    name: "Legend of Nian",
    img: "/assets/Casino/FS0017.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-031",
  },
  {
    name: "Lucky Fortune",
    img: "/assets/Casino/FS0016.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-011",
  },
  {
    name: "Legend Of Eagle",
    img: "/assets/Casino/FS0015.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "SLOTS",
    platFormCode: "FASTSPIN",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-015",
  },
  {
    name: "Lucky Cat Gala",
    img: "/assets/Casino/KM0101.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-028",
  },
  // {
  //   name: "Samba Rhapsody",
  //   img: "/assets/Casino/KM0098.webp",
  //   vendor: "/assets/Platform/KM-COLOR.webp",
  //   platForm: "KM",
  //   type: "SLOTS",
  // },
  {
    name: "Mahjong Beauty",
    img: "/assets/Casino/KM0097.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-027",
  },
  {
    name: "Salsa Fury",
    img: "/assets/Casino/KM0094.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-021",
  },
  {
    name: "Dear Senpai",
    img: "/assets/Casino/KM0093.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-020",
  },
  {
    name: "Chicken Crossy",
    img: "/assets/Casino/KM0090.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-086",
  },
  {
    name: "Hippo Splash",
    img: "/assets/Casino/KM0089.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-016",
  },
  {
    name: "Rome Gladiator",
    img: "/assets/Casino/KM0085.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-018",
  },
  {
    name: "Cupid Archery",
    img: "/assets/Casino/KM0084.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-017",
  },
  {
    name: "Hunk Cai Shen",
    img: "/assets/Casino/KM0082.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-019",
  },
  {
    name: "Leppy's Loot",
    img: "/assets/Casino/KM0073.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
  },
  {
    name: "Pirate's Treasure",
    img: "/assets/Casino/KM0080.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-015",
  },
  {
    name: "Horus Glory",
    img: "/assets/Casino/KM0078.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-014",
  },
  {
    name: "London Mystery",
    img: "/assets/Casino/KM0077.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-013",
  },
  {
    name: "Merlin's Saga",
    img: "/assets/Casino/KM0076.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-012",
  },
  {
    name: "Piggy Heist",
    img: "/assets/Casino/KM0075.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-011",
  },
  {
    name: "Gold Rush Bonanza",
    img: "/assets/Casino/KM0074.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-010",
  },
  {
    name: "Warriors Temple",
    img: "/assets/Casino/KM0069.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-008",
  },
  {
    name: "Gems of Valhalla",
    img: "/assets/Casino/KM0061.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
  },
  {
    name: "Gold Mine",
    img: "/assets/Casino/KM0066.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-006",
  },
  {
    name: "Sugar Blast Frenzy",
    img: "/assets/Casino/KM0065.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-003",
  },
  {
    name: "Coin Pusher",
    img: "/assets/Casino/KM0063.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
  },
  {
    name: "Almighty Greek",
    img: "/assets/Casino/KM0062.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-007",
  },
  {
    name: "Cleopatra's Treasure",
    img: "/assets/Casino/KM0060.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-004",
  },
  {
    name: "Rooster Blitz",
    img: "/assets/Casino/KM0059.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-005",
  },
  {
    name: "Olympus Glory",
    img: "/assets/Casino/KM0058.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-071",
  },
  {
    name: "Elite Aviator Club",
    img: "/assets/Casino/KM0056.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-069",
  },
  {
    name: "Cockfighting Arena",
    img: "/assets/Casino/KM0054.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
  },
  {
    name: "Pusoy",
    img: "/assets/Casino/KM0053.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-065",
  },
  {
    name: "Sugar Blast",
    img: "/assets/Casino/KM0048.webp",
    vendor: "/assets/Platform/KM-COLOR.webp",
    platForm: "KM",
    type: "SLOTS",
    platFormCode: "KINGMAKER",
    gameType: "SLOT",
    casinoType: "KM-SLOT-001",
  },
  {
    name: "Arowana's Luck",
    img: "/assets/Casino/PT0061.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
  },
  {
    name: "Buffalo Blitz: Cash Collect™",
    img: "/assets/Casino/PT0745.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
  },
  {
    name: "Gold Trio: Lil Demon",
    img: "/assets/Casino/PT0754.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-436",
  },
  {
    name: "Sticky Bandits Thunder Rail",
    img: "/assets/Casino/PT0752.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-434",
  },
  {
    name: "Beastwood",
    img: "/assets/Casino/PT0751.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-431",
  },
  // {
  //   name: "Pearl o' Plinko - Mermaid Cove",
  //   img: "/assets/Casino/PT0718.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Adventures Beyond Wonderland Magical Maze",
    img: "/assets/Casino/PT0739.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-426",
  },
  {
    name: "Shields of Lambda",
    img: "/assets/Casino/PT0542.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-441",
  },
  {
    name: "Azticons Chaos Clusters",
    img: "/assets/Casino/PT0740.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-428",
  },
  {
    name: "Betty Bonkers",
    img: "/assets/Casino/PT0741.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-429",
  },
  {
    name: "Big Bad Wolf: Pigs of Steel",
    img: "/assets/Casino/PT0464.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-248",
  },
  {
    name: "Sakura Fortune Epic Bloom 96",
    img: "/assets/Casino/PT0537.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-241",
  },
  {
    name: "Epic Fish:Net of Fortune",
    img: "/assets/Casino/PT0725.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-477",
  },
  // {
  //   name: "Temple of Paw",
  //   img: "/assets/Casino/PT0543.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "High Street Heist",
  //   img: "/assets/Casino/PT0726.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Book of Duat",
  //   img: "/assets/Casino/PT0465.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Scepter of Anubis",
  //   img: "/assets/Casino/PT0729.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Eastern Emeralds Megaways",
    img: "/assets/Casino/PT0476.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-251",
  },
  {
    name: "Gummy Giga Match",
    img: "/assets/Casino/PT0539.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-459",
  },
  {
    name: "The Racaroon",
    img: "/assets/Casino/PT0802.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-454",
  },
  // {
  //   name: "Zeus Rush Fever Deluxe",
  //   img: "/assets/Casino/PT0830.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Rush Fever 7s Deluxe",
  //   img: "/assets/Casino/PT0829.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "New Year Happiness",
  //   img: "/assets/Casino/PT0828.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Diamond Explosion Christmas Tango",
  //   img: "/assets/Casino/PT0827.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Cash Collect Roulette BF",
    img: "/assets/Casino/PT0824.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-131",
  },
  // {
  //   name: "Joker Poker",
  //   img: "/assets/Casino/PT0823.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "European Roulette",
    img: "/assets/Casino/PT0822.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
  },
  {
    name: "J Mania Hot Asses",
    img: "/assets/Casino/PT0821.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-464",
  },
  {
    name: "Giga Match Moolah",
    img: "/assets/Casino/PT0820.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-466",
  },
  {
    name: "Go High Safari",
    img: "/assets/Casino/PT0819.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-465",
  },
  {
    name: "Scatter Monsters",
    img: "/assets/Casino/PT0818.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-463",
  },
  {
    name: "Spinions Game Day",
    img: "/assets/Casino/PT0817.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-462",
  },
  {
    name: "Toucan Mania",
    img: "/assets/Casino/PT0816.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-467",
  },
  {
    name: "Blackbeard’s Hoard Cash Sacks",
    img: "/assets/Casino/PT0815.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-468",
  },
  {
    name: "Ka Ching Boom",
    img: "/assets/Casino/PT0814.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-469",
  },
  {
    name: "Mystic Mines",
    img: "/assets/Casino/PT0813.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-461",
  },
  {
    name: "Long Long Long",
    img: "/assets/Casino/PT0812.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-005",
  },
  {
    name: "Wizzy Trix",
    img: "/assets/Casino/PT0801.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-457",
  },
  // {
  //   name: "Book of Inferno",
  //   img: "/assets/Casino/PT0810.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "20 Stars Ablaze",
    img: "/assets/Casino/PT0809.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-450",
  },
  {
    name: "Mad Hit Jokester",
    img: "/assets/Casino/PT0808.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-456",
  },
  {
    name: "Mad Hit Gorillatron",
    img: "/assets/Casino/PT0807.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-458",
  },
  {
    name: "Giga Match Gems",
    img: "/assets/Casino/PT0806.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-459",
  },
  {
    name: "Primal Spirits",
    img: "/assets/Casino/PT0805.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-460",
  },
  {
    name: "Mine & Melt",
    img: "/assets/Casino/PT0804.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-455",
  },
  {
    name: "Bubblegum Burst",
    img: "/assets/Casino/PT0803.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-449",
  },
  {
    name: "Sahara Riches: Cash Collect Max",
    img: "/assets/Casino/PT0800.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-453",
  },
  // {
  //   name: "Cash Reveal - Credits",
  //   img: "/assets/Casino/PT0799.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Premium French Roulette",
    img: "/assets/Casino/PT0798.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-025",
  },
  {
    name: "Baccarat",
    img: "/assets/Casino/PT0797.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
  },
  // {
  //   name: "Aces and Faces Multi-hand",
  //   img: "/assets/Casino/PT0796.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "7 E Mezzo",
    img: "/assets/Casino/PT0795.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-009",
  },
  // {
  //   name: "Vegas Blackjack!",
  //   img: "/assets/Casino/PT0794.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Premium Blackjack Single Hand",
  //   img: "/assets/Casino/PT0793.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Mega Fire Blaze Roulette",
    img: "/assets/Casino/PT0792.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
  },
  // {
  //   name: "Berry Berry Bonanza",
  //   img: "/assets/Casino/PT0791.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "White King",
    img: "/assets/Casino/PT0790.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-055",
  },
  {
    name: "Tiger Claw",
    img: "/assets/Casino/PT0789.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-117",
  },
  {
    name: "Santa Surprise",
    img: "/assets/Casino/PT0788.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-145",
  },
  {
    name: "Safari Heat",
    img: "/assets/Casino/PT0787.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-143",
  },
  {
    name: "Plenty O'Fortune",
    img: "/assets/Casino/PT0786.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-080",
  },
  {
    name: "Panther Moon",
    img: "/assets/Casino/PT0785.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-129",
  },
  {
    name: "Lotto Madness",
    img: "/assets/Casino/PT0784.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-068",
  },
  {
    name: "Legacy of the Wild",
    img: "/assets/Casino/PT0783.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-072",
  },
  {
    name: "Jungle Giants",
    img: "/assets/Casino/PT0782.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-131",
  },
  {
    name: "Ice Cave",
    img: "/assets/Casino/PT0781.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-038",
  },
  {
    name: "Highway Kings",
    img: "/assets/Casino/PT0780.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-082",
  },
  {
    name: "Halloween Fortune",
    img: "/assets/Casino/PT0779.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-077",
  },
  {
    name: "Halloween Fortune 2",
    img: "/assets/Casino/PT0778.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-051",
  },
  {
    name: "Great Blue Jackpot",
    img: "/assets/Casino/PT0777.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-006",
  },
  {
    name: "Golden Tour",
    img: "/assets/Casino/PT0776.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-009",
  },
  {
    name: "Gaelic Luck",
    img: "/assets/Casino/PT0775.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-142",
  },
  {
    name: "Epic Ape",
    img: "/assets/Casino/PT0774.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-021",
  },
  {
    name: "Dragon Champions",
    img: "/assets/Casino/PT0773.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-136",
  },
  {
    name: "Dolphin Reef",
    img: "/assets/Casino/PT0772.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-040",
  },
  {
    name: "Captain's Treasure",
    img: "/assets/Casino/PT0771.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-027",
  },
  {
    name: "Buffalo Blitz",
    img: "/assets/Casino/PT0770.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
  },
  {
    name: "Bonus Bears",
    img: "/assets/Casino/PT0769.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-018",
  },
  // {
  //   name: "Age of the Gods: King of Olympus",
  //   img: "/assets/Casino/PT0768.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Age of Egypt",
    img: "/assets/Casino/PT0767.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-113",
  },
  {
    name: "A Night Out",
    img: "/assets/Casino/PT0766.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "JOKER",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-001",
  },
  // {
  //   name: "Perfect Blackjack",
  //   img: "/assets/Casino/PT0763.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "SLOTS",
  // },
  {
    name: "Cash Truck Begins",
    img: "/assets/Casino/PT0761.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-444",
  },
  {
    name: "Flip Royale",
    img: "/assets/Casino/PT0760.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-448",
  },
  {
    name: "Ten Ton Ways Stampede",
    img: "/assets/Casino/PT0759.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-445",
  },
  {
    name: "Giga Match Egypt",
    img: "/assets/Casino/PT0758.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-447",
  },
  {
    name: "Immortal Ways Volcano",
    img: "/assets/Casino/PT0757.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-446",
  },
  {
    name: "Joker Spin & Roll",
    img: "/assets/Casino/PT0756.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-443",
  },
  {
    name: "Solar Eclipse: Desert Treasure",
    img: "/assets/Casino/PT0755.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
  },
  {
    name: "Lil Demon: Blazing Lava",
    img: "/assets/Casino/PT0753.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-361",
  },
  {
    name: "J Mania Loco Habanero",
    img: "/assets/Casino/PT0750.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-432",
  },
  {
    name: "J Mania 3 Buffalo",
    img: "/assets/Casino/PT0749.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-437",
  },
  {
    name: "Immortal Ways Gallina Harvest",
    img: "/assets/Casino/PT0748.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-435",
  },
  {
    name: "Lil Demon: Double Heat",
    img: "/assets/Casino/PT0747.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-438",
  },
  {
    name: "Oink Oink Oink: Pharaohs™",
    img: "/assets/Casino/PT0746.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-440",
  },
  {
    name: "Cash It Multiplayer: Double Heat™",
    img: "/assets/Casino/PT0744.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "SLOTS",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-438",
  },

  // Dragoonsoft
  {
    name: "Great Lion",
    img: "/assets/Casino/DS001.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-013",
  },
  {
    name: "777",
    img: "/assets/Casino/DS002.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
  },
  {
    name: "Wonderful Christmas",
    img: "/assets/Casino/DS003.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-072",
  },
  {
    name: "Golf",
    img: "/assets/Casino/DS005.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-026",
  },
  {
    name: "Pirate King",
    img: "/assets/Casino/DS006.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-010",
  },
  {
    name: "Farm Family",
    img: "/assets/Casino/DS007.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-051",
  },
  {
    name: "Big Diamond",
    img: "/assets/Casino/DS008.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-053",
  },
  {
    name: "Dancing Samba",
    img: "/assets/Casino/DS009.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Bounty Clash",
    img: "/assets/Casino/DS010.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-084",
  },
  {
    name: "Stone Haminid",
    img: "/assets/Casino/DS013.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Fushen Coming",
    img: "/assets/Casino/DS014.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-037",
  },
  {
    name: "Coin Cat",
    img: "/assets/Casino/DS015.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-001",
  },
  {
    name: "Diamond Mogul",
    img: "/assets/Casino/DS016.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
  },
  {
    name: "T-Rex",
    img: "/assets/Casino/DS017.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-031",
  },
  {
    name: "Jin Houye",
    img: "/assets/Casino/DS018.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Phoenix",
    img: "/assets/Casino/DS019.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
  },
  {
    name: "Over Drangon's Gate",
    img: "/assets/Casino/DS020.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Rich Lion",
    img: "/assets/Casino/DS021.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-018",
  },
  {
    name: "Midas Touch",
    img: "/assets/Casino/DS022.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-033",
  },
  {
    name: "Fortune Twins",
    img: "/assets/Casino/DS023.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-077",
  },
  {
    name: "Wolf Legend",
    img: "/assets/Casino/DS025.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-024",
  },
  {
    name: "Zeus",
    img: "/assets/Casino/DS026.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-028",
  },
  {
    name: "Neko Treasures",
    img: "/assets/Casino/DS027.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-089",
  },
  {
    name: "Maya King",
    img: "/assets/Casino/DS029.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-009",
  },
  {
    name: "Buffalo Burst",
    img: "/assets/Casino/DS030.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-065",
  },
  {
    name: "Grand Sheriff",
    img: "/assets/Casino/DS031.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-068",
  },
  {
    name: "Volcanic Legend",
    img: "/assets/Casino/DS032.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-086",
  },
  {
    name: "Zhen Long Ju Bao",
    img: "/assets/Casino/DS033.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-083",
  },
  {
    name: "Get High",
    img: "/assets/Casino/DS034.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-022",
  },
  {
    name: "Tiger Lord",
    img: "/assets/Casino/DS035.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-027",
  },
  {
    name: "Immortal Heroes",
    img: "/assets/Casino/DS036.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-045",
  },
  {
    name: "Chicken Dinner",
    img: "/assets/Casino/DS037.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-050",
  },
  {
    name: "Egypt Dynasty",
    img: "/assets/Casino/DS038.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-055",
  },
  {
    name: "Candy Dynasty",
    img: "/assets/Casino/DS040.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-017",
  },
  {
    name: "Booming Gems",
    img: "/assets/Casino/DS041.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-042",
  },
  {
    name: "Ultra Treasure",
    img: "/assets/Casino/DS045.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-014",
  },
  {
    name: "Rich Dragon",
    img: "/assets/Casino/DS046.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-035",
  },
  {
    name: "Bust Treasury",
    img: "/assets/Casino/DS047.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-020",
  },
  {
    name: "Zhao Yun",
    img: "/assets/Casino/DS048.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-040",
  },
  {
    name: "Mahjong Win",
    img: "/assets/Casino/DS049.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-075",
  },
  {
    name: "Golf2",
    img: "/assets/Casino/DS050.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-073",
  },
  {
    name: "5 God Beast",
    img: "/assets/Casino/DS052.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-021",
  },
  {
    name: "Coin Rat",
    img: "/assets/Casino/DS053.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-046",
  },
  {
    name: "King's Sword",
    img: "/assets/Casino/DS054.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-070",
  },
  {
    name: "Overlord & Concubine",
    img: "/assets/Casino/DS055.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-069",
  },
  {
    name: "Monkey King",
    img: "/assets/Casino/DS056.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-019",
  },
  {
    name: "Lu Ling Qi",
    img: "/assets/Casino/DS057.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-041",
  },
  {
    name: "Many Beauties",
    img: "/assets/Casino/DS058.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-043",
  },
  {
    name: "Get Money",
    img: "/assets/Casino/DS059.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
  },
  {
    name: "Bakufu Shogun",
    img: "/assets/Casino/DS060.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-062",
  },
  {
    name: "Midas Hand",
    img: "/assets/Casino/DS061.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Lucky Bunny",
    img: "/assets/Casino/DS062.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-085",
  },
  {
    name: "Doggy Wealth",
    img: "/assets/Casino/DS064.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-007",
  },
  {
    name: "Ore Power",
    img: "/assets/Casino/DS065.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-047",
  },
  {
    name: "Icy Bar",
    img: "/assets/Casino/DS066.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-048",
  },
  {
    name: "Roman",
    img: "/assets/Casino/DS067.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-052",
  },
  {
    name: "Rich Ox",
    img: "/assets/Casino/DS068.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-059",
  },
  {
    name: "Dracula",
    img: "/assets/Casino/DS071.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
  },
  {
    name: "Super Hoo Hey How",
    img: "/assets/Casino/DS072.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Diamond 7",
    img: "/assets/Casino/DS074.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-060",
  },
  {
    name: "Party Night",
    img: "/assets/Casino/DS075.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-071",
  },
  {
    name: "Odin Territory",
    img: "/assets/Casino/DS076.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-082",
  },
  {
    name: "Crystal Fruits",
    img: "/assets/Casino/DS077.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-025",
  },
  {
    name: "Greatest Circus",
    img: "/assets/Casino/DS078.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-032",
  },
  {
    name: "Dragon's Treasure",
    img: "/assets/Casino/DS079.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-056",
  },
  {
    name: "Dragonburst",
    img: "/assets/Casino/DS080.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-064",
  },
  {
    name: "Much Richer",
    img: "/assets/Casino/DS081.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
  },
  {
    name: "Caishen Coming",
    img: "/assets/Casino/DS083.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-016",
  },
  {
    name: "Arab",
    img: "/assets/Casino/DS084.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-023",
  },
  {
    name: "Fire Ball Blaze Phoenix",
    img: "/assets/Casino/DS085.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-080",
  },
  {
    name: "Egypt Oracle",
    img: "/assets/Casino/DS087.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-015",
  },
  {
    name: "Fruits Bar",
    img: "/assets/Casino/DS088.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-034",
  },
  {
    name: "Worldie",
    img: "/assets/Casino/DS089.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-067",
  },
  {
    name: "Triple Monkey",
    img: "/assets/Casino/DS091.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-039",
  },
  {
    name: "Muay Thai",
    img: "/assets/Casino/DS092.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-054",
  },
  {
    name: "You Will Win",
    img: "/assets/Casino/DS093.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-057",
  },
  {
    name: "Roll in Money",
    img: "/assets/Casino/DS094.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-066",
  },
  {
    name: "Pandaria",
    img: "/assets/Casino/DS099.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-038",
  },
  {
    name: "Red Dragon’s Treasure",
    img: "/assets/Casino/DS101.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-087",
  },
  {
    name: "Alice",
    img: "/assets/Casino/DS105.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-029",
  },
  {
    name: "Rich Now",
    img: "/assets/Casino/DS106.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
  },
  {
    name: "Chef Lady",
    img: "/assets/Casino/DS107.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-006",
  },
  {
    name: "Bengal Tiger",
    img: "/assets/Casino/DS108.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-063",
  },
  {
    name: "Halloween Win",
    img: "/assets/Casino/DS109.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-074",
  },
  {
    name: "More Beauties",
    img: "/assets/Casino/DS111.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-044",
  },
  {
    name: "Bonus Cat",
    img: "/assets/Casino/DS112.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-061",
  },
  {
    name: "Mahjong Win 2",
    img: "/assets/Casino/DS113.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-088",
  },
  {
    name: "Golden Eye",
    img: "/assets/Casino/DS114.webp",
    vendor: "/assets/Platform/dragoon.png",
    platForm: "DS",
    type: "SLOTS",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-049",
  },

  // CG

  {
    name: "Aladdin",
    img: "/assets/Casino/CG001.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-077",
  },
  {
    name: "Aladdin2",
    img: "/assets/Casino/CG002.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-087",
  },
  {
    name: "Alice",
    img: "/assets/Casino/CG003.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-068",
  },
  {
    name: "Angry Birds",
    img: "/assets/Casino/CG004.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-018",
  },
  {
    name: "Arcadia",
    img: "/assets/Casino/CG005.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-023",
  },
  {
    name: "Artificial Girl",
    img: "/assets/Casino/CG006.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-064",
  },
  {
    name: "As The Gods Will",
    img: "/assets/Casino/CG007.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-026",
  },
  {
    name: "Astronaut",
    img: "/assets/Casino/CG008.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-019",
  },
  {
    name: "WarShip Girls",
    img: "/assets/Casino/CG009.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-058",
  },
  {
    name: "Black Sheep",
    img: "/assets/Casino/CG010.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-053",
  },
  {
    name: "Richman",
    img: "/assets/Casino/CG011.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-001",
  },
  {
    name: "Richman Crash",
    img: "/assets/Casino/CG012.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-016",
  },
  {
    name: "Rich Runner",
    img: "/assets/Casino/CG013.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-004",
  },
  {
    name: "RoosterFightingClub",
    img: "/assets/Casino/CG014.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-023",
  },
  {
    name: "Rugby World Cup",
    img: "/assets/Casino/CG015.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-088",
  },
  {
    name: "Seven Lucky God",
    img: "/assets/Casino/CG016.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-050",
  },
  {
    name: "Dragon Game Poker",
    img: "/assets/Casino/CG017.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-003",
  },
  {
    name: "Six Lions",
    img: "/assets/Casino/CG018.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-052",
  },
  {
    name: "Special Chef",
    img: "/assets/Casino/CG020.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-035",
  },
  {
    name: "Street Fighter 6",
    img: "/assets/Casino/CG022.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-022",
  },
  {
    name: "Street Fighter V",
    img: "/assets/Casino/CG023.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-009",
  },
  {
    name: "Sun Quest",
    img: "/assets/Casino/CG024.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-044",
  },
  {
    name: "Taiko Master",
    img: "/assets/Casino/CG025.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-055",
  },
  {
    name: "Tai Wang Si Shen",
    img: "/assets/Casino/CG026.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-005",
  },
  {
    name: "Tarzan",
    img: "/assets/Casino/CG027.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-029",
  },
  {
    name: "TEKKEN7",
    img: "/assets/Casino/CG028.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-025",
  },
  {
    name: "Travel Frog",
    img: "/assets/Casino/CG029.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-061",
  },
  {
    name: "777",
    img: "/assets/Casino/CG030.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-021",
  },
  {
    name: "Tropical Island",
    img: "/assets/Casino/CG031.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-076",
  },
  {
    name: "PUBG",
    img: "/assets/Casino/CG032.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-091",
  },
  {
    name: "BreakAway",
    img: "/assets/Casino/CG033.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-006",
  },
  {
    name: "True Zhao Cai Jin Bao",
    img: "/assets/Casino/CG034.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-047",
  },
  {
    name: "Zhao Cai Jin Bao",
    img: "/assets/Casino/CG041.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-039",
  },
  {
    name: "Pikachu Volleyball",
    img: "/assets/Casino/CG035.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-011",
  },
  {
    name: "City Of Poli",
    img: "/assets/Casino/CG036.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-024",
  },
  {
    name: "War Hammer 40K",
    img: "/assets/Casino/CG037.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-060",
  },
  {
    name: "2024Weightlifting",
    img: "/assets/Casino/CG039.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-032",
  },
  {
    name: "Wu Lu Cai Shen",
    img: "/assets/Casino/CG040.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-036",
  },
  {
    name: "Zhao Cai Tong Zi",
    img: "/assets/Casino/CG042.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-038",
  },
  {
    name: "Bean Stalk",
    img: "/assets/Casino/CG043.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-082",
  },
  {
    name: "Zombie Hunter",
    img: "/assets/Casino/CG044.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-063",
  },
  {
    name: "Benz BMW",
    img: "/assets/Casino/CG045.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-007",
  },
  {
    name: "Bingo Baccarat",
    img: "/assets/Casino/CG046.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-024",
  },
  {
    name: "Speed Racing",
    img: "/assets/Casino/CG047.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-032",
  },
  {
    name: "Captain Tsubasa",
    img: "/assets/Casino/CG048.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-013",
  },
  {
    name: "Chaoji 8",
    img: "/assets/Casino/CG049.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-022",
  },
  {
    name: "Chinese New Year",
    img: "/assets/Casino/CG050.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-083",
  },
  {
    name: "Amazing Circus",
    img: "/assets/Casino/CG051.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-004",
  },
  {
    name: "CrossyRoad Crash",
    img: "/assets/Casino/CG052.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-017",
  },
  {
    name: "Crossy Road",
    img: "/assets/Casino/CG053.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-062",
  },
  {
    name: "2024CyclingTrack",
    img: "/assets/Casino/CG054.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-028",
  },
  {
    name: "Deuces Wild",
    img: "/assets/Casino/CG055.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-002",
  },
  {
    name: "Diamond Slot",
    img: "/assets/Casino/CG056.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-030",
  },
  {
    name: "DragonBallXV2",
    img: "/assets/Casino/CG057.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-033",
  },
  {
    name: "Dragon Skies",
    img: "/assets/Casino/CG058.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-025",
  },
  {
    name: "5Treasures",
    img: "/assets/Casino/CG059.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "88Fortunes",
    img: "/assets/Casino/CG060.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "DancingDrum",
    img: "/assets/Casino/CG061.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "DiamondEternity",
    img: "/assets/Casino/CG062.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "FlowerOfRiches",
    img: "/assets/Casino/CG063.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Lost in Egypt",
    img: "/assets/Casino/CG064.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-079",
  },
  {
    name: "Scarab",
    img: "/assets/Casino/CG065.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-089",
  },
  {
    name: "Electro Rebel",
    img: "/assets/Casino/CG066.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-095",
  },
  {
    name: "Evil Cat",
    img: "/assets/Casino/CG067.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-094",
  },
  {
    name: "Fa Fa Fa",
    img: "/assets/Casino/CG068.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-020",
  },
  {
    name: "Falling Sakura",
    img: "/assets/Casino/CG069.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-065",
  },
  {
    name: "50 Lions",
    img: "/assets/Casino/CG070.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-031",
  },
  {
    name: "Fishing Expert",
    img: "/assets/Casino/CG071.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-037",
  },
  {
    name: "Fish Party",
    img: "/assets/Casino/CG072.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-041",
  },
  {
    name: "Wu Zi Ci Mile",
    img: "/assets/Casino/CG073.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-051",
  },
  {
    name: "5 Dragons",
    img: "/assets/Casino/CG074.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-045",
  },
  {
    name: "5 Dealers",
    img: "/assets/Casino/CG075.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-049",
  },
  {
    name: "Good Fortune",
    img: "/assets/Casino/CG077.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-092",
  },
  {
    name: "Fox Spirit",
    img: "/assets/Casino/CG078.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-081",
  },
  {
    name: "Funky Monkey",
    img: "/assets/Casino/CG079.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-018",
  },
  {
    name: "Geisha",
    img: "/assets/Casino/CG080.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-075",
  },
  {
    name: "Great Blue",
    img: "/assets/Casino/CG081.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-090",
  },
  {
    name: "Halloween",
    img: "/assets/Casino/CG082.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-003",
  },
  {
    name: "Halloween Party",
    img: "/assets/Casino/CG083.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-096",
  },
  {
    name: "2024Hockey2024",
    img: "/assets/Casino/CG084.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-029",
  },
  {
    name: "Horizon",
    img: "/assets/Casino/CG085.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-084",
  },
  {
    name: "Hungry Hungry Shark",
    img: "/assets/Casino/CG086.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-027",
  },
  {
    name: "Ice Storm",
    img: "/assets/Casino/CG087.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-085",
  },
  {
    name: "JOJO",
    img: "/assets/Casino/CG088.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-020",
  },
  {
    name: "Blooming Riches",
    img: "/assets/Casino/CG089.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Eternal Diamond",
    img: "/assets/Casino/CG090.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Fountain Of Wealth",
    img: "/assets/Casino/CG091.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Golden Tale",
    img: "/assets/Casino/CG092.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Rhythm Of Fortune",
    img: "/assets/Casino/CG093.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Jump Force",
    img: "/assets/Casino/CG094.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-021",
  },
  {
    name: "Jurassic Park",
    img: "/assets/Casino/CG095.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-002",
  },
  {
    name: "Kart Crash",
    img: "/assets/Casino/CG096.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-015",
  },
  {
    name: "Queen Of Cash",
    img: "/assets/Casino/CG097.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-042",
  },
  {
    name: "Kings Queen",
    img: "/assets/Casino/CG098.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-006",
  },
  {
    name: "KOFXV",
    img: "/assets/Casino/CG099.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-012",
  },
  {
    name: "New Get Rich",
    img: "/assets/Casino/CG100.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-034",
  },
  {
    name: "Lion Dance",
    img: "/assets/Casino/CG101.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-066",
  },
  {
    name: "Little Mary",
    img: "/assets/Casino/CG102.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-008",
  },
  {
    name: "Long Long Long",
    img: "/assets/Casino/CG103.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-019",
  },
  {
    name: "Lost City Of Gold",
    img: "/assets/Casino/CG104.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-086",
  },
  {
    name: "Love and Thunder",
    img: "/assets/Casino/CG105.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-097",
  },
  {
    name: "Lucky5",
    img: "/assets/Casino/CG106.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-001",
  },
  {
    name: "Lucky Pig",
    img: "/assets/Casino/CG107.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-046",
  },
  {
    name: "Lucky Twins",
    img: "/assets/Casino/CG108.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-043",
  },
  {
    name: "Magic Candy",
    img: "/assets/Casino/CG109.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-074",
  },
  {
    name: "Maple Story",
    img: "/assets/Casino/CG110.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-054",
  },
  {
    name: "Mariokart 8",
    img: "/assets/Casino/CG111.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-014",
  },
  {
    name: "Infinity War",
    img: "/assets/Casino/CG112.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-059",
  },
  {
    name: "Marvel Tsum Tsum",
    img: "/assets/Casino/CG113.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-033",
  },
  {
    name: "Might Magic",
    img: "/assets/Casino/CG114.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-073",
  },
  {
    name: "Military",
    img: "/assets/Casino/CG115.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-072",
  },
  {
    name: "Tomb",
    img: "/assets/Casino/CG116.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-069",
  },
  {
    name: "Money Farm",
    img: "/assets/Casino/CG117.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-048",
  },
  {
    name: "Money Farm 3",
    img: "/assets/Casino/CG118.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-040",
  },
  {
    name: "NARUTO4",
    img: "/assets/Casino/CG119.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-026",
  },
  {
    name: "Ninja Warrior",
    img: "/assets/Casino/CG120.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-080",
  },
  {
    name: "Odin",
    img: "/assets/Casino/CG121.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-078",
  },
  {
    name: "Onmyoji",
    img: "/assets/Casino/CG122.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-056",
  },
  {
    name: "Pig Racing",
    img: "/assets/Casino/CG123.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-005",
  },
  {
    name: "Pirates",
    img: "/assets/Casino/CG125.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-057",
  },
  {
    name: "Bright & Abyss",
    img: "/assets/Casino/CG126.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-067",
  },
  {
    name: "Plinko",
    img: "/assets/Casino/CG127.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-010",
  },
  {
    name: "Jo ma ji",
    img: "/assets/Casino/CG128.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-028",
  },
  {
    name: "POPMART",
    img: "/assets/Casino/CG129.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-093",
  },
  {
    name: "Platinum",
    img: "/assets/Casino/CG130.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-012",
  },
  {
    name: "2024Volleyball",
    img: "/assets/Casino/CG035.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "EGAME",
    casinoType: "CG-EGAME-031",
  },
  {
    name: "Slam Dunk",
    img: "/assets/Casino/CG131.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-098",
  },
  {
    name: "Football Star ITP",
    img: "/assets/Casino/CG132.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
  },
  {
    name: "Cricket Star ITP",
    img: "/assets/Casino/CG133.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-100",
  },
  {
    name: "Basketball Star ITP",
    img: "/assets/Casino/CG134.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-101",
  },
  {
    name: "Treasure Frog",
    img: "/assets/Casino/CG135.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-102",
  },
  {
    name: "TrialByViking",
    img: "/assets/Casino/CG136.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-103",
  },
  {
    name: "BAKI",
    img: "/assets/Casino/CG137.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-104",
  },
  {
    name: "Kimba",
    img: "/assets/Casino/CG138.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-105",
  },
  {
    name: "Dragon Black Gold",
    img: "/assets/Casino/CG139.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-106",
  },
  {
    name: "EPICAPE",
    img: "/assets/Casino/CG140.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-107",
  },
  {
    name: "Kleo Patra",
    img: "/assets/Casino/CG141.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-108",
  },
  {
    name: "Atocha Treasure",
    img: "/assets/Casino/CG142.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-109",
  },
  {
    name: "Case Closed",
    img: "/assets/Casino/CG143.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-110",
  },
  {
    name: "TreasureIsland",
    img: "/assets/Casino/CG144.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-111",
  },
  {
    name: "Gold Musa I",
    img: "/assets/Casino/CG145.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-112",
  },
  {
    name: "Chinese Halloween",
    img: "/assets/Casino/CG146.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-113",
  },
  {
    name: "Gold Meow Sushi Legend",
    img: "/assets/Casino/CG147.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-114",
  },
  {
    name: "The Wizard of OZ",
    img: "/assets/Casino/CG148.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-115",
  },
  {
    name: "Mystic Witch",
    img: "/assets/Casino/CG149.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-116",
  },
  {
    name: "Gold Aynu",
    img: "/assets/Casino/CG150.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-117",
  },
  {
    name: "Pharaoh Resort Hotel",
    img: "/assets/Casino/CG151.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-118",
  },
  {
    name: "DJ Remix",
    img: "/assets/Casino/CG152.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-119",
  },
  {
    name: "Triple Monkey",
    img: "/assets/Casino/CG153.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-120",
  },
  {
    name: "Mystic Nine",
    img: "/assets/Casino/CG154.webp",
    vendor: "/assets/Platform/cg.png",
    platForm: "CG",
    type: "SLOTS",
    platFormCode: "CG",
    gameType: "SLOT",
    casinoType: "CG-SLOT-121",
  },

  // LADYLUCK
  {
    name: "Lucky Heaven",
    img: "/assets/Casino/LL01.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-003",
  },
  {
    name: "Orango Tango",
    img: "/assets/Casino/LL03.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-004",
  },
  {
    name: "Quartz SiO2",
    img: "/assets/Casino/LL04.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-006",
  },
  {
    name: "SpinJoy Society Megaways",
    img: "/assets/Casino/LL06.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-009",
  },
  {
    name: "Total Summer Bliss",
    img: "/assets/Casino/LL07.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-010",
  },
  {
    name: "Valhöll Wild Hammers",
    img: "/assets/Casino/LL08.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-011",
  },
  {
    name: "Valley of the Muses",
    img: "/assets/Casino/LL09.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-012",
  },
  {
    name: "Weight of the Gun",
    img: "/assets/Casino/LL10.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-013",
  },
  {
    name: "Cuddles Royal",
    img: "/assets/Casino/LL11.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-002",
  },
  {
    name: "Cherry Supreme",
    img: "/assets/Casino/LL12.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-001",
  },
  {
    name: "Spinjoy Society",
    img: "/assets/Casino/LL13.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-008",
  },
  {
    name: "The treasures of Tizoc",
    img: "/assets/Casino/LL14.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-016",
  },
  {
    name: "Lucky Mr Wild",
    img: "/assets/Casino/LL15.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-018",
  },
  {
    name: "Mr. Alchemister",
    img: "/assets/Casino/LL16.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-019",
  },
  {
    name: "Madame Clues",
    img: "/assets/Casino/LL17.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-020",
  },
  {
    name: "Astro Anna",
    img: "/assets/Casino/LL18.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-015",
  },
  {
    name: "Popeye",
    img: "/assets/Casino/LL19.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-005",
  },
  {
    name: "Ruler of Egypt",
    img: "/assets/Casino/LL05.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-007",
  },
  {
    name: "Xmas at the Cabin",
    img: "/assets/Casino/LL02.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-014",
  },
  {
    name: "Valhöll Hall of the Slain",
    img: "/assets/Casino/LL23.webp",
    vendor: "/assets/Platform/ladyluck.png",
    platForm: "LADYLUCK",
    type: "SLOTS",
    platFormCode: "LADYLUCK",
    gameType: "SLOT",
    casinoType: "LADYLUCK-SLOT-017",
  },

  // PLAY8

  {
    name: "A Night Out",
    img: "/assets/Casino/P801.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-015",
  },
  {
    name: "Big Prosperity",
    img: "/assets/Casino/P802.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-023",
  },
  {
    name: "Big Shot",
    img: "/assets/Casino/P803.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-013",
  },
  {
    name: "Captain Treasure",
    img: "/assets/Casino/P804.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-012",
  },
  {
    name: "Cherry Love",
    img: "/assets/Casino/P805.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-010",
  },
  {
    name: "Dolphin Reef",
    img: "/assets/Casino/P806.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-006",
  },
  {
    name: "Dragon Gold",
    img: "/assets/Casino/P807.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-022",
  },
  {
    name: "Emperor Gate",
    img: "/assets/Casino/P808.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-017",
  },
  {
    name: "Fortune",
    img: "/assets/Casino/P809.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-021",
  },
  {
    name: "Golden Slut",
    img: "/assets/Casino/P810.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-025",
  },
  {
    name: "Great Blue",
    img: "/assets/Casino/P811.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-003",
  },
  {
    name: "Highroad Kings JP",
    img: "/assets/Casino/P812.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-007",
  },
  {
    name: "Ice Land",
    img: "/assets/Casino/P813.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-018",
  },
  {
    name: "Jin Qian Wa",
    img: "/assets/Casino/P814.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-004",
  },
  {
    name: "Ocean King",
    img: "/assets/Casino/P815.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "FH",
    casinoType: "P8-FISH-001",
  },
  {
    name: "CrazyMonkey",
    img: "/assets/Casino/P816.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-029",
  },
  {
    name: "Jungle",
    img: "/assets/Casino/P817.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-030",
  },
  {
    name: "Ocean",
    img: "/assets/Casino/P818.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-031",
  },
  {
    name: "Pyramid",
    img: "/assets/Casino/P819.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-032",
  },
  {
    name: "SangoWarlord",
    img: "/assets/Casino/P821.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-034",
  },
  {
    name: "Pan Jin Lian",
    img: "/assets/Casino/P822.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-005",
  },
  {
    name: "Panther Moon",
    img: "/assets/Casino/P823.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-001",
  },
  {
    name: "Safari Heat",
    img: "/assets/Casino/P825.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-002",
  },
  {
    name: "Sea Captain",
    img: "/assets/Casino/P826.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-014",
  },
  {
    name: "Silent Samurai",
    img: "/assets/Casino/P827.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-009",
  },
  {
    name: "Super Lucky Cat",
    img: "/assets/Casino/P828.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-027",
  },
  {
    name: "Tally Ho",
    img: "/assets/Casino/P829.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-020",
  },
  {
    name: "Thai Paradise",
    img: "/assets/Casino/P830.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-011",
  },
  {
    name: "The Discovery",
    img: "/assets/Casino/P831.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-008",
  },
  {
    name: "T-Rex",
    img: "/assets/Casino/P832.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-019",
  },
  {
    name: "Triple Twister",
    img: "/assets/Casino/P833.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-016",
  },
  {
    name: "White King",
    img: "/assets/Casino/P834.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-024",
  },
  {
    name: "Wong Choy",
    img: "/assets/Casino/P835.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-028",
  },
  {
    name: "Rich Mouse",
    img: "/assets/Casino/P836.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-026",
  },
  {
    name: "Qin",
    img: "/assets/Casino/P837.webp",
    vendor: "/assets/Platform/play8.png",
    platForm: "PLAY8",
    type: "SLOTS",
    platFormCode: "PLAY8",
    gameType: "SLOT",
    casinoType: "P8-SLOT-033",
  },

  // ILU

  {
    name: "Jungle",
    img: "/assets/Casino/ILU01.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-001",
  },
  {
    name: "Crazy Monkey",
    img: "/assets/Casino/ILU02.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-002",
  },
  {
    name: "Qin",
    img: "/assets/Casino/ILU03.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-003",
  },
  {
    name: "Ocean",
    img: "/assets/Casino/ILU04.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-004",
  },
  {
    name: "Pyramid",
    img: "/assets/Casino/ILU05.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-005",
  },
  {
    name: "Pirate Ship",
    img: "/assets/Casino/ILU06.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-006",
  },
  {
    name: "Sango",
    img: "/assets/Casino/ILU07.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-008",
  },
  {
    name: "Christmas",
    img: "/assets/Casino/ILU08.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-009",
  },
  {
    name: "Aladdin",
    img: "/assets/Casino/ILU09.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-010",
  },
  {
    name: "White Snake",
    img: "/assets/Casino/ILU10.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-011",
  },
  {
    name: "Thai Paradise",
    img: "/assets/Casino/ILU11.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-012",
  },
  {
    name: "Sparta",
    img: "/assets/Casino/ILU13.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-014",
  },
  {
    name: "God Of Fortune",
    img: "/assets/Casino/ILU14.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-015",
  },
  {
    name: "Safari Heat",
    img: "/assets/Casino/ILU15.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-016",
  },
  {
    name: "Panther Moon",
    img: "/assets/Casino/ILU16.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-017",
  },
  {
    name: "Great Blue",
    img: "/assets/Casino/ILU17.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-018",
  },
  {
    name: "Beans Talk",
    img: "/assets/Casino/ILU18.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-020",
  },
  {
    name: "Money Bang Bang",
    img: "/assets/Casino/ILU19.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-021",
  },
  {
    name: "Dolphin Reef",
    img: "/assets/Casino/ILU20.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-022",
  },
  {
    name: "Three Kingdoms",
    img: "/assets/Casino/ILU21.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-023",
  },
  {
    name: "A Night Out",
    img: "/assets/Casino/ILU22.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-024",
  },
  {
    name: "Golden Lotus",
    img: "/assets/Casino/ILU23.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-025",
  },
  {
    name: "Penguin Vacation",
    img: "/assets/Casino/ILU24.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-026",
  },
  {
    name: "Highway Kings JP",
    img: "/assets/Casino/ILU25.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-027",
  },
  {
    name: "Robin Hood",
    img: "/assets/Casino/ILU26.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-028",
  },
  {
    name: "Monkey King slot",
    img: "/assets/Casino/ILU27.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-029",
  },
  {
    name: "God Of Wealth2",
    img: "/assets/Casino/ILU28.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-030",
  },
  {
    name: "Fortune Panda",
    img: "/assets/Casino/ILU29.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-031",
  },
  {
    name: "Hercules",
    img: "/assets/Casino/ILU30.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-032",
  },
  {
    name: "Queen",
    img: "/assets/Casino/ILU31.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-033",
  },
  {
    name: "African Wildilfe",
    img: "/assets/Casino/ILU32.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-034",
  },
  {
    name: "Laura",
    img: "/assets/Casino/ILU33.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-035",
  },
  {
    name: "Seasons Greetings",
    img: "/assets/Casino/ILU34.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-036",
  },
  {
    name: "Fortune God",
    img: "/assets/Casino/ILU36.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-039",
  },
  {
    name: "Dragon Fortune",
    img: "/assets/Casino/ILU37.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-040",
  },
  {
    name: "Beer Party",
    img: "/assets/Casino/ILU38.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-041",
  },
  {
    name: "Legend Of Nezha",
    img: "/assets/Casino/ILU39.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-042",
  },
  {
    name: "Fortune Fuwa",
    img: "/assets/Casino/ILU40.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-043",
  },
  {
    name: "Fortune Tiger",
    img: "/assets/Casino/ILU41.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-044",
  },
  {
    name: "Master Ninja",
    img: "/assets/Casino/ILU43.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-063",
  },
  {
    name: "Ocean Quest",
    img: "/assets/Casino/ILU44.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-060",
  },
  {
    name: "Gold Train",
    img: "/assets/Casino/ILU45.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-059",
  },
  {
    name: "Storm Estate",
    img: "/assets/Casino/ILU46.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-050",
  },
  {
    name: "Assassin",
    img: "/assets/Casino/ILU47.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-049",
  },
  {
    name: "Queen Of Egypt",
    img: "/assets/Casino/ILU48.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-045",
  },
  {
    name: "Might Of Zeus",
    img: "/assets/Casino/ILU50.webp",
    vendor: "/assets/Platform/iloveu.png",
    platForm: "ILU",
    type: "SLOTS",
    platFormCode: "ILOVEU",
    gameType: "SLOT",
    casinoType: "ILOVEU-SLOT-046",
  },

  // {
  //   name: "Treasure of Atlantis",
  //   img: "/assets/Casino/NS0061.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Win Win Neko",
  //   img: "/assets/Casino/NS0060.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  //   platFormCode: "FC",
  //   gameType: "SLOT",
  //   casinoType: "FC-SLOT-030",
  // },
  // {
  //   name: "Royal Gem Match",
  //   img: "/assets/Casino/NS0059.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Prosperity Snake",
  //   img: "/assets/Casino/NS0058.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Zeus Mighty Wealth",
  //   img: "/assets/Casino/NS0057.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Blue Phantom",
  //   img: "/assets/Casino/NS0056.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Legend of Guan Gong",
  //   img: "/assets/Casino/NS0055.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Prosperity Dragon",
  //   img: "/assets/Casino/NS0054.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Mahjong Dragon",
  //   img: "/assets/Casino/NS0053.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Mahjong Phoenix",
  //   img: "/assets/Casino/NS0052.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Princess of Ra",
  //   img: "/assets/Casino/NS0051.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Aztec Gold Treasure",
  //   img: "/assets/Casino/NS0050.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Lightning Dragon",
  //   img: "/assets/Casino/NS0049.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Golden War",
  //   img: "/assets/Casino/NS0048.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Roma II",
  //   img: "/assets/Casino/NS0047.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Big Cai Shen",
  //   img: "/assets/Casino/NS0046.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Golden Fa",
  //   img: "/assets/Casino/NS0044.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Candy Bonanza Xmas",
  //   img: "/assets/Casino/NS0043.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Roma",
  //   img: "/assets/Casino/NS0042.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  //   platFormCode: "SPADE",
  //   gameType: "SLOT",
  //   casinoType: "SG-SLOT-102",
  // },
  // {
  //   name: "Donki Kong",
  //   img: "/assets/Casino/NS0041.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Ocean Chest",
  //   img: "/assets/Casino/NS0040.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Soccer King",
  //   img: "/assets/Casino/NS0039.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Fruit Tycoon",
  //   img: "/assets/Casino/NS0038.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Fortune Toad",
  //   img: "/assets/Casino/NS0037.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Ricky Tycoon",
  //   img: "/assets/Casino/NS0036.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Sweet Lava",
  //   img: "/assets/Casino/NS0035.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Candy Bonanza",
  //   img: "/assets/Casino/NS0034.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  //   platFormCode: "PG",
  //   gameType: "SLOT",
  //   casinoType: "PG-SLOT-074",
  // },
  // {
  //   name: "Golden West",
  //   img: "/assets/Casino/NS0033.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Forest Secret",
  //   img: "/assets/Casino/NS0032.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Dolphin Dive",
  //   img: "/assets/Casino/NS0031.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Princess of Crime",
  //   img: "/assets/Casino/NS0030.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Twinkle Ice",
  //   img: "/assets/Casino/NS0029.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Eternal Fire",
  //   img: "/assets/Casino/NS0028.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Hot Smash",
  //   img: "/assets/Casino/NS0027.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Lightning Woman",
  //   img: "/assets/Casino/NS0026.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Buffalo King",
  //   img: "/assets/Casino/NS0025.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  //   platFormCode: "PP",
  //   gameType: "SLOT",
  //   casinoType: "PP-SLOT-062",
  // },
  // {
  //   name: "5 Fortune Stars",
  //   img: "/assets/Casino/NS0024.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Honey 888",
  //   img: "/assets/Casino/NS0023.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Shake Thai Thai",
  //   img: "/assets/Casino/NS0022.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Monkey Jump",
  //   img: "/assets/Casino/NS0021.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Taiga 88",
  //   img: "/assets/Casino/NS0020.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "7 Dragons",
  //   img: "/assets/Casino/NS0019.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Super Fortune",
  //   img: "/assets/Casino/NS0018.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Triple Monkey",
  //   img: "/assets/Casino/NS0017.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  //   platFormCode: "PT",
  //   gameType: "SLOT",
  //   casinoType: "PT-SLOT-001",
  // },
  // {
  //   name: "Lucky Gems",
  //   img: "/assets/Casino/NS0016.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Crazy Monkey Deluxe",
  //   img: "/assets/Casino/NS0015.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Dragon Blitz",
  //   img: "/assets/Casino/NS0014.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
  // {
  //   name: "Maya Quest",
  //   img: "/assets/Casino/NS00131.webp",
  //   vendor: "/assets/Platform/NS-COLOR.webp",
  //   platForm: "NEXTSPIN",
  //   type: "SLOTS",
  // },
];

export const SlotNew = [
  {
    name: "888",
    img: "/assets/Slot/SG-SLOT-069.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-069",
    platFormCode: "SPADE",
  },
  {
    name: "Mega7",
    img: "/assets/Old/SG-SLOT-074.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-074",
    platFormCode: "SPADE",
  },
  {
    name: "DoubleFlame",
    img: "/assets/Old/SG-SLOT-076.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-076",
    platFormCode: "SPADE",
  },
  {
    name: "Triple Panda",
    img: "/assets/Old/SG-SLOT-081.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-081",
    platFormCode: "SPADE",
  },
  {
    name: "Book of Myth",
    img: "/assets/Old/SG-SLOT-077.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-077",
    platFormCode: "SPADE",
  },
  {
    name: "JokersTreasure",
    img: "/assets/Old/SG-SLOT-075.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-075",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Panther",
    img: "/assets/Old/SG-SLOT-082.webp",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-082",
    platFormCode: "SPADE",
  },
  {
    name: "Burglar",
    img: "/assets/Old/JDB-SLOT-001.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-001",
    platFormCode: "JDB",
  },
  {
    name: "Chef Doeuvre",
    img: "/assets/Old/JDB-SLOT-003.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-003",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Miner",
    img: "/assets/Old/JDB-SLOT-004.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-004",
    platFormCode: "JDB",
  },
  {
    name: "Candy Land",
    img: "/assets/Old/JDB-SLOT-005.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-005",
    platFormCode: "JDB",
  },
  {
    name: "Crazy Scientist",
    img: "/assets/Old/JDB-SLOT-006.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-006",
    platFormCode: "JDB",
  },
  {
    name: "Cash Man",
    img: "/assets/Old/JDB-SLOT-008.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-008",
    platFormCode: "JDB",
  },
  {
    name: "Wild Beauty",
    img: "/assets/Old/JDB-SLOT-009.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Qilin",
    img: "/assets/Old/JDB-SLOT-015.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-015",
    platFormCode: "JDB",
  },
  {
    name: "Dancing Pa Pa",
    img: "/assets/Old/JDB-SLOT-021.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-021",
    platFormCode: "JDB",
  },
  {
    name: "Dragon King",
    img: "/assets/Old/JDB-SLOT-022.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-022",
    platFormCode: "JDB",
  },
  {
    name: "Magic Show",
    img: "/assets/Old/JDB-SLOT-023.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-023",
    platFormCode: "JDB",
  },
  {
    name: "Cock Fight",
    img: "/assets/Old/JDB-SLOT-024.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-024",
    platFormCode: "JDB",
  },
  {
    name: "Guan Gong",
    img: "/assets/Old/JDB-SLOT-030.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-030",
    platFormCode: "JDB",
  },
  {
    name: "Curvy Magician",
    img: "/assets/Old/JDB-SLOT-034.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-034",
    platFormCode: "JDB",
  },
  {
    name: "RollingIn Money",
    img: "/assets/Old/JDB-SLOT-035.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-035",
    platFormCode: "JDB",
  },
  {
    name: "Chef Panda",
    img: "/assets/Old/JDB-SLOT-036.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-036",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Lion",
    img: "/assets/Old/JDB-SLOT-046.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-046",
    platFormCode: "JDB",
  },
  {
    name: "Coffeeholics",
    img: "/assets/Old/JDB-SLOT-047.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-047",
    platFormCode: "JDB",
  },
  {
    name: "Flirting Scholar Tang II",
    img: "/assets/Old/JDB-SLOT-052.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-052",
    platFormCode: "JDB",
  },
  {
    name: "Panda Panda",
    img: "/assets/Old/JDB-SLOT-055.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-055",
    platFormCode: "JDB",
  },
  {
    name: "Zelda",
    img: "/assets/Old/JDB-SLOT-056.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-056",
    platFormCode: "JDB",
  },
  {
    name: "Mr Bao",
    img: "/assets/Old/JDB-SLOT-057.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-057",
    platFormCode: "JDB",
  },
  {
    name: "One Punch Man",
    img: "/assets/Old/JDB-SLOT-058.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-058",
    platFormCode: "JDB",
  },
  {
    name: "Guardians of The Galaxy",
    img: "/assets/Old/JDB-SLOT-059.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-059",
    platFormCode: "JDB",
  },
  {
    name: "Street Fighter",
    img: "/assets/Old/JDB-SLOT-060.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-060",
    platFormCode: "JDB",
  },
  {
    name: "Star Wars",
    img: "/assets/Old/JDB-SLOT-061.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-061",
    platFormCode: "JDB",
  },
  {
    name: "War of Beauty",
    img: "/assets/Old/JDB-SLOT-062.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-062",
    platFormCode: "JDB",
  },
  {
    name: "Daji",
    img: "/assets/Old/JDB-SLOT-063.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-063",
    platFormCode: "JDB",
  },
  {
    name: "Poker King",
    img: "/assets/Old/JDB-SLOT-064.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-064",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Racing",
    img: "/assets/Old/JDB-SLOT-065.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-065",
    platFormCode: "JDB",
  },
  {
    name: "Gems Gems",
    img: "/assets/Old/JDB-SLOT-068.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-068",
    platFormCode: "JDB",
  },
  {
    name: "Egypt Treasure",
    img: "/assets/Old/JDB-SLOT-071.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-071",
    platFormCode: "JDB",
  },
  {
    name: "Mjoinir",
    img: "/assets/Old/JDB-SLOT-074.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-074",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Fuwa",
    img: "/assets/Old/JDB-SLOT-079.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-079",
    platFormCode: "JDB",
  },
  {
    name: "Inca Empire",
    img: "/assets/Old/JDB-SLOT-080.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-080",
    platFormCode: "JDB",
  },
  {
    name: "Ninja Rush",
    img: "/assets/Old/JDB-SLOT-081.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-081",
    platFormCode: "JDB",
  },
  {
    name: "Sun Archer",
    img: "/assets/Old/JDB-SLOT-082.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-082",
    platFormCode: "JDB",
  },
  {
    name: "Mystery of Nine Tales",
    img: "/assets/Old/JDB-SLOT-083.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-083",
    platFormCode: "JDB",
  },
  {
    name: "Pop Pop Fruity",
    img: "/assets/Old/JDB-SLOT-088.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-088",
    platFormCode: "JDB",
  },
  {
    name: "Jungle Jungle",
    img: "/assets/Old/JDB-SLOT-091.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-091",
    platFormCode: "JDB",
  },
  {
    name: "NinjaX",
    img: "/assets/Old/JDB-SLOT-095.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-095",
    platFormCode: "JDB",
  },
  {
    name: "Rex Brothers",
    img: "/assets/Old/JDB-SLOT-096.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-096",
    platFormCode: "JDB",
  },
  {
    name: "Matka India",
    img: "/assets/Old/JILI-SLOT-032.webp",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-032",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter",
    img: "/assets/Old/JILI-SLOT-045.webp",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
    platFormCode: "JILI",
  },
  {
    name: "Gem Queen",
    img: "/assets/Old/PT-SLOT-019.webp",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-019",
    platFormCode: "PT",
  },
  {
    name: "Tiger, Turtle, Dragon, Phoenix",
    img: "/assets/Old/PT-SLOT-034.webp",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-034",
    platFormCode: "PT",
  },
  {
    name: "Heart of the Jungle",
    img: "/assets/Old/PT-SLOT-035.webp",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-035",
    platFormCode: "PT",
  },
  {
    name: "Sun WuKong",
    img: "/assets/Old/PT-SLOT-048.webp",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-048",
    platFormCode: "PT",
  },
  {
    name: "Ji Xiang 8",
    img: "/assets/Old/PT-SLOT-049.webp",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-049",
    platFormCode: "PT",
  },
  {
    name: "Super Dumpling",
    img: "/assets/Old/JDB-SLOT-007.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-007",
    platFormCode: "JDB",
  },
  {
    name: "Starburst™",
    img: "/assets/Old/NETENT-SLOT-008.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-008",
    platFormCode: "NETENT",
  },
  {
    name: "Gonzo's Quest™",
    img: "/assets/Old/NETENT-SLOT-009.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-009",
    platFormCode: "NETENT",
  },
  {
    name: "Divine Fortune™ Megaways™",
    img: "/assets/Old/NETENT-SLOT-013.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-013",
    platFormCode: "NETENT",
  },
  {
    name: "Finn's Golden Tavern™",
    img: "/assets/Old/NETENT-SLOT-010.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-010",
    platFormCode: "NETENT",
  },
  {
    name: "Twin Spin™",
    img: "/assets/Old/NETENT-SLOT-018.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-018",
    platFormCode: "NETENT",
  },
  {
    name: "Jimi Hendrix Online Slot™",
    img: "/assets/Old/NETENT-SLOT-025.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-025",
    platFormCode: "NETENT",
  },
  {
    name: "Parthenon: Quest for Immortality™",
    img: "/assets/Old/NETENT-SLOT-006.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-006",
    platFormCode: "NETENT",
  },
  {
    name: "Wild Wild West: The Great Train Heist™",
    img: "/assets/Old/NETENT-SLOT-027.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-027",
    platFormCode: "NETENT",
  },
  {
    name: "Reel Rush™",
    img: "/assets/Old/NETENT-SLOT-001.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-001",
    platFormCode: "NETENT",
  },
  {
    name: "Dracula™",
    img: "/assets/Old/NETENT-SLOT-002.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-002",
    platFormCode: "NETENT",
  },
  {
    name: "Riches of Midgard: Land and Expand™",
    img: "/assets/Old/NETENT-SLOT-003.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-003",
    platFormCode: "NETENT",
  },
  {
    name: "Dark King: Forbidden Riches™",
    img: "/assets/Old/NETENT-SLOT-004.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-004",
    platFormCode: "NETENT",
  },
  {
    name: "Jungle Spirit: Call of the Wild™",
    img: "/assets/Old/NETENT-SLOT-029.png",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-029",
    platFormCode: "NETENT",
  },
  {
    name: "Crab Trap™",
    img: "/assets/Old/NETENT-SLOT-179.webp",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-179",
    platFormCode: "NETENT",
  },
  {
    name: "Thrill to Grill™",
    img: "/assets/Old/NETENT-SLOT-181.webp",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-181",
    platFormCode: "NETENT",
  },
  {
    name: "CAISHEN PARTY",
    img: "/assets/Old/JDB-EGAME-005.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    platFormCode: "JDB",
  },
  {
    name: "Happy New Year",
    img: "/assets/Old/JDB-EGAME-004.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    platFormCode: "JDB",
  },
  {
    name: "Huaguoshan Legends",
    img: "/assets/Old/JDB-EGAME-008.webp",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    platFormCode: "JDB",
  },
  {
    name: "Fantastic League",
    img: "/assets/Old/PP-EGAME-004.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-001",
    platFormCode: "PP",
  },
  {
    name: "Penalty Shootout",
    img: "/assets/Old/PP-EGAME-002.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    platFormCode: "PP",
  },
  {
    name: "Greyhound Racing",
    img: "/assets/Old/PP-EGAME-005.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    platFormCode: "PP",
  },
  {
    name: "Horse Racing",
    img: "/assets/Old/PP-EGAME-003.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-004",
    platFormCode: "PP",
  },
  {
    name: "Force 1",
    img: "/assets/Old/PP-EGAME-006.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    platFormCode: "PP",
  },
  {
    name: "Darts",
    img: "/assets/Old/PP-EGAME-007.webp",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    platFormCode: "PP",
  },
  {
    name: "Millionaire",
    img: "/assets/Old/BTG-SLOT-007.webp",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-007",
    platFormCode: "BTG",
  },
  {
    name: "Ancient Script",
    img: "/assets/Old/RT-SLOT-052.webp",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-052",
    platFormCode: "RT",
  },
  {
    name: "YesBingo",
    img: "/assets/Old/YesBingo-SLOT-031.webp",
    platForm: "YB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
    platFormCode: "YESBINGO",
  },
  {
    name: "Super Ace",
    img: "/assets/Slot/JILI-SLOT-027.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    platFormCode: "JILI",
  },
  {
    name: "Big Bass Christmas - Frozen Lake",
    img: "/assets/Slot/PP-SLOT-612.Big Bass Christmas - Frozen Lake.webp?v=1764398422437",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-612",
    platFormCode: "PP",
  },
  {
    name: "Boxing King",
    img: "/assets/Slot/JILI-SLOT-031.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace Speed",
    img: "/assets/Slot/JILI-SLOT-142.webp?v=1761895788159",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-142",
    platFormCode: "JILI",
  },
  {
    name: "Money Coming",
    img: "/assets/Slot/JILI-SLOT-029.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems",
    img: "/assets/Slot/JILI-SLOT-043.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    platFormCode: "JILI",
  },
  {
    name: "Crazy777",
    img: "/assets/Slot/JILI-SLOT-014.webp?v=1755509218609",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-014",
    platFormCode: "JILI",
  },
  {
    name: "Zeus' Lightning Power Reels",
    img: "/assets/Slot/RT-SLOT-110.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-110",
    platFormCode: "RT",
  },
  {
    name: "10,000 Wonders",
    img: "/assets/Slot/RELAX-SLOT-091.webp?v=1761884901148",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-091",
    platFormCode: "RELAX",
  },
  {
    name: "10000 BC 2 DoubleMax",
    img: "/assets/Slot/YGG-SLOT-308.webp?v=1767056428809",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-308",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "10000 BC DoubleMax",
    img: "/assets/Slot/YGG-SLOT-211.webp?v=1767056428559",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-211",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "10000 Years Before Cash",
    img: "/assets/Slot/RELAX-SLOT-248.webp?v=1761884942485",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-248",
    platFormCode: "RELAX",
  },
  {
    name: "10001 Nights",
    img: "/assets/Slot/RT-SLOT-107.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-107",
    platFormCode: "RT",
  },
  {
    name: "10x Rewind",
    img: "/assets/Slot/YGG-SLOT-081.webp?v=1767056428423",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-081",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "12 Treasures: Aztec Riches",
    img: "/assets/Slot/OCTOPLAY-SLOT-067.12 Treasures of Actec Riches.webp?v=1764929679046",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-067",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "12 Trojan Mysteries",
    img: "/assets/Slot/YGG-SLOT-067.webp?v=1767056428404",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-067",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "123 Boom!",
    img: "/assets/Slot/RELAX-SLOT-002.webp?v=1761884984096",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-002",
    platFormCode: "RELAX",
  },
  {
    name: "1942: Sky Warrior",
    img: "/assets/Slot/RT-SLOT-221.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-221",
    platFormCode: "RT",
  },
  {
    name: "1c JuFuNaCai-Blooming Riches",
    img: "/assets/Slot/CG-SLOT-016.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-016",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Eternal Diamond",
    img: "/assets/Slot/CG-SLOT-014.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-014",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Fountain Of Wealth",
    img: "/assets/Slot/CG-SLOT-015.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-015",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Golden Tale",
    img: "/assets/Slot/CG-SLOT-013.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-013",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Rhythm Of Fortune",
    img: "/assets/Slot/CG-SLOT-017.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-017",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-5Treasures",
    img: "/assets/Slot/CG-SLOT-007.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-007",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-88Fortunes",
    img: "/assets/Slot/CG-SLOT-008.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-008",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-DancingDrum",
    img: "/assets/Slot/CG-SLOT-010.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-010",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-DiamondEternity",
    img: "/assets/Slot/CG-SLOT-009.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-009",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-FlowerOfRiches",
    img: "/assets/Slot/CG-SLOT-011.webp?v=1751418030825",
    platForm: "CG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "CG-SLOT-011",
    platFormCode: "CG",
  },
  {
    name: "2 Fast 2 Fruity",
    img: "/assets/Slot/YGG-SLOT-326.webp?v=1767056428826",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-326",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "2 Sweet 4 U",
    img: "/assets/Slot/YGG-SLOT-291.webp?v=1767056428795",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-291",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "20 Times Casino",
    img: "/assets/Slot/YGG-SLOT-365.webp?v=1767056428872",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-365",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "21 Thor Lightning Ways",
    img: "/assets/Slot/RELAX-SLOT-216.webp?v=1761885013844",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-216",
    platFormCode: "RELAX",
  },
  {
    name: "24 Hour Grand Prix",
    img: "/assets/Slot/RT-SLOT-114.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-114",
    platFormCode: "RT",
  },
  {
    name: "24k Gold JailBreak",
    img: "/assets/Slot/YGG-SLOT-281.webp?v=1767056428787",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-281",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "24k Gold ShamRock On!",
    img: "/assets/Slot/YGG-SLOT-335.webp?v=1767056428834",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-335",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "28 Mansions",
    img: "/assets/Slot/PT-SLOT-186.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-186",
    platFormCode: "PT",
  },
  {
    name: "3 Bears",
    img: "/assets/Slot/RELAX-SLOT-270.webp?v=1761885041590",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-270",
    platFormCode: "RELAX",
  },
  {
    name: "3 Buzzing Wilds",
    img: "/assets/Slot/PP-SLOT-365.3-Buzzing-Wilds.webp?v=1764402281497",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-365",
    platFormCode: "PP",
  },
  {
    name: "3 Coin Golden OX",
    img: "/assets/Slot/JILI-SLOT-165.webp?v=1769054172936",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-058",
    platFormCode: "TADA",
  },
  {
    name: "3 Dancing Monkeys",
    img: "/assets/Slot/PP-SLOT-334.3-Dancing-Monkey.webp?v=1764402212166",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-334",
    platFormCode: "PP",
  },
  {
    name: "3 Energy Diamonds: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-100.Energy Diamonds Hold & Win.webp?v=1764929703134",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-100",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Genie Wishes",
    img: "/assets/Slot/PP-SLOT-133.3-Genie-Wishes.webp?v=1764402147168",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-133",
    platFormCode: "PP",
  },
  {
    name: "3 Gladiators vs Caesar",
    img: "/assets/Slot/YGG-SLOT-297.webp?v=1767056428800",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-297",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Gods Unleashed: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-120.webp?v=1767778776453",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-120",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Golden Baskets: Treasure Tides",
    img: "/assets/Slot/OCTOPLAY-SLOT-091.3 Golden Baskets Treasure Tides.webp?v=1764929721923",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-091",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Kingdoms - Battle of Red Cliffs",
    img: "/assets/Slot/PP-SLOT-126.3-Kingdoms.webp?v=1764402096729",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-126",
    platFormCode: "PP",
  },
  {
    name: "3 Lucky Leprechauns",
    img: "/assets/Slot/YGG-SLOT-182.webp?v=1767056428520",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-182",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Lucky Witches",
    img: "/assets/Slot/YGG-SLOT-222.webp?v=1767056428568",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-222",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Mummy Treasures",
    img: "/assets/Slot/JILI-SLOT-159.3 Mummy Treasures.webp?v=1764311913126",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-159",
    platFormCode: "JILI",
  },
  {
    name: "3 Pyramids of Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-088.Pyramids of Gold Hold & Win.webp?v=1764929806188",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-088",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Rail Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-114.Rail Express Hold & Win.webp?v=1764929842202",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-114",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Secret Cities",
    img: "/assets/Slot/RELAX-SLOT-059.webp?v=1761885077201",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-059",
    platFormCode: "RELAX",
  },
  {
    name: "3 Wonders Monster Pays",
    img: "/assets/Slot/YGG-SLOT-415.webp?v=1767056428923",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-415",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Wonders New year Carnival",
    img: "/assets/Slot/YGG-SLOT-322.webp?v=1767056428823",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-322",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Wonders Zoo",
    img: "/assets/Slot/YGG-SLOT-423.webp?v=1767056428931",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-423",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Crazy Cluckers",
    img: "/assets/Slot/PT-SLOT-471.4 Crazy Cluckers.webp?v=1764941193690",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-471",
    platFormCode: "PT",
  },
  {
    name: "4 Deals With The Devil",
    img: "/assets/Slot/RELAX-SLOT-138.webp?v=1761885144941",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-138",
    platFormCode: "RELAX",
  },
  {
    name: "4 Fantastic Fish",
    img: "/assets/Slot/YGG-SLOT-141.webp?v=1767056428475",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-141",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish Amazon Adventure",
    img: "/assets/Slot/YGG-SLOT-361.webp?v=1767056428869",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-361",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish Gigablox",
    img: "/assets/Slot/YGG-SLOT-241.webp?v=1767056428592",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-241",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish In Egypt",
    img: "/assets/Slot/YGG-SLOT-196.webp?v=1767056428544",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-196",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Vikings Go Fishing",
    img: "/assets/Slot/YGG-SLOT-296.webp?v=1767056428799",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-296",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Leaf Fortune: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-098.Leaf Fortune Hold & Win.webp?v=1764929906050",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-098",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "4 Secret Pyramids",
    img: "/assets/Slot/RELAX-SLOT-130.webp?v=1761885181602",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-130",
    platFormCode: "RELAX",
  },
  {
    name: "4 Squad",
    img: "/assets/Slot/RT-SLOT-111.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-111",
    platFormCode: "RT",
  },
  {
    name: "4 Wolves of Fortune",
    img: "/assets/Slot/YGG-SLOT-397.webp?v=1767056428906",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-397",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "40 Crown Hotfire",
    img: "/assets/Slot/YGG-SLOT-394.webp?v=1767056428902",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-394",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4K Ultra Gold",
    img: "/assets/Slot/YGG-SLOT-252.webp?v=1767056428757",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-252",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4TP Guns N’ Gold",
    img: "/assets/Slot/YGG-SLOT-406.webp?v=1767056428916",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-406",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Crown Hotfire",
    img: "/assets/Slot/YGG-SLOT-383.webp?v=1767056428889",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-383",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Doggy Dollars",
    img: "/assets/Slot/RELAX-SLOT-187.webp?v=1761885211705",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-187",
    platFormCode: "RELAX",
  },
  {
    name: "5 Families",
    img: "/assets/Slot/RT-SLOT-115.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-115",
    platFormCode: "RT",
  },
  {
    name: "5 Fortune SA",
    img: "/assets/Slot/SG-SLOT-030.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-030",
    platFormCode: "SPADE",
  },
  {
    name: "5 Frozen Charms Megaways",
    img: "/assets/Slot/PP-SLOT-418.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-418",
    platFormCode: "PP",
  },
  {
    name: "5 Lions",
    img: "/assets/Slot/PP-SLOT-104.5-Lions.webp?v=1764402015890",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-104",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Dance",
    img: "/assets/Slot/PP-SLOT-028.5-Lion-Dance.webp?v=1764401955657",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-028",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Gold",
    img: "/assets/Slot/PP-SLOT-080.5-Lion-Gold.webp?v=1764401898249",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-080",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Reborn",
    img: "/assets/Slot/PP-SLOT-559.webp?v=1755572137731",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-559",
    platFormCode: "PP",
  },
  {
    name: "5 Monsters",
    img: "/assets/Slot/RELAX-SLOT-192.webp?v=1761885278596",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-192",
    platFormCode: "RELAX",
  },
  {
    name: "5 Rabbits Megaways",
    img: "/assets/Slot/PP-SLOT-306.5-Rabbits-Megaways.webp?v=1764401616802",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-306",
    platFormCode: "PP",
  },
  {
    name: "5 Relics of Power: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-106.5 Relics of Power Hold & Win.webp?v=1764929922197",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-106",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "5 Rings of Darkness",
    img: "/assets/Slot/OCTOPLAY-SLOT-075.5 rings of Darkness.webp?v=1764929961059",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-075",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "5 Sevens Hold and Win",
    img: "/assets/Slot/YGG-SLOT-246.webp?v=1767056428596",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-246",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Star Coins: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-072.5 Star Coins Hold & Win.webp?v=1764930001809",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-072",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "50 Jokers Hotfire",
    img: "/assets/Slot/YGG-SLOT-262.webp?v=1767056428770",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-262",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5K Gold Mine",
    img: "/assets/Slot/RELAX-SLOT-174.webp?v=1761890083459",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-174",
    platFormCode: "RELAX",
  },
  {
    name: "6 Jokers",
    img: "/assets/Slot/PP-SLOT-477.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-477",
    platFormCode: "PP",
  },
  {
    name: "6 Wild Sharks",
    img: "/assets/Slot/RELAX-SLOT-001.webp?v=1761885411679",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-001",
    platFormCode: "RELAX",
  },
  {
    name: "60 Second Heist",
    img: "/assets/Slot/YGG-SLOT-133.webp?v=1767056428469",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-133",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7 Clovers of Fortune",
    img: "/assets/Slot/PP-SLOT-507.7 Clovers of Fortune.webp?v=1764401416161",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-507",
    platFormCode: "PP",
  },
  {
    name: "7 Elements",
    img: "/assets/Slot/RELAX-SLOT-115.webp?v=1761885484956",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-115",
    platFormCode: "RELAX",
  },
  {
    name: "7 Gold Fruits",
    img: "/assets/Slot/RELAX-SLOT-253.webp?v=1761885526190",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-253",
    platFormCode: "RELAX",
  },
  {
    name: "7 Gold Gigablox",
    img: "/assets/Slot/YGG-SLOT-166.webp?v=1767056428504",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-166",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7 Monkeys",
    img: "/assets/Slot/PP-SLOT-163.7-Monkeys.webp?v=1764401338230",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-163",
    platFormCode: "PP",
  },
  {
    name: "7 Piggies",
    img: "/assets/Slot/PP-SLOT-117.7-Piggies.webp?v=1764401273712",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-117",
    platFormCode: "PP",
  },
  {
    name: "7's Luck",
    img: "/assets/Slot/RT-SLOT-337.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-337",
    platFormCode: "RT",
  },
  {
    name: "777 FRUIT",
    img: "/assets/Slot/2J-SLOT-003.777 FRUIT.webp?v=1763551127538",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-003",
    platFormCode: "JJ",
  },
  {
    name: "777 Hot Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-055.777 Hot reels.webp?v=1764930054355",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-055",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Hot Reels: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-085.777 Hot Reels Supercharged.webp?v=1764930073726",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-085",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Streak",
    img: "/assets/Slot/OCTOPLAY-SLOT-083.777 Streak.webp?v=1764930114206",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-083",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Streak: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-123.777 Streak_ Supercharged.webp?v=1764930146368",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-123",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Strike",
    img: "/assets/Slot/RT-SLOT-103.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-103",
    platFormCode: "RT",
  },
  {
    name: "777 Super Wheel: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-121.777 Super Wheel_ Hold & Win.webp?v=1764930169851",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-121",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Volt",
    img: "/assets/Slot/YGG-SLOT-271.webp?v=1767056428778",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-271",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7x7 Zeus",
    img: "/assets/Slot/YGG-SLOT-279.webp?v=1767056428785",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-279",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Balls of Fire",
    img: "/assets/Slot/YGG-SLOT-223.webp?v=1767056428569",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-223",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Balls of Fire Blazing Bounty",
    img: "/assets/Slot/YGG-SLOT-421.webp?v=1767056428929",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-421",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Dragons",
    img: "/assets/Slot/PP-SLOT-125.8-Dragons.webp?v=1764401182645",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-125",
    platFormCode: "PP",
  },
  {
    name: "8 Golden Dragon Challenge",
    img: "/assets/Slot/PP-SLOT-379.8-Golden-Dragon-Challenge.webp?v=1764401122659",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-379",
    platFormCode: "PP",
  },
  {
    name: "80s Spins",
    img: "/assets/Slot/RT-SLOT-290.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-290",
    platFormCode: "RT",
  },
  {
    name: "888 Bonanza",
    img: "/assets/Slot/PP-SLOT-391.888-Bonanza.webp?v=1764400994862",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-391",
    platFormCode: "PP",
  },
  {
    name: "888 Dragons",
    img: "/assets/Slot/PP-SLOT-167.888 Dragons.webp?v=1764400942135",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-167",
    platFormCode: "PP",
  },
  {
    name: "8K Ultra Gold Ultimate",
    img: "/assets/Slot/YGG-SLOT-381.webp?v=1767056428887",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-381",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "9 Arrows of Odysseus",
    img: "/assets/Slot/YGG-SLOT-336.webp?v=1767056428835",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-336",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "90k Yeti Gigablox",
    img: "/assets/Slot/YGG-SLOT-073.webp?v=1767056428411",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-073",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "98 Bounty Hot 1",
    img: "/assets/Slot/RELAX-SLOT-113.webp?v=1761885559902",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-113",
    platFormCode: "RELAX",
  },
  {
    name: "9K Kong in Vegas",
    img: "/assets/Slot/RELAX-SLOT-149.webp?v=1761890173533",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-149",
    platFormCode: "RELAX",
  },
  {
    name: "9kYeti",
    img: "/assets/Slot/YGG-SLOT-001.webp?v=1767056428319",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-001",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "ARRR! 10K Ways",
    img: "/assets/Slot/YGG-SLOT-144.webp?v=1767056428478",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-144",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Abrakadabra",
    img: "/assets/Slot/RELAX-SLOT-190.webp?v=1761889964654",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-190",
    platFormCode: "RELAX",
  },
  {
    name: "Absolutely Mammoth",
    img: "/assets/Slot/PT-SLOT-155.absolutely-mammoth.webp?v=1764330658822",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-155",
    platFormCode: "PT",
  },
  {
    name: "Adventure Trail",
    img: "/assets/Slot/PT-SLOT-198.Adventure Trail.webp?v=1764326677272",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-198",
    platFormCode: "PT",
  },
  {
    name: "Adventures of Captain Cash",
    img: "/assets/Slot/YGG-SLOT-343.webp?v=1767056428840",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-343",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "African Elephant",
    img: "/assets/Slot/PP-SLOT-335.African-Elephant.webp?v=1764400799182",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-335",
    platFormCode: "PP",
  },
  {
    name: "Age Of Akkadia",
    img: "/assets/Slot/RT-SLOT-131.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-131",
    platFormCode: "RT",
  },
  {
    name: "Age of Asgard",
    img: "/assets/Slot/YGG-SLOT-040.webp?v=1767056428366",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-040",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Age of Beasts Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-129.webp?v=1767056428466",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-129",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Agent Ace",
    img: "/assets/Slot/JILI-SLOT-048.webp?v=1755509687090",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-048",
    platFormCode: "JILI",
  },
  {
    name: "Agent Royale",
    img: "/assets/Slot/RT-SLOT-112.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-112",
    platFormCode: "RT",
  },
  {
    name: "Aladdin and the Sorcerer",
    img: "/assets/Slot/PP-SLOT-065.Aladdin-and-the-Sorcerer.webp?v=1764400551941",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-065",
    platFormCode: "PP",
  },
  {
    name: "Alchemy Gold",
    img: "/assets/Slot/PG-SLOT-108.webp?v=1765933237834",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-108",
    platFormCode: "PG",
  },
  {
    name: "Alchymedes",
    img: "/assets/Slot/YGG-SLOT-029.webp?v=1767056428358",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-029",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Aldo's Journey",
    img: "/assets/Slot/YGG-SLOT-043.webp?v=1767056428370",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-043",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Alexander The Great World Conqueror",
    img: "/assets/Slot/RT-SLOT-245.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-245",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck",
    img: "/assets/Slot/RT-SLOT-247.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-247",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck Megaways",
    img: "/assets/Slot/RT-SLOT-291.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-291",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck Power Reels",
    img: "/assets/Slot/RT-SLOT-292.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-292",
    platFormCode: "RT",
  },
  {
    name: "Alibaba",
    img: "/assets/Slot/JILI-SLOT-049.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-049",
    platFormCode: "JILI",
  },
  {
    name: "Alibaba's Cave of Fortune",
    img: "/assets/Slot/PG-SLOT-167.webp?v=1765933237890",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-167",
    platFormCode: "PG",
  },
  {
    name: "Alice In Lollyland",
    img: "/assets/Slot/YGG-SLOT-333.webp?v=1767056428832",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-333",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Alice In Wonderland",
    img: "/assets/Slot/6po7ddrpokbay.Alice-In-Wonderland.webp?v=1765037367701",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-004",
    platFormCode: "JOKER",
  },
  {
    name: "Alice in Adventureland",
    img: "/assets/Slot/RELAX-SLOT-114.webp?v=1761890321596",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-114",
    platFormCode: "RELAX",
  },
  {
    name: "Amazon Island Megaways",
    img: "/assets/Slot/RT-SLOT-293.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-293",
    platFormCode: "RT",
  },
  {
    name: "American Outlaws Multimax",
    img: "/assets/Slot/YGG-SLOT-307.webp?v=1767056428808",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-307",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Anaconda Uncoiled",
    img: "/assets/Slot/PT-SLOT-103.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-103",
    platFormCode: "PT",
  },
  {
    name: "Anaconda Wild",
    img: "/assets/Slot/PT-SLOT-120.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-120",
    platFormCode: "PT",
  },
  {
    name: "Anaconda Wild II",
    img: "/assets/Slot/PT-SLOT-179.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-179",
    platFormCode: "PT",
  },
  {
    name: "Ancient Artifact",
    img: "/assets/Slot/ie9eti6w4zfcs.Ancient-Artifact.webp?v=1765041252090",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-005",
    platFormCode: "JOKER",
  },
  {
    name: "Ancient Disco",
    img: "/assets/Slot/RT-SLOT-232.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-232",
    platFormCode: "RT",
  },
  {
    name: "Ancient Eclipse",
    img: "/assets/Slot/YGG-SLOT-007.webp?v=1767056428327",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-007",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ancient Egypt",
    img: "/assets/Slot/PP-SLOT-112.Ancient-Egypt.webp?v=1764400426897",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-112",
    platFormCode: "PP",
  },
  {
    name: "Ancient Egypt Classic",
    img: "/assets/Slot/PP-SLOT-095.Ancient-Egypt-Classic.webp?v=1764400370161",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-095",
    platFormCode: "PP",
  },
  {
    name: "Ancient Rome Deluxe",
    img: "/assets/Slot/c96w4rytnamte.Ancient-Rome-Deluxe.webp?v=1765044599025",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-007",
    platFormCode: "JOKER",
  },
  {
    name: "Ancient Tumble",
    img: "/assets/Slot/RELAX-SLOT-251.webp?v=1761890346195",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-251",
    platFormCode: "RELAX",
  },
  {
    name: "Angel vs Sinner",
    img: "/assets/Slot/PP-SLOT-491.Angel-vs-Sinner.webp?v=1764400256243",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-491",
    platFormCode: "PP",
  },
  {
    name: "Animafia",
    img: "/assets/Slot/YGG-SLOT-227.webp?v=1767056428575",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-227",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Animal Carnival",
    img: "/assets/Slot/RELAX-SLOT-135.webp?v=1761890382703",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-135",
    platFormCode: "RELAX",
  },
  {
    name: "Apache Way",
    img: "/assets/Slot/RT-SLOT-187.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-187",
    platFormCode: "RT",
  },
  {
    name: "Aphrodite Goes Wild RushingWilds",
    img: "/assets/Slot/YGG-SLOT-290.webp?v=1767056428794",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-290",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Archer",
    img: "/assets/Slot/PT-SLOT-073.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-073",
    platFormCode: "PT",
  },
  {
    name: "Arctic Catch",
    img: "/assets/Slot/YGG-SLOT-233.webp?v=1767056428584",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-233",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arctic Sorcerer Gigablox",
    img: "/assets/Slot/YGG-SLOT-161.webp?v=1767056428492",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-161",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arctic Treasure",
    img: "/assets/Slot/7rw3tfwz11kaw.Arctic-Treasure.webp?v=1765036450262",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-009",
    platFormCode: "JOKER",
  },
  {
    name: "Armageddon 10K Ways",
    img: "/assets/Slot/YGG-SLOT-264.webp?v=1767056428772",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-264",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arowanas Luck",
    img: "/assets/Slot/PT-SLOT-002.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-002",
    platFormCode: "PT",
  },
  {
    name: "Arthur's Fortune",
    img: "/assets/Slot/YGG-SLOT-114.webp?v=1767056428451",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-114",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arto And The Seven Deadly Spins",
    img: "/assets/Slot/RELAX-SLOT-104.webp?v=1761890690136",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-104",
    platFormCode: "RELAX",
  },
  {
    name: "Asgard",
    img: "/assets/Slot/PP-SLOT-103.Asgard.webp?v=1764399960768",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-103",
    platFormCode: "PP",
  },
  {
    name: "Asgardian Rising",
    img: "/assets/Slot/PG-SLOT-110.webp?v=1765933237837",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-110",
    platFormCode: "PG",
  },
  {
    name: "Asian Fantasy",
    img: "/assets/Slot/PT-SLOT-043.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-043",
    platFormCode: "PT",
  },
  {
    name: "Asian Fortune",
    img: "/assets/Slot/RT-SLOT-294.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-294",
    platFormCode: "RT",
  },
  {
    name: "Atlantis Cash Collect",
    img: "/assets/Slot/PT-SLOT-097.Atlantis Cash Collect.webp?v=1764328476196",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-097",
    platFormCode: "PT",
  },
  {
    name: "Atlantis Crush",
    img: "/assets/Slot/RELAX-SLOT-252.webp?v=1761890758100",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-252",
    platFormCode: "RELAX",
  },
  {
    name: "Atlantis Megaways",
    img: "/assets/Slot/YGG-SLOT-003.webp?v=1767056428321",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-003",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Attack of the Zombees WildEnergy",
    img: "/assets/Slot/YGG-SLOT-277.webp?v=1767056428783",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-277",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Attila The Hun",
    img: "/assets/Slot/RELAX-SLOT-234.webp?v=1761890920009",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-234",
    platFormCode: "RELAX",
  },
  {
    name: "Aurum Codex",
    img: "/assets/Slot/RT-SLOT-104.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-104",
    platFormCode: "RT",
  },
  {
    name: "Aussie vs Emus",
    img: "/assets/Slot/RELAX-SLOT-219.webp?v=1761891001838",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-219",
    platFormCode: "RELAX",
  },
  {
    name: "Avatars: Gateway Guardians",
    img: "/assets/Slot/YGG-SLOT-060.webp?v=1767056428398",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-060",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Aztec Ancients",
    img: "/assets/Slot/OCTOPLAY-SLOT-001.Aztec Ancients.webp?v=1764930252695",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-001",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Aztec Blaze",
    img: "/assets/Slot/PP-SLOT-296.Aztec-Blaze.webp?v=1764399900343",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-296",
    platFormCode: "PP",
  },
  {
    name: "Aztec Bonanza",
    img: "/assets/Slot/PP-SLOT-056.Aztec-Bonanza.webp?v=1764399842776",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-056",
    platFormCode: "PP",
  },
  {
    name: "Aztec Fortune",
    img: "/assets/Slot/KM-SLOT-022.Aztec Fortune.webp?v=1764860551830",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-022",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Aztec Gems Deluxe",
    img: "/assets/Slot/PP-SLOT-035.Aztec-Gems-Deluxe.webp?v=1764399721454",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-035",
    platFormCode: "PP",
  },
  {
    name: "Aztec King",
    img: "/assets/Slot/PP-SLOT-180.Aztec-King.webp?v=1764399503184",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-180",
    platFormCode: "PP",
  },
  {
    name: "Aztec King Megaways",
    img: "/assets/Slot/PP-SLOT-198.Aztec-King-Megaways.webp?v=1764399428237",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-198",
    platFormCode: "PP",
  },
  {
    name: "Aztec Powernudge",
    img: "/assets/Slot/PP-SLOT-447.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-447",
    platFormCode: "PP",
  },
  {
    name: "Aztec Smash",
    img: "/assets/Slot/PP-SLOT-531.Aztec Smash.webp?v=1764399353647",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-531",
    platFormCode: "PP",
  },
  {
    name: "Aztec Spins",
    img: "/assets/Slot/RT-SLOT-089.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-089",
    platFormCode: "RT",
  },
  {
    name: "Aztec Temple",
    img: "/assets/Slot/6o5emdcnoqyen.Aztec-Temple.webp?v=1765049761545",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-010",
    platFormCode: "JOKER",
  },
  {
    name: "Aztec Treasure Hunt",
    img: "/assets/Slot/PP-SLOT-488.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-488",
    platFormCode: "PP",
  },
  {
    name: "Azteca",
    img: "/assets/Slot/oqt9p9876m39y.Azteca.webp?v=1765050846135",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-011",
    platFormCode: "JOKER",
  },
  {
    name: "BELL DEER",
    img: "/assets/Slot/2J-SLOT-049.BELL DEER.webp?v=1763551033521",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-049",
    platFormCode: "JJ",
  },
  {
    name: "BINGO LUCKY CLOVER",
    img: "/assets/Slot/2J-SLOT-004.BINGO LUCKY CLOVER.webp?v=1763550986461",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-004",
    platFormCode: "JJ",
  },
  {
    name: "Badge Blitz",
    img: "/assets/Slot/PP-SLOT-497.Badge-Blitz.webp?v=1764399281619",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-497",
    platFormCode: "PP",
  },
  {
    name: "Badger Miners",
    img: "/assets/Slot/YGG-SLOT-205.webp?v=1767056428555",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-205",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bagua",
    img: "/assets/Slot/gn1bc1kqj7gr4.Bagua.webp?v=1765036260606",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-012",
    platFormCode: "JOKER",
  },
  {
    name: "Bagua 2",
    img: "/assets/Slot/quofrdenycyyn.Bagua-2.webp?v=1765052057981",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-013",
    platFormCode: "JOKER",
  },
  {
    name: "Bai Shi",
    img: "/assets/Slot/PT-SLOT-122.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-122",
    platFormCode: "PT",
  },
  {
    name: "Bakery Bonanza",
    img: "/assets/Slot/PG-SLOT-115.webp?v=1765933237841",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-115",
    platFormCode: "PG",
  },
  {
    name: "Bali",
    img: "/assets/Slot/rg5oqz19mtqir.Bali.webp?v=1765046150834",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-014",
    platFormCode: "JOKER",
  },
  {
    name: "Bali Vacation",
    img: "/assets/Slot/PG-SLOT-071.webp?v=1765933237804",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-071",
    platFormCode: "PG",
  },
  {
    name: "Banana Saga",
    img: "/assets/Slot/JDB-SLOT-019.BANANA SAGA.webp?v=1765264465360",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    platFormCode: "JDB",
  },
  {
    name: "Banana Town",
    img: "/assets/Slot/RELAX-SLOT-128.webp?v=1761891036243",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-128",
    platFormCode: "RELAX",
  },
  {
    name: "Bananaz 10K Ways",
    img: "/assets/Slot/YGG-SLOT-087.webp?v=1767056428430",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-087",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bandit Megaways",
    img: "/assets/Slot/PP-SLOT-556.webp?v=1755572050025",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-556",
    platFormCode: "PP",
  },
  {
    name: "Bank Busters: The Big Score",
    img: "/assets/Slot/OCTOPLAY-SLOT-090.The Big Score.webp?v=1764930345030",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-090",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bao boon chin",
    img: "/assets/Slot/JILI-SLOT-016.webp?v=1755509249803",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-016",
    platFormCode: "JILI",
  },
  {
    name: "Barbarian Fury",
    img: "/assets/Slot/NLC-SLOT-039.Barbarian Fury.webp?v=1764392766514",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-039",
    platFormCode: "NLC",
  },
  {
    name: "Barbarossa DoubleMax",
    img: "/assets/Slot/YGG-SLOT-194.webp?v=1767056428532",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-194",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Barbarossa Revenge",
    img: "/assets/Slot/YGG-SLOT-288.webp?v=1767056428792",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-288",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Barhalla",
    img: "/assets/Slot/OCTOPLAY-SLOT-052.Barhalla.webp?v=1764930606360",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-052",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Barn Festival",
    img: "/assets/Slot/PP-SLOT-236.Barn Festival.webp?v=1764399220396",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-236",
    platFormCode: "PP",
  },
  {
    name: "Baron Samedi",
    img: "/assets/Slot/YGG-SLOT-037.webp?v=1767056428363",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-037",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bass Boss",
    img: "/assets/Slot/RT-SLOT-190.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-190",
    platFormCode: "RT",
  },
  {
    name: "Bass Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-030.Bass Smash.webp?v=1764931866545",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-030",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Battleground Royale",
    img: "/assets/Slot/PG-SLOT-099.webp?v=1765933237827",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-099",
    platFormCode: "PG",
  },
  {
    name: "Beach Life",
    img: "/assets/Slot/y6q14hdtq35ze.Beach-Life.webp?v=1765051885297",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-015",
    platFormCode: "JOKER",
  },
  {
    name: "Beanstalk Grows Wild",
    img: "/assets/Slot/RELAX-SLOT-264.webp?v=1761891067544",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-264",
    platFormCode: "RELAX",
  },
  {
    name: "Beast Mode",
    img: "/assets/Slot/RELAX-SLOT-106.webp?v=1761891143246",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-106",
    platFormCode: "RELAX",
  },
  {
    name: "Beasty Blox",
    img: "/assets/Slot/YGG-SLOT-202.webp?v=1767056428552",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-202",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Beauty And The Kingdom",
    img: "/assets/Slot/JDB-SLOT-009.beauty_and_the_kingdom.webp?v=1765264338617",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    platFormCode: "JDB",
  },
  {
    name: "Beauty and the Beast",
    img: "/assets/Slot/YGG-SLOT-030.webp?v=1767056428358",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-030",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bee Frenzy",
    img: "/assets/Slot/PT-SLOT-182.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-182",
    platFormCode: "PT",
  },
  {
    name: "Beellionaires",
    img: "/assets/Slot/RELAX-SLOT-170.webp?v=1761891172182",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-170",
    platFormCode: "RELAX",
  },
  {
    name: "Benji Killed in Vegas",
    img: "/assets/Slot/NLC-SLOT-064.Benji Killed in Vegas.webp?v=1764392647878",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-064",
    platFormCode: "NLC",
  },
  {
    name: "Beriched",
    img: "/assets/Slot/RT-SLOT-217.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-217",
    platFormCode: "RT",
  },
  {
    name: "Bermuda Triangle",
    img: "/assets/Slot/PT-SLOT-119.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-119",
    platFormCode: "PT",
  },
  {
    name: "Better Wilds",
    img: "/assets/Slot/PT-SLOT-196.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-196",
    platFormCode: "PT",
  },
  {
    name: "Betty, Boris and Boo",
    img: "/assets/Slot/RT-SLOT-142.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-142",
    platFormCode: "RT",
  },
  {
    name: "Beware The Deep Megaways",
    img: "/assets/Slot/PP-SLOT-440.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-440",
    platFormCode: "PP",
  },
  {
    name: "Bicicleta",
    img: "/assets/Slot/YGG-SLOT-026.webp?v=1767056428354",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-026",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bass Amazon Xtreme",
    img: "/assets/Slot/PP-SLOT-356.Big-Bass-Amazon-Xtreme.webp?v=1764399086439",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-356",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza",
    img: "/assets/Slot/SlotBigBassBonanza.BIG BASS BONANZA.webp?v=1764776858723",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-014",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza - Hold & Spinner",
    img: "/assets/Slot/PP-SLOT-333.Big-Bass-Hold-and-Spinner.webp?v=1764398956183",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-333",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 1000",
    img: "/assets/Slot/PP-SLOT-560.webp?v=1755572162854",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-560",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 3 Reeler",
    img: "/assets/Slot/PP-SLOT-529.Big Bass Bonanza 3 Reeler.webp?v=1764398716967",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-529",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Christmas Bash",
    img: "/assets/Slot/PP-SLOT-401.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-401",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Day at the Races",
    img: "/assets/Slot/PP-SLOT-441.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-441",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Floats My Boat",
    img: "/assets/Slot/PP-SLOT-430.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-430",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween",
    img: "/assets/Slot/PP-SLOT-389.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-389",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween 2",
    img: "/assets/Slot/PP-SLOT-504.Big Bass Halloween 2.webp?v=1764398333795",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-504",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Hold & Spinner Megaways",
    img: "/assets/Slot/PP-SLOT-376.Big Bass Hold & Spinner Megaways.webp?v=1764398170218",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-376",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Mission Fishin’",
    img: "/assets/Slot/PP-SLOT-469.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-469",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Return to the Races",
    img: "/assets/Slot/PP-SLOT-544.webp?v=1755571912491",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-544",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Secrets of the Golden Lake",
    img: "/assets/Slot/PP-SLOT-450.webp?v=1761309081519",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Splash",
    img: "/assets/Slot/PP-SLOT-261.Big-Bass-Splash.webp?v=1764397983574",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-261",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Splash 1000",
    img: "/assets/Slot/PP-SLOT-654.webp?v=1765954402894",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-654",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Vegas Double Down Deluxe",
    img: "/assets/Slot/PP-SLOT-493.Big-Bass-Vegas-Double-Down-Deluxe.webp?v=1764397926258",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-493",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Xmas Xtreme",
    img: "/assets/Slot/PP-SLOT-521.Big Bass Xmas Xtreme.webp?v=1764397858193",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-521",
    platFormCode: "PP",
  },
  {
    name: "Big Benji Bonanza",
    img: "/assets/Slot/YGG-SLOT-140.webp?v=1767056428474",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-140",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Benji's Back WildWays",
    img: "/assets/Slot/YGG-SLOT-304.webp?v=1767056428805",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-304",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Blox",
    img: "/assets/Slot/YGG-SLOT-027.webp?v=1767056428356",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-027",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Bandits MegaWays",
    img: "/assets/Slot/YGG-SLOT-005.webp?v=1767056428323",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-005",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Bandits Megaways",
    img: "/assets/Slot/RELAX-SLOT-093.webp?v=1761891200482",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-093",
    platFormCode: "RELAX",
  },
  {
    name: "Big Bucks Bison 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-273.webp?v=1761891250220",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-273",
    platFormCode: "RELAX",
  },
  {
    name: "Big Bucks Buffalo GigaBlox",
    img: "/assets/Slot/YGG-SLOT-185.webp?v=1767056428523",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-185",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Deluxe Tapcards",
    img: "/assets/Slot/BTG-SLOT-063.webp?v=1756256536975",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-063",
    platFormCode: "BTG",
  },
  {
    name: "Big Burger Load it up with Xtra Cheese",
    img: "/assets/Slot/PP-SLOT-448.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-448",
    platFormCode: "PP",
  },
  {
    name: "Big Game Fishing Golden Catch",
    img: "/assets/Slot/YGG-SLOT-357.webp?v=1767056428866",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-357",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Game Fishing TopHit",
    img: "/assets/Slot/YGG-SLOT-315.webp?v=1767056428814",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-315",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Juan",
    img: "/assets/Slot/PP-SLOT-209.Big-Juan.webp?v=1764397785692",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-209",
    platFormCode: "PP",
  },
  {
    name: "Big Prosperity SA",
    img: "/assets/Slot/SG-SLOT-021.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-021",
    platFormCode: "SPADE",
  },
  {
    name: "Big Top Terror",
    img: "/assets/Slot/YGG-SLOT-272.webp?v=1767056428779",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-272",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "BigThreeDragons",
    img: "/assets/Slot/JDB-SLOT-117.big-three-dragons.webp?v=1767691606971",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-117",
    platFormCode: "JDB",
  },
  {
    name: "Bigger Bass Blizzard - Christmas Catch",
    img: "/assets/Slot/PP-SLOT-292.Bigger-Bass-Blizzard-Christmas-Catch.webp?v=1764397663399",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-292",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Bonanza",
    img: "/assets/Slot/PP-SLOT-190.Bigger-Bass-Bonanza.webp?v=1764397592819",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-190",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Splash",
    img: "/assets/Slot/PP-SLOT-543.Bigger Bass Splash.webp?v=1764397539457",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-543",
    platFormCode: "PP",
  },
  {
    name: "Bikini Paradise",
    img: "/assets/Slot/PG-SLOT-049.webp?v=1765933237790",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-049",
    platFormCode: "PG",
  },
  {
    name: "Bill & Coin",
    img: "/assets/Slot/RELAX-SLOT-220.webp?v=1761891336948",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-220",
    platFormCode: "RELAX",
  },
  {
    name: "Billionaire",
    img: "/assets/Slot/JDB-SLOT-031.billionaire.webp?v=1765264229636",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-031",
    platFormCode: "JDB",
  },
  {
    name: "BingoFortune",
    img: "/assets/Slot/ACEWIN-SLOT-015.Bingo Fortune.webp?v=1764853864898",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-015",
    platFormCode: "ACEWIN",
  },
  {
    name: "Bison Wilds",
    img: "/assets/Slot/YGG-SLOT-284.webp?v=1767056428789",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-284",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Black Beard Legacy",
    img: "/assets/Slot/swt38osdadyhc.Black-Beard-Legacy.webp?v=1765044801712",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-018",
    platFormCode: "JOKER",
  },
  {
    name: "Black Bull",
    img: "/assets/Slot/PP-SLOT-282.Black-Bull.webp?v=1764397453321",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-282",
    platFormCode: "PP",
  },
  {
    name: "Blackbeard Battle Of The Seas",
    img: "/assets/Slot/YGG-SLOT-217.webp?v=1767056428564",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-217",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Blade & Fangs",
    img: "/assets/Slot/PP-SLOT-414.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-414",
    platFormCode: "PP",
  },
  {
    name: "Blarney's Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-002.Blarney_s Gold.webp?v=1764931916869",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-002",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Bells",
    img: "/assets/Slot/PT-SLOT-199.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-199",
    platFormCode: "PT",
  },
  {
    name: "Blazing Clusters",
    img: "/assets/Slot/RT-SLOT-172.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-172",
    platFormCode: "RT",
  },
  {
    name: "Blazing Inferno Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-076.Blazing Inferno Chaos Reels.webp?v=1765034333815",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-076",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Touch",
    img: "/assets/Slot/OCTOPLAY-SLOT-003.Blazing Touch.webp?v=1764931957224",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-003",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Wilds Megaways",
    img: "/assets/Slot/PP-SLOT-427.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-427",
    platFormCode: "PP",
  },
  {
    name: "Blender Blitz",
    img: "/assets/Slot/RELAX-SLOT-126.webp?v=1761891366782",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-126",
    platFormCode: "RELAX",
  },
  {
    name: "Blitz Super Wheel",
    img: "/assets/Slot/PP-SLOT-555.webp?v=1755572019088",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-555",
    platFormCode: "PP",
  },
  {
    name: "Blood & Shadow",
    img: "/assets/Slot/NLC-SLOT-065.Blood & Shadow.webp?v=1764392596841",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-065",
    platFormCode: "NLC",
  },
  {
    name: "Blood Moon Wilds",
    img: "/assets/Slot/YGG-SLOT-115.webp?v=1767056428452",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-115",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bloodaxe",
    img: "/assets/Slot/RELAX-SLOT-207.webp?v=1761891439828",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-207",
    platFormCode: "RELAX",
  },
  {
    name: "Bloody Pesos",
    img: "/assets/Slot/YGG-SLOT-417.webp?v=1767056428925",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-417",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Blue Wizard",
    img: "/assets/Slot/PT-SLOT-008.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-008",
    platFormCode: "PT",
  },
  {
    name: "Blue Wizard: Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-425.blue-wizard-cash-collect-&-link.webp?v=1764333105408",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-425",
    platFormCode: "PT",
  },
  {
    name: "Bob Marlin Goes Deep",
    img: "/assets/Slot/YGG-SLOT-374.webp?v=1767056428880",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-374",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Boilin' Pots",
    img: "/assets/Slot/YGG-SLOT-147.webp?v=1767056428481",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-147",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bomb Bonanza",
    img: "/assets/Slot/PP-SLOT-259.Bomb-Bonanza.webp?v=1764397356574",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-259",
    platFormCode: "PP",
  },
  {
    name: "Bombuster",
    img: "/assets/Slot/RT-SLOT-143.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-143",
    platFormCode: "RT",
  },
  {
    name: "Bonanza Gold",
    img: "/assets/Slot/PP-SLOT-015.Bonanza-Gold.webp?v=1764397293969",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-015",
    platFormCode: "PP",
  },
  {
    name: "Bonanza Tapcards",
    img: "/assets/Slot/BTG-SLOT-064.webp?v=1756256536975",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-064",
    platFormCode: "BTG",
  },
  {
    name: "Bone Fortune",
    img: "/assets/Slot/JILI-SLOT-059.webp?v=1755509815485",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-059",
    platFormCode: "JILI",
  },
  {
    name: "Bone Raiders",
    img: "/assets/Slot/RELAX-SLOT-260.webp?v=1761891471261",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-260",
    platFormCode: "RELAX",
  },
  {
    name: "Bonus Bear",
    img: "/assets/Slot/bwwza4umpbwsh.Bonus-Bear.webp?v=1765052497569",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-019",
    platFormCode: "JOKER",
  },
  {
    name: "Bonus Bunnies",
    img: "/assets/Slot/NLC-SLOT-020.Bonus Bunnies.webp?v=1764392426474",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-020",
    platFormCode: "NLC",
  },
  {
    name: "Bonus Hunter",
    img: "/assets/Slot/JILI-SLOT-062.webp?v=1755509849913",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-062",
    platFormCode: "JILI",
  },
  {
    name: "Book Extreme",
    img: "/assets/Slot/YGG-SLOT-292.webp?v=1767056428795",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-292",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book HOTFIRE",
    img: "/assets/Slot/YGG-SLOT-154.webp?v=1767056428487",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-154",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book Of Ra",
    img: "/assets/Slot/ioheiiqk3xrc1.Book-Of-Ra.webp?v=1765048845159",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-020",
    platFormCode: "JOKER",
  },
  {
    name: "Book Of Ra Deluxe",
    img: "/assets/Slot/hf5hx8w9u1q3r.Book-Of-Ra-Deluxe.webp?v=1765047029285",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-021",
    platFormCode: "JOKER",
  },
  {
    name: "Book Of Shadows",
    img: "/assets/Slot/NLC-SLOT-016.Book Of Shadows.webp?v=1764392379103",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-016",
    platFormCode: "NLC",
  },
  {
    name: "Book of 99",
    img: "/assets/Slot/RELAX-SLOT-052.webp?v=1761891500476",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-052",
    platFormCode: "RELAX",
  },
  {
    name: "Book of Aztec King",
    img: "/assets/Slot/PP-SLOT-241.Book-of-Aztec-King.webp?v=1764397242945",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-241",
    platFormCode: "PP",
  },
  {
    name: "Book of Blarney Gigablox",
    img: "/assets/Slot/YGG-SLOT-245.webp?v=1767056428596",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-245",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Books",
    img: "/assets/Slot/YGG-SLOT-183.webp?v=1767056428521",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-183",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Dead",
    img: "/assets/Slot/SlotBookOfDead.BOOK OF DEAD.webp?v=1764776789591",
    platForm: "PLAYNGO",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PLAYNGO-SLOT-017",
    platFormCode: "PLAYNGO",
  },
  {
    name: "Book of Destiny",
    img: "/assets/Slot/RELAX-SLOT-086.webp?v=1761891533481",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-086",
    platFormCode: "RELAX",
  },
  {
    name: "Book of Evil",
    img: "/assets/Slot/YGG-SLOT-286.webp?v=1767056428791",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-286",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Gold",
    img: "/assets/Slot/JILI-SLOT-053.webp?v=1755509725618",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-053",
    platFormCode: "JILI",
  },
  {
    name: "Book of Golden Sands",
    img: "/assets/Slot/PP-SLOT-288.Book-of-Golden-Sands.webp?v=1764397116626",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-288",
    platFormCode: "PP",
  },
  {
    name: "Book of Kingdoms",
    img: "/assets/Slot/PP-SLOT-023.Book-of-Kingdoms.webp?v=1764845512548",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-023",
    platFormCode: "PP",
  },
  {
    name: "Book of Kings",
    img: "/assets/Slot/PT-SLOT-202.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-202",
    platFormCode: "PT",
  },
  {
    name: "Book of Monsters",
    img: "/assets/Slot/PP-SLOT-554.webp?v=1755571999273",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-554",
    platFormCode: "PP",
  },
  {
    name: "Book of Power",
    img: "/assets/Slot/RELAX-SLOT-159.webp?v=1761891562111",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-159",
    platFormCode: "RELAX",
  },
  {
    name: "Boom the Buffoon",
    img: "/assets/Slot/OCTOPLAY-SLOT-025.Boom The Buffoon.webp?v=1764931999910",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-025",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bounty Hunter MultiBoost",
    img: "/assets/Slot/YGG-SLOT-356.webp?v=1767056428865",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-356",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bounty Hunters xNudge",
    img: "/assets/Slot/NLC-SLOT-070.Bounty Hunters xNudge.webp?v=1764392323890",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-070",
    platFormCode: "NLC",
  },
  {
    name: "Bounty Raid",
    img: "/assets/Slot/RT-SLOT-124.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-124",
    platFormCode: "RT",
  },
  {
    name: "Bounty Showdown",
    img: "/assets/Slot/RELAX-SLOT-081.webp?v=1761891602193",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-081",
    platFormCode: "RELAX",
  },
  {
    name: "Bounty Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-031.Bounty Smash.webp?v=1764932049134",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-031",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bow of Artemis",
    img: "/assets/Slot/PP-SLOT-481.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-481",
    platFormCode: "PP",
  },
  {
    name: "Boxing King Title Match",
    img: "/assets/Slot/JILI-SLOT-161.Boxing King Title Match.webp?v=1764474438046",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-161",
    platFormCode: "JILI",
  },
  {
    name: "Brazil Bomba",
    img: "/assets/Slot/YGG-SLOT-045.webp?v=1767056428372",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-045",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Breach the Vault",
    img: "/assets/Slot/PT-SLOT-354.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-354",
    platFormCode: "PT",
  },
  {
    name: "Break the Piggy Bank",
    img: "/assets/Slot/OCTOPLAY-SLOT-093.Break the Piggy Bank.webp?v=1764932074241",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-093",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Breakout",
    img: "/assets/Slot/NLC-SLOT-119.breakout.webp?v=1764392274490",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-119",
    platFormCode: "NLC",
  },
  {
    name: "Breakout Bob",
    img: "/assets/Slot/PT-SLOT-170.webp?v=1762261391898",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-170",
    platFormCode: "PT",
  },
  {
    name: "Brick House Bonanza",
    img: "/assets/Slot/PP-SLOT-534.Brick House Bonanza.webp?v=1764396785432",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-534",
    platFormCode: "PP",
  },
  {
    name: "Brothers Kingdom 2",
    img: "/assets/Slot/SG-SLOT-143.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-143",
    platFormCode: "SPADE",
  },
  {
    name: "Brute Force: Alien Onslaught",
    img: "/assets/Slot/NLC-SLOT-114.Brute Force Alien Onslaught.webp?v=1764392107732",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-114",
    platFormCode: "NLC",
  },
  {
    name: "Bubble Beauty",
    img: "/assets/Slot/JILI-SLOT-015.webp?v=1755509234342",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-015",
    platFormCode: "JILI",
  },
  {
    name: "Buccaneer Deluxe",
    img: "/assets/Slot/bsp1s4umpbwsh.Buccaneer-Deluxe.webp?v=1765042466116",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-023",
    platFormCode: "JOKER",
  },
  {
    name: "Bucks and Doe 10K Ways",
    img: "/assets/Slot/YGG-SLOT-206.webp?v=1767056428556",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-206",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buddha Spin",
    img: "/assets/Slot/ACEWIN-SLOT-029.Buddha Spin.webp?v=1764853892167",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-029",
    platFormCode: "ACEWIN",
  },
  {
    name: "Buffalo Blaze: Wild Wealth",
    img: "/assets/Slot/OCTOPLAY-SLOT-068.buffalo Blaze Wild Wealth.webp?v=1764932120422",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-068",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Blitz Cash Collect",
    img: "/assets/Slot/PT-SLOT-436.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-436",
    platFormCode: "PT",
  },
  {
    name: "Buffalo Blitz II",
    img: "/assets/Slot/PT-SLOT-017.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-017",
    platFormCode: "PT",
  },
  {
    name: "Buffalo Blow",
    img: "/assets/Slot/RELAX-SLOT-274.webp?v=1761891654030",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-274",
    platFormCode: "RELAX",
  },
  {
    name: "Buffalo Blox",
    img: "/assets/Slot/YGG-SLOT-151.webp?v=1767056428484",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-151",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buffalo Hunter",
    img: "/assets/Slot/NLC-SLOT-033.Buffalo Hunter.webp?v=1764392070831",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-033",
    platFormCode: "NLC",
  },
  {
    name: "Buffalo King",
    img: "/assets/Slot/PP-SLOT-062.Buffalo-King.webp?v=1764840375598",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-062",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King MEGAWAYS",
    img: "/assets/Slot/SlotBuffaloKing.Buffalo King MEGAWAYS.webp?v=1764776746870",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King Megaways",
    img: "/assets/Slot/PP-SLOT-176.Buffalo-King-Megaways.webp?v=1764396614073",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King Untamed Megaways",
    img: "/assets/Slot/PP-SLOT-470.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-470",
    platFormCode: "PP",
  },
  {
    name: "Buffalo Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-038.Buffalo Smash.webp?v=1764932159294",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-038",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Smash: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-097.Buffalo Smash Supercharged.webp?v=1764932191914",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-097",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Super Stars",
    img: "/assets/Slot/YGG-SLOT-352.webp?v=1767056428859",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-352",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buffalo Win",
    img: "/assets/Slot/PG-SLOT-085.webp?v=1765933237816",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-085",
    platFormCode: "PG",
  },
  {
    name: "Bugs Money",
    img: "/assets/Slot/YGG-SLOT-184.webp?v=1767056428522",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-184",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bugsy’s Bar",
    img: "/assets/Slot/RT-SLOT-235.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-235",
    platFormCode: "RT",
  },
  {
    name: "Bull Fiesta",
    img: "/assets/Slot/PP-SLOT-242.Bull-Fiesta.webp?v=1764396542562",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-242",
    platFormCode: "PP",
  },
  {
    name: "Bull Treasure",
    img: "/assets/Slot/JDB-SLOT-126.Bull Treasure.webp?v=1765263660421",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-126",
    platFormCode: "JDB",
  },
  {
    name: "Bullet Bonanza",
    img: "/assets/Slot/OCTOPLAY-SLOT-004.Bullet Bonanza.webp?v=1764932235646",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-004",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bulls Run Wild",
    img: "/assets/Slot/RT-SLOT-180.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-180",
    platFormCode: "RT",
  },
  {
    name: "Bunny VIP Night",
    img: "/assets/Slot/KM-SLOT-024.Bunny VIP Night.webp?v=1764860746591",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-024",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Burning Blox",
    img: "/assets/Slot/YGG-SLOT-220.webp?v=1767056428567",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-220",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Burning Pearl",
    img: "/assets/Slot/ur8593z8hu17w.Burning-Pearl.webp?v=1765052393983",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-024",
    platFormCode: "JOKER",
  },
  {
    name: "Burning Riot",
    img: "/assets/Slot/YGG-SLOT-346.webp?v=1767056428849",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-346",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bushido Blade",
    img: "/assets/Slot/86burqb38a9ua.Bushido-Blade.webp?v=1765054140622",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-025",
    platFormCode: "JOKER",
  },
  {
    name: "Bushido Way xNudge",
    img: "/assets/Slot/NLC-SLOT-028.Bushido Way xNudge.webp?v=1764392015727",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-028",
    platFormCode: "NLC",
  },
  {
    name: "Buster Hammer Carnival",
    img: "/assets/Slot/YGG-SLOT-008.webp?v=1767056428329",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-008",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Busy Bees",
    img: "/assets/Slot/PP-SLOT-162.Busy-Bees.webp?v=1764396487960",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-162",
    platFormCode: "PP",
  },
  {
    name: "Butterfly Blossom",
    img: "/assets/Slot/PG-SLOT-096.webp?v=1765933237825",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-096",
    platFormCode: "PG",
  },
  {
    name: "CASHPOWER MANIA",
    img: "/assets/Slot/2J-SLOT-060.CASHPOWER MANIA.webp?v=1763550924722",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-060",
    platFormCode: "JJ",
  },
  {
    name: "CHEESE CLASH",
    img: "/assets/Slot/2J-SLOT-059.CHEESE CLASH.webp?v=1763550870227",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-059",
    platFormCode: "JJ",
  },
  {
    name: "CLEOPATRA'S FLAME",
    img: "/assets/Slot/2J-SLOT-044.CLEOPATRA_S FLAME.webp?v=1763550824268",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-044",
    platFormCode: "JJ",
  },
  {
    name: "COSMIC BLITZ",
    img: "/assets/Slot/2J-SLOT-053.COSMIC BLITZ.webp?v=1763550763743",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-053",
    platFormCode: "JJ",
  },
  {
    name: "Cai Shen 168",
    img: "/assets/Slot/RT-SLOT-230.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-230",
    platFormCode: "RT",
  },
  {
    name: "Caishen Riches",
    img: "/assets/Slot/zygj7oqga9nck.Caishen-Riches.webp?v=1765053480891",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-026",
    platFormCode: "JOKER",
  },
  {
    name: "Caishen Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-032.Caishen Smash.webp?v=1764932276895",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-032",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Caishen Ways",
    img: "/assets/Slot/PT-SLOT-189.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-189",
    platFormCode: "PT",
  },
  {
    name: "Caishen Wins",
    img: "/assets/Slot/PG-SLOT-047.webp?v=1765933237788",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-047",
    platFormCode: "PG",
  },
  {
    name: "Caishen's Cash",
    img: "/assets/Slot/PP-SLOT-083.Caishen_s-Cash.webp?v=1764396359761",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-083",
    platFormCode: "PP",
  },
  {
    name: "Caishen's Gold",
    img: "/assets/Slot/PP-SLOT-121.Caishen_s-Gold.webp?v=1764396287526",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-121",
    platFormCode: "PP",
  },
  {
    name: "Caishen's Temple of Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-005.Caishen_s Temple of Gold.webp?v=1764932319720",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-005",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cake Bonanza",
    img: "/assets/Slot/ACEWIN-SLOT-025.Cake Bonanza.webp?v=1764853949300",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-025",
    platFormCode: "ACEWIN",
  },
  {
    name: "Cake and Ice Cream",
    img: "/assets/Slot/RT-SLOT-129.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-129",
    platFormCode: "RT",
  },
  {
    name: "Calavera Crush",
    img: "/assets/Slot/YGG-SLOT-158.webp?v=1767056428490",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-158",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Candy Baby",
    img: "/assets/Slot/JILI-SLOT-020.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-020",
    platFormCode: "JILI",
  },
  {
    name: "Candy Blitz",
    img: "/assets/Slot/PP-SLOT-381.Candy-Blitz.webp?v=1764396219749",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-381",
    platFormCode: "PP",
  },
  {
    name: "Candy Blitz Bombs",
    img: "/assets/Slot/PP-SLOT-453.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-453",
    platFormCode: "PP",
  },
  {
    name: "Candy Burst",
    img: "/assets/Slot/PG-SLOT-048.webp?v=1765933237789",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-048",
    platFormCode: "PG",
  },
  {
    name: "Candy Corner",
    img: "/assets/Slot/PP-SLOT-508.Candy Corner.webp?v=1764396146213",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-508",
    platFormCode: "PP",
  },
  {
    name: "Candy Pop",
    img: "/assets/Slot/SG-SLOT-001.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-001",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Stars",
    img: "/assets/Slot/PP-SLOT-281.Candy-Stars.webp?v=1764396073445",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-281",
    platFormCode: "PP",
  },
  {
    name: "Candy Village",
    img: "/assets/Slot/PP-SLOT-204.Candy-Village.webp?v=1764396020403",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-204",
    platFormCode: "PP",
  },
  {
    name: "Candyfinity",
    img: "/assets/Slot/YGG-SLOT-199.webp?v=1767056428549",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-199",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Candyland Jackpots",
    img: "/assets/Slot/OCTOPLAY-SLOT-113.Candyland Jackpots.webp?v=1764932345044",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-113",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Captain Cashmap",
    img: "/assets/Slot/YGG-SLOT-422.webp?v=1767056428930",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-422",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Captains Bounty",
    img: "/assets/Slot/PG-SLOT-034.webp?v=1765933237774",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-034",
    platFormCode: "PG",
  },
  {
    name: "Captains Treasure Progressive",
    img: "/assets/Slot/awn5jciusna5c.Captains-Treasure-PRogressive.webp?v=1765051948670",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-029",
    platFormCode: "JOKER",
  },
  {
    name: "Caravan of Riches",
    img: "/assets/Slot/RELAX-SLOT-108.webp?v=1761891695378",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-108",
    platFormCode: "RELAX",
  },
  {
    name: "Carol of the Elves",
    img: "/assets/Slot/YGG-SLOT-097.webp?v=1767056428438",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-097",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cascading Cave",
    img: "/assets/Slot/PT-SLOT-228.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-228",
    platFormCode: "PT",
  },
  {
    name: "Cash Bonanza",
    img: "/assets/Slot/PP-SLOT-201.Cash-Bonanza.webp?v=1764392670183",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-201",
    platFormCode: "PP",
  },
  {
    name: "Cash Box",
    img: "/assets/Slot/PP-SLOT-360.Cash-Box_.webp?v=1764392615948",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-360",
    platFormCode: "PP",
  },
  {
    name: "Cash Chips",
    img: "/assets/Slot/PP-SLOT-387.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-387",
    platFormCode: "PP",
  },
  {
    name: "Cash Defense",
    img: "/assets/Slot/RELAX-SLOT-181.webp?v=1761891798687",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-181",
    platFormCode: "RELAX",
  },
  {
    name: "Cash Elevator",
    img: "/assets/Slot/PP-SLOT-182.Cash-Elevator.webp?v=1764392556677",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-182",
    platFormCode: "PP",
  },
  {
    name: "Cash IT",
    img: "/assets/Slot/PT-SLOT-260.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-260",
    platFormCode: "PT",
  },
  {
    name: "Cash Inferno Sizzling Scatters",
    img: "/assets/Slot/OCTOPLAY-SLOT-048.Cash Inferno Sizzling Scatters.webp?v=1764932383099",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-048",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Maximus: Battle Arena",
    img: "/assets/Slot/OCTOPLAY-SLOT-087.Cash Maximus Battle Arena.webp?v=1764932408301",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-087",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash On Wheels: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-064.Cash on Wheels Hold and Win.webp?v=1764932448546",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-064",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Patrol",
    img: "/assets/Slot/PP-SLOT-230.Cash-Patrol.webp?v=1764392507137",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-230",
    platFormCode: "PP",
  },
  {
    name: "Cash Strike",
    img: "/assets/Slot/OCTOPLAY-SLOT-006.Cash Strike.webp?v=1764932489493",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-006",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Surge",
    img: "/assets/Slot/PP-SLOT-561.webp?v=1755572303802",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-561",
    platFormCode: "PP",
  },
  {
    name: "Cash Ultimate",
    img: "/assets/Slot/RT-SLOT-123.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-123",
    platFormCode: "RT",
  },
  {
    name: "Cash Volt",
    img: "/assets/Slot/RT-SLOT-090.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-090",
    platFormCode: "RT",
  },
  {
    name: "Cash or Nothing",
    img: "/assets/Slot/RT-SLOT-179.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-179",
    platFormCode: "RT",
  },
  {
    name: "CashKing",
    img: "/assets/Slot/ACEWIN-SLOT-030.Cash king.webp?v=1764853966005",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-030",
    platFormCode: "ACEWIN",
  },
  {
    name: "Casino Spin",
    img: "/assets/Slot/RT-SLOT-275.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-275",
    platFormCode: "RT",
  },
  {
    name: "Casino Win Spin",
    img: "/assets/Slot/NLC-SLOT-058.Casino Win Spin.webp?v=1764391956834",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-058",
    platFormCode: "NLC",
  },
  {
    name: "Castle Cash Megaways",
    img: "/assets/Slot/YGG-SLOT-334.webp?v=1767056428833",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-334",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Castle of Fire",
    img: "/assets/Slot/PP-SLOT-408.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-408",
    platFormCode: "PP",
  },
  {
    name: "Castle of Terror 2",
    img: "/assets/Slot/BTG-SLOT-069.Castle of Terror 2.webp?v=1764410060847",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-069",
    platFormCode: "BTG",
  },
  {
    name: "Cat Queen",
    img: "/assets/Slot/PT-SLOT-058.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-058",
    platFormCode: "PT",
  },
  {
    name: "Cauldron",
    img: "/assets/Slot/YGG-SLOT-014.webp?v=1767056428339",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-014",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Caveman Bob",
    img: "/assets/Slot/RELAX-SLOT-022.webp?v=1761891878037",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-022",
    platFormCode: "RELAX",
  },
  {
    name: "Cazino Cosmos",
    img: "/assets/Slot/YGG-SLOT-106.webp?v=1767056428444",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-106",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cazino Zeppelin",
    img: "/assets/Slot/YGG-SLOT-116.webp?v=1767056428453",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-116",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cazino Zeppelin Reloaded",
    img: "/assets/Slot/YGG-SLOT-126.webp?v=1767056428463",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-126",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cereal Thrillers",
    img: "/assets/Slot/YGG-SLOT-371.webp?v=1767056428878",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-371",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Champion of the Underworld Gigablox Wild Fight",
    img: "/assets/Slot/YGG-SLOT-162.webp?v=1767056428493",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-162",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Champions of Rome",
    img: "/assets/Slot/YGG-SLOT-112.webp?v=1767056428450",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-112",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chaoji 888",
    img: "/assets/Slot/PT-SLOT-023.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-023",
    platFormCode: "PT",
  },
  {
    name: "Charge Buffalo",
    img: "/assets/Slot/JILI-SLOT-026.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-026",
    platFormCode: "JILI",
  },
  {
    name: "Chase for Glory",
    img: "/assets/Slot/PP-SLOT-399.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-399",
    platFormCode: "PP",
  },
  {
    name: "Cheeky Emperor",
    img: "/assets/Slot/PP-SLOT-264.Cheeky-Emperor.webp?v=1764392402979",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-264",
    platFormCode: "PP",
  },
  {
    name: "Chests of Cai Shen",
    img: "/assets/Slot/PP-SLOT-502.Chests-of-Cai-Shen.webp?v=1764392348722",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-502",
    platFormCode: "PP",
  },
  {
    name: "Chibeasties",
    img: "/assets/Slot/YGG-SLOT-021.webp?v=1767056428347",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-021",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chicken Chase",
    img: "/assets/Slot/PP-SLOT-237.Chicken-Chase.webp?v=1764392246635",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-237",
    platFormCode: "PP",
  },
  {
    name: "Chicken Drop",
    img: "/assets/Slot/PP-SLOT-196.Chicken-Drop.webp?v=1764392196093",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-196",
    platFormCode: "PP",
  },
  {
    name: "Chili Eruption Thundershots",
    img: "/assets/Slot/PT-SLOT-100.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-100",
    platFormCode: "PT",
  },
  {
    name: "Chilli Champions UltraHitz",
    img: "/assets/Slot/YGG-SLOT-289.webp?v=1767056428793",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-289",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chilli Heat",
    img: "/assets/Slot/PP-SLOT-110.Chilli-Heat.webp?v=1764392144633",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-110",
    platFormCode: "PP",
  },
  {
    name: "Chilli Heat Megaways",
    img: "/assets/Slot/PP-SLOT-199.Chilli-Heat-Megaways.webp?v=1764392089746",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-199",
    platFormCode: "PP",
  },
  {
    name: "Chilli Hunter",
    img: "/assets/Slot/n1ydr5mncpogn.Chilli-Hunter.webp?v=1765035955294",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-030",
    platFormCode: "JOKER",
  },
  {
    name: "Chilli Xtreme",
    img: "/assets/Slot/PT-SLOT-104.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-104",
    platFormCode: "PT",
  },
  {
    name: "Chin Shi Huang",
    img: "/assets/Slot/JILI-SLOT-003.webp?v=1755507914254",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-003",
    platFormCode: "JILI",
  },
  {
    name: "China",
    img: "/assets/Slot/dkzdo35rcipfs.China.webp?v=1765036657080",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-031",
    platFormCode: "JOKER",
  },
  {
    name: "Chinese Boss",
    img: "/assets/Slot/7tccifcktqre1.Chinese-Boss.webp?v=1765043020575",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-032",
    platFormCode: "JOKER",
  },
  {
    name: "Chinese Kitchen",
    img: "/assets/Slot/PT-SLOT-060.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-060",
    platFormCode: "PT",
  },
  {
    name: "Chinese Wilds",
    img: "/assets/Slot/RT-SLOT-295.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-295",
    platFormCode: "RT",
  },
  {
    name: "Chip Spin",
    img: "/assets/Slot/RELAX-SLOT-057.webp?v=1761891911447",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-057",
    platFormCode: "RELAX",
  },
  {
    name: "Christmas Big Bass Bonanza",
    img: "/assets/Slot/PP-SLOT-211.Christmas-Big-Bass-Bonanza.webp?v=1764391956460",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-211",
    platFormCode: "PP",
  },
  {
    name: "Christmas Carol Megaways",
    img: "/assets/Slot/PP-SLOT-018.Christmas-Carol-Megaways.webp?v=1764391905822",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-018",
    platFormCode: "PP",
  },
  {
    name: "Christmas Crumble",
    img: "/assets/Slot/OCTOPLAY-SLOT-034.Christmas Crumble.webp?v=1764932530509",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-034",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Christmas Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-059.Christmas Link Express Hold & Win.webp?v=1764932572986",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-059",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Christmas Plaza DoubleMax",
    img: "/assets/Slot/YGG-SLOT-170.webp?v=1767056428508",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-170",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Christmas Santa",
    img: "/assets/Slot/RELAX-SLOT-085.webp?v=1761892173844",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-085",
    platFormCode: "RELAX",
  },
  {
    name: "Circle of Sylvan",
    img: "/assets/Slot/RELAX-SLOT-257.webp?v=1761892222591",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-257",
    platFormCode: "RELAX",
  },
  {
    name: "Circuit Shock",
    img: "/assets/Slot/PT-SLOT-352.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-352",
    platFormCode: "PT",
  },
  {
    name: "Circus Delight",
    img: "/assets/Slot/PG-SLOT-059.webp?v=1765933237796",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-059",
    platFormCode: "PG",
  },
  {
    name: "Cirque Dе La Fortune",
    img: "/assets/Slot/RT-SLOT-144.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-144",
    platFormCode: "RT",
  },
  {
    name: "Clash of the Beasts",
    img: "/assets/Slot/RT-SLOT-145.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-145",
    platFormCode: "RT",
  },
  {
    name: "CleoPatrick",
    img: "/assets/Slot/YGG-SLOT-247.webp?v=1767056428597",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-247",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cleocatra",
    img: "/assets/Slot/PP-SLOT-255.Cleocatra.webp?v=1764391852167",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-255",
    platFormCode: "PP",
  },
  {
    name: "Cleopatra’s Fortune Ways",
    img: "/assets/Slot/KM-SLOT-025.Cleopatra’s Fortune Ways.webp?v=1764860806393",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-025",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Clover Coins 4x4",
    img: "/assets/Slot/JILI-SLOT-148.Clover Coins 4x4.webp?v=1764311058321",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-148",
    platFormCode: "JILI",
  },
  {
    name: "Clover Fortunes",
    img: "/assets/Slot/RELAX-SLOT-124.webp?v=1761892257315",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-124",
    platFormCode: "RELAX",
  },
  {
    name: "Clover Gold",
    img: "/assets/Slot/PP-SLOT-251.Clover-Gold.webp?v=1764391798669",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-251",
    platFormCode: "PP",
  },
  {
    name: "Club Tropicana",
    img: "/assets/Slot/PP-SLOT-321.Club-Tropicana.webp?v=1764391746435",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-321",
    platFormCode: "PP",
  },
  {
    name: "Cluster Mania",
    img: "/assets/Slot/iw7az1sm3drhh.Cluster-Mania.webp?v=1765049706524",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-033",
    platFormCode: "JOKER",
  },
  {
    name: "Cluster Tumble",
    img: "/assets/Slot/RELAX-SLOT-094.webp?v=1761892285729",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-094",
    platFormCode: "RELAX",
  },
  {
    name: "Cobra Queen",
    img: "/assets/Slot/RT-SLOT-276.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-276",
    platFormCode: "RT",
  },
  {
    name: "Cocktail Nights",
    img: "/assets/Slot/PG-SLOT-090.webp?v=1765933237820",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-090",
    platFormCode: "PG",
  },
  {
    name: "Coffee Wild",
    img: "/assets/Slot/PP-SLOT-263.Coffee-Wild.webp?v=1764391518632",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-263",
    platFormCode: "PP",
  },
  {
    name: "Coin Bang Bang: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-111.Coin Bang Bang Hold & Win.webp?v=1764932592830",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-111",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Coin Infinity",
    img: "/assets/Slot/JILI-SLOT-122.webp?v=1755510869140",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-122",
    platFormCode: "JILI",
  },
  {
    name: "Coins of Fortune",
    img: "/assets/Slot/NLC-SLOT-056.Coins of Fortune.webp?v=1764391894826",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-056",
    platFormCode: "NLC",
  },
  {
    name: "Colossal Cash Zone",
    img: "/assets/Slot/PP-SLOT-232.Colossal Cash Zone.webp?v=1764391463566",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-232",
    platFormCode: "PP",
  },
  {
    name: "Columbus",
    img: "/assets/Slot/aij68ciusna5c.Columbus.webp?v=1765051211805",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-034",
    platFormCode: "JOKER",
  },
  {
    name: "Congo Cash",
    img: "/assets/Slot/PP-SLOT-009.Congo-Cash.webp?v=1764391413306",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-009",
    platFormCode: "PP",
  },
  {
    name: "Congo Cash XL",
    img: "/assets/Slot/PP-SLOT-494.Congo-Cash-XL.webp?v=1764391352840",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-494",
    platFormCode: "PP",
  },
  {
    name: "CooCoo Farm",
    img: "/assets/Slot/JDB-SLOT-112.coocoo-farm.webp?v=1767691582025",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-112",
    platFormCode: "JDB",
  },
  {
    name: "Cosmic Cash",
    img: "/assets/Slot/PP-SLOT-258.Cosmic-Cash.webp?v=1764391297899",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-258",
    platFormCode: "PP",
  },
  {
    name: "Cosmic Drop",
    img: "/assets/Slot/YGG-SLOT-420.webp?v=1767056428928",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-420",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cotton Gang Affair",
    img: "/assets/Slot/RT-SLOT-277.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-277",
    platFormCode: "RT",
  },
  {
    name: "Cowabunga",
    img: "/assets/Slot/RELAX-SLOT-258.webp?v=1761892313667",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-258",
    platFormCode: "RELAX",
  },
  {
    name: "Cowboy Coins",
    img: "/assets/Slot/PP-SLOT-339.Cowboy-Coins.webp?v=1764391244953",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-339",
    platFormCode: "PP",
  },
  {
    name: "Cowboys Gold",
    img: "/assets/Slot/PP-SLOT-019.Cowboys-Gold.webp?v=1764391193123",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-019",
    platFormCode: "PP",
  },
  {
    name: "Crab Chaos",
    img: "/assets/Slot/YGG-SLOT-380.webp?v=1767056428886",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-380",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Crack the Pumpkin Bank",
    img: "/assets/Slot/OCTOPLAY-SLOT-122.Crack the Pumpkin Bank.webp?v=1764932611948",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-122",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Crank It Up",
    img: "/assets/Slot/PP-SLOT-474.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-474",
    platFormCode: "PP",
  },
  {
    name: "Crazy 7",
    img: "/assets/Slot/PT-SLOT-124.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-124",
    platFormCode: "PT",
  },
  {
    name: "Crazy FaFaFa",
    img: "/assets/Slot/JILI-SLOT-017.webp?v=1755509264855",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Pusher",
    img: "/assets/Slot/JILI-SLOT-054.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-054",
    platFormCode: "JILI",
  },
  {
    name: "Critter Mania Deluxe",
    img: "/assets/Slot/zowjitp4zqhm1.Critter-Mania-deluxe.webp?v=1765048279649",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-035",
    platFormCode: "JOKER",
  },
  {
    name: "Crop of the Dead",
    img: "/assets/Slot/OCTOPLAY-SLOT-057.Crop of The Dead.webp?v=1764932648567",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-057",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Crown of Fire",
    img: "/assets/Slot/PP-SLOT-284.Crown-of-Fire.webp?v=1764391137544",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-284",
    platFormCode: "PP",
  },
  {
    name: "Crypto Gold",
    img: "/assets/Slot/PG-SLOT-072.webp?v=1765933237805",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-072",
    platFormCode: "PG",
  },
  {
    name: "Cryptomania",
    img: "/assets/Slot/4akkze7ywgukq.Crypto-mania.webp?v=1765042271376",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-036",
    platFormCode: "JOKER",
  },
  {
    name: "Crystal 777 DELUXE",
    img: "/assets/Slot/JILI-SLOT-128.webp?v=1755510914395",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-128",
    platFormCode: "JILI",
  },
  {
    name: "Crystal Caverns Megaways",
    img: "/assets/Slot/PP-SLOT-221.Crystal-Caverns-Megaways.webp?v=1764391083571",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-221",
    platFormCode: "PP",
  },
  {
    name: "Crystal Falls",
    img: "/assets/Slot/YGG-SLOT-075.webp?v=1767056428415",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-075",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Crystal Golem",
    img: "/assets/Slot/RELAX-SLOT-087.webp?v=1761892340024",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-087",
    platFormCode: "RELAX",
  },
  {
    name: "Crystal Mirror",
    img: "/assets/Slot/RT-SLOT-134.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-134",
    platFormCode: "RT",
  },
  {
    name: "Crystal Towers",
    img: "/assets/Slot/BTG-SLOT-062.webp?v=1756256536974",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-062",
    platFormCode: "BTG",
  },
  {
    name: "Cthulhu",
    img: "/assets/Slot/YGG-SLOT-123.webp?v=1767056428461",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-123",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Curse of Anubis",
    img: "/assets/Slot/PT-SLOT-150.Curse-of-Anubis.webp?v=1765032994731",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-150",
    platFormCode: "PT",
  },
  {
    name: "Curse of Ra",
    img: "/assets/Slot/RELAX-SLOT-245.webp?v=1761892376799",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-245",
    platFormCode: "RELAX",
  },
  {
    name: "Curse of the Mummies",
    img: "/assets/Slot/RELAX-SLOT-125.webp?v=1761892427331",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-125",
    platFormCode: "RELAX",
  },
  {
    name: "Curse of the Werewolf Megaways",
    img: "/assets/Slot/PP-SLOT-033.Curse-of-the-Werewolf-Megaways.webp?v=1764391030069",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-033",
    platFormCode: "PP",
  },
  {
    name: "Cursed Deluxe",
    img: "/assets/Slot/ue8mt39rhzpps.Cursed-Deluxe.webp?v=1765053061265",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-037",
    platFormCode: "JOKER",
  },
  {
    name: "Cyber Attack",
    img: "/assets/Slot/RT-SLOT-256.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-256",
    platFormCode: "RT",
  },
  {
    name: "Cyber Doom",
    img: "/assets/Slot/YGG-SLOT-404.webp?v=1767056428915",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-404",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cyber Race",
    img: "/assets/Slot/nqyun5dpcjtsy.Cyber-Race.webp?v=1765050556292",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-038",
    platFormCode: "JOKER",
  },
  {
    name: "Cyber Vault",
    img: "/assets/Slot/RELAX-SLOT-224.webp?v=1761892455322",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-224",
    platFormCode: "RELAX",
  },
  {
    name: "Cyclops Smash",
    img: "/assets/Slot/PP-SLOT-375.Cyclops-Smash.webp?v=1764390979655",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-375",
    platFormCode: "PP",
  },
  {
    name: "DJ Neko",
    img: "/assets/Slot/PP-SLOT-636.DJ Neko.webp?v=1764840283321",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-636",
    platFormCode: "PP",
  },
  {
    name: "DRAGON & TIGER",
    img: "/assets/Slot/2J-SLOT-022.DRAGON & TIGER.webp?v=1763550711308",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-022",
    platFormCode: "JJ",
  },
  {
    name: "Da Vinci's Mystery",
    img: "/assets/Slot/RT-SLOT-146.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-146",
    platFormCode: "RT",
  },
  {
    name: "Da Vinci's Treasure",
    img: "/assets/Slot/PP-SLOT-098.Da-Vincis-Treasure.webp?v=1764390891519",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-098",
    platFormCode: "PP",
  },
  {
    name: "Dance Party",
    img: "/assets/Slot/PP-SLOT-051.Dance-Party.webp?v=1764390805887",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-051",
    platFormCode: "PP",
  },
  {
    name: "Danger High Voltage 2",
    img: "/assets/Slot/BTG-SLOT-056.webp?v=1756256536968",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-056",
    platFormCode: "BTG",
  },
  {
    name: "Darkness",
    img: "/assets/Slot/RELAX-SLOT-204.webp?v=1761892507263",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-204",
    platFormCode: "RELAX",
  },
  {
    name: "Das xBoot",
    img: "/assets/Slot/NLC-SLOT-001.Das xBoot.webp?v=1764391697996",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-001",
    platFormCode: "NLC",
  },
  {
    name: "Dawn of Anubis",
    img: "/assets/Slot/YGG-SLOT-342.webp?v=1767056428839",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-342",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Day of Dead",
    img: "/assets/Slot/PP-SLOT-203.Day-of-Dead.webp?v=1764390759966",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-203",
    platFormCode: "PP",
  },
  {
    name: "Dazzle Me™ Christmas",
    img: "/assets/Slot/NETENT-SLOT-224.dazzle-me-christmas.webp?v=1764961419269",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-224",
    platFormCode: "NETENT",
  },
  {
    name: "Dead Canary",
    img: "/assets/Slot/NLC-SLOT-009.webp?v=1762002940648",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-009",
    platFormCode: "NLC",
  },
  {
    name: "Dead Man's Trail",
    img: "/assets/Slot/RELAX-SLOT-065.webp?v=1761892636041",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-065",
    platFormCode: "RELAX",
  },
  {
    name: "Dead Mans Fingers",
    img: "/assets/Slot/YGG-SLOT-132.webp?v=1767056428468",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-132",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dead Men Walking",
    img: "/assets/Slot/NLC-SLOT-118.dead men walking.webp?v=1764391580695",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-118",
    platFormCode: "NLC",
  },
  {
    name: "Dead Riders Trail",
    img: "/assets/Slot/RELAX-SLOT-134.webp?v=1761892674718",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-134",
    platFormCode: "RELAX",
  },
  {
    name: "Dead West",
    img: "/assets/Slot/NETENT-SLOT-232.Dead West.webp?v=1764961355861",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-232",
    platFormCode: "NETENT",
  },
  {
    name: "Dead or Alive 2™ Feature Buy",
    img: "/assets/Slot/NETENT-SLOT-005.Dead-or-Alive-2-Feature-Buy.webp?v=1764961270469",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-005",
    platFormCode: "NETENT",
  },
  {
    name: "Deadly West",
    img: "/assets/Slot/YGG-SLOT-370.webp?v=1767056428877",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-370",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Deadwood xNudge",
    img: "/assets/Slot/NLC-SLOT-010.Deadwood xNudge.webp?v=1764391390616",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-010",
    platFormCode: "NLC",
  },
  {
    name: "Deep Descent",
    img: "/assets/Slot/RELAX-SLOT-061.webp?v=1761892715863",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-061",
    platFormCode: "RELAX",
  },
  {
    name: "Defenders of Mystica",
    img: "/assets/Slot/YGG-SLOT-225.webp?v=1767056428571",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-225",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Demon Pots",
    img: "/assets/Slot/PP-SLOT-393.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-393",
    platFormCode: "PP",
  },
  {
    name: "Desert Legends",
    img: "/assets/Slot/RT-SLOT-257.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-257",
    platFormCode: "RT",
  },
  {
    name: "Desert Shark",
    img: "/assets/Slot/RELAX-SLOT-073.webp?v=1761892745628",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-073",
    platFormCode: "RELAX",
  },
  {
    name: "Desert Treasure",
    img: "/assets/Slot/PT-SLOT-066.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
    platFormCode: "PT",
  },
  {
    name: "Desperate Dawgs",
    img: "/assets/Slot/YGG-SLOT-012.webp?v=1767056428336",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-012",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Desperate Dawgs 2 Gigablox",
    img: "/assets/Slot/YGG-SLOT-165.webp?v=1767056428503",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-165",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Destiny of sun and moon",
    img: "/assets/Slot/PG-SLOT-095.webp?v=1765933237824",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-095",
    platFormCode: "PG",
  },
  {
    name: "Devil Wilds",
    img: "/assets/Slot/PT-SLOT-262.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-262",
    platFormCode: "PT",
  },
  {
    name: "Devil's 13",
    img: "/assets/Slot/PP-SLOT-160.Devil_s-13.webp?v=1764390697533",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-160",
    platFormCode: "PP",
  },
  {
    name: "Devilicious",
    img: "/assets/Slot/PP-SLOT-466.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-466",
    platFormCode: "PP",
  },
  {
    name: "Devil’s Delight",
    img: "/assets/Slot/YGG-SLOT-410.webp?v=1767056428919",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-410",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Devour the Weak",
    img: "/assets/Slot/YGG-SLOT-191.webp?v=1767056428529",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-191",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dia De Los Muertos Deluxe",
    img: "/assets/Slot/b6nuk4djp3zsa.Dia_De_Los_Muertos_Deluxe_.webp?v=1765054446761",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-039",
    platFormCode: "JOKER",
  },
  {
    name: "Diamond Blitz",
    img: "/assets/Slot/RT-SLOT-133.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-133",
    platFormCode: "RT",
  },
  {
    name: "Diamond Cascade",
    img: "/assets/Slot/PP-SLOT-367.Diamond-Cascade.webp?v=1764390621550",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-367",
    platFormCode: "PP",
  },
  {
    name: "Diamond Delirium",
    img: "/assets/Slot/YGG-SLOT-331.webp?v=1767056428830",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-331",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamond Match",
    img: "/assets/Slot/PT-SLOT-267.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-267",
    platFormCode: "PT",
  },
  {
    name: "Diamond Match Deluxe",
    img: "/assets/Slot/PT-SLOT-360.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-360",
    platFormCode: "PT",
  },
  {
    name: "Diamond Miner DuoMax",
    img: "/assets/Slot/YGG-SLOT-260.webp?v=1767056428767",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-260",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamond Rise",
    img: "/assets/Slot/PT-SLOT-088.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-088",
    platFormCode: "PT",
  },
  {
    name: "Diamond Royale",
    img: "/assets/Slot/RT-SLOT-183.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-183",
    platFormCode: "RT",
  },
  {
    name: "Diamond Strike",
    img: "/assets/Slot/PP-SLOT-118.Diamond-Strike.webp?v=1764390557465",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-118",
    platFormCode: "PP",
  },
  {
    name: "Diamond Symphony DoubleMax",
    img: "/assets/Slot/YGG-SLOT-201.webp?v=1767056428551",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-201",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamonds",
    img: "/assets/Slot/RELAX-SLOT-141.webp?v=1761892782080",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-141",
    platFormCode: "RELAX",
  },
  {
    name: "Diamonds are Forever 3 Lines",
    img: "/assets/Slot/PP-SLOT-170.Diamonds are Forever 3 Lines.webp?v=1764390415783",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-170",
    platFormCode: "PP",
  },
  {
    name: "Diamonds of Egypt",
    img: "/assets/Slot/PP-SLOT-342.Diamonds-of-Egypt.webp?v=1764390352782",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-342",
    platFormCode: "PP",
  },
  {
    name: "Dice Dice Dice",
    img: "/assets/Slot/RT-SLOT-127.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-127",
    platFormCode: "RT",
  },
  {
    name: "Dick the Farmer",
    img: "/assets/Slot/YGG-SLOT-363.webp?v=1767056428870",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-363",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diggin for Diamonds",
    img: "/assets/Slot/YGG-SLOT-230.webp?v=1767056428578",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-230",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diggin for Diamonds 2",
    img: "/assets/Slot/YGG-SLOT-395.webp?v=1767056428903",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-395",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diner Delights",
    img: "/assets/Slot/PG-SLOT-109.webp?v=1765933237836",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-109",
    platFormCode: "PG",
  },
  {
    name: "Ding Dong Christmas Bells",
    img: "/assets/Slot/PP-SLOT-417.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-417",
    platFormCode: "PP",
  },
  {
    name: "Disco Dive",
    img: "/assets/Slot/OCTOPLAY-SLOT-007.Disco Dive.webp?v=1764932686804",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-007",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Disco Lady",
    img: "/assets/Slot/PP-SLOT-247.Disco-Lady.webp?v=1764390252942",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-247",
    platFormCode: "PP",
  },
  {
    name: "Divine 9",
    img: "/assets/Slot/PT-SLOT-332.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-332",
    platFormCode: "PT",
  },
  {
    name: "Dog Fighters - Their Finest Hour",
    img: "/assets/Slot/YGG-SLOT-318.webp?v=1767056428818",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-318",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Doge Life",
    img: "/assets/Slot/OCTOPLAY-SLOT-047.Doge Life.webp?v=1764932723774",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-047",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Dolphin Hot 1",
    img: "/assets/Slot/YGG-SLOT-287.webp?v=1767056428792",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-287",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dolphin Treasure",
    img: "/assets/Slot/ateqfxp1sqamn.Dolphin-Treasure.webp?v=1765048728672",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-041",
    platFormCode: "JOKER",
  },
  {
    name: "Dolphins Pearl Deluxe",
    img: "/assets/Slot/43bx3e7ywgukq.Dolphins-Pearl-Deluxe.webp?v=1765042912088",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-042",
    platFormCode: "JOKER",
  },
  {
    name: "Donkey & The GOATS",
    img: "/assets/Slot/RELAX-SLOT-263.webp?v=1761892864989",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-263",
    platFormCode: "RELAX",
  },
  {
    name: "Dont Hit Plz",
    img: "/assets/Slot/RT-SLOT-296.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-296",
    platFormCode: "RT",
  },
  {
    name: "Doom's Digging Machine",
    img: "/assets/Slot/OCTOPLAY-SLOT-078.Doom_s Digging Machine.webp?v=1764932765709",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-078",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Double Dragons",
    img: "/assets/Slot/YGG-SLOT-028.webp?v=1767056428357",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-028",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Fortune",
    img: "/assets/Slot/PG-SLOT-030.webp?v=1765933237772",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-030",
    platFormCode: "PG",
  },
  {
    name: "Double Fruit Frenzy DoubleMax",
    img: "/assets/Slot/YGG-SLOT-316.webp?v=1767056428816",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-316",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Lucky Mushrooms DoubleMax",
    img: "/assets/Slot/YGG-SLOT-176.webp?v=1767056428515",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-176",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Wilds",
    img: "/assets/Slot/JDB-SLOT-087.double_wilds.webp?v=1767691419778",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-087",
    platFormCode: "JDB",
  },
  {
    name: "Down The Rails",
    img: "/assets/Slot/PP-SLOT-278.Down-the-Rails.webp?v=1764390205362",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-278",
    platFormCode: "PP",
  },
  {
    name: "DrFrancashstein",
    img: "/assets/Slot/RT-SLOT-297.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-297",
    platFormCode: "RT",
  },
  {
    name: "Dracula Awakening",
    img: "/assets/Slot/RT-SLOT-220.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-220",
    platFormCode: "RT",
  },
  {
    name: "Dragon",
    img: "/assets/Slot/JDB-SLOT-025.dragon.webp?v=1765263466344",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-025",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Blox Gigablox",
    img: "/assets/Slot/YGG-SLOT-174.webp?v=1767056428513",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-174",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragon Bond",
    img: "/assets/Slot/PT-SLOT-205.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-205",
    platFormCode: "PT",
  },
  {
    name: "Dragon Chi",
    img: "/assets/Slot/PT-SLOT-191.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-191",
    platFormCode: "PT",
  },
  {
    name: "Dragon Gold 88",
    img: "/assets/Slot/PP-SLOT-489.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-489",
    platFormCode: "PP",
  },
  {
    name: "Dragon Gold SA",
    img: "/assets/Slot/SG-SLOT-019.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-019",
    platFormCode: "SPADE",
  },
  {
    name: "Dragon Hatch",
    img: "/assets/Slot/PG-SLOT-042.webp?v=1765933237782",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-042",
    platFormCode: "PG",
  },
  {
    name: "Dragon Hero",
    img: "/assets/Slot/PP-SLOT-307.Dragon-Hero.webp?v=1764390100045",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-307",
    platFormCode: "PP",
  },
  {
    name: "Dragon Hot Hold and Spin",
    img: "/assets/Slot/PP-SLOT-184.Dragon-Hot-Hold-and-Spin.webp?v=1764390046600",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-184",
    platFormCode: "PP",
  },
  {
    name: "Dragon King Hot Pots",
    img: "/assets/Slot/PP-SLOT-527.Dragon King Hot Pots.webp?v=1764389996661",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-527",
    platFormCode: "PP",
  },
  {
    name: "Dragon King: Legend of the Seas",
    img: "/assets/Slot/RT-SLOT-120.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-120",
    platFormCode: "RT",
  },
  {
    name: "Dragon Kingdom",
    img: "/assets/Slot/PP-SLOT-131.Dragon-Kingdom.webp?v=1764389944548",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-131",
    platFormCode: "PP",
  },
  {
    name: "Dragon Legend",
    img: "/assets/Slot/PG-SLOT-016.webp?v=1765933237762",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-016",
    platFormCode: "PG",
  },
  {
    name: "Dragon Lore Gigarise",
    img: "/assets/Slot/YGG-SLOT-169.webp?v=1767056428507",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-169",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragon Of The Eastern Sea",
    img: "/assets/Slot/fqho1inijjfwo.Dragon-Of-The-Eastern.webp?v=1765050956788",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-043",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Pearl",
    img: "/assets/Slot/RT-SLOT-121.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-121",
    platFormCode: "RT",
  },
  {
    name: "Dragon Phoenix",
    img: "/assets/Slot/w4ypzw6o48mpq.Dragon-Phoenix.webp?v=1765049815809",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-044",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Power Flame",
    img: "/assets/Slot/3yfmucpss64mk.Dragon-Power-Flame.webp?v=1765036956645",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-045",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Spark",
    img: "/assets/Slot/PT-SLOT-195.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-195",
    platFormCode: "PT",
  },
  {
    name: "Dragon Tiger Luck",
    img: "/assets/Slot/PG-SLOT-035.webp?v=1765933237775",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-035",
    platFormCode: "PG",
  },
  {
    name: "Dragon Treasure",
    img: "/assets/Slot/JILI-SLOT-025.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-025",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Tribe",
    img: "/assets/Slot/NLC-SLOT-041.Dragon Tribe.webp?v=1764391137733",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-041",
    platFormCode: "NLC",
  },
  {
    name: "Dragon Warrior",
    img: "/assets/Slot/JDB-SLOT-032.dragon_warrior.webp?v=1765263295153",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-032",
    platFormCode: "JDB",
  },
  {
    name: "Dragon's Fire INFINIREELS",
    img: "/assets/Slot/RT-SLOT-119.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-119",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Fire MegaWays",
    img: "/assets/Slot/RT-SLOT-091.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-091",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Luck Deluxe",
    img: "/assets/Slot/RT-SLOT-116.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-116",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Luck MegaWays",
    img: "/assets/Slot/RT-SLOT-092.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-092",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Realm",
    img: "/assets/Slot/4eekxm7cistkg.Dragon_s-Realm.webp?v=1765054343476",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-046",
    platFormCode: "JOKER",
  },
  {
    name: "DragonBaoBao",
    img: "/assets/Slot/ACEWIN-SLOT-005.Dragon Bao Bao.webp?v=1764853982137",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-005",
    platFormCode: "ACEWIN",
  },
  {
    name: "Dragons Awakening",
    img: "/assets/Slot/RELAX-SLOT-023.webp?v=1761892892029",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-023",
    platFormCode: "RELAX",
  },
  {
    name: "Dragons Gate",
    img: "/assets/Slot/JDB-SLOT-092.dragons_gate.webp?v=1767691445570",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-092",
    platFormCode: "JDB",
  },
  {
    name: "Dragons Hall: Thundershots",
    img: "/assets/Slot/PT-SLOT-158.dragon_s-hall-thunder-shots.webp?v=1764330069657",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-158",
    platFormCode: "PT",
  },
  {
    name: "Dragons Legend",
    img: "/assets/Slot/ACEWIN-SLOT-012.5 Dragons Legend.webp?v=1764853999510",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-012",
    platFormCode: "ACEWIN",
  },
  {
    name: "Dragons Vs Gigablox",
    img: "/assets/Slot/YGG-SLOT-273.webp?v=1767056428780",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-273",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragons World",
    img: "/assets/Slot/JDB-SLOT-069.dragons_world.webp?v=1765263184524",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-069",
    platFormCode: "JDB",
  },
  {
    name: "Dragons’ Lock",
    img: "/assets/Slot/RT-SLOT-338.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-338",
    platFormCode: "RT",
  },
  {
    name: "Dreadworks",
    img: "/assets/Slot/RELAX-SLOT-268.webp?v=1761892920781",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-268",
    platFormCode: "RELAX",
  },
  {
    name: "Dream Destiny",
    img: "/assets/Slot/RT-SLOT-278.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-278",
    platFormCode: "RT",
  },
  {
    name: "Dream of Macau",
    img: "/assets/Slot/PG-SLOT-054.webp?v=1765933237793",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-054",
    platFormCode: "PG",
  },
  {
    name: "Drill that Gold",
    img: "/assets/Slot/PP-SLOT-250.Drill-That-Gold.webp?v=1764389846068",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-250",
    platFormCode: "PP",
  },
  {
    name: "Drop for Top",
    img: "/assets/Slot/PT-SLOT-417.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-417",
    platFormCode: "PT",
  },
  {
    name: "Dublin Up",
    img: "/assets/Slot/YGG-SLOT-150.webp?v=1767056428483",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-150",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Duel of Night & Day",
    img: "/assets/Slot/PP-SLOT-656.Duel of Night & Day.webp?v=1764840486514",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-656",
    platFormCode: "PP",
  },
  {
    name: "Dueling Jokers",
    img: "/assets/Slot/RELAX-SLOT-180.webp?v=1761892972069",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-180",
    platFormCode: "RELAX",
  },
  {
    name: "Dungeon Quest",
    img: "/assets/Slot/NLC-SLOT-054.Dungeon Quest.webp?v=1764391029022",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-054",
    platFormCode: "NLC",
  },
  {
    name: "Dungeon Tower",
    img: "/assets/Slot/YGG-SLOT-167.webp?v=1767056428505",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-167",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dwarf & Dragon",
    img: "/assets/Slot/PP-SLOT-459.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-459",
    platFormCode: "PP",
  },
  {
    name: "Dwarf Mine",
    img: "/assets/Slot/YGG-SLOT-099.webp?v=1767056428439",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-099",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dwarven Gold Deluxe",
    img: "/assets/Slot/PP-SLOT-139.Dwarven-Gold-Deluxe.webp?v=1764389729976",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-139",
    platFormCode: "PP",
  },
  {
    name: "Dynamite Diggin Doug",
    img: "/assets/Slot/PP-SLOT-478.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-478",
    platFormCode: "PP",
  },
  {
    name: "Dynamite Reels",
    img: "/assets/Slot/8u9r4tj48chd1.Dynamite-Reels.webp?v=1765041073435",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-047",
    platFormCode: "JOKER",
  },
  {
    name: "Dynamite Riches",
    img: "/assets/Slot/RT-SLOT-093.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-093",
    platFormCode: "RT",
  },
  {
    name: "Dynamite Riches MW + PowerWheel",
    img: "/assets/Slot/RT-SLOT-212.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-212",
    platFormCode: "RT",
  },
  {
    name: "Dynamite Trail: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-092.Dynamite Trail Hold & Win.webp?v=1764932816331",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-092",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Dystopia: Rebel Road",
    img: "/assets/Slot/OCTOPLAY-SLOT-053.Dystopia Rebel Road.webp?v=1764932855249",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-053",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "E-Force",
    img: "/assets/Slot/YGG-SLOT-186.webp?v=1767056428524",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-186",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "ELVES",
    img: "/assets/Slot/2J-SLOT-002.ELVES.webp?v=1763550667271",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-002",
    platFormCode: "JJ",
  },
  {
    name: "ENDLESS TREASURE",
    img: "/assets/Slot/2J-SLOT-030.ENDLESS TREASURE.webp?v=1763550614895",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-030",
    platFormCode: "JJ",
  },
  {
    name: "Eagle Riches",
    img: "/assets/Slot/RT-SLOT-147.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-147",
    platFormCode: "RT",
  },
  {
    name: "East Coast Vs West Coast",
    img: "/assets/Slot/NLC-SLOT-029.East Coast Vs West Coast.webp?v=1764390980115",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-029",
    platFormCode: "NLC",
  },
  {
    name: "Easter Island",
    img: "/assets/Slot/YGG-SLOT-078.webp?v=1767056428419",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-078",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Easter Island 2",
    img: "/assets/Slot/YGG-SLOT-050.webp?v=1767056428380",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-050",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Easter Surprise",
    img: "/assets/Slot/PT-SLOT-067.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-067",
    platFormCode: "PT",
  },
  {
    name: "Eggsponential",
    img: "/assets/Slot/OCTOPLAY-SLOT-033.Egg Sponential.webp?v=1764932901861",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-033",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Egypt Queen",
    img: "/assets/Slot/igg7tisz4ukhw.Egypt-Queen.webp?v=1765043924655",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-048",
    platFormCode: "JOKER",
  },
  {
    name: "Egypt's Book of Mystery",
    img: "/assets/Slot/PG-SLOT-051.webp?v=1765933237791",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-051",
    platFormCode: "PG",
  },
  {
    name: "Egyptian Emeralds",
    img: "/assets/Slot/PT-SLOT-204.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-204",
    platFormCode: "PT",
  },
  {
    name: "Egyptian Fortunes",
    img: "/assets/Slot/PP-SLOT-086.Egyptians-Fortune.webp?v=1764389669480",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-086",
    platFormCode: "PP",
  },
  {
    name: "El Dorado Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-006.webp?v=1767056428325",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-006",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "El Paso Gunfight xNudge",
    img: "/assets/Slot/NLC-SLOT-027.El Paso Gunfight xNudge.webp?v=1764390905074",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-027",
    platFormCode: "NLC",
  },
  {
    name: "El Ranchero Cash Collect Diamond Path",
    img: "/assets/Slot/PT-SLOT-415.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-415",
    platFormCode: "PT",
  },
  {
    name: "Eldritch Dungeon",
    img: "/assets/Slot/RELAX-SLOT-256.webp?v=1761893000212",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-256",
    platFormCode: "RELAX",
  },
  {
    name: "Elemental Gems Megaways",
    img: "/assets/Slot/PP-SLOT-228.Elemental-Gems-Megaways.webp?v=1764389616599",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-228",
    platFormCode: "PP",
  },
  {
    name: "Elemento",
    img: "/assets/Slot/RELAX-SLOT-078.webp?v=1761893030240",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-078",
    platFormCode: "RELAX",
  },
  {
    name: "Elephant Treasure",
    img: "/assets/Slot/RT-SLOT-298.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-298",
    platFormCode: "RT",
  },
  {
    name: "Elixir of Wealth MultiBoost",
    img: "/assets/Slot/YGG-SLOT-299.webp?v=1767056428801",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-299",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Emerald King",
    img: "/assets/Slot/PP-SLOT-021.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-021",
    platFormCode: "PP",
  },
  {
    name: "Emerald King Rainbow Road",
    img: "/assets/Slot/PP-SLOT-010.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-010",
    platFormCode: "PP",
  },
  {
    name: "Emerald's Infinity Reels",
    img: "/assets/Slot/RELAX-SLOT-024.webp?v=1761893094484",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-024",
    platFormCode: "RELAX",
  },
  {
    name: "Emoji Riches",
    img: "/assets/Slot/PG-SLOT-089.webp?v=1765933237819",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-089",
    platFormCode: "PG",
  },
  {
    name: "Emotiwins",
    img: "/assets/Slot/PP-SLOT-614.Emotiwins.webp?v=1764389544851",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-614",
    platFormCode: "PP",
  },
  {
    name: "Emperor Caishen",
    img: "/assets/Slot/PP-SLOT-220.Emperor-Caishen.webp?v=1764389498655",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-220",
    platFormCode: "PP",
  },
  {
    name: "Emperors Favour",
    img: "/assets/Slot/PG-SLOT-028.webp?v=1765933237772",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-028",
    platFormCode: "PG",
  },
  {
    name: "Empress Regnant",
    img: "/assets/Slot/o7f9ih8t6559e.Empress-Regnant.webp?v=1765054742916",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-049",
    platFormCode: "JOKER",
  },
  {
    name: "Empty the Bank",
    img: "/assets/Slot/PP-SLOT-193.Empty-the-Bank.webp?v=1764389449191",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-193",
    platFormCode: "PP",
  },
  {
    name: "Enchanted Water",
    img: "/assets/Slot/YGG-SLOT-214.webp?v=1767056428562",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-214",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Enter The KTV",
    img: "/assets/Slot/srd3xusx3ughr.Enter-The-KTV.webp?v=1765043393886",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-051",
    platFormCode: "JOKER",
  },
  {
    name: "Epic Dreams",
    img: "/assets/Slot/RELAX-SLOT-244.webp?v=1761893191369",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-244",
    platFormCode: "RELAX",
  },
  {
    name: "Epic Fish: Marlin Madness",
    img: "/assets/Slot/PT-SLOT-477.Epic Fish Marlin Madness.webp?v=1764996518227",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-477",
    platFormCode: "PT",
  },
  {
    name: "Epic Joker",
    img: "/assets/Slot/RELAX-SLOT-025.webp?v=1761893220489",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-025",
    platFormCode: "RELAX",
  },
  {
    name: "Epic Treasure",
    img: "/assets/Slot/RT-SLOT-279.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-279",
    platFormCode: "RT",
  },
  {
    name: "Epic Treasure 2",
    img: "/assets/Slot/RT-SLOT-319.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-319",
    platFormCode: "RT",
  },
  {
    name: "Erik the Red",
    img: "/assets/Slot/RELAX-SLOT-026.webp?v=1761893245301",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-026",
    platFormCode: "RELAX",
  },
  {
    name: "Escape the Pyramid - Fire & Ice",
    img: "/assets/Slot/PP-SLOT-539.Escape the Pyramid - Fire & Ice.webp?v=1764389398593",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-539",
    platFormCode: "PP",
  },
  {
    name: "Eskimo Riches",
    img: "/assets/Slot/YGG-SLOT-393.webp?v=1767056428900",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-393",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eternal Clash",
    img: "/assets/Slot/OCTOPLAY-SLOT-040.Eternal Clash.webp?v=1764932946311",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-040",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Eternal Clash Reloaded",
    img: "/assets/Slot/OCTOPLAY-SLOT-046.Eternal Clash Reloaded.webp?v=1764932984955",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-046",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Eternal Empress - Freeze Time",
    img: "/assets/Slot/PP-SLOT-520.Eternal Empress – Freeze Time.webp?v=1764389342986",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-520",
    platFormCode: "PP",
  },
  {
    name: "Eternal Lady",
    img: "/assets/Slot/PT-SLOT-025.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-025",
    platFormCode: "PT",
  },
  {
    name: "Everest",
    img: "/assets/Slot/RELAX-SLOT-184.webp?v=1761893272389",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-184",
    platFormCode: "RELAX",
  },
  {
    name: "Evil Goblins xBomb",
    img: "/assets/Slot/NLC-SLOT-011.Evil Goblins xBomb.webp?v=1764390855785",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-011",
    platFormCode: "NLC",
  },
  {
    name: "Excalibur Unleashed",
    img: "/assets/Slot/PP-SLOT-344.Excalibur-Unleashed.webp?v=1764389259856",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-344",
    platFormCode: "PP",
  },
  {
    name: "Extra Chili Tapcards",
    img: "/assets/Slot/BTG-SLOT-065.webp?v=1756256536976",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-065",
    platFormCode: "BTG",
  },
  {
    name: "Extra Chilli",
    img: "/assets/Slot/BTG-SLOT-005.webp?v=1756256536929",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-005",
    platFormCode: "BTG",
  },
  {
    name: "Extra Juicy",
    img: "/assets/Slot/PP-SLOT-087.Extra Juicy.webp?v=1764389204393",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-087",
    platFormCode: "PP",
  },
  {
    name: "Extra Juicy Megaways",
    img: "/assets/Slot/PP-SLOT-224.Extra-Juicy-Megaways.webp?v=1764389152391",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-224",
    platFormCode: "PP",
  },
  {
    name: "Extreme Hot Gems",
    img: "/assets/Slot/YGG-SLOT-345.webp?v=1767056428841",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-345",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eye of Cleopatra",
    img: "/assets/Slot/PP-SLOT-239.Eye-of-Cleopatra.webp?v=1764389099524",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-239",
    platFormCode: "PP",
  },
  {
    name: "Eye of Anubis",
    img: "/assets/Slot/PT-SLOT-162.Eye of Anubis.webp?v=1764327093870",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-162",
    platFormCode: "PT",
  },
  {
    name: "Eye of Persia 2",
    img: "/assets/Slot/YGG-SLOT-145.webp?v=1767056428478",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-145",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eye of Spartacus",
    img: "/assets/Slot/PP-SLOT-570.Eye of Spartacus.webp?v=1764389045130",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-570",
    platFormCode: "PP",
  },
  {
    name: "Eye of the Storm",
    img: "/assets/Slot/PP-SLOT-006.Eye-of-the-Storm.webp?v=1764388991259",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    platFormCode: "PP",
  },
  {
    name: "FATHER KIM",
    img: "/assets/Slot/2J-SLOT-057.FATHER KIM.webp?v=1763550520119",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-057",
    platFormCode: "JJ",
  },
  {
    name: "FIRE 4: Cash Collect Quattro",
    img: "/assets/Slot/PT-SLOT-245.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-245",
    platFormCode: "PT",
  },
  {
    name: "FISH ON! BASS HUNTER",
    img: "/assets/Slot/2J-SLOT-052.FISH ON! BASS HUNTER.webp?v=1763550466856",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-052",
    platFormCode: "JJ",
  },
  {
    name: "FOOTBALL",
    img: "/assets/Slot/2J-SLOT-005.FOOTBALL.webp?v=1763550406997",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-005",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE BAMBOO PANDA",
    img: "/assets/Slot/2J-SLOT-018.FORTUNE BAMBOO PANDA.webp?v=1763550339340",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-018",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE GEMS",
    img: "/assets/Slot/2J-SLOT-050.FORTUNE GEMS.webp?v=1763550111414",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-050",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE MOUSE",
    img: "/assets/Slot/2J-SLOT-042.FORTUNE MOUSE.webp?v=1763550055360",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-042",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE RABBIT",
    img: "/assets/Slot/2J-SLOT-039.FORTUNE RABBIT.webp?v=1763549979910",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-039",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE SHEEP",
    img: "/assets/Slot/FC-SLOT-037.webp?v=1751418030798",
    platForm: "FC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "FC-SLOT-037",
    platFormCode: "FC",
  },
  {
    name: "FRUIT MARY",
    img: "/assets/Slot/2J-SLOT-012.FRUIT MARY.webp?v=1763549760344",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-012",
    platFormCode: "JJ",
  },
  {
    name: "Fa Fa Babies",
    img: "/assets/Slot/RT-SLOT-175.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-175",
    platFormCode: "RT",
  },
  {
    name: "FaFaDragon",
    img: "/assets/Slot/YesBingo-SLOT-007.Fa Fa Dragon.webp?v=1765104969955",
    platForm: "YB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
    platFormCode: "YESBINGO",
  },
  {
    name: "FaFaFa2",
    img: "/assets/Slot/SG-SLOT-003.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-003",
    platFormCode: "SPADE",
  },
  {
    name: "Fabulous Eights",
    img: "/assets/Slot/5cx47jffukp3o.Fabulous-Eights.webp?v=1765054289656",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-052",
    platFormCode: "JOKER",
  },
  {
    name: "Fairytale Fortune",
    img: "/assets/Slot/PP-SLOT-108.Fairytale-Fortune.webp?v=1764388936963",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-108",
    platFormCode: "PP",
  },
  {
    name: "Fangtastic Freespins",
    img: "/assets/Slot/PP-SLOT-506.Fangtastic Freespins.webp?v=1764388866175",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-506",
    platFormCode: "PP",
  },
  {
    name: "Fantasy Falls",
    img: "/assets/Slot/YGG-SLOT-339.webp?v=1767056428837",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-339",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fast Fruits Doublemax",
    img: "/assets/Slot/YGG-SLOT-207.webp?v=1767056428557",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-207",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fat Choy Choy Sun",
    img: "/assets/Slot/PT-SLOT-206.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-206",
    platFormCode: "PT",
  },
  {
    name: "Fat Panda",
    img: "/assets/Slot/PP-SLOT-355.Fat-Panda.webp?v=1764388812080",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-355",
    platFormCode: "PP",
  },
  {
    name: "Fatz's Diner",
    img: "/assets/Slot/YGG-SLOT-219.webp?v=1767056428566",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-219",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Feather Fury",
    img: "/assets/Slot/RELAX-SLOT-267.webp?v=1761893296949",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-267",
    platFormCode: "RELAX",
  },
  {
    name: "Fei Long Zai Tian",
    img: "/assets/Slot/PT-SLOT-027.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-027",
    platFormCode: "PT",
  },
  {
    name: "Feng Kuang Ma Jiang",
    img: "/assets/Slot/PT-SLOT-020.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-020",
    platFormCode: "PT",
  },
  {
    name: "Feng Shui Flip",
    img: "/assets/Slot/PT-SLOT-348.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-348",
    platFormCode: "PT",
  },
  {
    name: "Fengshen",
    img: "/assets/Slot/JILI-SLOT-022.webp?v=1755509312899",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-022",
    platFormCode: "JILI",
  },
  {
    name: "Festival 10K Ways",
    img: "/assets/Slot/YGG-SLOT-175.webp?v=1767056428514",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-175",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fiery Sevens Hot 20",
    img: "/assets/Slot/SG-SLOT-154.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-154",
    platFormCode: "SPADE",
  },
  {
    name: "Fiesta Explosiva DuoMax",
    img: "/assets/Slot/YGG-SLOT-298.webp?v=1767056428801",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-298",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fifty Dragons",
    img: "/assets/Slot/k9gz4ebbrau1e.Fifty-Dragons.webp?v=1765043133778",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-056",
    platFormCode: "JOKER",
  },
  {
    name: "Fifty Lions",
    img: "/assets/Slot/fk9yoi4wkifrs.Fifty-Lions.webp?v=1765053544828",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-057",
    platFormCode: "JOKER",
  },
  {
    name: "Fire 88",
    img: "/assets/Slot/PP-SLOT-109.Fire-88.webp?v=1764845613691",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-109",
    platFormCode: "PP",
  },
  {
    name: "Fire Archer",
    img: "/assets/Slot/PP-SLOT-322.Fire-Archer.webp?v=1764388531714",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-322",
    platFormCode: "PP",
  },
  {
    name: "Fire Blaze Golden: Amazing Factory",
    img: "/assets/Slot/PT-SLOT-181.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-181",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Golden: Buccaneer Bells",
    img: "/assets/Slot/PT-SLOT-165.Fire Blaze-Golden-Buccaneer-Bells.webp?v=1764328249072",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-165",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Golden: Tundra Wolf",
    img: "/assets/Slot/PT-SLOT-157.fire,blaze-tundra-wolf.webp?v=1764330528802",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-157",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Quattro: Celtic Charm",
    img: "/assets/Slot/PT-SLOT-074.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-074",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Blue Wizard Megaways",
    img: "/assets/Slot/PT-SLOT-094.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-094",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Fire Fighter",
    img: "/assets/Slot/PT-SLOT-232.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-232",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Green Wizard",
    img: "/assets/Slot/PT-SLOT-336.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-336",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Red Wizard",
    img: "/assets/Slot/PT-SLOT-167.fire blaze-red-wizard.webp?v=1764327974890",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-167",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: River Empress",
    img: "/assets/Slot/PT-SLOT-168.fire blaze-river-empress.webp?v=1764327699023",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-168",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Sisters Gift",
    img: "/assets/Slot/PT-SLOT-169.fire-blaze-sister-gift.webp?v=1764327534085",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-169",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Toltec Blocks",
    img: "/assets/Slot/PT-SLOT-264.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-264",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: White Witch",
    img: "/assets/Slot/PT-SLOT-470.Fire Blaze White Witch.webp?v=1764940976143",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-470",
    platFormCode: "PT",
  },
  {
    name: "Fire Hot 100",
    img: "/assets/Slot/PP-SLOT-276.Fire Hot 100.webp?v=1764388485717",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-276",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 20",
    img: "/assets/Slot/PP-SLOT-274.Fire Hot 20.webp?v=1764388229021",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-274",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 40",
    img: "/assets/Slot/PP-SLOT-275.Fire Hot 40.webp?v=1764388174623",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-275",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 5",
    img: "/assets/Slot/PP-SLOT-273.Fire Hot 5.webp?v=1764388124013",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-273",
    platFormCode: "PP",
  },
  {
    name: "Fire In The Hole xBomb",
    img: "/assets/Slot/NLC-SLOT-008.Fire In The Hole xBomb.webp?v=1764390734139",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-008",
    platFormCode: "NLC",
  },
  {
    name: "Fire Portals",
    img: "/assets/Slot/PP-SLOT-444.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-444",
    platFormCode: "PP",
  },
  {
    name: "Fire Reel",
    img: "/assets/Slot/yxdzc9d7qj3zy.Fire-Reel.webp?v=1765049587047",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-058",
    platFormCode: "JOKER",
  },
  {
    name: "Fire Reign",
    img: "/assets/Slot/ofy9b9z99u69r.Fire-Reign.webp?v=1765054791282",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-059",
    platFormCode: "JOKER",
  },
  {
    name: "Fire Stampede",
    img: "/assets/Slot/PP-SLOT-420.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-420",
    platFormCode: "PP",
  },
  {
    name: "Fire Strike 2",
    img: "/assets/Slot/PP-SLOT-235.Fire-Strike-2.webp?v=1764387899084",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-235",
    platFormCode: "PP",
  },
  {
    name: "Fire in the Hole 3",
    img: "/assets/Slot/NLC-SLOT-113.Fire In The Hole 3.webp?v=1764390684075",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-113",
    platFormCode: "NLC",
  },
  {
    name: "Firebird Spirit",
    img: "/assets/Slot/PP-SLOT-299.Firebird Spirit.webp?v=1764387821638",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-299",
    platFormCode: "PP",
  },
  {
    name: "Firekick! Multimax",
    img: "/assets/Slot/YGG-SLOT-168.webp?v=1767056428506",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-168",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Firewins Factory",
    img: "/assets/Slot/RELAX-SLOT-227.Firewins Factory.webp?v=1763104867946",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-227",
    platFormCode: "RELAX",
  },
  {
    name: "Fish Eye",
    img: "/assets/Slot/PP-SLOT-319.Fish-Eye.webp?v=1764387759867",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-319",
    platFormCode: "PP",
  },
  {
    name: "Fishin' Bonanza",
    img: "/assets/Slot/PT-SLOT-089.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-089",
    platFormCode: "PT",
  },
  {
    name: "Fist Champion",
    img: "/assets/Slot/ACEWIN-SLOT-009.Fist Champion.webp?v=1764854018746",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-009",
    platFormCode: "ACEWIN",
  },
  {
    name: "Five Clans",
    img: "/assets/Slot/YGG-SLOT-105.webp?v=1767056428443",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-105",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Five Tiger Generals",
    img: "/assets/Slot/j6j1rkbjfaz1a.Five-Tiger-Generals.webp?v=1765044533037",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-060",
    platFormCode: "JOKER",
  },
  {
    name: "Flame & Fortune: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-086.Flame & Fortune Hold & Win.webp?v=1764933005482",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-086",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Flames Of Fortune",
    img: "/assets/Slot/3erm9p7wssiks.Flames-Of-Fortune.webp?v=1765054847391",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-061",
    platFormCode: "JOKER",
  },
  {
    name: "Flaming Frenzy",
    img: "/assets/Slot/OCTOPLAY-SLOT-024.Flaming Frenzy.webp?v=1764933052160",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-024",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Flight Mode",
    img: "/assets/Slot/NLC-SLOT-112.Flight Mode.webp?v=1764390659669",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-112",
    platFormCode: "NLC",
  },
  {
    name: "Flirting Scholar",
    img: "/assets/Slot/PG-SLOT-036.webp?v=1765933237776",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-036",
    platFormCode: "PG",
  },
  {
    name: "Flirting Scholar Tang",
    img: "/assets/Slot/JDB-SLOT-010.flirting_scholar_tang.webp?v=1765262983799",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    platFormCode: "JDB",
  },
  {
    name: "Floating Dragon",
    img: "/assets/Slot/PP-SLOT-177.Floating-Dragon.webp?v=1764387642656",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-177",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon - Dragon Boat Festival",
    img: "/assets/Slot/PP-SLOT-347.Floating-Dragon---Dragon-Boat-Festival.webp?v=1764387590844",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-347",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon - Year of the Snake",
    img: "/assets/Slot/PP-SLOT-533.Floating Dragon – Year of the Snake.webp?v=1764387532260",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-533",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon Megaways",
    img: "/assets/Slot/PP-SLOT-279.Floating-Dragon-Megaways.webp?v=1764387459042",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-279",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon New Year Festival Ultra Megaways",
    img: "/assets/Slot/PP-SLOT-423.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-423",
    platFormCode: "PP",
  },
  {
    name: "Flodder",
    img: "/assets/Slot/RT-SLOT-184.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-184",
    platFormCode: "RT",
  },
  {
    name: "Florageddon!",
    img: "/assets/Slot/YGG-SLOT-159.webp?v=1767056428491",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-159",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Flower Fortune Supreme",
    img: "/assets/Slot/RELAX-SLOT-127.webp?v=1761893561055",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-127",
    platFormCode: "RELAX",
  },
  {
    name: "Fluffy Favourites: Cash Collect",
    img: "/assets/Slot/PT-SLOT-410.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-410",
    platFormCode: "PT",
  },
  {
    name: "Fly Cat$",
    img: "/assets/Slot/RELAX-SLOT-178.webp?v=1761893720638",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-178",
    platFormCode: "RELAX",
  },
  {
    name: "Follow the Cash Rabbit",
    img: "/assets/Slot/OCTOPLAY-SLOT-105.Follow the Cash Rabbit.webp?v=1764933079971",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-105",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Folsom Prison",
    img: "/assets/Slot/NLC-SLOT-007.Folsom Prison.webp?v=1764390621926",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-007",
    platFormCode: "NLC",
  },
  {
    name: "Fonzo’s Feline Fortunes",
    img: "/assets/Slot/PP-SLOT-532.Fonzo’s Feline Fortunes.webp?v=1764387390636",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-532",
    platFormCode: "PP",
  },
  {
    name: "Football Glory",
    img: "/assets/Slot/YGG-SLOT-047.webp?v=1767056428375",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-047",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Football Rules",
    img: "/assets/Slot/PT-SLOT-082.Football Rules.webp?v=1764328523554",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    platFormCode: "PT",
  },
  {
    name: "Football! Cash Collect",
    img: "/assets/Slot/PT-SLOT-238.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-238",
    platFormCode: "PT",
  },
  {
    name: "Forever 7's",
    img: "/assets/Slot/RT-SLOT-213.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-213",
    platFormCode: "RT",
  },
  {
    name: "Forge of Olympus",
    img: "/assets/Slot/PP-SLOT-373.Forge-of-Olympus-2.webp?v=1764387338841",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-373",
    platFormCode: "PP",
  },
  {
    name: "Forging Wilds",
    img: "/assets/Slot/PP-SLOT-486.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-486",
    platFormCode: "PP",
  },
  {
    name: "Formosa Bear",
    img: "/assets/Slot/JDB-SLOT-014.formosa_bear.webp?v=1765262922476",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Ace",
    img: "/assets/Slot/PP-SLOT-426.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-426",
    platFormCode: "PP",
  },
  {
    name: "Fortune Day",
    img: "/assets/Slot/PT-SLOT-046.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-046",
    platFormCode: "PT",
  },
  {
    name: "Fortune Festival",
    img: "/assets/Slot/gqotnunpejbwy.Fortune-Festival.webp?v=1765053699277",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-064",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Four",
    img: "/assets/Slot/ACEWIN-SLOT-016.Fortune Four.webp?v=1764854044285",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-016",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Gods",
    img: "/assets/Slot/PG-SLOT-003.webp?v=1765933237755",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-003",
    platFormCode: "PG",
  },
  {
    name: "Fortune Hook Boom",
    img: "/assets/Slot/JILI-SLOT-156.Fortune Hook Boom.webp?v=1764310776734",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-156",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Horse",
    img: "/assets/Slot/PG-SLOT-171.webp?v=1770862519059",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Lions",
    img: "/assets/Slot/PT-SLOT-044.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-044",
    platFormCode: "PT",
  },
  {
    name: "Fortune Llama",
    img: "/assets/Slot/RELAX-SLOT-167.webp?v=1761893765503",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-167",
    platFormCode: "RELAX",
  },
  {
    name: "Fortune Mouse",
    img: "/assets/Slot/PG-SLOT-043.webp?v=1765933237783",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-043",
    platFormCode: "PG",
  },
  {
    name: "Fortune Ox",
    img: "/assets/Slot/PG-SLOT-070.webp?v=1765933237804",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-070",
    platFormCode: "PG",
  },
  {
    name: "Fortune Rabbit",
    img: "/assets/Slot/PG-SLOT-112.webp?v=1765933237838",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-112",
    platFormCode: "PG",
  },
  {
    name: "Fortune Tai Chi",
    img: "/assets/Slot/ACEWIN-SLOT-006.Fortune Tai Chi.webp?v=1764854095147",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-006",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Tree",
    img: "/assets/Slot/ACEWIN-SLOT-018.Fortune Tree.webp?v=1764854117438",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-018",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune of Giza",
    img: "/assets/Slot/PP-SLOT-217.Fortune-of-Giza.webp?v=1764387095707",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-217",
    platFormCode: "PP",
  },
  {
    name: "FortuneArrow",
    img: "/assets/Slot/ACEWIN-SLOT-026.FortuneArrow.webp?v=1764854144703",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-026",
    platFormCode: "ACEWIN",
  },
  {
    name: "FortunePig",
    img: "/assets/Slot/JILI-SLOT-019.webp?v=1755509296329",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-019",
    platFormCode: "JILI",
  },
  {
    name: "Fortunes of Aztec",
    img: "/assets/Slot/PP-SLOT-382.Fortunes of Aztec.webp?v=1764387048538",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-382",
    platFormCode: "PP",
  },
  {
    name: "Fortunes of the Fox",
    img: "/assets/Slot/PT-SLOT-062.Fortunes of the Fox.webp?v=1764326781589",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-062",
    platFormCode: "PT",
  },
  {
    name: "Four Dragons",
    img: "/assets/Slot/wykepsq659qp4.Four-Dragons.webp?v=1765048461092",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-065",
    platFormCode: "JOKER",
  },
  {
    name: "Four Tigers",
    img: "/assets/Slot/rsjogw1ukbeic.Four-Tigers.webp?v=1765042969514",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-066",
    platFormCode: "JOKER",
  },
  {
    name: "Four Treasures",
    img: "/assets/Slot/JDB-SLOT-017.four_treasures.webp?v=1765262662557",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    platFormCode: "JDB",
  },
  {
    name: "Fourtune 4ever Dragon",
    img: "/assets/Slot/ACEWIN-SLOT-035.Fourtune 4ever Dragon.webp?v=1764854165723",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-035",
    platFormCode: "ACEWIN",
  },
  {
    name: "Freaked Out Fish",
    img: "/assets/Slot/RELAX-SLOT-266.webp?v=1761893802808",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-266",
    platFormCode: "RELAX",
  },
  {
    name: "Frequent Flyer",
    img: "/assets/Slot/RELAX-SLOT-027.webp?v=1761893826445",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-027",
    platFormCode: "RELAX",
  },
  {
    name: "Frog's Gift",
    img: "/assets/Slot/PT-SLOT-187.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-187",
    platFormCode: "PT",
  },
  {
    name: "Frogs & Bugs",
    img: "/assets/Slot/PP-SLOT-350.Frogs-&-Bugs.webp?v=1764386968407",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-350",
    platFormCode: "PP",
  },
  {
    name: "Frontier Lock & Load",
    img: "/assets/Slot/YGG-SLOT-384.webp?v=1767056428889",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-384",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Frozen Age",
    img: "/assets/Slot/YGG-SLOT-235.webp?v=1767056428588",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-235",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Frozen Tropics",
    img: "/assets/Slot/PP-SLOT-377.Frozen-Tropics.webp?v=1764386856868",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-377",
    platFormCode: "PP",
  },
  {
    name: "Fruit Combinator",
    img: "/assets/Slot/YGG-SLOT-195.webp?v=1767056428542",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-195",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruit Gemz Splitz",
    img: "/assets/Slot/YGG-SLOT-164.webp?v=1767056428503",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-164",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruit Paradise",
    img: "/assets/Slot/uh4amsg355x7a.Fruit-Paradise.webp?v=1765043508038",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-067",
    platFormCode: "JOKER",
  },
  {
    name: "Fruit Party",
    img: "/assets/Slot/PP-SLOT-046.Fruit-Party.webp?v=1764386802138",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-046",
    platFormCode: "PP",
  },
  {
    name: "Fruit Party 2",
    img: "/assets/Slot/PP-SLOT-194.Fruit-Party-2.webp?v=1764386749859",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-194",
    platFormCode: "PP",
  },
  {
    name: "Fruit Rainbow",
    img: "/assets/Slot/PP-SLOT-054.Fruit-Rainbow.webp?v=1764386684924",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-054",
    platFormCode: "PP",
  },
  {
    name: "Fruit Snap",
    img: "/assets/Slot/RT-SLOT-094.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-094",
    platFormCode: "RT",
  },
  {
    name: "Fruit Strike",
    img: "/assets/Slot/RELAX-SLOT-083.webp?v=1761893848346",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-083",
    platFormCode: "RELAX",
  },
  {
    name: "FruitPunk",
    img: "/assets/Slot/YGG-SLOT-391.webp?v=1767056428896",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-391",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruitjitsu",
    img: "/assets/Slot/YGG-SLOT-402.webp?v=1767056428912",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-402",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruitoids",
    img: "/assets/Slot/YGG-SLOT-019.webp?v=1767056428346",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-019",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruits",
    img: "/assets/Slot/NLC-SLOT-052.Fruits.webp?v=1764390557694",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-052",
    platFormCode: "NLC",
  },
  {
    name: "Fruits of the Amazon",
    img: "/assets/Slot/PP-SLOT-329.Fruits-of-the-Amazon.webp?v=1764386636066",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-329",
    platFormCode: "PP",
  },
  {
    name: "Fruity Candy",
    img: "/assets/Slot/PG-SLOT-120.webp?v=1765933237845",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-120",
    platFormCode: "PG",
  },
  {
    name: "Fruity Treats",
    img: "/assets/Slot/PP-SLOT-461.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-461",
    platFormCode: "PP",
  },
  {
    name: "Fruitylicious",
    img: "/assets/Slot/YGG-SLOT-280.webp?v=1767056428786",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-280",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fu Fu Fu",
    img: "/assets/Slot/PP-SLOT-039.Fu-Fu-Fu.webp?v=1764386517257",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-039",
    platFormCode: "PP",
  },
  {
    name: "Full Moon: White King",
    img: "/assets/Slot/PT-SLOT-359.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-359",
    platFormCode: "PT",
  },
  {
    name: "Full Moon: White Panda",
    img: "/assets/Slot/PT-SLOT-160.Full-Moon-White-Panda.webp?v=1764327351699",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-160",
    platFormCode: "PT",
  },
  {
    name: "Fury of Hyde Megaways",
    img: "/assets/Slot/YGG-SLOT-180.webp?v=1767056428518",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-180",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fury of Odin Megaways",
    img: "/assets/Slot/PP-SLOT-313.Fury-of-Odin-Megaways.webp?v=1764386465575",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-313",
    platFormCode: "PP",
  },
  {
    name: "GOD OF WEALTH",
    img: "/assets/Slot/2J-SLOT-001.GOD OF WEALTH.webp?v=1763549608509",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-001",
    platFormCode: "JJ",
  },
  {
    name: "GOLD MANIA",
    img: "/assets/Slot/2J-SLOT-034.GOLD MANIA.webp?v=1763549552771",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-034",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN BUFFALO",
    img: "/assets/Slot/2J-SLOT-038.GOLDEN BUFFALO.webp?v=1763549510746",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-038",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN CENTURY",
    img: "/assets/Slot/2J-SLOT-031.GOLDEN CENTURY.webp?v=1763549438332",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-031",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN OX",
    img: "/assets/Slot/2J-SLOT-029.GOLDEN OX.webp?v=1763549388285",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-029",
    platFormCode: "JJ",
  },
  {
    name: "Gaelic Gold",
    img: "/assets/Slot/NLC-SLOT-038.Gaelic Gold.webp?v=1764390510748",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-038",
    platFormCode: "NLC",
  },
  {
    name: "Galactic Gems",
    img: "/assets/Slot/PG-SLOT-067.webp?v=1765933237801",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-067",
    platFormCode: "PG",
  },
  {
    name: "Galactic Racers",
    img: "/assets/Slot/RELAX-SLOT-214.webp?v=1761893877103",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-214",
    platFormCode: "RELAX",
  },
  {
    name: "Gallina Vince",
    img: "/assets/Slot/JILI-SLOT-141.webp?v=1755511014026",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-141",
    platFormCode: "JILI",
  },
  {
    name: "Ganesha Fortune",
    img: "/assets/Slot/PG-SLOT-052.webp?v=1765933237792",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-052",
    platFormCode: "PG",
  },
  {
    name: "Ganesha Gold",
    img: "/assets/Slot/PG-SLOT-026.webp?v=1765933237771",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-026",
    platFormCode: "PG",
  },
  {
    name: "Gargoyle Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-064.webp?v=1767056428401",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-064",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Garuda Gems",
    img: "/assets/Slot/PG-SLOT-094.webp?v=1765933237823",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-094",
    platFormCode: "PG",
  },
  {
    name: "Gates of Aztec",
    img: "/assets/Slot/PP-SLOT-312.Gates-of-Aztec.webp?v=1764386404862",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-312",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca",
    img: "/assets/Slot/PP-SLOT-303.Gates-of-Gatotkaca.webp?v=1765791293934",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-303",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca 1000",
    img: "/assets/Slot/PP-SLOT-439.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-439",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca Super Scatter",
    img: "/assets/Slot/PP-SLOT-663.Gates of Gatot Kaca Super Scatter.webp?v=1765423183483",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-663",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Dice",
    img: "/assets/Slot/PP-SLOT-436.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-436",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Xmas 1000",
    img: "/assets/Slot/PP-SLOT-524.Gates of Olympus Xmas 1000.webp?v=1764386071967",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-524",
    platFormCode: "PP",
  },
  {
    name: "Gates of Thunder",
    img: "/assets/Slot/YGG-SLOT-283.webp?v=1767056428788",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-283",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gates of Valhalla",
    img: "/assets/Slot/PP-SLOT-226.Gates-of-Valhalla.webp?v=1764386014807",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-226",
    platFormCode: "PP",
  },
  {
    name: "Gates of the Underworld",
    img: "/assets/Slot/OCTOPLAY-SLOT-115.Gates of the Underworld.webp?v=1764933095467",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-115",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gator Gold Deluxe Gigablox",
    img: "/assets/Slot/YGG-SLOT-118.webp?v=1767056428454",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-118",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gator Gold Gigablox",
    img: "/assets/Slot/YGG-SLOT-052.webp?v=1767056428383",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-052",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gator Hunters",
    img: "/assets/Slot/NLC-SLOT-117.Gator Hunters.webp?v=1764390458111",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-117",
    platFormCode: "NLC",
  },
  {
    name: "Gatot Kaca's Fury",
    img: "/assets/Slot/PP-SLOT-320.Gatot-Kaca_s-Fury.webp?v=1764385967066",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-320",
    platFormCode: "PP",
  },
  {
    name: "Gears of Horus",
    img: "/assets/Slot/PP-SLOT-438.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-438",
    platFormCode: "PP",
  },
  {
    name: "Geisha Story",
    img: "/assets/Slot/PT-SLOT-061.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-061",
    platFormCode: "PT",
  },
  {
    name: "Gem Elevator",
    img: "/assets/Slot/PP-SLOT-490.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-490",
    platFormCode: "PP",
  },
  {
    name: "Gem Heat",
    img: "/assets/Slot/PT-SLOT-128.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-128",
    platFormCode: "PT",
  },
  {
    name: "Gem Pops",
    img: "/assets/Slot/RELAX-SLOT-249.webp?v=1761893904787",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-249",
    platFormCode: "RELAX",
  },
  {
    name: "Gem Rocks",
    img: "/assets/Slot/YGG-SLOT-100.webp?v=1767056428440",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-100",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gem Saviour",
    img: "/assets/Slot/PG-SLOT-002.webp?v=1765933237754",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-002",
    platFormCode: "PG",
  },
  {
    name: "Gem Saviour Conquest",
    img: "/assets/Slot/PG-SLOT-045.webp?v=1765933237785",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-045",
    platFormCode: "PG",
  },
  {
    name: "Gem Saviour Sword",
    img: "/assets/Slot/PG-SLOT-022.webp?v=1765933237767",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-022",
    platFormCode: "PG",
  },
  {
    name: "Gems Bonanza",
    img: "/assets/Slot/PP-SLOT-025.Gems-Bonanza.webp?v=1764385806643",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-025",
    platFormCode: "PP",
  },
  {
    name: "Gems Gone Wild Power Reels",
    img: "/assets/Slot/RT-SLOT-148.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-148",
    platFormCode: "RT",
  },
  {
    name: "Gems Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-125.webp?v=1767056428463",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-125",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gems of Serengeti",
    img: "/assets/Slot/PP-SLOT-301.Gems-of-Serengeti.webp?v=1764385757101",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-301",
    platFormCode: "PP",
  },
  {
    name: "Gemstone Guardians",
    img: "/assets/Slot/OCTOPLAY-SLOT-021.Gemstone Guardians.webp?v=1764933133227",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-021",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gemtastic",
    img: "/assets/Slot/RT-SLOT-024.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-024",
    platFormCode: "RT",
  },
  {
    name: "Genie",
    img: "/assets/Slot/1q36p58phmt6y.Genie.webp?v=1765045495082",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-069",
    platFormCode: "JOKER",
  },
  {
    name: "Genie 2",
    img: "/assets/Slot/b4pde45epfzg6.Genie-2.webp?v=1765036336582",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-070",
    platFormCode: "JOKER",
  },
  {
    name: "Genie Nights",
    img: "/assets/Slot/RT-SLOT-178.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-178",
    platFormCode: "RT",
  },
  {
    name: "Genie's 3 Wishes",
    img: "/assets/Slot/PG-SLOT-057.webp?v=1765933237794",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-057",
    platFormCode: "PG",
  },
  {
    name: "Ghost Father",
    img: "/assets/Slot/YGG-SLOT-248.webp?v=1767056428598",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-248",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giga Bass Gigablox",
    img: "/assets/Slot/YGG-SLOT-312.webp?v=1767056428812",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-312",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giga Blast",
    img: "/assets/Slot/RT-SLOT-249.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-249",
    platFormCode: "RT",
  },
  {
    name: "Giga Match Bunny",
    img: "/assets/Slot/PT-SLOT-430.giga-match-bunny.webp?v=1764332621474",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-430",
    platFormCode: "PT",
  },
  {
    name: "Giga Match Phantasmal",
    img: "/assets/Slot/PT-SLOT-474.Giga Match Phantasmal.webp?v=1764943256990",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-474",
    platFormCode: "PT",
  },
  {
    name: "GigaGong GigaBlox",
    img: "/assets/Slot/YGG-SLOT-215.webp?v=1767056428563",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-215",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gigablox Kingdom",
    img: "/assets/Slot/YGG-SLOT-382.webp?v=1767056428888",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-382",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giganimals GigaBlox",
    img: "/assets/Slot/YGG-SLOT-188.webp?v=1767056428526",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-188",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giza Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-004.webp?v=1767056428322",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-004",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Glorious Guardians",
    img: "/assets/Slot/PT-SLOT-098.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-098",
    platFormCode: "PT",
  },
  {
    name: "Gnomes & Giants",
    img: "/assets/Slot/RELAX-SLOT-228.webp?v=1761893924958",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-228",
    platFormCode: "RELAX",
  },
  {
    name: "Goblin Heist Powernudge",
    img: "/assets/Slot/PP-SLOT-238.Goblin-Heist-Powernudge.webp?v=1764385639197",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-238",
    platFormCode: "PP",
  },
  {
    name: "Goblin’s Bargain MultiMax",
    img: "/assets/Slot/YGG-SLOT-258.webp?v=1767056428765",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-258",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "God Of Martial",
    img: "/assets/Slot/JILI-SLOT-010.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-010",
    platFormCode: "JILI",
  },
  {
    name: "God Smash: Eternal Chaos",
    img: "/assets/Slot/OCTOPLAY-SLOT-066.God Smash Eternal Chaos.webp?v=1764933170628",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-066",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gods Gone Wild",
    img: "/assets/Slot/YGG-SLOT-369.webp?v=1767056428877",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-369",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gods Vs Gigablox",
    img: "/assets/Slot/YGG-SLOT-171.webp?v=1767056428509",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-171",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gods of Giza",
    img: "/assets/Slot/PP-SLOT-336.Gods-of-Giza.webp?v=1764385589723",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-336",
    platFormCode: "PP",
  },
  {
    name: "Gods of Troy",
    img: "/assets/Slot/RT-SLOT-105.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-105",
    platFormCode: "RT",
  },
  {
    name: "Going Wild in Vegas",
    img: "/assets/Slot/YGG-SLOT-213.webp?v=1767056428561",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-213",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Chain",
    img: "/assets/Slot/OCTOPLAY-SLOT-008.Gold Chain.webp?v=1764933220660",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-008",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gold Fever",
    img: "/assets/Slot/YGG-SLOT-187.webp?v=1767056428525",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-187",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Hit & Link: Tiger Jones",
    img: "/assets/Slot/PT-SLOT-357.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-357",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: Dragon Bonanza",
    img: "/assets/Slot/PT-SLOT-327.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-327",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: O'Reilly's Riches",
    img: "/assets/Slot/PT-SLOT-076.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-076",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: Shrine of Anubis",
    img: "/assets/Slot/PT-SLOT-259.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-259",
    platFormCode: "PT",
  },
  {
    name: "Gold Is All Mine 10K Ways",
    img: "/assets/Slot/YGG-SLOT-332.webp?v=1767056428831",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-332",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Oasis",
    img: "/assets/Slot/PP-SLOT-378.Gold-Oasis.webp?v=1764385527860",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-378",
    platFormCode: "PP",
  },
  {
    name: "Gold Party",
    img: "/assets/Slot/PP-SLOT-227.Gold-Party.webp?v=1764385475104",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-227",
    platFormCode: "PP",
  },
  {
    name: "Gold Pile: New Years Gold",
    img: "/assets/Slot/PT-SLOT-185.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-185",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Orangutan",
    img: "/assets/Slot/PT-SLOT-166.Gold Pile Orangutan.webp?v=1764328027974",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-166",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Tigers Pride",
    img: "/assets/Slot/PT-SLOT-173.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-173",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Toltec Treasure",
    img: "/assets/Slot/PT-SLOT-183.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-183",
    platFormCode: "PT",
  },
  {
    name: "Gold Rush Cowboy",
    img: "/assets/Slot/SG-SLOT-100.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-100",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-043.Gold Smash.webp?v=1764933285500",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-043",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gold Trio",
    img: "/assets/Slot/PT-SLOT-347.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-347",
    platFormCode: "PT",
  },
  {
    name: "Gold Trio: Leprechaun's Luck BF",
    img: "/assets/Slot/PT-SLOT-416.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-416",
    platFormCode: "PT",
  },
  {
    name: "Gold Trio: Sinbad’s Riches",
    img: "/assets/Slot/PT-SLOT-268.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-268",
    platFormCode: "PT",
  },
  {
    name: "Gold hit & link: J.P. Bacon & Co",
    img: "/assets/Slot/PT-SLOT-271.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-271",
    platFormCode: "PT",
  },
  {
    name: "GoldStorm Ultra",
    img: "/assets/Slot/YGG-SLOT-411.webp?v=1767056428920",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-411",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Bank",
    img: "/assets/Slot/JILI-SLOT-023.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-023",
    platFormCode: "JILI",
  },
  {
    name: "Golden Castle",
    img: "/assets/Slot/RELAX-SLOT-079.webp?v=1761893950295",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-079",
    platFormCode: "RELAX",
  },
  {
    name: "Golden Chicken",
    img: "/assets/Slot/SG-SLOT-018.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-018",
    platFormCode: "SPADE",
  },
  {
    name: "Golden Cryptex",
    img: "/assets/Slot/RT-SLOT-095.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-095",
    platFormCode: "RT",
  },
  {
    name: "Golden Donkey Xmas",
    img: "/assets/Slot/YGG-SLOT-303.webp?v=1767056428804",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-303",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Dragon",
    img: "/assets/Slot/9w6aa6u5xbhzh.Golden-Dragon.webp?v=1765050672925",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-072",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Empire",
    img: "/assets/Slot/JILI-SLOT-042.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
    platFormCode: "JILI",
  },
  {
    name: "Golden Fish Tank 2 Gigablox",
    img: "/assets/Slot/YGG-SLOT-055.webp?v=1767056428389",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-055",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Fish Tank Party",
    img: "/assets/Slot/YGG-SLOT-314.webp?v=1767056428814",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-314",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Fish tank",
    img: "/assets/Slot/YGG-SLOT-117.webp?v=1767056428454",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-117",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Genie And The Walking Wilds",
    img: "/assets/Slot/NLC-SLOT-035.Golden Genie And The Walking Wilds.webp?v=1764390400186",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-035",
    platFormCode: "NLC",
  },
  {
    name: "Golden Gods",
    img: "/assets/Slot/RELAX-SLOT-097.webp?v=1761893984401",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-097",
    platFormCode: "RELAX",
  },
  {
    name: "Golden Gorgon",
    img: "/assets/Slot/YGG-SLOT-065.webp?v=1767056428402",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-065",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Island",
    img: "/assets/Slot/ywozehuuqbazc.Golden-Island.webp?v=1765046641599",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-073",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Joker",
    img: "/assets/Slot/JILI-SLOT-074.webp?v=1755509943211",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-074",
    platFormCode: "JILI",
  },
  {
    name: "Golden Lamps",
    img: "/assets/Slot/RT-SLOT-300.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-300",
    platFormCode: "RT",
  },
  {
    name: "Golden Macaque",
    img: "/assets/Slot/PT-SLOT-026.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-026",
    platFormCode: "PT",
  },
  {
    name: "Golden Monkey King",
    img: "/assets/Slot/9mqe9bhroi78s.Golden Monkey King.webp?v=1765042511425",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-074",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Offer",
    img: "/assets/Slot/RT-SLOT-028.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
    platFormCode: "RT",
  },
  {
    name: "Golden Ox",
    img: "/assets/Slot/PP-SLOT-012.Golden-Ox.webp?v=1764385270957",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-012",
    platFormCode: "PP",
  },
  {
    name: "Golden Pig",
    img: "/assets/Slot/PP-SLOT-089.Golden-Pig.webp?v=1764385221525",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-089",
    platFormCode: "PP",
  },
  {
    name: "Golden Queen",
    img: "/assets/Slot/JILI-SLOT-030.webp?v=1755509380517",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-030",
    platFormCode: "JILI",
  },
  {
    name: "Golden Rooster",
    img: "/assets/Slot/jpiuhpbifei1o.Golden-Rooster.webp?v=1765035855328",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-075",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Suns Chain Collect",
    img: "/assets/Slot/OCTOPLAY-SLOT-058.Golden Suns Chail Collect.webp?v=1764933327636",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-058",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Golden Toad",
    img: "/assets/Slot/RT-SLOT-301.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-301",
    platFormCode: "RT",
  },
  {
    name: "Golden Triad",
    img: "/assets/Slot/YGG-SLOT-349.webp?v=1767056428855",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-349",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Tsar",
    img: "/assets/Slot/RT-SLOT-150.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-150",
    platFormCode: "RT",
  },
  {
    name: "Golden Ways",
    img: "/assets/Slot/PT-SLOT-190.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-190",
    platFormCode: "PT",
  },
  {
    name: "Gonzita's Quest",
    img: "/assets/Slot/RT-SLOT-192.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-192",
    platFormCode: "RT",
  },
  {
    name: "Gonzo's Quest 2",
    img: "/assets/Slot/NETENT-SLOT-233.Gonzo_s Quest 2.webp?v=1764959551212",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-233",
    platFormCode: "NETENT",
  },
  {
    name: "Good Luck & Good Fortune",
    img: "/assets/Slot/PP-SLOT-407.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-407",
    platFormCode: "PP",
  },
  {
    name: "Goood Heavens",
    img: "/assets/Slot/PT-SLOT-409.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-409",
    platFormCode: "PT",
  },
  {
    name: "Gordon Ramsay Hell’s Kitchen",
    img: "/assets/Slot/NETENT-SLOT-039.gordon-ramsay-hell_s-kitchen.webp?v=1764959405568",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-039",
    platFormCode: "NETENT",
  },
  {
    name: "Gorilla Mayhem",
    img: "/assets/Slot/PP-SLOT-272.Gorilla-Mayham.webp?v=1764385160774",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-272",
    platFormCode: "PP",
  },
  {
    name: "Grand Junction: Mountain Express",
    img: "/assets/Slot/PT-SLOT-263.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-263",
    platFormCode: "PT",
  },
  {
    name: "Grand Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-081.Grand Link Express Hold & Win.webp?v=1764933370447",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-081",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Great Gold",
    img: "/assets/Slot/RT-SLOT-193.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-193",
    platFormCode: "RT",
  },
  {
    name: "Great Lagoon",
    img: "/assets/Slot/PP-SLOT-434.Great-Lagoon.webp?v=1764385060003",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-434",
    platFormCode: "PP",
  },
  {
    name: "Great Reef",
    img: "/assets/Slot/PP-SLOT-156.Great-Reef.webp?v=1764385012283",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-156",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino",
    img: "/assets/Slot/PP-SLOT-106.Great-Rhino.webp?v=1764384961146",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-106",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino Deluxe",
    img: "/assets/Slot/PP-SLOT-030.Great-Rhino-Deluxe.webp?v=1764384916287",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-030",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino Megaways",
    img: "/assets/Slot/PP-SLOT-049.Great-Rhino-Megaways.webp?v=1764384867535",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-049",
    platFormCode: "PP",
  },
  {
    name: "Great Stars SA",
    img: "/assets/Slot/SG-SLOT-022.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-022",
    platFormCode: "SPADE",
  },
  {
    name: "Greedy Alice",
    img: "/assets/Slot/YGG-SLOT-310.webp?v=1767056428811",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-310",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Greedy Fortune Pig",
    img: "/assets/Slot/PP-SLOT-547.webp?v=1755571929491",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-547",
    platFormCode: "PP",
  },
  {
    name: "Greedy Wolf",
    img: "/assets/Slot/PP-SLOT-277.Greedy-Wolf.webp?v=1764384809684",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-277",
    platFormCode: "PP",
  },
  {
    name: "Greek Gods",
    img: "/assets/Slot/PP-SLOT-066.Greek-Gods.webp?v=1764384758920",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-066",
    platFormCode: "PP",
  },
  {
    name: "Grim The Splitter",
    img: "/assets/Slot/RELAX-SLOT-160.webp?v=1761894015171",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-160",
    platFormCode: "RELAX",
  },
  {
    name: "Guardian of Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-119.Guardian of Gold Hold & Win.webp?v=1764933388209",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-119",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Guardians of Ice and Fire",
    img: "/assets/Slot/PG-SLOT-068.webp?v=1765933237802",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-068",
    platFormCode: "PG",
  },
  {
    name: "Gunpowder",
    img: "/assets/Slot/YGG-SLOT-257.webp?v=1767056428764",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-257",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "HEX",
    img: "/assets/Slot/RELAX-SLOT-111.webp?v=1761894038532",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-111",
    platFormCode: "RELAX",
  },
  {
    name: "HUFF N PUFF",
    img: "/assets/Slot/2J-SLOT-045.HUFF N PUFF.webp?v=1763549305638",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-045",
    platFormCode: "JJ",
  },
  {
    name: "Hackers Haven",
    img: "/assets/Slot/YGG-SLOT-388.webp?v=1767056428893",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-388",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hades",
    img: "/assets/Slot/YGG-SLOT-096.webp?v=1767056428436",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-096",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hades River of Souls",
    img: "/assets/Slot/RELAX-SLOT-080.webp?v=1761894069314",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-080",
    platFormCode: "RELAX",
  },
  {
    name: "Hainan Ice",
    img: "/assets/Slot/PT-SLOT-209.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-209",
    platFormCode: "PT",
  },
  {
    name: "Hall of Wealth",
    img: "/assets/Slot/YGG-SLOT-364.webp?v=1767056428871",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-364",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hammer Gods",
    img: "/assets/Slot/RT-SLOT-136.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-136",
    platFormCode: "RT",
  },
  {
    name: "Hammer of Gods",
    img: "/assets/Slot/YGG-SLOT-085.webp?v=1767056428428",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-085",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hand of Midas 2",
    img: "/assets/Slot/PP-SLOT-472.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-472",
    platFormCode: "PP",
  },
  {
    name: "Hanzo's Dojo",
    img: "/assets/Slot/YGG-SLOT-102.webp?v=1767056428442",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-102",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Happy Apples",
    img: "/assets/Slot/RT-SLOT-236.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-236",
    platFormCode: "RT",
  },
  {
    name: "Happy Buddha",
    img: "/assets/Slot/55hj8ghaugxj6.Happy-Buddha.webp?v=1765043291103",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-077",
    platFormCode: "JOKER",
  },
  {
    name: "Happy Honey",
    img: "/assets/Slot/OCTOPLAY-SLOT-026.Happy Honey.webp?v=1764933427023",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-026",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Happy Neko",
    img: "/assets/Slot/SG-SLOT-149.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-149",
    platFormCode: "SPADE",
  },
  {
    name: "Happy Party",
    img: "/assets/Slot/ebudnqj68h6d4.Happy-Party.webp?v=1765053390862",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-078",
    platFormCode: "JOKER",
  },
  {
    name: "Happy Taxi",
    img: "/assets/Slot/JILI-SLOT-056.webp?v=1755509750179",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-056",
    platFormCode: "JILI",
  },
  {
    name: "Harle Coin",
    img: "/assets/Slot/RT-SLOT-200.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-200",
    platFormCode: "RT",
  },
  {
    name: "Harlequin Carnival",
    img: "/assets/Slot/NLC-SLOT-037.Harlequin Carnival.webp?v=1764390353229",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-037",
    platFormCode: "NLC",
  },
  {
    name: "Hawaiian Tiki",
    img: "/assets/Slot/PG-SLOT-114.webp?v=1765933237840",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-114",
    platFormCode: "PG",
  },
  {
    name: "Hazakura Ways",
    img: "/assets/Slot/RELAX-SLOT-103.webp?v=1761894110736",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-103",
    platFormCode: "RELAX",
  },
  {
    name: "Heart of Cleopatra",
    img: "/assets/Slot/PP-SLOT-457.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-457",
    platFormCode: "PP",
  },
  {
    name: "Heart of Rio",
    img: "/assets/Slot/PP-SLOT-191.Heart-of-Rio.webp?v=1764384665507",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-191",
    platFormCode: "PP",
  },
  {
    name: "Heart of the Frontier",
    img: "/assets/Slot/PT-SLOT-070.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-070",
    platFormCode: "PT",
  },
  {
    name: "Heavenly Ruler",
    img: "/assets/Slot/PT-SLOT-036.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-036",
    platFormCode: "PT",
  },
  {
    name: "Heavy Anchor",
    img: "/assets/Slot/OCTOPLAY-SLOT-009.Heavy Anchor.webp?v=1764933468511",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-009",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Heist Deluxe",
    img: "/assets/Slot/7phhufritkfao.Heist-Deluxe.webp?v=1765036743065",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-080",
    platFormCode: "JOKER",
  },
  {
    name: "Heist Stakes",
    img: "/assets/Slot/PG-SLOT-077.webp?v=1765933237809",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-077",
    platFormCode: "PG",
  },
  {
    name: "Heist for the Golden Nuggets",
    img: "/assets/Slot/PP-SLOT-357.Heist-for-the-Golden-Nuggets.webp?v=1764384611776",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-357",
    platFormCode: "PP",
  },
  {
    name: "Helios Fury",
    img: "/assets/Slot/RELAX-SLOT-067.webp?v=1761894136683",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-067",
    platFormCode: "RELAX",
  },
  {
    name: "Hell Of A Spin",
    img: "/assets/Slot/OCTOPLAY-SLOT-042.Hell of Spin.webp?v=1764933508985",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-042",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Hell's Hogs 2 Squealin' Wheels",
    img: "/assets/Slot/YGG-SLOT-268.webp?v=1767056428776",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-268",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hellcatraz",
    img: "/assets/Slot/RELAX-SLOT-028.webp?v=1761894170594",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-028",
    platFormCode: "RELAX",
  },
  {
    name: "Hellcatraz 2",
    img: "/assets/Slot/RELAX-SLOT-176.webp?v=1761894204516",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-176",
    platFormCode: "RELAX",
  },
  {
    name: "Hells Hogs",
    img: "/assets/Slot/YGG-SLOT-139.webp?v=1767056428473",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-139",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hellvis Wild",
    img: "/assets/Slot/PP-SLOT-359.Hellvis-wild.webp?v=1764384565316",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-359",
    platFormCode: "PP",
  },
  {
    name: "Hercules 10K Ways",
    img: "/assets/Slot/YGG-SLOT-216.webp?v=1767056428563",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-216",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hercules Son Of Zeus",
    img: "/assets/Slot/PP-SLOT-132.Hercules-Son-of-Zeus.webp?v=1764384514448",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-132",
    platFormCode: "PP",
  },
  {
    name: "Hercules and Pegasus",
    img: "/assets/Slot/PP-SLOT-068.Hercules-and-Pegasus.webp?v=1764384460751",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-068",
    platFormCode: "PP",
  },
  {
    name: "Heroes Arrow",
    img: "/assets/Slot/PT-SLOT-095.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-095",
    platFormCode: "PT",
  },
  {
    name: "Heroes Hunt 2",
    img: "/assets/Slot/RELAX-SLOT-082.webp?v=1761894287071",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-082",
    platFormCode: "RELAX",
  },
  {
    name: "Heroes' Gathering",
    img: "/assets/Slot/RELAX-SLOT-029.webp?v=1761894310186",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-029",
    platFormCode: "RELAX",
  },
  {
    name: "Heroic Spin",
    img: "/assets/Slot/PP-SLOT-455.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-455",
    platFormCode: "PP",
  },
  {
    name: "Hidden Egypt DoubleMax",
    img: "/assets/Slot/YGG-SLOT-253.webp?v=1767056428759",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-253",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hillbilly Vegas",
    img: "/assets/Slot/YGG-SLOT-156.webp?v=1767056428488",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-156",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Himalayan Wild",
    img: "/assets/Slot/PP-SLOT-519.Himalayan Wild.webp?v=1764384402058",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-519",
    platFormCode: "PP",
  },
  {
    name: "Hip Hop Panda",
    img: "/assets/Slot/PG-SLOT-017.webp?v=1765933237763",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-017",
    platFormCode: "PG",
  },
  {
    name: "Hit Bar: Gold",
    img: "/assets/Slot/PT-SLOT-334.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-334",
    platFormCode: "PT",
  },
  {
    name: "Ho Yeah Monkey",
    img: "/assets/Slot/SG-SLOT-017.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-017",
    platFormCode: "SPADE",
  },
  {
    name: "Hoard of Poseidon",
    img: "/assets/Slot/RT-SLOT-152.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-152",
    platFormCode: "RT",
  },
  {
    name: "Hokkaido Wolf",
    img: "/assets/Slot/PP-SLOT-604.Hokkaido-Wolf.webp?v=1764384297889",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-604",
    platFormCode: "PP",
  },
  {
    name: "Holiday Ride",
    img: "/assets/Slot/PP-SLOT-404.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-404",
    platFormCode: "PP",
  },
  {
    name: "Holy Hand Grenade",
    img: "/assets/Slot/RELAX-SLOT-166.webp?v=1761894336311",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-166",
    platFormCode: "RELAX",
  },
  {
    name: "Honey Gems",
    img: "/assets/Slot/PT-SLOT-261.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-261",
    platFormCode: "PT",
  },
  {
    name: "Honey Honey Honey",
    img: "/assets/Slot/PP-SLOT-070.Honey-Honey-Honey.webp?v=1764384233215",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-070",
    platFormCode: "PP",
  },
  {
    name: "Honey Hunters",
    img: "/assets/Slot/RELAX-SLOT-247.webp?v=1761894360760",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-247",
    platFormCode: "RELAX",
  },
  {
    name: "Honey Trap of Diao Chan",
    img: "/assets/Slot/PG-SLOT-001.webp?v=1765933237754",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-001",
    platFormCode: "PG",
  },
  {
    name: "Hood vs Wolf",
    img: "/assets/Slot/PG-SLOT-009.webp?v=1765933237758",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-009",
    platFormCode: "PG",
  },
  {
    name: "Horror Hotel",
    img: "/assets/Slot/RELAX-SLOT-161.webp?v=1761894391305",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-161",
    platFormCode: "RELAX",
  },
  {
    name: "Horus Eye",
    img: "/assets/Slot/j9nzkkbjfaz1a.Horus-Eye.webp?v=1765045702822",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-084",
    platFormCode: "JOKER",
  },
  {
    name: "Hot 4 Cash",
    img: "/assets/Slot/NLC-SLOT-045.Hot 4 Cash.webp?v=1764390138292",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-045",
    platFormCode: "NLC",
  },
  {
    name: "Hot Chilli",
    img: "/assets/Slot/JILI-SLOT-002.webp?v=1755507846546",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-002",
    platFormCode: "JILI",
  },
  {
    name: "Hot Fiesta",
    img: "/assets/Slot/PP-SLOT-175.Hot-Fiesta.webp?v=1764384130390",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-175",
    platFormCode: "PP",
  },
  {
    name: "Hot Fruits",
    img: "/assets/Slot/soojfuqnaxycn.Hot-Fruits.webp?v=1765043185291",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-085",
    platFormCode: "JOKER",
  },
  {
    name: "Hot Gems",
    img: "/assets/Slot/PT-SLOT-030.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-030",
    platFormCode: "PT",
  },
  {
    name: "Hot Gems Xtreme Scratch",
    img: "/assets/Slot/PT-SLOT-247.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-247",
    platFormCode: "PT",
  },
  {
    name: "Hot Harvest",
    img: "/assets/Slot/OCTOPLAY-SLOT-010.Hot Harvest.webp?v=1764933548064",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-010",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Hot Hot Chilli Pot",
    img: "/assets/Slot/RT-SLOT-219.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-219",
    platFormCode: "RT",
  },
  {
    name: "Hot KTV",
    img: "/assets/Slot/PT-SLOT-045.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-045",
    platFormCode: "PT",
  },
  {
    name: "Hot Nudge",
    img: "/assets/Slot/NLC-SLOT-055.Hot Nudge.webp?v=1764390086933",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-055",
    platFormCode: "NLC",
  },
  {
    name: "Hot Pepper",
    img: "/assets/Slot/PP-SLOT-311.Hot-Pepper.webp?v=1764384081196",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-311",
    platFormCode: "PP",
  },
  {
    name: "Hot Rod Racers",
    img: "/assets/Slot/RELAX-SLOT-150.webp?v=1761894416164",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-150",
    platFormCode: "RELAX",
  },
  {
    name: "Hot Safari",
    img: "/assets/Slot/PP-SLOT-141.Hot-Safari.webp?v=1764384028181",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-141",
    platFormCode: "PP",
  },
  {
    name: "Hot Shot",
    img: "/assets/Slot/ACEWIN-SLOT-021.Hot Shot.webp?v=1764854190419",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-021",
    platFormCode: "ACEWIN",
  },
  {
    name: "Hot to Burn",
    img: "/assets/Slot/PP-SLOT-050.Hot-to-Burn.webp?v=1764383974791",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-050",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Extreme",
    img: "/assets/Slot/PP-SLOT-265.Hot-To-Burn-Extreme.webp?v=1764383918547",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-265",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Hold and Spin",
    img: "/assets/Slot/PP-SLOT-003.Hot-to-Burn-Hold-and-Spin.webp?v=1764383865298",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Multiplier",
    img: "/assets/Slot/PP-SLOT-476.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-476",
    platFormCode: "PP",
  },
  {
    name: "Hotpot",
    img: "/assets/Slot/PG-SLOT-015.webp?v=1765933237761",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-015",
    platFormCode: "PG",
  },
  {
    name: "Hugon Quest",
    img: "/assets/Slot/SG-SLOT-089.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-089",
    platFormCode: "SPADE",
  },
  {
    name: "Hulao Battle",
    img: "/assets/Slot/ACEWIN-SLOT-013.Hulao Battle.webp?v=1764854211448",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-013",
    platFormCode: "ACEWIN",
  },
  {
    name: "Hunters Moon",
    img: "/assets/Slot/YGG-SLOT-120.webp?v=1767056428457",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-120",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Huntress: Wild Vengeance",
    img: "/assets/Slot/RELAX-SLOT-144.webp?v=1761894446684",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-144",
    platFormCode: "RELAX",
  },
  {
    name: "Hustling",
    img: "/assets/Slot/RT-SLOT-173.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-173",
    platFormCode: "RT",
  },
  {
    name: "Hyper Burst",
    img: "/assets/Slot/JILI-SLOT-007.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-007",
    platFormCode: "JILI",
  },
  {
    name: "Hyper Respins",
    img: "/assets/Slot/YGG-SLOT-189.webp?v=1767056428527",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-189",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hyperburst",
    img: "/assets/Slot/YGG-SLOT-108.webp?v=1767056428446",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-108",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hypernova 10K Ways",
    img: "/assets/Slot/YGG-SLOT-119.webp?v=1767056428456",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-119",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hypernova Megaways",
    img: "/assets/Slot/RELAX-SLOT-020.webp?v=1761894531669",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-020",
    platFormCode: "RELAX",
  },
  {
    name: "Ice Ice Yeti",
    img: "/assets/Slot/NLC-SLOT-053.Ice Ice Yeti.webp?v=1764390005735",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-053",
    platFormCode: "NLC",
  },
  {
    name: "Ice Lobster",
    img: "/assets/Slot/PP-SLOT-451.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-451",
    platFormCode: "PP",
  },
  {
    name: "Ignite The Night",
    img: "/assets/Slot/RELAX-SLOT-030.webp?v=1761894553402",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-030",
    platFormCode: "RELAX",
  },
  {
    name: "Immortal 5",
    img: "/assets/Slot/RELAX-SLOT-277.webp?v=1761894583746",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-277",
    platFormCode: "RELAX",
  },
  {
    name: "Immortal Fruits",
    img: "/assets/Slot/NLC-SLOT-034.Immortal Fruits.webp?v=1764389935820",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-034",
    platFormCode: "NLC",
  },
  {
    name: "In the Rabbit Hole",
    img: "/assets/Slot/RT-SLOT-227.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-227",
    platFormCode: "RT",
  },
  {
    name: "Incinerator",
    img: "/assets/Slot/YGG-SLOT-023.webp?v=1767056428349",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-023",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Infectious 5 xWays",
    img: "/assets/Slot/NLC-SLOT-014.Infectious 5 xWays.webp?v=1764389891897",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-014",
    platFormCode: "NLC",
  },
  {
    name: "Irish Charms",
    img: "/assets/Slot/PP-SLOT-168.Irish Charms.webp?v=1764383543121",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-168",
    platFormCode: "PP",
  },
  {
    name: "Irish Crown",
    img: "/assets/Slot/PP-SLOT-537.Irish Crown.webp?v=1764383492057",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-537",
    platFormCode: "PP",
  },
  {
    name: "Irish Luck",
    img: "/assets/Slot/PT-SLOT-057.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-057",
    platFormCode: "PT",
  },
  {
    name: "Irish Pots MulitMax",
    img: "/assets/Slot/YGG-SLOT-319.webp?v=1767056428818",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-319",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Iron Bank",
    img: "/assets/Slot/RELAX-SLOT-031.webp?v=1761894611596",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-031",
    platFormCode: "RELAX",
  },
  {
    name: "Ishtar",
    img: "/assets/Slot/PT-SLOT-156.ishtar-power-zones.webp?v=1764330592030",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-156",
    platFormCode: "PT",
  },
  {
    name: "J Mania Lucky Pyggs",
    img: "/assets/Slot/PT-SLOT-475.J Mania Lucky Pyggs.webp?v=1764947276883",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-475",
    platFormCode: "PT",
  },
  {
    name: "J Mania Maniac",
    img: "/assets/Slot/PT-SLOT-473.J Mania Maniac.webp?v=1764941704311",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-473",
    platFormCode: "PT",
  },
  {
    name: "JILI CAISHEN",
    img: "/assets/Slot/JILI-SLOT-060.webp?v=1755509833526",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-060",
    platFormCode: "JILI",
  },
  {
    name: "JIN JI MAHJONG",
    img: "/assets/Slot/2J-SLOT-024.JIN JI MAHJONG.webp?v=1763549252082",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-024",
    platFormCode: "JJ",
  },
  {
    name: "JIN LOONG",
    img: "/assets/Slot/2J-SLOT-033.JIN LOONG.webp?v=1763549150377",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-033",
    platFormCode: "JJ",
  },
  {
    name: "JJ 1000: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-104.JJ 1000 Hold & Win.webp?v=1764933564373",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-104",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "JUNGLE TIGER",
    img: "/assets/Slot/2J-SLOT-016.JUNGLE TIGER.webp?v=1763549051552",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-016",
    platFormCode: "JJ",
  },
  {
    name: "Jack Frost's Winter",
    img: "/assets/Slot/PG-SLOT-066.webp?v=1765933237801",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-066",
    platFormCode: "PG",
  },
  {
    name: "Jack Hammer™ 4: Chasing the Dragon",
    img: "/assets/Slot/NETENT-SLOT-228.Jack Hammer™ 4_ Chasing the Dragon.webp?v=1764958815400",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-228",
    platFormCode: "NETENT",
  },
  {
    name: "Jackpot District: City of Fortune",
    img: "/assets/Slot/OCTOPLAY-SLOT-103.Jackpot District City of Fortune.webp?v=1764933582186",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-103",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jackpot Heist: Daylight Robbery",
    img: "/assets/Slot/OCTOPLAY-SLOT-054.jackpot Heist Daylight Robbery.webp?v=1764933619184",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-054",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jackpot Hunter",
    img: "/assets/Slot/PP-SLOT-485.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-485",
    platFormCode: "PP",
  },
  {
    name: "Jade Butterfly",
    img: "/assets/Slot/PP-SLOT-101.Jade-Butterfly.webp?v=1764383342378",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-101",
    platFormCode: "PP",
  },
  {
    name: "Jade Emperor Yu Huang Da Di",
    img: "/assets/Slot/PT-SLOT-050.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-050",
    platFormCode: "PT",
  },
  {
    name: "Jane Hunter and the Mask of Montezuma",
    img: "/assets/Slot/PP-SLOT-338.Jane-Hunter-and-the--Mask-of-Montezuma.webp?v=1764383289045",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-338",
    platFormCode: "PP",
  },
  {
    name: "Jane Jones In Book Of King 2",
    img: "/assets/Slot/PT-SLOT-172.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-172",
    platFormCode: "PT",
  },
  {
    name: "Jasmine Dreams",
    img: "/assets/Slot/PP-SLOT-341.Jasmine-Dreams.webp?v=1764383238622",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-341",
    platFormCode: "PP",
  },
  {
    name: "Jekyllz Wild UltraNudge",
    img: "/assets/Slot/YGG-SLOT-160.webp?v=1767056428491",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-160",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jelly Candy",
    img: "/assets/Slot/PP-SLOT-618.Jelly Candy.webp?v=1764383186997",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-618",
    platFormCode: "PP",
  },
  {
    name: "Jewel Rush",
    img: "/assets/Slot/PP-SLOT-353.Jewel-Rush.webp?v=1764383156731",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-353",
    platFormCode: "PP",
  },
  {
    name: "Jewel Scarabs",
    img: "/assets/Slot/RT-SLOT-153.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-153",
    platFormCode: "RT",
  },
  {
    name: "Jewels of Prosperity",
    img: "/assets/Slot/PG-SLOT-064.webp?v=1765933237799",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-064",
    platFormCode: "PG",
  },
  {
    name: "Jin Fu Xing Yun",
    img: "/assets/Slot/ahf5icfts455e.Jin-Fu-Xing-Yun.webp?v=1765047099403",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-088",
    platFormCode: "JOKER",
  },
  {
    name: "Jinfu Long",
    img: "/assets/Slot/PT-SLOT-029.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-029",
    platFormCode: "PT",
  },
  {
    name: "Jinfu Xingyun",
    img: "/assets/Slot/PT-SLOT-207.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-207",
    platFormCode: "PT",
  },
  {
    name: "Jingle Bells Power Reels",
    img: "/assets/Slot/RT-SLOT-154.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-154",
    platFormCode: "RT",
  },
  {
    name: "Jinns Moon",
    img: "/assets/Slot/PT-SLOT-033.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-033",
    platFormCode: "PT",
  },
  {
    name: "Jo Blitz",
    img: "/assets/Slot/PT-SLOT-478.Jo Blitz.webp?v=1764996619837",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-478",
    platFormCode: "PT",
  },
  {
    name: "Joe Exotic",
    img: "/assets/Slot/RT-SLOT-201.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-201",
    platFormCode: "RT",
  },
  {
    name: "John Hunter & the Book of Tut Respin",
    img: "/assets/Slot/PP-SLOT-291.John-Hunter-and-The-Book-of-Tut-Respins.webp?v=1764383109976",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-291",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and Galileo’s Secrets",
    img: "/assets/Slot/PP-SLOT-541.John Hunter and Galileo’s Secrets.webp?v=1764383046406",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-541",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Aztec Treasure",
    img: "/assets/Slot/PP-SLOT-077.John-Hunter-and-the-Aztec-Treasure.webp?v=1764382997543",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-077",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Book of Tut",
    img: "/assets/Slot/PP-SLOT-047.John-Hunter-and-The-Book-of-Tut.webp?v=1764382940236",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-047",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Mayan Gods",
    img: "/assets/Slot/PP-SLOT-016.John-Hunter-and-The-Mayan-Gods.webp?v=1764845146009",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-016",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Quest for Bermuda Riches",
    img: "/assets/Slot/PP-SLOT-208.John-Hunter-and-the-Quest-for-Bermuda-Riches.webp?v=1764845262912",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-208",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Tomb of the Scarab Queen",
    img: "/assets/Slot/PP-SLOT-072.John-Hunter-and-the-Tomb-of-the-Scarab-Queen.webp?v=1764382885366",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-072",
    platFormCode: "PP",
  },
  {
    name: "Johnan Legendarian",
    img: "/assets/Slot/YGG-SLOT-009.webp?v=1767056428331",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-009",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Joker Jackpot",
    img: "/assets/Slot/RELAX-SLOT-070.webp?v=1761894638300",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-070",
    platFormCode: "RELAX",
  },
  {
    name: "Joker Jackpots: Prize Mania",
    img: "/assets/Slot/OCTOPLAY-SLOT-074.Joker Jackpots Prize Mania.webp?v=1764933703288",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-074",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Joker Jewels Dice",
    img: "/assets/Slot/PP-SLOT-398.Joker-Jewel-Dice.webp?v=1764382835566",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-398",
    platFormCode: "PP",
  },
  {
    name: "Joker King",
    img: "/assets/Slot/PP-SLOT-004.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-004",
    platFormCode: "PP",
  },
  {
    name: "Joker Madness",
    img: "/assets/Slot/gkubyu4cjibrg.Joker-Madness.webp?v=1765052117751",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-089",
    platFormCode: "JOKER",
  },
  {
    name: "Joker Race",
    img: "/assets/Slot/PP-SLOT-358.Joker-Race.webp?v=1764382766391",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-358",
    platFormCode: "PP",
  },
  {
    name: "Joker Rush",
    img: "/assets/Slot/PT-SLOT-108.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-108",
    platFormCode: "PT",
  },
  {
    name: "Joker Rush: Cash collect",
    img: "/assets/Slot/PT-SLOT-269.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-269",
    platFormCode: "PT",
  },
  {
    name: "Joker Split",
    img: "/assets/Slot/RELAX-SLOT-200.webp?v=1761894992287",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-200",
    platFormCode: "RELAX",
  },
  {
    name: "Joker Super Reels",
    img: "/assets/Slot/RELAX-SLOT-021.webp?v=1761895022095",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-021",
    platFormCode: "RELAX",
  },
  {
    name: "Joker's Jewels",
    img: "/assets/Slot/PP-SLOT-107.Joker_s-Jewels.webp?v=1764382719499",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-107",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Hot",
    img: "/assets/Slot/PP-SLOT-479.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-479",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Wild",
    img: "/assets/Slot/PP-SLOT-454.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-454",
    platFormCode: "PP",
  },
  {
    name: "Joker's Treasure Exclusive",
    img: "/assets/Slot/SG-SLOT-108.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-108",
    platFormCode: "SPADE",
  },
  {
    name: "Joker’s Jewels Cash",
    img: "/assets/Slot/PP-SLOT-557.webp?v=1755572073768",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-557",
    platFormCode: "PP",
  },
  {
    name: "Jokrz Wild UltraNudge",
    img: "/assets/Slot/YGG-SLOT-135.webp?v=1767056428470",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-135",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jokrz Wild UltraNudge Gigablox",
    img: "/assets/Slot/YGG-SLOT-200.webp?v=1767056428550",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-200",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Journey To The Wealth",
    img: "/assets/Slot/PG-SLOT-037.webp?v=1765933237777",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-037",
    platFormCode: "PG",
  },
  {
    name: "Journey to the West",
    img: "/assets/Slot/PP-SLOT-135.Journey-to-the-West.webp?v=1764382625273",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-135",
    platFormCode: "PP",
  },
  {
    name: "Juiced Duomax",
    img: "/assets/Slot/YGG-SLOT-226.webp?v=1767056428573",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-226",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Juicy Fruits",
    img: "/assets/Slot/PP-SLOT-172.Juicy Fruits.webp?v=1764382577553",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-172",
    platFormCode: "PP",
  },
  {
    name: "Juicy Fruits Multihold",
    img: "/assets/Slot/PP-SLOT-424.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-424",
    platFormCode: "PP",
  },
  {
    name: "Juicy Jelly Thunder Ways",
    img: "/assets/Slot/YGG-SLOT-353.webp?v=1767056428860",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-353",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Juicy Jewels Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-107.Juicy Jewels Supercharged.webp?v=1764933718420",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-107",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Juicy Rolls: Feature Frenzy",
    img: "/assets/Slot/OCTOPLAY-SLOT-060.Juicy Rolls Feature Frenzy.webp?v=1764933759672",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-060",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jumanji",
    img: "/assets/Slot/NETENT-SLOT-034.Jumanji.webp?v=1764958474884",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-034",
    platFormCode: "NETENT",
  },
  {
    name: "Jumbo Jellies",
    img: "/assets/Slot/YGG-SLOT-128.webp?v=1767056428465",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-128",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jump For Richness",
    img: "/assets/Slot/ACEWIN-SLOT-017.Jump for Riches.webp?v=1764854230822",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-017",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jungle Adventure",
    img: "/assets/Slot/ACEWIN-SLOT-027.Jungle Adventure.webp?v=1764854248202",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-027",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jungle Books",
    img: "/assets/Slot/YGG-SLOT-031.webp?v=1767056428359",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-031",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jungle Delight",
    img: "/assets/Slot/PG-SLOT-024.webp?v=1765933237769",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-024",
    platFormCode: "PG",
  },
  {
    name: "Jungle Gorilla",
    img: "/assets/Slot/PP-SLOT-034.Jungle Gorilla.webp?v=1764337965768",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-034",
    platFormCode: "PP",
  },
  {
    name: "Jungle Island",
    img: "/assets/Slot/xbxy1yegyhnyk.Jungle-Island.webp?v=1765054045115",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-091",
    platFormCode: "JOKER",
  },
  {
    name: "Jungle King",
    img: "/assets/Slot/SG-SLOT-012.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
    platFormCode: "JILI",
  },
  {
    name: "Jungle Pop",
    img: "/assets/Slot/YGG-SLOT-340.webp?v=1767056428837",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-340",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jungle Smash",
    img: "/assets/Slot/YGG-SLOT-337.webp?v=1767056428835",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-337",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jurassic Island",
    img: "/assets/Slot/PT-SLOT-086.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-086",
    platFormCode: "PT",
  },
  {
    name: "Jurassic Island 2",
    img: "/assets/Slot/PT-SLOT-096.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-096",
    platFormCode: "PT",
  },
  {
    name: "Jurassic Kingdom",
    img: "/assets/Slot/PG-SLOT-079.webp?v=1765933237811",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-079",
    platFormCode: "PG",
  },
  {
    name: "Jurassic Party",
    img: "/assets/Slot/RELAX-SLOT-116.webp?v=1761895060574",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-116",
    platFormCode: "RELAX",
  },
  {
    name: "Just Jewels Deluxe",
    img: "/assets/Slot/satj3o6ya8dcq.Just-Jewels-Deluxe.webp?v=1765051047993",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-092",
    platFormCode: "JOKER",
  },
  {
    name: "KING KONG",
    img: "/assets/Slot/2J-SLOT-062.KING KONG.webp?v=1763548824745",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-062",
    platFormCode: "JJ",
  },
  {
    name: "Karen Maneater",
    img: "/assets/Slot/NLC-SLOT-024.Karen Maneater.webp?v=1764389786878",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-024",
    platFormCode: "NLC",
  },
  {
    name: "Kawaii Princess",
    img: "/assets/Slot/OCTOPLAY-SLOT-073.Kawaii Princess.webp?v=1764933796364",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-073",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Killroad 66",
    img: "/assets/Slot/YGG-SLOT-323.webp?v=1767056428824",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-323",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "King Arthur 10K Ways",
    img: "/assets/Slot/YGG-SLOT-238.webp?v=1767056428591",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-238",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "King Kong",
    img: "/assets/Slot/SlotKingKong.KING KONG.webp?v=1764775649221",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-062",
    platFormCode: "JJ",
  },
  {
    name: "King Power",
    img: "/assets/Slot/YGG-SLOT-328.webp?v=1767056428828",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-328",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "King of Giza: Mega Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-472.King of Giza Mega Cash Collect & Link.webp?v=1764941534935",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-472",
    platFormCode: "PT",
  },
  {
    name: "King of Kings",
    img: "/assets/Slot/RELAX-SLOT-032.webp?v=1761895127162",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-032",
    platFormCode: "RELAX",
  },
  {
    name: "Kingdom of Asgard",
    img: "/assets/Slot/PP-SLOT-293.Kingdom of Asgard.webp?v=1764337821562",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-293",
    platFormCode: "PP",
  },
  {
    name: "Kingdom of The Dead",
    img: "/assets/Slot/PP-SLOT-340.Kingdom of The Dead.webp?v=1764337760653",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-340",
    platFormCode: "PP",
  },
  {
    name: "Kingsman",
    img: "/assets/Slot/JDB-SLOT-033.kingsman.webp?v=1765262316072",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-033",
    platFormCode: "JDB",
  },
  {
    name: "Kiss My Chainsaw",
    img: "/assets/Slot/NLC-SLOT-066.Kiss My Chainsaw.webp?v=1764389122864",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-066",
    platFormCode: "NLC",
  },
  {
    name: "KittyGold",
    img: "/assets/Slot/YL-EGAME-019.webp?v=1751418030471",
    platForm: "YL",
    type: "SLOTS",
    gameType: "EGAME",
    casinoType: "YL-EGAME-019",
    platFormCode: "YL",
  },
  {
    name: "Kluster Krystals Megaclusters",
    img: "/assets/Slot/RELAX-SLOT-033.webp?v=1761895208920",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-033",
    platFormCode: "RELAX",
  },
  {
    name: "Knight Hot Spotz",
    img: "/assets/Slot/PP-SLOT-345.Knight Hot Spotz.webp?v=1764337693290",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-345",
    platFormCode: "PP",
  },
  {
    name: "Knights Of Avalon",
    img: "/assets/Slot/RT-SLOT-243.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-243",
    platFormCode: "RT",
  },
  {
    name: "Koi Harmony",
    img: "/assets/Slot/PT-SLOT-106.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-106",
    platFormCode: "PT",
  },
  {
    name: "Koi Pond",
    img: "/assets/Slot/PP-SLOT-254.Koi Pond.webp?v=1764334416035",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-254",
    platFormCode: "PP",
  },
  {
    name: "Kraken's Sky Bounty",
    img: "/assets/Slot/PP-SLOT-361.Kraken_s Sky Bounty.webp?v=1764334358982",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-361",
    platFormCode: "PP",
  },
  {
    name: "Krazy Klimber",
    img: "/assets/Slot/YGG-SLOT-072.webp?v=1767056428409",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-072",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "LAND OF GEMS",
    img: "/assets/Slot/2J-SLOT-007.LAND OF GEMS.webp?v=1763548781190",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-007",
    platFormCode: "JJ",
  },
  {
    name: "LEPPY LOOT",
    img: "/assets/Slot/KM-SLOT-009.webp?v=1751418030734",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-009",
    platFormCode: "KINGMAKER",
  },
  {
    name: "LEPRECHAUN'S COIN",
    img: "/assets/Slot/2J-SLOT-020.LEPRECHAUN_S COIN.webp?v=1763548720024",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-020",
    platFormCode: "JJ",
  },
  {
    name: "La Fiesta",
    img: "/assets/Slot/RELAX-SLOT-034.webp?v=1761895638812",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-034",
    platFormCode: "RELAX",
  },
  {
    name: "La Fiesta 10K",
    img: "/assets/Slot/RELAX-SLOT-236.webp?v=1761898913175",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-236",
    platFormCode: "RELAX",
  },
  {
    name: "La Fiesta 5K",
    img: "/assets/Slot/RELAX-SLOT-235.webp?v=1761898937646",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-235",
    platFormCode: "RELAX",
  },
  {
    name: "Lady Godiva",
    img: "/assets/Slot/PP-SLOT-144.Lady Godiva.webp?v=1764334289164",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-144",
    platFormCode: "PP",
  },
  {
    name: "Lady Hawk",
    img: "/assets/Slot/wcaadzg74mj7y.Lady-Hawk.webp?v=1765054921289",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-093",
    platFormCode: "JOKER",
  },
  {
    name: "Lady Merlin Lightning Chase",
    img: "/assets/Slot/YGG-SLOT-077.webp?v=1767056428417",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-077",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lady Merlin Multimax",
    img: "/assets/Slot/YGG-SLOT-178.webp?v=1767056428517",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-178",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lady Midas",
    img: "/assets/Slot/YGG-SLOT-385.webp?v=1767056428890",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-385",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lamp Of Infinity",
    img: "/assets/Slot/PP-SLOT-351.Lamp Of Infinity.webp?v=1764334213606",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-351",
    platFormCode: "PP",
  },
  {
    name: "Last Chance Saloon",
    img: "/assets/Slot/RT-SLOT-176.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-176",
    platFormCode: "RT",
  },
  {
    name: "League Of Legends",
    img: "/assets/Slot/orm4x9z99u69r.League-Of-Legends.webp?v=1765052008270",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-094",
    platFormCode: "JOKER",
  },
  {
    name: "Legacy of Anubis",
    img: "/assets/Slot/YGG-SLOT-311.webp?v=1767056428811",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-311",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legacy of the Tiger",
    img: "/assets/Slot/PT-SLOT-193.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-193",
    platFormCode: "PT",
  },
  {
    name: "Legacy of the Wilds 2",
    img: "/assets/Slot/PT-SLOT-188.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-188",
    platFormCode: "PT",
  },
  {
    name: "Legend Of Athena",
    img: "/assets/Slot/RT-SLOT-122.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-122",
    platFormCode: "RT",
  },
  {
    name: "Legend of Dragon Wins",
    img: "/assets/Slot/YGG-SLOT-234.webp?v=1767056428586",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-234",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legend of Hou Yi",
    img: "/assets/Slot/PG-SLOT-018.webp?v=1765933237764",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-018",
    platFormCode: "PG",
  },
  {
    name: "Legend of Hydra",
    img: "/assets/Slot/PT-SLOT-194.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-194",
    platFormCode: "PT",
  },
  {
    name: "Legend of Perseus",
    img: "/assets/Slot/PG-SLOT-103.webp?v=1765933237830",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-103",
    platFormCode: "PG",
  },
  {
    name: "Legend of the Golden Monkey",
    img: "/assets/Slot/YGG-SLOT-025.webp?v=1767056428352",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-025",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legendary Excalibur",
    img: "/assets/Slot/RT-SLOT-155.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-155",
    platFormCode: "RT",
  },
  {
    name: "Legendary Monkey King",
    img: "/assets/Slot/PG-SLOT-086.webp?v=1765933237817",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-086",
    platFormCode: "PG",
  },
  {
    name: "Legends: Battle for Earth",
    img: "/assets/Slot/OCTOPLAY-SLOT-077.Legends Battle For Earth.webp?v=1764933839638",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-077",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Legion Hot1",
    img: "/assets/Slot/YGG-SLOT-066.webp?v=1767056428403",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-066",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legion X",
    img: "/assets/Slot/NLC-SLOT-026.Legion X.webp?v=1764388955246",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-026",
    platFormCode: "NLC",
  },
  {
    name: "Leprechaun Carol",
    img: "/assets/Slot/PP-SLOT-092.Leprechaun Carol.webp?v=1764334076892",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-092",
    platFormCode: "PP",
  },
  {
    name: "Leprechaun Riches",
    img: "/assets/Slot/PG-SLOT-038.webp?v=1765933237778",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-038",
    platFormCode: "PG",
  },
  {
    name: "Leprechaun Song",
    img: "/assets/Slot/PP-SLOT-100.Leprechaun Song.webp?v=1764334004090",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-100",
    platFormCode: "PP",
  },
  {
    name: "Leprechaun's Magic",
    img: "/assets/Slot/RT-SLOT-096.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-096",
    platFormCode: "RT",
  },
  {
    name: "Leprechauns Magic Megaways",
    img: "/assets/Slot/RT-SLOT-302.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-302",
    platFormCode: "RT",
  },
  {
    name: "Leprechauns Magic Power Reels",
    img: "/assets/Slot/RT-SLOT-303.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-303",
    platFormCode: "RT",
  },
  {
    name: "Let's get ready to Rumble",
    img: "/assets/Slot/RELAX-SLOT-035.webp?v=1761898993409",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-035",
    platFormCode: "RELAX",
  },
  {
    name: "Lie Yan Zuan Shi",
    img: "/assets/Slot/PT-SLOT-031.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-031",
    platFormCode: "PT",
  },
  {
    name: "Life O'Riley",
    img: "/assets/Slot/YGG-SLOT-321.webp?v=1767056428822",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-321",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lightning God",
    img: "/assets/Slot/1ru5x5zx7us6r.Lightning-God.webp?v=1765045365800",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-095",
    platFormCode: "JOKER",
  },
  {
    name: "Lightning Joker",
    img: "/assets/Slot/YGG-SLOT-049.webp?v=1767056428378",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-049",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lights of Luck",
    img: "/assets/Slot/PT-SLOT-408.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-408",
    platFormCode: "PT",
  },
  {
    name: "Lil Demo Double Heat",
    img: "/assets/Slot/PT-SLOT-438.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-438",
    platFormCode: "PT",
  },
  {
    name: "Lil Demon: Mega Cash Collect",
    img: "/assets/Slot/PT-SLOT-361.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-361",
    platFormCode: "PT",
  },
  {
    name: "Lil Sphinx",
    img: "/assets/Slot/PT-SLOT-413.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-413",
    platFormCode: "PT",
  },
  {
    name: "Lion's Hoard",
    img: "/assets/Slot/RT-SLOT-215.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-215",
    platFormCode: "RT",
  },
  {
    name: "Lion2Dance",
    img: "/assets/Slot/ACEWIN-SLOT-031.Lion2 Dance.webp?v=1764854270962",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-031",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lions Dance",
    img: "/assets/Slot/wtupmzq14xepn.Lions-Dance.webp?v=1765044187489",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-096",
    platFormCode: "JOKER",
  },
  {
    name: "Lions Gigablox",
    img: "/assets/Slot/YGG-SLOT-274.webp?v=1767056428781",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-274",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Little Bighorn",
    img: "/assets/Slot/NLC-SLOT-021.Little Bighorn.webp?v=1764388900025",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-021",
    platFormCode: "NLC",
  },
  {
    name: "Little Gem",
    img: "/assets/Slot/PP-SLOT-256.Little Gem.webp?v=1764333938705",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-256",
    platFormCode: "PP",
  },
  {
    name: "Llama Adventure",
    img: "/assets/Slot/JDB-SLOT-013.the_llama_adventure.webp?v=1765262020993",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    platFormCode: "JDB",
  },
  {
    name: "Lobster Bob's Crazy Crab Shack",
    img: "/assets/Slot/PP-SLOT-366.Lobster Bob_s Crazy Crab Shack.webp?v=1764333878794",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-366",
    platFormCode: "PP",
  },
  {
    name: "Lobster Bob's Sea Food and Win It",
    img: "/assets/Slot/PP-SLOT-456.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-456",
    platFormCode: "PP",
  },
  {
    name: "Lock & Hit: Red Knight",
    img: "/assets/Slot/PT-SLOT-333.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-333",
    platFormCode: "PT",
  },
  {
    name: "Lock & Loot Gigablox",
    img: "/assets/Slot/YGG-SLOT-400.webp?v=1767056428910",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-400",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lock ‘n Load",
    img: "/assets/Slot/YGG-SLOT-376.webp?v=1767056428882",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-376",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lockdown Loot",
    img: "/assets/Slot/PT-SLOT-325.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-325",
    platFormCode: "PT",
  },
  {
    name: "Lollicat",
    img: "/assets/Slot/OCTOPLAY-SLOT-011.lollicat.webp?v=1764933883036",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-011",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Lollipop Drop MultiMax",
    img: "/assets/Slot/YGG-SLOT-301.webp?v=1767056428803",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-301",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Looney Pop",
    img: "/assets/Slot/RELAX-SLOT-211.webp?v=1761899022345",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-211",
    platFormCode: "RELAX",
  },
  {
    name: "Lord Of The Ocean",
    img: "/assets/Slot/xmzfobaryz7xs.Lord-Of-The-Ocean.webp?v=1765046975297",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-097",
    platFormCode: "JOKER",
  },
  {
    name: "Lord of the Dunes",
    img: "/assets/Slot/OCTOPLAY-SLOT-044.Lord of the dunes.webp?v=1764933931507",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-044",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Lost Relics 2",
    img: "/assets/Slot/NETENT-SLOT-204.lost-relic-2.webp?v=1764957764750",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-204",
    platFormCode: "NETENT",
  },
  {
    name: "Lotus Warrior",
    img: "/assets/Slot/YGG-SLOT-218.webp?v=1767056428565",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-218",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Love Idol",
    img: "/assets/Slot/SG-SLOT-093.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-093",
    platFormCode: "SPADE",
  },
  {
    name: "Lovefool",
    img: "/assets/Slot/PT-SLOT-176.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-176",
    platFormCode: "PT",
  },
  {
    name: "Lucha Maniacs",
    img: "/assets/Slot/YGG-SLOT-032.webp?v=1767056428360",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-032",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lucky Ball",
    img: "/assets/Slot/JILI-SLOT-006.webp?v=1755509025363",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-006",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Bass: Mega Cash Collect",
    img: "/assets/Slot/PT-SLOT-358.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-358",
    platFormCode: "PT",
  },
  {
    name: "Lucky Carnival",
    img: "/assets/Slot/RT-SLOT-304.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-304",
    platFormCode: "RT",
  },
  {
    name: "Lucky Coming",
    img: "/assets/Slot/JILI-SLOT-037.webp?v=1755509404144",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-037",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Dog",
    img: "/assets/Slot/PP-SLOT-620.Lucky Dog.webp?v=1764333698071",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-620",
    platFormCode: "PP",
  },
  {
    name: "Lucky Dragon Ball",
    img: "/assets/Slot/PP-SLOT-053.Lucky Dragon Ball.webp?v=1764333652900",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-053",
    platFormCode: "PP",
  },
  {
    name: "Lucky Dragons",
    img: "/assets/Slot/JDB-SLOT-045.Lucky Dragons.webp?v=1765261912825",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-045",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Drum",
    img: "/assets/Slot/wpu7pzg74mj7y.Lucky-Drum.webp?v=1765044128151",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-098",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Emeralds",
    img: "/assets/Slot/PT-SLOT-216.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-216",
    platFormCode: "PT",
  },
  {
    name: "Lucky Fishing Megaways",
    img: "/assets/Slot/PP-SLOT-305.Lucky Fishing Megaways.webp?v=1764333473740",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-305",
    platFormCode: "PP",
  },
  {
    name: "Lucky Fridays",
    img: "/assets/Slot/RT-SLOT-156.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-156",
    platFormCode: "RT",
  },
  {
    name: "Lucky God",
    img: "/assets/Slot/dhdirsn3m3xia.Lucky-God.webp?v=1765053131983",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-099",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky God Progressive",
    img: "/assets/Slot/ef1uyxt98o6ur.Lucky-God-Progressive.webp?v=1765046584054",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-100",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky God Progressive 2",
    img: "/assets/Slot/3hj4fkfji4z4a.Lucky God Progressive 2.webp?v=1765049938033",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-101",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Goldbricks",
    img: "/assets/Slot/JILI-SLOT-024.webp?v=1755509341303",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-024",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Grace And Charm",
    img: "/assets/Slot/PP-SLOT-197.Lucky Grace And Charm.webp?v=1764333411373",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-197",
    platFormCode: "PP",
  },
  {
    name: "Lucky Joker",
    img: "/assets/Slot/r8oiyz19mtqir.Lucky-Joker.webp?v=1765048345898",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-102",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Lady Charm",
    img: "/assets/Slot/7f9h9fwz11kaw.Lucky-Lady-Charm.webp?v=1765048909737",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-103",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Lightning",
    img: "/assets/Slot/PP-SLOT-192.Lucky Lightning.webp?v=1764333328592",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-192",
    platFormCode: "PP",
  },
  {
    name: "Lucky Little Devil",
    img: "/assets/Slot/RT-SLOT-196.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-196",
    platFormCode: "RT",
  },
  {
    name: "Lucky Macaw",
    img: "/assets/Slot/JILI-SLOT-158.Lucky Macaw.webp?v=1767014009352",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-158",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Money",
    img: "/assets/Slot/RELAX-SLOT-133.webp?v=1761899054427",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-133",
    platFormCode: "RELAX",
  },
  {
    name: "Lucky Monkey",
    img: "/assets/Slot/PP-SLOT-621.Lucky Monkey.webp?v=1764333244563",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-621",
    platFormCode: "PP",
  },
  {
    name: "Lucky Mouse",
    img: "/assets/Slot/PP-SLOT-616.Lucky Mouse.webp?v=1764333202125",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-616",
    platFormCode: "PP",
  },
  {
    name: "Lucky Neko",
    img: "/assets/Slot/YGG-SLOT-095.webp?v=1767056428436",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-095",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lucky New Year",
    img: "/assets/Slot/PP-SLOT-113.Lucky New Year.webp?v=1764333158638",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-113",
    platFormCode: "PP",
  },
  {
    name: "Lucky New Year - Tiger Treasures",
    img: "/assets/Slot/PP-SLOT-219.Lucky New Year - Tiger Treasures.webp?v=1764333086208",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-219",
    platFormCode: "PP",
  },
  {
    name: "Lucky Oktoberfest",
    img: "/assets/Slot/RT-SLOT-157.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-157",
    platFormCode: "RT",
  },
  {
    name: "Lucky Ox",
    img: "/assets/Slot/PP-SLOT-617.Lucky Ox.webp?v=1764333005705",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-617",
    platFormCode: "PP",
  },
  {
    name: "Lucky Phoenix",
    img: "/assets/Slot/PP-SLOT-623.Lucky Phoenix.webp?v=1764332903682",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-623",
    platFormCode: "PP",
  },
  {
    name: "Lucky Piggy",
    img: "/assets/Slot/PG-SLOT-101.webp?v=1765933237829",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-101",
    platFormCode: "PG",
  },
  {
    name: "Lucky Riches",
    img: "/assets/Slot/ACEWIN-SLOT-004.Lucky Riches.webp?v=1764854291848",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-004",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lucky Rooster",
    img: "/assets/Slot/7cz37fritkfao.Lucky-Rooster.webp?v=1765041190241",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-105",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Seven",
    img: "/assets/Slot/JDB-SLOT-041.lucky_777.webp?v=1765261799146",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-041",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Seven Spin",
    img: "/assets/Slot/OCTOPLAY-SLOT-063.Lucky seven spin.webp?v=1764934407216",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-063",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Lucky Streak",
    img: "/assets/Slot/3fx69pizs144w.Lucky-Streak.webp?v=1765052440747",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-106",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Tiger",
    img: "/assets/Slot/PP-SLOT-615.Lucky Tiger.webp?v=1764332863116",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-615",
    platFormCode: "PP",
  },
  {
    name: "Lucky Tiger 1000",
    img: "/assets/Slot/PP-SLOT-622.Lucky Tiger 1000.webp?v=1770095367588",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-622",
    platFormCode: "PP",
  },
  {
    name: "Lucky's Wild Pub",
    img: "/assets/Slot/PP-SLOT-550.webp?v=1755571953063",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-550",
    platFormCode: "PP",
  },
  {
    name: "Luminous Life",
    img: "/assets/Slot/PT-SLOT-115.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-115",
    platFormCode: "PT",
  },
  {
    name: "Lure of Fortune",
    img: "/assets/Slot/RELAX-SLOT-206.webp?v=1761899234219",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-206",
    platFormCode: "RELAX",
  },
  {
    name: "MAGIC DROP",
    img: "/assets/Slot/2J-SLOT-063.MAGIC DROP.webp?v=1763548626862",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-063",
    platFormCode: "JJ",
  },
  {
    name: "MEDUSA UNLEASHED",
    img: "/assets/Slot/2J-SLOT-021.MEDUSA UNLEASHED.webp?v=1763548584178",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-021",
    platFormCode: "JJ",
  },
  {
    name: "MERMAID'S DANCE",
    img: "/assets/Slot/2J-SLOT-013.MERMAID_S DANCE.webp?v=1763548540412",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-013",
    platFormCode: "JJ",
  },
  {
    name: "MONEY MANIA",
    img: "/assets/Slot/2J-SLOT-051.MONEY MANIA.webp?v=1769697769527",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-051",
    platFormCode: "JJ",
  },
  {
    name: "MR.FRANKENSTEIN",
    img: "/assets/Slot/2J-SLOT-017.MR.FRANKENSTEIN.webp?v=1763548433918",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-017",
    platFormCode: "JJ",
  },
  {
    name: "Macabra Linx",
    img: "/assets/Slot/PT-SLOT-318.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-318",
    platFormCode: "PT",
  },
  {
    name: "Macau Racing",
    img: "/assets/Slot/RT-SLOT-305.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-305",
    platFormCode: "RT",
  },
  {
    name: "Mad Hit Devil",
    img: "/assets/Slot/PT-SLOT-476.Mad Hit Devil.webp?v=1764947367250",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-476",
    platFormCode: "PT",
  },
  {
    name: "Mad Hit Diamonds",
    img: "/assets/Slot/PT-SLOT-424.mad,hit-diamonds.webp?v=1764333229292",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-424",
    platFormCode: "PT",
  },
  {
    name: "Mad Melons Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-056.mad melons chaos reels.webp?v=1764934475953",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-056",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Madame Destiny",
    img: "/assets/Slot/PP-SLOT-102.Madame Destiny.webp?v=1764332735480",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-102",
    platFormCode: "PP",
  },
  {
    name: "Madame Destiny Megaways",
    img: "/assets/Slot/PP-SLOT-008.Madame Destiny Megaways.webp?v=1764332673339",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-008",
    platFormCode: "PP",
  },
  {
    name: "Mafioso",
    img: "/assets/Slot/YGG-SLOT-405.webp?v=1767056428915",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-405",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Magawa vs Mines",
    img: "/assets/Slot/RELAX-SLOT-275.webp?v=1761899266797",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-275",
    platFormCode: "RELAX",
  },
  {
    name: "Magic Journey",
    img: "/assets/Slot/PP-SLOT-063.Magic Journey.webp?v=1764332608546",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-063",
    platFormCode: "PP",
  },
  {
    name: "Magic Kitty",
    img: "/assets/Slot/SG-SLOT-091.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-091",
    platFormCode: "SPADE",
  },
  {
    name: "Magic Money Maze",
    img: "/assets/Slot/PP-SLOT-266.Magic Money Maze.webp?v=1764332552468",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-266",
    platFormCode: "PP",
  },
  {
    name: "Magic Powers Megaways",
    img: "/assets/Slot/RT-SLOT-242.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-242",
    platFormCode: "RT",
  },
  {
    name: "Magician's Secrets",
    img: "/assets/Slot/PP-SLOT-223.Magician_s Secrets.webp?v=1764332474346",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-223",
    platFormCode: "PP",
  },
  {
    name: "Magikspell",
    img: "/assets/Slot/RELAX-SLOT-117.webp?v=1761899291993",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-117",
    platFormCode: "RELAX",
  },
  {
    name: "Mahjong",
    img: "/assets/Slot/JDB-SLOT-029.mahjong.webp?v=1765261645546",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-029",
    platFormCode: "JDB",
  },
  {
    name: "Mahjong Dragon Ways",
    img: "/assets/Slot/KM-SLOT-026.Mahjong Dragon Ways.webp?v=1764861408775",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-026",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Mahjong Panda",
    img: "/assets/Slot/PP-SLOT-260.Mahjong Panda.webp?v=1764332414621",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-260",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Ways",
    img: "/assets/Slot/PG-SLOT-041.webp?v=1765933237781",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-041",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Ways 2",
    img: "/assets/Slot/PG-SLOT-050.webp?v=1765933237791",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-050",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Wins",
    img: "/assets/Slot/PP-SLOT-372.Mahjong Wins.webp?v=1764332353837",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-372",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins Bonus",
    img: "/assets/Slot/PP-SLOT-413.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-413",
    platFormCode: "PP",
  },
  {
    name: "MahjongWays",
    img: "/assets/Slot/YL-EGAME-027.MahjongWays.webp?v=1764321043333",
    platForm: "YL",
    type: "SLOTS",
    gameType: "EGAME",
    casinoType: "YL-EGAME-027",
    platFormCode: "YL",
  },
  {
    name: "Majapahit",
    img: "/assets/Slot/67s75yrbo4dae.Majapahit.webp?v=1765053285039",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-107",
    platFormCode: "JOKER",
  },
  {
    name: "Majestic Treasures",
    img: "/assets/Slot/PG-SLOT-073.webp?v=1765933237806",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-073",
    platFormCode: "PG",
  },
  {
    name: "Major Miners",
    img: "/assets/Slot/YGG-SLOT-320.webp?v=1767056428821",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-320",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mammamia",
    img: "/assets/Slot/9xpa7brfxj7zo.Mammamia.webp?v=1765041607808",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-108",
    platFormCode: "JOKER",
  },
  {
    name: "Mammoth Gold Megaways",
    img: "/assets/Slot/PP-SLOT-314.Mammoth Gold Megaways.webp?v=1764332208859",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-314",
    platFormCode: "PP",
  },
  {
    name: "Manhattan Goes Wild",
    img: "/assets/Slot/NLC-SLOT-043.Manhattan Goes Wild.webp?v=1764388826509",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-043",
    platFormCode: "NLC",
  },
  {
    name: "Marching Legions",
    img: "/assets/Slot/RELAX-SLOT-036.webp?v=1761899362153",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-036",
    platFormCode: "RELAX",
  },
  {
    name: "Mask Carnival",
    img: "/assets/Slot/PG-SLOT-091.webp?v=1765933237820",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-091",
    platFormCode: "PG",
  },
  {
    name: "Masskara Mania",
    img: "/assets/Slot/ACEWIN-SLOT-032.webp?v=1762477160143",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-032",
    platFormCode: "ACEWIN",
  },
  {
    name: "Master Chen's Fortune",
    img: "/assets/Slot/PP-SLOT-097.Master Chen_s Fortune.webp?v=1764332142577",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-097",
    platFormCode: "PP",
  },
  {
    name: "Master Joker",
    img: "/assets/Slot/PP-SLOT-059.Master Joker.webp?v=1764332023845",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-059",
    platFormCode: "PP",
  },
  {
    name: "Master Tiger",
    img: "/assets/Slot/JILI-SLOT-077.webp?v=1755510054553",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-077",
    platFormCode: "JILI",
  },
  {
    name: "Max Megaways",
    img: "/assets/Slot/BTG-SLOT-019.Max Megaways.webp?v=1764409604798",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-019",
    platFormCode: "BTG",
  },
  {
    name: "Max Megaways 3",
    img: "/assets/Slot/BTG-SLOT-060.webp?v=1756256536972",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-060",
    platFormCode: "BTG",
  },
  {
    name: "Maximum Fish",
    img: "/assets/Slot/YGG-SLOT-392.webp?v=1767056428898",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-392",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mayan Blocks",
    img: "/assets/Slot/PT-SLOT-102.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-102",
    platFormCode: "PT",
  },
  {
    name: "Mayan Empire",
    img: "/assets/Slot/ACEWIN-SLOT-020.Mayan Empire.webp?v=1764854406017",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-020",
    platFormCode: "ACEWIN",
  },
  {
    name: "Mayan Gems",
    img: "/assets/Slot/SG-SLOT-086.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-086",
    platFormCode: "SPADE",
  },
  {
    name: "Mayan Magic Wildfire",
    img: "/assets/Slot/NLC-SLOT-048.Mayan Magic Wildfire.webp?v=1764388732003",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-048",
    platFormCode: "NLC",
  },
  {
    name: "Mayan Temple Riches",
    img: "/assets/Slot/YGG-SLOT-278.webp?v=1767056428784",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-278",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mayhem",
    img: "/assets/Slot/RT-SLOT-181.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-181",
    platFormCode: "RT",
  },
  {
    name: "Maze Escape",
    img: "/assets/Slot/RELAX-SLOT-077.webp?v=1761899433574",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-077",
    platFormCode: "RELAX",
  },
  {
    name: "Medallion Megaways",
    img: "/assets/Slot/RELAX-SLOT-101.webp?v=1761899534946",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-101",
    platFormCode: "RELAX",
  },
  {
    name: "Medusa",
    img: "/assets/Slot/PG-SLOT-006.webp?v=1765933237757",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-006",
    platFormCode: "PG",
  },
  {
    name: "Medusa Hot 1",
    img: "/assets/Slot/YGG-SLOT-084.webp?v=1767056428427",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-084",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Medusa2",
    img: "/assets/Slot/PG-SLOT-005.webp?v=1765933237756",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-005",
    platFormCode: "PG",
  },
  {
    name: "Mega Ace",
    img: "/assets/Slot/JILI-SLOT-051.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    platFormCode: "JILI",
  },
  {
    name: "Mega Cash Stacks",
    img: "/assets/Slot/YGG-SLOT-155.webp?v=1767056428487",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-155",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mega Dragon",
    img: "/assets/Slot/RT-SLOT-118.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-118",
    platFormCode: "RT",
  },
  {
    name: "Mega Fire Blaze Lucky Bass",
    img: "/assets/Slot/PT-SLOT-439.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-439",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Big Circus!",
    img: "/assets/Slot/PT-SLOT-092.Mega Fire Blaze Big Circus!.webp?v=1764328409931",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-092",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Emperor of Rome",
    img: "/assets/Slot/PT-SLOT-244.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-244",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Khonsu God of Moon",
    img: "/assets/Slot/PT-SLOT-153.Mega Fire Blaze Khonsu God of Moon.webp?v=1764330881366",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-153",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Wild Pistolero",
    img: "/assets/Slot/PT-SLOT-091.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-091",
    platFormCode: "PT",
  },
  {
    name: "Mega Flip",
    img: "/assets/Slot/RELAX-SLOT-037.webp?v=1761899598251",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-037",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Heist",
    img: "/assets/Slot/RELAX-SLOT-177.webp?v=1761899679642",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-177",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Masks",
    img: "/assets/Slot/RELAX-SLOT-038.webp?v=1761899749300",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-038",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Mine",
    img: "/assets/Slot/RELAX-SLOT-068.webp?v=1761899801299",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-068",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Money Machine",
    img: "/assets/Slot/YGG-SLOT-228.webp?v=1767056428577",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-228",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mega Pearl Gigablox",
    img: "/assets/Slot/YGG-SLOT-143.webp?v=1767056428477",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-143",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Megaways Mob",
    img: "/assets/Slot/RELAX-SLOT-118.webp?v=1761899888066",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-118",
    platFormCode: "RELAX",
  },
  {
    name: "Mental",
    img: "/assets/Slot/NLC-SLOT-002.Mental.webp?v=1764388684372",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-002",
    platFormCode: "NLC",
  },
  {
    name: "Merlin's Beard",
    img: "/assets/Slot/YGG-SLOT-302.webp?v=1767056428804",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-302",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mermaid Riches",
    img: "/assets/Slot/PG-SLOT-081.webp?v=1765933237812",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-081",
    platFormCode: "PG",
  },
  {
    name: "MexoMax! Multimax",
    img: "/assets/Slot/YGG-SLOT-149.webp?v=1767056428482",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-149",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Miami",
    img: "/assets/Slot/tqi9778i7mi6o.Miami.webp?v=1765043074579",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-110",
    platFormCode: "JOKER",
  },
  {
    name: "Midas Fortune",
    img: "/assets/Slot/PG-SLOT-111.webp?v=1765933237837",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-111",
    platFormCode: "PG",
  },
  {
    name: "Midas Moolah: Random Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-050.midas moolah random reels.webp?v=1764934535344",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-050",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Midnight Marauder",
    img: "/assets/Slot/RELAX-SLOT-122.webp?v=1761899915379",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-122",
    platFormCode: "RELAX",
  },
  {
    name: "Midnight Wilds",
    img: "/assets/Slot/PT-SLOT-203.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-203",
    platFormCode: "PT",
  },
  {
    name: "Might of Ra",
    img: "/assets/Slot/PP-SLOT-243.Might of Ra.webp?v=1764331796594",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-243",
    platFormCode: "PP",
  },
  {
    name: "Mighty Hat: Lamp of Gold",
    img: "/assets/Slot/PT-SLOT-105.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-105",
    platFormCode: "PT",
  },
  {
    name: "Mighty Kong",
    img: "/assets/Slot/PP-SLOT-143.Mighty Kong.webp?v=1764331740626",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-143",
    platFormCode: "PP",
  },
  {
    name: "Mighty Munching Melons",
    img: "/assets/Slot/PP-SLOT-432.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-432",
    platFormCode: "PP",
  },
  {
    name: "Milky Ways",
    img: "/assets/Slot/NLC-SLOT-036.Milky Ways.webp?v=1764388436101",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-036",
    platFormCode: "NLC",
  },
  {
    name: "Millionaire Tapcards",
    img: "/assets/Slot/BTG-SLOT-066.webp?v=1756256536977",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-066",
    platFormCode: "BTG",
  },
  {
    name: "Mine and Win",
    img: "/assets/Slot/YGG-SLOT-351.webp?v=1767056428857",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-351",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mining Rush",
    img: "/assets/Slot/PP-SLOT-530.Mining Rush.webp?v=1764331665381",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-530",
    platFormCode: "PP",
  },
  {
    name: "Misery Mining",
    img: "/assets/Slot/NLC-SLOT-015.Misery Mining.webp?v=1764388366469",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-015",
    platFormCode: "NLC",
  },
  {
    name: "Miss Fortune",
    img: "/assets/Slot/PT-SLOT-065.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-065",
    platFormCode: "PT",
  },
  {
    name: "Mole Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-029.mole smash.webp?v=1764934750450",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-029",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Moleionaire",
    img: "/assets/Slot/PP-SLOT-517.Moleionaire.webp?v=1764331613784",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-517",
    platFormCode: "PP",
  },
  {
    name: "Moley Moolah",
    img: "/assets/Slot/YGG-SLOT-002.webp?v=1767056428320",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-002",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Cart",
    img: "/assets/Slot/RELAX-SLOT-098.webp?v=1761899984037",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-098",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 2",
    img: "/assets/Slot/RELAX-SLOT-060.webp?v=1761900029089",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-060",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 3",
    img: "/assets/Slot/RELAX-SLOT-173.webp?v=1761900092421",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-173",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 4",
    img: "/assets/Slot/RELAX-SLOT-221.webp?v=1761900127418",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-221",
    platFormCode: "RELAX",
  },
  {
    name: "Money Flash",
    img: "/assets/Slot/YGG-SLOT-407.webp?v=1767056428917",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-407",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Mariachi Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-130.webp?v=1767056428466",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-130",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Money Money",
    img: "/assets/Slot/PP-SLOT-044.Money Money Money.webp?v=1764331552585",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-044",
    platFormCode: "PP",
  },
  {
    name: "Money Mouse",
    img: "/assets/Slot/SG-SLOT-071.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-064",
    platFormCode: "PP",
  },
  {
    name: "Money Roll",
    img: "/assets/Slot/PP-SLOT-166.Money Roll.webp?v=1764331432759",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-166",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks",
    img: "/assets/Slot/PP-SLOT-482.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-482",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks Megaways",
    img: "/assets/Slot/PP-SLOT-528.Money Stacks Megaways.webp?v=1764331340151",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-528",
    platFormCode: "PP",
  },
  {
    name: "Money Train",
    img: "/assets/Slot/RELAX-SLOT-039.webp?v=1761900159405",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-039",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 2",
    img: "/assets/Slot/RELAX-SLOT-040.webp?v=1761900222714",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-040",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 3",
    img: "/assets/Slot/RELAX-SLOT-137.webp?v=1761900384743",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-137",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 4",
    img: "/assets/Slot/RELAX-SLOT-198.webp?v=1761900420753",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-198",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train Origins",
    img: "/assets/Slot/RELAX-SLOT-182.webp?v=1761900450117",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-182",
    platFormCode: "RELAX",
  },
  {
    name: "Money Vault",
    img: "/assets/Slot/oajk3h9o685xq.Money-Vault.webp?v=1765051105354",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-112",
    platFormCode: "JOKER",
  },
  {
    name: "Monkey Madness",
    img: "/assets/Slot/PP-SLOT-165.Monkey Madness.webp?v=1764331278584",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-165",
    platFormCode: "PP",
  },
  {
    name: "Monkey Warrior",
    img: "/assets/Slot/PP-SLOT-078.Monkey Warrior.webp?v=1764331220456",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-078",
    platFormCode: "PP",
  },
  {
    name: "Monkey and Rat",
    img: "/assets/Slot/PT-SLOT-152.monkey-and-rat.webp?v=1764331042322",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-152",
    platFormCode: "PT",
  },
  {
    name: "Monkey's Gold xPays",
    img: "/assets/Slot/NLC-SLOT-032.Monkey_s Gold xPays.webp?v=1764388311950",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-032",
    platFormCode: "NLC",
  },
  {
    name: "Monkeys Go Bananas",
    img: "/assets/Slot/YGG-SLOT-261.webp?v=1767056428769",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-261",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Monster Blox",
    img: "/assets/Slot/YGG-SLOT-124.webp?v=1767056428462",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-124",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Monster Multipliers",
    img: "/assets/Slot/PT-SLOT-110.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-110",
    platFormCode: "PT",
  },
  {
    name: "Monster Superlanche",
    img: "/assets/Slot/PP-SLOT-318.Monster Superlanche.webp?v=1764331158070",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-318",
    platFormCode: "PP",
  },
  {
    name: "Monsters VS Gigablox",
    img: "/assets/Slot/YGG-SLOT-148.webp?v=1767056428482",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-148",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Moonlight Treasure",
    img: "/assets/Slot/JDB-SLOT-028.moonlight_treasure.webp?v=1765261284043",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-028",
    platFormCode: "JDB",
  },
  {
    name: "Moonshot",
    img: "/assets/Slot/PP-SLOT-331.Moonshot.webp?v=1764331092443",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-331",
    platFormCode: "PP",
  },
  {
    name: "Mr Hallow-Jackpot!",
    img: "/assets/Slot/PG-SLOT-019.webp?v=1765933237765",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-019",
    platFormCode: "PG",
  },
  {
    name: "Mr Piggles",
    img: "/assets/Slot/OCTOPLAY-SLOT-012.Mr piggles.webp?v=1764934785965",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-012",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Mr. Cashback",
    img: "/assets/Slot/PT-SLOT-063.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-063",
    platFormCode: "PT",
  },
  {
    name: "Muay Thai Champion",
    img: "/assets/Slot/PG-SLOT-039.webp?v=1765933237779",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-039",
    platFormCode: "PG",
  },
  {
    name: "Muertos Multiplier Megaways",
    img: "/assets/Slot/PP-SLOT-283.Muertos Multiplier Megaways.webp?v=1764331031355",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-283",
    platFormCode: "PP",
  },
  {
    name: "Mulan",
    img: "/assets/Slot/bcizh7dipjiso.Mulan.webp?v=1765047298172",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-114",
    platFormCode: "JOKER",
  },
  {
    name: "Multifly!",
    img: "/assets/Slot/YGG-SLOT-093.webp?v=1767056428435",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-093",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Multiplier Odyssey",
    img: "/assets/Slot/RELAX-SLOT-041.webp?v=1761900480080",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-041",
    platFormCode: "RELAX",
  },
  {
    name: "Multiplier Riches",
    img: "/assets/Slot/RT-SLOT-126.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-126",
    platFormCode: "RT",
  },
  {
    name: "Mummy Mia",
    img: "/assets/Slot/ACEWIN-SLOT-034.webp?v=1762477182129",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-034",
    platFormCode: "ACEWIN",
  },
  {
    name: "Mustang Gold",
    img: "/assets/Slot/PP-SLOT-093.Mustang Gold.webp?v=1764330884209",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-093",
    platFormCode: "PP",
  },
  {
    name: "Mustang Trail",
    img: "/assets/Slot/PP-SLOT-368.Mustang Trail.webp?v=1764330750601",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-368",
    platFormCode: "PP",
  },
  {
    name: "Mutagenes",
    img: "/assets/Slot/YGG-SLOT-275.webp?v=1767056428781",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-275",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mutant Potatoes",
    img: "/assets/Slot/OCTOPLAY-SLOT-013.Mutant Potatoes.webp?v=1764934823538",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-013",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Mutant Trawlers",
    img: "/assets/Slot/YGG-SLOT-259.webp?v=1767056428766",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-259",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mysterious",
    img: "/assets/Slot/PP-SLOT-057.Mysterious.webp?v=1764330689387",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-057",
    platFormCode: "PP",
  },
  {
    name: "Mysterious Egypt",
    img: "/assets/Slot/PP-SLOT-011.Mysterious Egypt.webp?v=1764330625310",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-011",
    platFormCode: "PP",
  },
  {
    name: "Mystery Mice",
    img: "/assets/Slot/PP-SLOT-496.Mystery Mice.webp?v=1764330561967",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-496",
    platFormCode: "PP",
  },
  {
    name: "Mystery Of The Orient",
    img: "/assets/Slot/PP-SLOT-326.Mystery Of The Orient.webp?v=1764330497787",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-326",
    platFormCode: "PP",
  },
  {
    name: "Mystery Reels Deluxe",
    img: "/assets/Slot/RT-SLOT-194.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-194",
    platFormCode: "RT",
  },
  {
    name: "Mystery Reels MegaWays",
    img: "/assets/Slot/RT-SLOT-051.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-051",
    platFormCode: "RT",
  },
  {
    name: "Mystery Reels Power Reels",
    img: "/assets/Slot/RT-SLOT-158.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-158",
    platFormCode: "RT",
  },
  {
    name: "Mystic Chief",
    img: "/assets/Slot/PP-SLOT-205.Mystic Chief.webp?v=1764330421690",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-205",
    platFormCode: "PP",
  },
  {
    name: "Mystic Magic",
    img: "/assets/Slot/YGG-SLOT-285.webp?v=1767056428790",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-285",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mystic Spells",
    img: "/assets/Slot/RELAX-SLOT-202.webp?v=1761900525094",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-202",
    platFormCode: "RELAX",
  },
  {
    name: "Mystic Staxx",
    img: "/assets/Slot/RT-SLOT-135.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-135",
    platFormCode: "RT",
  },
  {
    name: "Mystic Wishes",
    img: "/assets/Slot/PP-SLOT-632.Mystic Wishes.webp?v=1764330364181",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-632",
    platFormCode: "PP",
  },
  {
    name: "Mystical Spirits",
    img: "/assets/Slot/PG-SLOT-117.webp?v=1765933237843",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-117",
    platFormCode: "PG",
  },
  {
    name: "Mythical Sand",
    img: "/assets/Slot/m94wkgy3daxta.Mythical-Sand.webp?v=1765047953874",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-115",
    platFormCode: "JOKER",
  },
  {
    name: "Napoleon",
    img: "/assets/Slot/JDB-SLOT-048.napoleon.webp?v=1765261230832",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-048",
    platFormCode: "JDB",
  },
  {
    name: "Napoleon vs Rabbits",
    img: "/assets/Slot/RELAX-SLOT-155.webp?v=1761900555120",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-155",
    platFormCode: "RELAX",
  },
  {
    name: "Narcos Mexico",
    img: "/assets/Slot/RT-SLOT-222.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-222",
    platFormCode: "RT",
  },
  {
    name: "Nautical Treasures",
    img: "/assets/Slot/YGG-SLOT-350.webp?v=1767056428856",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-350",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neko Fortune",
    img: "/assets/Slot/JILI-SLOT-071.webp?v=1755509899422",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-071",
    platFormCode: "JILI",
  },
  {
    name: "Neko Night",
    img: "/assets/Slot/RELAX-SLOT-169.webp?v=1761900578490",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-169",
    platFormCode: "RELAX",
  },
  {
    name: "Neon Links",
    img: "/assets/Slot/RT-SLOT-207.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-207",
    platFormCode: "RT",
  },
  {
    name: "Neon Rush: Splitz",
    img: "/assets/Slot/YGG-SLOT-046.webp?v=1767056428373",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-046",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neon Villains DoubleMax",
    img: "/assets/Slot/YGG-SLOT-177.webp?v=1767056428516",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-177",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neon West",
    img: "/assets/Slot/YGG-SLOT-412.webp?v=1767056428921",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-412",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neptune Treasure",
    img: "/assets/Slot/5ii9zgw5unc3h.Neptune-Treasure.webp?v=1765042056370",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-117",
    platFormCode: "JOKER",
  },
  {
    name: "Neptune's Kingdom",
    img: "/assets/Slot/PT-SLOT-137.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-137",
    platFormCode: "PT",
  },
  {
    name: "Net Gains",
    img: "/assets/Slot/RELAX-SLOT-156.webp?v=1761900606138",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-156",
    platFormCode: "RELAX",
  },
  {
    name: "New Year",
    img: "/assets/Slot/JDB-SLOT-016.New Year.webp?v=1765261180983",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    platFormCode: "JDB",
  },
  {
    name: "Ni Shu Shen Me",
    img: "/assets/Slot/PT-SLOT-022.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-022",
    platFormCode: "PT",
  },
  {
    name: "Nice Catch 2",
    img: "/assets/Slot/YGG-SLOT-237.webp?v=1767056428590",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-237",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Nice Catch Doublemax",
    img: "/assets/Slot/YGG-SLOT-193.webp?v=1767056428531",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-193",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Night Roller",
    img: "/assets/Slot/RT-SLOT-202.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-202",
    platFormCode: "RT",
  },
  {
    name: "Nightmare Family Megaways",
    img: "/assets/Slot/RT-SLOT-307.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-307",
    platFormCode: "RT",
  },
  {
    name: "Nile Fortune",
    img: "/assets/Slot/PP-SLOT-402.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-402",
    platFormCode: "PP",
  },
  {
    name: "Ninja vs Samurai",
    img: "/assets/Slot/PG-SLOT-040.webp?v=1765933237780",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-040",
    platFormCode: "PG",
  },
  {
    name: "Nirvana",
    img: "/assets/Slot/YGG-SLOT-022.webp?v=1767056428347",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-022",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "North Guardians",
    img: "/assets/Slot/PP-SLOT-253.North Guardians.webp?v=1764330217781",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-253",
    platFormCode: "PP",
  },
  {
    name: "Notre-Dame Tales",
    img: "/assets/Slot/YGG-SLOT-208.webp?v=1767056428557",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-208",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Nugget Hunter",
    img: "/assets/Slot/84igeq3a8r9d6.Nugget-Hunter.webp?v=1765045595141",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-119",
    platFormCode: "JOKER",
  },
  {
    name: "ORB OF GANESHA",
    img: "/assets/Slot/2J-SLOT-046.ORB OF GANESHA.webp?v=1763548390074",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-046",
    platFormCode: "JJ",
  },
  {
    name: "ORIENTAL RICHES",
    img: "/assets/Slot/2J-SLOT-032.ORIENTAL RICHES.webp?v=1763548337104",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-032",
    platFormCode: "JJ",
  },
  {
    name: "Oasis",
    img: "/assets/Slot/ggutqu1xjtgwr.Oasis.webp?v=1765048974787",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-120",
    platFormCode: "JOKER",
  },
  {
    name: "Ocean Frenzy",
    img: "/assets/Slot/PT-SLOT-423.ocean-frenzy.webp?v=1764333316474",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-423",
    platFormCode: "PT",
  },
  {
    name: "Ocean Paradise",
    img: "/assets/Slot/kf41ymtxfos1r.OceanParadise.webp?v=1765045184681",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-121",
    platFormCode: "JOKER",
  },
  {
    name: "Ocean Spray",
    img: "/assets/Slot/7b6c7rcs16kjk.Ocean-Spray.webp?v=1765049148923",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-122",
    platFormCode: "JOKER",
  },
  {
    name: "Octagon Gem",
    img: "/assets/Slot/4tyxfmpnwqokn.Octagon-Gem.webp?v=1765046429427",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-123",
    platFormCode: "JOKER",
  },
  {
    name: "Octagon Gem 2",
    img: "/assets/Slot/gsttgo1debywc.Octagon-Gem-2.webp?v=1765047210118",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-124",
    platFormCode: "JOKER",
  },
  {
    name: "Octobeer Fortunes",
    img: "/assets/Slot/PP-SLOT-271.Octobeer Fortunes.webp?v=1764330162055",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-271",
    platFormCode: "PP",
  },
  {
    name: "Odds On Winner",
    img: "/assets/Slot/PP-SLOT-458.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-458",
    platFormCode: "PP",
  },
  {
    name: "Odin Infinity Reels Megaways",
    img: "/assets/Slot/YGG-SLOT-010.webp?v=1767056428333",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-010",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Odin Lightning Blitz",
    img: "/assets/Slot/YGG-SLOT-282.webp?v=1767056428787",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-282",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Of Sabers and Monsters Wild Fight",
    img: "/assets/Slot/YGG-SLOT-153.webp?v=1767056428486",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-153",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Oink Oink Oink",
    img: "/assets/Slot/PT-SLOT-319.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-319",
    platFormCode: "PT",
  },
  {
    name: "Oink Oink Oink Pharaohs",
    img: "/assets/Slot/PT-SLOT-440.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-440",
    platFormCode: "PT",
  },
  {
    name: "Olympian Temple",
    img: "/assets/Slot/JDB-SLOT-020.Olympian Temple.webp?v=1765261129736",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-020",
    platFormCode: "JDB",
  },
  {
    name: "Ong Bak Deluxe",
    img: "/assets/Slot/bkxno75wqiigs.Ong-Bak-Deluxe.webp?v=1765053232919",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-126",
    platFormCode: "JOKER",
  },
  {
    name: "Oodles of Noodles",
    img: "/assets/Slot/PP-SLOT-495.Oodles of Noodles.webp?v=1764330038719",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-495",
    platFormCode: "PP",
  },
  {
    name: "Open Sesame II",
    img: "/assets/Slot/JDB-SLOT-051.open_sesame_II.webp?v=1765260983062",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-051",
    platFormCode: "JDB",
  },
  {
    name: "Opera Dynasty",
    img: "/assets/Slot/PG-SLOT-069.webp?v=1765933237803",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-069",
    platFormCode: "PG",
  },
  {
    name: "Orca's Wild Bonanza",
    img: "/assets/Slot/YGG-SLOT-198.webp?v=1767056428548",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-198",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Orient Animals",
    img: "/assets/Slot/JDB-SLOT-042.orient_animals.webp?v=1765260880285",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-042",
    platFormCode: "JDB",
  },
  {
    name: "Orient Express",
    img: "/assets/Slot/YGG-SLOT-056.webp?v=1767056428391",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-056",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Oriental Prosperity",
    img: "/assets/Slot/PG-SLOT-092.webp?v=1765933237821",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-092",
    platFormCode: "PG",
  },
  {
    name: "Out of The Ice",
    img: "/assets/Slot/RELAX-SLOT-120.webp?v=1761900631705",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-120",
    platFormCode: "RELAX",
  },
  {
    name: "Outsourced Payday",
    img: "/assets/Slot/NLC-SLOT-101.Outsourced Payday.webp?v=1764387977816",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-101",
    platFormCode: "NLC",
  },
  {
    name: "Over Dragon's Gate",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-012.over-dragon_s-gate.webp?v=1765272943523",
    platForm: "DS",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Owls",
    img: "/assets/Slot/NLC-SLOT-051.Owls.webp?v=1764387899277",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-051",
    platFormCode: "NLC",
  },
  {
    name: "Ox Riches",
    img: "/assets/Slot/PT-SLOT-037.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-037",
    platFormCode: "PT",
  },
  {
    name: "PIGGY BANKIN",
    img: "/assets/Slot/2J-SLOT-047.PIGGY BANKIN.webp?v=1763548244928",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-047",
    platFormCode: "JJ",
  },
  {
    name: "PIZZA! PIZZA? PIZZA!",
    img: "/assets/Slot/PP-SLOT-308.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-308",
    platFormCode: "PP",
  },
  {
    name: "POKER WIN 2",
    img: "/assets/Slot/FC-SLOT-057.POKER WIN 2.webp?v=1764940640691",
    platForm: "FC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "FC-SLOT-057",
    platFormCode: "FC",
  },
  {
    name: "POWER OF KRAKEN",
    img: "/assets/Slot/2J-SLOT-061.POWER OF KRAKEN.webp?v=1763548202566",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-061",
    platFormCode: "JJ",
  },
  {
    name: "PUMPKIN PARTY",
    img: "/assets/Slot/2J-SLOT-043.PUMPKIN PARTY.webp?v=1763548156918",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-043",
    platFormCode: "JJ",
  },
  {
    name: "Pan Jin Lian 2",
    img: "/assets/Slot/c53raraonrmbq.Pan-Jian-Lian2.webp?v=1765043453463",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-128",
    platFormCode: "JOKER",
  },
  {
    name: "Panda Bills",
    img: "/assets/Slot/OCTOPLAY-SLOT-014.Panda Bills.webp?v=1764934862677",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-014",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Panda Fortune 2",
    img: "/assets/Slot/PP-SLOT-178.Panda Fortune 2.webp?v=1764329853329",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-178",
    platFormCode: "PP",
  },
  {
    name: "Panda Luck",
    img: "/assets/Slot/PT-SLOT-197.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-197",
    platFormCode: "PT",
  },
  {
    name: "Panda's Fortune",
    img: "/assets/Slot/PP-SLOT-116.Panda_s Fortune.webp?v=1764329790207",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-116",
    platFormCode: "PP",
  },
  {
    name: "Panther Pays",
    img: "/assets/Slot/PT-SLOT-230.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-230",
    platFormCode: "PT",
  },
  {
    name: "Path of Destiny",
    img: "/assets/Slot/RT-SLOT-125.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-125",
    platFormCode: "RT",
  },
  {
    name: "Pay Pig 10K WAYS",
    img: "/assets/Slot/RELAX-SLOT-269.webp?v=1761901145438",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-269",
    platFormCode: "RELAX",
  },
  {
    name: "Payday Megaways",
    img: "/assets/Slot/RELAX-SLOT-243.webp?v=1761901190255",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-243",
    platFormCode: "RELAX",
  },
  {
    name: "Peach Banquet",
    img: "/assets/Slot/s77hiogba5dhe.Peach-Banquet.webp?v=1765042562343",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-130",
    platFormCode: "JOKER",
  },
  {
    name: "Peak Power",
    img: "/assets/Slot/PP-SLOT-324.Peak Power.webp?v=1764329684742",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-324",
    platFormCode: "PP",
  },
  {
    name: "Pearl Harbor",
    img: "/assets/Slot/NLC-SLOT-018.Pearl Harbor.webp?v=1764387843128",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-018",
    platFormCode: "NLC",
  },
  {
    name: "Pearls Pearls Pearls",
    img: "/assets/Slot/PT-SLOT-178.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-178",
    platFormCode: "PT",
  },
  {
    name: "Pearly Shores",
    img: "/assets/Slot/OCTOPLAY-SLOT-015.Pearly Shores.webp?v=1764934910776",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-015",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Peggy Sweets",
    img: "/assets/Slot/RT-SLOT-137.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-137",
    platFormCode: "RT",
  },
  {
    name: "Peking Luck",
    img: "/assets/Slot/PP-SLOT-099.Peking Luck.webp?v=1764329614646",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-099",
    platFormCode: "PP",
  },
  {
    name: "Penguin City",
    img: "/assets/Slot/YGG-SLOT-034.webp?v=1767056428362",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-034",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Penguins Christmas Party Time",
    img: "/assets/Slot/PP-SLOT-523.Penguins Christmas Party Time.webp?v=1764329560572",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-523",
    platFormCode: "PP",
  },
  {
    name: "Pharaoh Treasure",
    img: "/assets/Slot/JILI-SLOT-038.Pharaoh Treasure.webp?v=1764311424958",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-038",
    platFormCode: "JILI",
  },
  {
    name: "Pharaoh's Daughter",
    img: "/assets/Slot/PT-SLOT-213.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-213",
    platFormCode: "PT",
  },
  {
    name: "Pharaoh's Secrets",
    img: "/assets/Slot/PT-SLOT-126.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-126",
    platFormCode: "PT",
  },
  {
    name: "Pharaoh’s Gaze DoubleMax",
    img: "/assets/Slot/YGG-SLOT-181.webp?v=1767056428519",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-181",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pharaoh’s Rage UltraSpinz",
    img: "/assets/Slot/YGG-SLOT-377.webp?v=1767056428883",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-377",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Phoenix 888",
    img: "/assets/Slot/d8cso3u8ct1iw.Phoenix888.webp?v=1765041656119",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-132",
    platFormCode: "JOKER",
  },
  {
    name: "Phoenix Forge",
    img: "/assets/Slot/PP-SLOT-195.Phoenix Forge.webp?v=1764329487174",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-195",
    platFormCode: "PP",
  },
  {
    name: "Phoenix Rises",
    img: "/assets/Slot/PG-SLOT-053.webp?v=1765933237792",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-053",
    platFormCode: "PG",
  },
  {
    name: "Pigeons from Space",
    img: "/assets/Slot/PT-SLOT-240.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-240",
    platFormCode: "PT",
  },
  {
    name: "Piggies and the Bank: Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-412.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-412",
    platFormCode: "PT",
  },
  {
    name: "Piggies and the Wolf",
    img: "/assets/Slot/PT-SLOT-140.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-140",
    platFormCode: "PT",
  },
  {
    name: "Piggy Bank Bills",
    img: "/assets/Slot/PP-SLOT-202.Piggy Bank Bills.webp?v=1764329372086",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-202",
    platFormCode: "PP",
  },
  {
    name: "Piggy Bankers",
    img: "/assets/Slot/PP-SLOT-370.Piggy Bankers.webp?v=1764329295311",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-370",
    platFormCode: "PP",
  },
  {
    name: "Piggy Coin: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-099.Piggy Coin Hold & Win.webp?v=1764934930326",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-099",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Piggy Gold",
    img: "/assets/Slot/PG-SLOT-023.webp?v=1765933237768",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-023",
    platFormCode: "PG",
  },
  {
    name: "Piggy Mania",
    img: "/assets/Slot/PT-SLOT-433.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-433",
    platFormCode: "PT",
  },
  {
    name: "Piggy Riches™ 3: Hog Heaven",
    img: "/assets/Slot/NETENT-SLOT-231.Piggy Riches™ 3_ Hog Heaven.webp?v=1764956732132",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-231",
    platFormCode: "NETENT",
  },
  {
    name: "Piggy Staxx",
    img: "/assets/Slot/YGG-SLOT-419.webp?v=1767056428927",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-419",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pillage The Village 10K Ways",
    img: "/assets/Slot/YGG-SLOT-348.webp?v=1767056428853",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-348",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pinata Popper",
    img: "/assets/Slot/RELAX-SLOT-197.webp?v=1761901249674",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-197",
    platFormCode: "RELAX",
  },
  {
    name: "Pinatas & Ponies",
    img: "/assets/Slot/RT-SLOT-229.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-229",
    platFormCode: "RT",
  },
  {
    name: "Pine of Plinko",
    img: "/assets/Slot/RELAX-SLOT-157.webp?v=1761901669358",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-157",
    platFormCode: "RELAX",
  },
  {
    name: "Pine of Plinko 2",
    img: "/assets/Slot/RELAX-SLOT-217.webp?v=1761901722427",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-217",
    platFormCode: "RELAX",
  },
  {
    name: "Ping Pong Panda",
    img: "/assets/Slot/SG-SLOT-164.Ping Pong Panda.webp?v=1764997112097",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-164",
    platFormCode: "SPADE",
  },
  {
    name: "Pinup Girls",
    img: "/assets/Slot/PP-SLOT-317.Pinup Girls.webp?v=1764329232396",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-317",
    platFormCode: "PP",
  },
  {
    name: "Pip & Pippa's Pots of Plenty",
    img: "/assets/Slot/OCTOPLAY-SLOT-084.pip & pippa_s pots of plenty.webp?v=1764934974291",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-084",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Pirate Gold",
    img: "/assets/Slot/PP-SLOT-084.Pirate Gold.webp?v=1764329176244",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-084",
    platFormCode: "PP",
  },
  {
    name: "Pirate Gold Deluxe",
    img: "/assets/Slot/PP-SLOT-020.Pirate Gold Deluxe.webp?v=1764329113559",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-020",
    platFormCode: "PP",
  },
  {
    name: "Pirate Golden Age",
    img: "/assets/Slot/PP-SLOT-300.Pirate Golden Age.webp?v=1764329015414",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-300",
    platFormCode: "PP",
  },
  {
    name: "Pirate Multi Coins",
    img: "/assets/Slot/RELAX-SLOT-232.webp?v=1761902011017",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-232",
    platFormCode: "RELAX",
  },
  {
    name: "Pirate Queen",
    img: "/assets/Slot/JILI-SLOT-073.webp?v=1755509929136",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-073",
    platFormCode: "JILI",
  },
  {
    name: "Pirate Treasure",
    img: "/assets/Slot/ACEWIN-SLOT-014.Pirate Treasure.webp?v=1764854427116",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-014",
    platFormCode: "ACEWIN",
  },
  {
    name: "Pirates 2: Mutiny",
    img: "/assets/Slot/YGG-SLOT-061.webp?v=1767056428399",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-061",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pirates Plenty MegaWays",
    img: "/assets/Slot/RT-SLOT-058.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-058",
    platFormCode: "RT",
  },
  {
    name: "Pirates Pub",
    img: "/assets/Slot/PP-SLOT-352.Pirates Pub.webp?v=1764328953716",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-352",
    platFormCode: "PP",
  },
  {
    name: "Pirates' Plenty",
    img: "/assets/Slot/RT-SLOT-140.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-140",
    platFormCode: "RT",
  },
  {
    name: "Pirates' Plenty Battle For Gold",
    img: "/assets/Slot/RT-SLOT-097.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-097",
    platFormCode: "RT",
  },
  {
    name: "Pirates: Smugglers Paradise",
    img: "/assets/Slot/YGG-SLOT-059.webp?v=1767056428396",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-059",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pixie Wings",
    img: "/assets/Slot/PP-SLOT-122.Pixie Wings.webp?v=1764328894863",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-122",
    platFormCode: "PP",
  },
  {
    name: "Pixies vs Pirates",
    img: "/assets/Slot/NLC-SLOT-044.Pixies vs Pirates.webp?v=1764387781673",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-044",
    platFormCode: "NLC",
  },
  {
    name: "Plunderland",
    img: "/assets/Slot/RELAX-SLOT-100.webp?v=1761902038551",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-100",
    platFormCode: "RELAX",
  },
  {
    name: "Plunderland 10K",
    img: "/assets/Slot/RELAX-SLOT-238.webp?v=1761902074045",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-238",
    platFormCode: "RELAX",
  },
  {
    name: "Plunderland 5K",
    img: "/assets/Slot/RELAX-SLOT-237.webp?v=1761902098090",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-237",
    platFormCode: "RELAX",
  },
  {
    name: "Plushie Frenzy",
    img: "/assets/Slot/PG-SLOT-012.webp?v=1765933237760",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-012",
    platFormCode: "PG",
  },
  {
    name: "Plushie Wins",
    img: "/assets/Slot/PP-SLOT-619.Plushie Wins.webp?v=1764328827453",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-619",
    platFormCode: "PP",
  },
  {
    name: "Poison Eve",
    img: "/assets/Slot/NLC-SLOT-040.Poison Eve.webp?v=1764387731500",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-040",
    platFormCode: "NLC",
  },
  {
    name: "Pompeii Megareels Megaways",
    img: "/assets/Slot/PP-SLOT-429.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-429",
    platFormCode: "PP",
  },
  {
    name: "Pond of Plinko",
    img: "/assets/Slot/RELAX-SLOT-276.webp?v=1761902124322",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-276",
    platFormCode: "RELAX",
  },
  {
    name: "PopNoir",
    img: "/assets/Slot/YGG-SLOT-358.webp?v=1767056428867",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-358",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pot of Fortune",
    img: "/assets/Slot/PP-SLOT-442.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-442",
    platFormCode: "PP",
  },
  {
    name: "Power Pack",
    img: "/assets/Slot/YGG-SLOT-390.webp?v=1767056428894",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-390",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Power Stars",
    img: "/assets/Slot/hcu3p8r71kj3y.Power-Star.webp?v=1765049203309",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-133",
    platFormCode: "JOKER",
  },
  {
    name: "Power Zones: Thunder Birds",
    img: "/assets/Slot/PT-SLOT-093.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-093",
    platFormCode: "PT",
  },
  {
    name: "Power of Merlin Megaways",
    img: "/assets/Slot/PP-SLOT-362.Power of Merlin Megaways.webp?v=1764328757279",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-362",
    platFormCode: "PP",
  },
  {
    name: "Power of Ninja",
    img: "/assets/Slot/PP-SLOT-435.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-435",
    platFormCode: "PP",
  },
  {
    name: "Power of Thor Megaways",
    img: "/assets/Slot/PP-SLOT-174.Power of Thor Megaways.webp?v=1764328684091",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-174",
    platFormCode: "PP",
  },
  {
    name: "Powerspin",
    img: "/assets/Slot/RELAX-SLOT-042.webp?v=1761902447681",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-042",
    platFormCode: "RELAX",
  },
  {
    name: "Primal Hunter Gigablox",
    img: "/assets/Slot/YGG-SLOT-249.webp?v=1767056428750",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-249",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Primate King",
    img: "/assets/Slot/RT-SLOT-203.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-203",
    platFormCode: "RT",
  },
  {
    name: "Professor Clanks Combinator",
    img: "/assets/Slot/YGG-SLOT-146.webp?v=1767056428479",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-146",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Prosperity Fortune Tree",
    img: "/assets/Slot/PG-SLOT-106.webp?v=1765933237833",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-106",
    platFormCode: "PG",
  },
  {
    name: "Prosperity Lion",
    img: "/assets/Slot/PG-SLOT-020.webp?v=1765933237765",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-020",
    platFormCode: "PG",
  },
  {
    name: "Pub Kings",
    img: "/assets/Slot/PP-SLOT-371.Pub Kings.webp?v=1764328607139",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-371",
    platFormCode: "PP",
  },
  {
    name: "Pulled From The Deep UltraNudge",
    img: "/assets/Slot/YGG-SLOT-269.webp?v=1767056428777",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-269",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pumpkin Smash",
    img: "/assets/Slot/YGG-SLOT-101.webp?v=1767056428441",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-101",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Punk Rocker",
    img: "/assets/Slot/NLC-SLOT-012.Punk Rocker.webp?v=1764387631887",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-012",
    platFormCode: "NLC",
  },
  {
    name: "Punk Toilet",
    img: "/assets/Slot/NLC-SLOT-003.Punk Toilet.webp?v=1764387522994",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-003",
    platFormCode: "NLC",
  },
  {
    name: "Purrfect Potions",
    img: "/assets/Slot/YGG-SLOT-192.webp?v=1767056428530",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-192",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pushy Cats",
    img: "/assets/Slot/YGG-SLOT-068.webp?v=1767056428406",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-068",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pyramid Bonanza",
    img: "/assets/Slot/PP-SLOT-187.Pyramid Bonanza.webp?v=1764328548763",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-187",
    platFormCode: "PP",
  },
  {
    name: "Pyramid King",
    img: "/assets/Slot/PP-SLOT-042.Pyramid King.webp?v=1764328423333",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-042",
    platFormCode: "PP",
  },
  {
    name: "Pyramid Linx",
    img: "/assets/Slot/PT-SLOT-418.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-418",
    platFormCode: "PT",
  },
  {
    name: "Pyramid Valley: Power Zones",
    img: "/assets/Slot/PT-SLOT-099.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-099",
    platFormCode: "PT",
  },
  {
    name: "Qatar 2022",
    img: "/assets/Slot/sco3dugpambhy.Qatar-2022.webp?v=1765043242029",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-134",
    platFormCode: "JOKER",
  },
  {
    name: "Qin's Empire: Caishen's Temple",
    img: "/assets/Slot/PT-SLOT-234.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-234",
    platFormCode: "PT",
  },
  {
    name: "Quackin Reels",
    img: "/assets/Slot/RELAX-SLOT-265.webp?v=1761902476806",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-265",
    platFormCode: "RELAX",
  },
  {
    name: "Queen 2",
    img: "/assets/Slot/5bgx7epgw61kk.Queen-2.webp?v=1765042421237",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-136",
    platFormCode: "JOKER",
  },
  {
    name: "Queen Of The Nile",
    img: "/assets/Slot/8nsbhokge7nrk.Queen-Of-The-Nile.webp?v=1765051678846",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-137",
    platFormCode: "JOKER",
  },
  {
    name: "Queen of Bounty",
    img: "/assets/Slot/PG-SLOT-063.webp?v=1765933237798",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-063",
    platFormCode: "PG",
  },
  {
    name: "Queen of Gods",
    img: "/assets/Slot/PP-SLOT-257.Queen of Gods.webp?v=1764328490097",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-257",
    platFormCode: "PP",
  },
  {
    name: "Queen of Wands",
    img: "/assets/Slot/PT-SLOT-039.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-039",
    platFormCode: "PT",
  },
  {
    name: "Queen's Mystery",
    img: "/assets/Slot/PT-SLOT-355.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-355",
    platFormCode: "PT",
  },
  {
    name: "Queenie",
    img: "/assets/Slot/PP-SLOT-249.Queenie.webp?v=1764328365898",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-249",
    platFormCode: "PP",
  },
  {
    name: "Quest West",
    img: "/assets/Slot/PT-SLOT-192.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-192",
    platFormCode: "PT",
  },
  {
    name: "RAILROAD RICHES",
    img: "/assets/Slot/2J-SLOT-048.RAILROAD RICHES.webp?v=1763548087971",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-048",
    platFormCode: "JJ",
  },
  {
    name: "RAMPAGE BUFFALO",
    img: "/assets/Slot/2J-SLOT-011.RAMPAGE BUFFALO.webp?v=1763548025609",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-011",
    platFormCode: "JJ",
  },
  {
    name: "RISING FORTUNES",
    img: "/assets/Slot/2J-SLOT-015.RISING FORTUNES.webp?v=1763547982916",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-015",
    platFormCode: "JJ",
  },
  {
    name: "ROMA X 10000",
    img: "/assets/Slot/JILI-SLOT-155.ROMA X 10000.webp?v=1764310696688",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-155",
    platFormCode: "JILI",
  },
  {
    name: "Rabbit Garden",
    img: "/assets/Slot/PP-SLOT-328.Rabbit Garden.webp?v=1764327637898",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-328",
    platFormCode: "PP",
  },
  {
    name: "Rabid Randy Dark Trails",
    img: "/assets/Slot/NETENT-SLOT-234.Rabid Randy Dark Trails.webp?v=1764956406618",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-234",
    platFormCode: "NETENT",
  },
  {
    name: "Racing Lovers",
    img: "/assets/Slot/YGG-SLOT-255.webp?v=1767056428760",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-255",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Raging Bull",
    img: "/assets/Slot/PP-SLOT-188.Raging Bull.webp?v=1764327582261",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-188",
    platFormCode: "PP",
  },
  {
    name: "Ragnawolves",
    img: "/assets/Slot/YGG-SLOT-197.webp?v=1767056428546",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-197",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Raider Jane's Crypt of Fortune",
    img: "/assets/Slot/PG-SLOT-083.webp?v=1765933237813",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-083",
    platFormCode: "PG",
  },
  {
    name: "Rainbow Gold",
    img: "/assets/Slot/PP-SLOT-244.Rainbow Gold.webp?v=1764327511855",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-244",
    platFormCode: "PP",
  },
  {
    name: "Rainbow Jackpots Power Lines",
    img: "/assets/Slot/RT-SLOT-098.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-098",
    platFormCode: "RT",
  },
  {
    name: "Rainbow Power Potz UltraNudge",
    img: "/assets/Slot/YGG-SLOT-172.webp?v=1767056428510",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-172",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rainbow Reels",
    img: "/assets/Slot/PP-SLOT-390.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-390",
    platFormCode: "PP",
  },
  {
    name: "Rainbow Ryan",
    img: "/assets/Slot/YGG-SLOT-079.webp?v=1767056428421",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-079",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rainbow Ryan 2",
    img: "/assets/Slot/YGG-SLOT-244.webp?v=1767056428595",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-244",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramesses Gold 10K Ways",
    img: "/assets/Slot/YGG-SLOT-327.webp?v=1767056428827",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-327",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramses Retro",
    img: "/assets/Slot/YGG-SLOT-300.webp?v=1767056428802",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-300",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramses Revenge",
    img: "/assets/Slot/RELAX-SLOT-043.webp?v=1761902499587",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-043",
    platFormCode: "RELAX",
  },
  {
    name: "Rancher's Wealth",
    img: "/assets/Slot/e5jgac3ogr5dq.Rancher_s-Wealth.webp?v=1765045418559",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-138",
    platFormCode: "JOKER",
  },
  {
    name: "Rapid Gems 777",
    img: "/assets/Slot/JILI-SLOT-152.Rapid Gems 777.webp?v=1764311080125",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-152",
    platFormCode: "JILI",
  },
  {
    name: "Raptor Doublemax",
    img: "/assets/Slot/YGG-SLOT-054.webp?v=1767056428387",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-054",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rave Party Fever",
    img: "/assets/Slot/PG-SLOT-113.webp?v=1765933237839",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-113",
    platFormCode: "PG",
  },
  {
    name: "Reaction Link",
    img: "/assets/Slot/PT-SLOT-414.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-414",
    platFormCode: "PT",
  },
  {
    name: "Reactor",
    img: "/assets/Slot/RT-SLOT-062.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-062",
    platFormCode: "RT",
  },
  {
    name: "Ready to Blow Thundershots",
    img: "/assets/Slot/PT-SLOT-258.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-258",
    platFormCode: "PT",
  },
  {
    name: "Reapers",
    img: "/assets/Slot/RELAX-SLOT-154.webp?v=1761902524448",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-154",
    platFormCode: "RELAX",
  },
  {
    name: "Record Riches",
    img: "/assets/Slot/PT-SLOT-175.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-175",
    platFormCode: "PT",
  },
  {
    name: "Reel Banks",
    img: "/assets/Slot/PP-SLOT-309.Reel Banks.webp?v=1764327435327",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-309",
    platFormCode: "PP",
  },
  {
    name: "Reel Desire",
    img: "/assets/Slot/YGG-SLOT-104.webp?v=1767056428443",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-104",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Reel Keeper",
    img: "/assets/Slot/RT-SLOT-160.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-160",
    platFormCode: "RT",
  },
  {
    name: "Reel Keeper Power Reels",
    img: "/assets/Slot/RT-SLOT-240.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-240",
    platFormCode: "RT",
  },
  {
    name: "Reel King Mega",
    img: "/assets/Slot/RT-SLOT-130.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-130",
    platFormCode: "RT",
  },
  {
    name: "Reel Love",
    img: "/assets/Slot/PG-SLOT-044.webp?v=1765933237784",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-044",
    platFormCode: "PG",
  },
  {
    name: "Reel The Groove",
    img: "/assets/Slot/YGG-SLOT-373.webp?v=1767056428880",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-373",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Regal Beasts",
    img: "/assets/Slot/RT-SLOT-161.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-161",
    platFormCode: "RT",
  },
  {
    name: "Regal Streak",
    img: "/assets/Slot/RT-SLOT-138.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-138",
    platFormCode: "RT",
  },
  {
    name: "Release the Bison",
    img: "/assets/Slot/PP-SLOT-446.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-446",
    platFormCode: "PP",
  },
  {
    name: "Release the Kraken",
    img: "/assets/Slot/PP-SLOT-061.Release the Kraken.webp?v=1764327351392",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-061",
    platFormCode: "PP",
  },
  {
    name: "Release the Kraken 2",
    img: "/assets/Slot/PP-SLOT-294.Release the Kraken 2.webp?v=1764327294936",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-294",
    platFormCode: "PP",
  },
  {
    name: "Remember Gulag",
    img: "/assets/Slot/NLC-SLOT-017.Remember Gulag.webp?v=1764387441846",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-017",
    platFormCode: "NLC",
  },
  {
    name: "Renegade Revengers",
    img: "/assets/Slot/YGG-SLOT-401.webp?v=1767056428911",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-401",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Reptizillions Power Reels",
    img: "/assets/Slot/RT-SLOT-204.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-204",
    platFormCode: "RT",
  },
  {
    name: "Respin Mania",
    img: "/assets/Slot/d5qfgs4amfxf6.Respin-Mania.webp?v=1765047789495",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-139",
    platFormCode: "JOKER",
  },
  {
    name: "Resurrecting Riches",
    img: "/assets/Slot/PP-SLOT-567.Resurrecting Riches.webp?v=1764327056704",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-567",
    platFormCode: "PP",
  },
  {
    name: "Retro Rush",
    img: "/assets/Slot/PT-SLOT-231.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-231",
    platFormCode: "PT",
  },
  {
    name: "Return of the Dead",
    img: "/assets/Slot/PP-SLOT-024.Return of the Dead.webp?v=1764326997309",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-024",
    platFormCode: "PP",
  },
  {
    name: "Return of the Valkyrie",
    img: "/assets/Slot/YGG-SLOT-136.webp?v=1767056428471",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-136",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Revenge of Loki Megaways",
    img: "/assets/Slot/PP-SLOT-462.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-462",
    platFormCode: "PP",
  },
  {
    name: "Ri Ri Jin Cai",
    img: "/assets/Slot/PT-SLOT-047.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-047",
    platFormCode: "PT",
  },
  {
    name: "Rich Piggies",
    img: "/assets/Slot/ACEWIN-SLOT-002.Rich Piggies.webp?v=1764854597417",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-002",
    platFormCode: "ACEWIN",
  },
  {
    name: "Rich Raptors",
    img: "/assets/Slot/RELAX-SLOT-186.webp?v=1761902548203",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-186",
    platFormCode: "RELAX",
  },
  {
    name: "Riches of Olympus",
    img: "/assets/Slot/YGG-SLOT-295.webp?v=1767056428798",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-295",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Riddle Of The Sphinx",
    img: "/assets/Slot/RT-SLOT-162.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-162",
    platFormCode: "RT",
  },
  {
    name: "Ride The Lightning",
    img: "/assets/Slot/PP-SLOT-558.webp?v=1755572094851",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-558",
    platFormCode: "PP",
  },
  {
    name: "Ring of Odin",
    img: "/assets/Slot/SlotRingOfOdin.RING OF ODIN.webp?v=1764775004957",
    platForm: "PLAYNGO",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PLAYNGO-SLOT-127",
    platFormCode: "PLAYNGO",
  },
  {
    name: "Rio Stars",
    img: "/assets/Slot/RT-SLOT-099.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-099",
    platFormCode: "RT",
  },
  {
    name: "Ripe Rewards",
    img: "/assets/Slot/PP-SLOT-449.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-449",
    platFormCode: "PP",
  },
  {
    name: "Rise Of Werewolves",
    img: "/assets/Slot/SG-SLOT-087.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-087",
    platFormCode: "SPADE",
  },
  {
    name: "Rise of Giza PowerNudge",
    img: "/assets/Slot/PP-SLOT-186.Rise of Giza PowerNudge.webp?v=1764326895073",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-186",
    platFormCode: "PP",
  },
  {
    name: "Rise of Pyramids",
    img: "/assets/Slot/PP-SLOT-460.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-460",
    platFormCode: "PP",
  },
  {
    name: "Rise of Samurai",
    img: "/assets/Slot/PP-SLOT-027.Rise of Samurai.webp?v=1764326827318",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-027",
    platFormCode: "PP",
  },
  {
    name: "Rise of the Sun God",
    img: "/assets/Slot/PG-SLOT-078.webp?v=1765933237810",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-078",
    platFormCode: "PG",
  },
  {
    name: "Road Rage",
    img: "/assets/Slot/NLC-SLOT-019.Road Rage.webp?v=1764387390619",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-019",
    platFormCode: "NLC",
  },
  {
    name: "Roamin' Romans UltraNudge",
    img: "/assets/Slot/YGG-SLOT-212.webp?v=1767056428560",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-212",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Roaming Wild Buffalo",
    img: "/assets/Slot/OCTOPLAY-SLOT-089.Roaming Wild Buffalo.webp?v=1764935034481",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-089",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Robber Strike",
    img: "/assets/Slot/PP-SLOT-349.Robber Strike.webp?v=1764326775556",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-349",
    platFormCode: "PP",
  },
  {
    name: "Robin Hood's Wild Forest",
    img: "/assets/Slot/RT-SLOT-223.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-223",
    platFormCode: "RT",
  },
  {
    name: "Robin Nottingham Raiders",
    img: "/assets/Slot/YGG-SLOT-069.webp?v=1767056428407",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-069",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Robin Sherwood Marauders",
    img: "/assets/Slot/YGG-SLOT-013.webp?v=1767056428338",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-013",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Roby Dick",
    img: "/assets/Slot/YGG-SLOT-378.webp?v=1767056428884",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-378",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rock Bottom",
    img: "/assets/Slot/NLC-SLOT-062.Rock Bottom.webp?v=1764387293630",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-062",
    platFormCode: "NLC",
  },
  {
    name: "Rock Star Santa",
    img: "/assets/Slot/YGG-SLOT-231.webp?v=1767056428580",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-231",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rock Vegas",
    img: "/assets/Slot/PP-SLOT-229.Rock Vegas.webp?v=1764326724672",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-229",
    platFormCode: "PP",
  },
  {
    name: "Rock'n'Lock",
    img: "/assets/Slot/RT-SLOT-191.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-191",
    platFormCode: "RT",
  },
  {
    name: "Rocket Blast Megaways",
    img: "/assets/Slot/PP-SLOT-369.Rocket Blast Megaways.webp?v=1764326253702",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-369",
    platFormCode: "PP",
  },
  {
    name: "Roma Legacy",
    img: "/assets/Slot/ape6dxf7sk35y.Roma-Legacy.webp?v=1765041951576",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-142",
    platFormCode: "JOKER",
  },
  {
    name: "Roma Plus",
    img: "/assets/Slot/ACEWIN-SLOT-011.Roma Plus.webp?v=1764854671416",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-011",
    platFormCode: "ACEWIN",
  },
  {
    name: "RomaX",
    img: "/assets/Slot/JILI-SLOT-040.webp?v=1755509635989",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-040",
    platFormCode: "JILI",
  },
  {
    name: "RomeandGlory",
    img: "/assets/Slot/PT-SLOT-079.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-079",
    platFormCode: "PT",
  },
  {
    name: "Rooster Rumble",
    img: "/assets/Slot/PG-SLOT-097.webp?v=1765933237825",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-097",
    platFormCode: "PG",
  },
  {
    name: "Rooster's Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-109.Rooster_s Gold Hold & Win.webp?v=1764935058261",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-109",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Royal Dragon Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-016.webp?v=1767056428342",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-016",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Royal Family",
    img: "/assets/Slot/YGG-SLOT-058.webp?v=1767056428394",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-058",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Royal Potato",
    img: "/assets/Slot/RELAX-SLOT-099.webp?v=1761902571823",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-099",
    platFormCode: "RELAX",
  },
  {
    name: "Royal Potato 2",
    img: "/assets/Slot/RELAX-SLOT-199.webp?v=1761902599834",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-199",
    platFormCode: "RELAX",
  },
  {
    name: "Royal Ribbit",
    img: "/assets/Slot/OCTOPLAY-SLOT-036.Royal ribbit.webp?v=1764935112319",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-036",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Royale Vegas",
    img: "/assets/Slot/SG-SLOT-140.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-140",
    platFormCode: "SPADE",
  },
  {
    name: "Rudis",
    img: "/assets/Slot/YGG-SLOT-354.webp?v=1767056428861",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-354",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rujak Bonanza",
    img: "/assets/Slot/PP-SLOT-395.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-395",
    platFormCode: "PP",
  },
  {
    name: "Rune Raiders",
    img: "/assets/Slot/OCTOPLAY-SLOT-023.rune Raiders.webp?v=1764935156935",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-023",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Runes of Battle",
    img: "/assets/Slot/YGG-SLOT-368.webp?v=1767056428876",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-368",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Running Sushi",
    img: "/assets/Slot/PP-SLOT-483.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-483",
    platFormCode: "PP",
  },
  {
    name: "SUPER ACE",
    img: "/assets/Slot/2J-SLOT-037.SUPER ACE.webp?v=1763547852211",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-037",
    platFormCode: "JJ",
  },
  {
    name: "Saber",
    img: "/assets/Slot/YGG-SLOT-344.webp?v=1767056428840",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-344",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Safari Life",
    img: "/assets/Slot/xtpy4bx49xhx1.Safari-Life.webp?v=1765051265818",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-144",
    platFormCode: "JOKER",
  },
  {
    name: "Safari Sun",
    img: "/assets/Slot/RELAX-SLOT-193.webp?v=1761902653369",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-193",
    platFormCode: "RELAX",
  },
  {
    name: "Sahara Nights",
    img: "/assets/Slot/YGG-SLOT-111.webp?v=1767056428448",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-111",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sahara Riches MegaWays: Cash Collect",
    img: "/assets/Slot/PT-SLOT-235.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-235",
    platFormCode: "PT",
  },
  {
    name: "Sahara Riches: Cash Collect",
    img: "/assets/Slot/PT-SLOT-101.Sahara Riches Cash Collect.webp?v=1764329202579",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-101",
    platFormCode: "PT",
  },
  {
    name: "Sails of Fortune",
    img: "/assets/Slot/RELAX-SLOT-053.webp?v=1761902737399",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-053",
    platFormCode: "RELAX",
  },
  {
    name: "Sakura Fortune",
    img: "/assets/Slot/PT-SLOT-241.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-241",
    platFormCode: "PT",
  },
  {
    name: "Salmon King",
    img: "/assets/Slot/OCTOPLAY-SLOT-016.Salmon King.webp?v=1764935204368",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-016",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Samba",
    img: "/assets/Slot/JILI-SLOT-070.webp?v=1755509882324",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-070",
    platFormCode: "JILI",
  },
  {
    name: "Samurai Code",
    img: "/assets/Slot/PP-SLOT-475.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-475",
    platFormCode: "PP",
  },
  {
    name: "San Quentin xWays",
    img: "/assets/Slot/NLC-SLOT-030.San Quentin xWays.webp?v=1764387146554",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-030",
    platFormCode: "NLC",
  },
  {
    name: "Santa",
    img: "/assets/Slot/PP-SLOT-115.Santa.webp?v=1764326096250",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-115",
    platFormCode: "PP",
  },
  {
    name: "Santa Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-035.Santa Smash.webp?v=1764935261528",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-035",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Santa Spins",
    img: "/assets/Slot/RT-SLOT-106.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-106",
    platFormCode: "RT",
  },
  {
    name: "Santa's Great Gifts",
    img: "/assets/Slot/PP-SLOT-295.Santa_s Great Gifts.webp?v=1764326044876",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-295",
    platFormCode: "PP",
  },
  {
    name: "Santa's Stack",
    img: "/assets/Slot/RELAX-SLOT-095.webp?v=1761902854470",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-095",
    platFormCode: "RELAX",
  },
  {
    name: "Santa's Wonderland",
    img: "/assets/Slot/PP-SLOT-210.Santa_s Wonderland.webp?v=1764325984853",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-210",
    platFormCode: "PP",
  },
  {
    name: "Santas Gift Rush",
    img: "/assets/Slot/PG-SLOT-021.webp?v=1765933237766",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-021",
    platFormCode: "PG",
  },
  {
    name: "Santa’s Slay",
    img: "/assets/Slot/PP-SLOT-660.Santa’s Slay.webp?v=1764662968751",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-660",
    platFormCode: "PP",
  },
  {
    name: "Savage Frontier",
    img: "/assets/Slot/es9sgctugyauc.Savage Frontier.webp?v=1765049085784",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-224",
    platFormCode: "JOKER",
  },
  {
    name: "Savage Jungle",
    img: "/assets/Slot/PT-SLOT-220.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-220",
    platFormCode: "PT",
  },
  {
    name: "Savannah Gold: Coin of the Wild",
    img: "/assets/Slot/OCTOPLAY-SLOT-102.Savannah Gold Coin of the Wild.webp?v=1764935286211",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-102",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Savannah Legend",
    img: "/assets/Slot/PP-SLOT-542.Savannah Legend.webp?v=1764325652399",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-542",
    platFormCode: "PP",
  },
  {
    name: "Scara-Bucks",
    img: "/assets/Slot/YGG-SLOT-409.webp?v=1767056428918",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-409",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Scheherazade",
    img: "/assets/Slot/mur8wje4dccb1.SCHEHERAZA.webp?v=1765050898477",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-147",
    platFormCode: "JOKER",
  },
  {
    name: "Scudamore's Super Stakes",
    img: "/assets/Slot/NETENT-SLOT-101.Scudamore_s-Super-Stake.webp?v=1764955739902",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-101",
    platFormCode: "NETENT",
  },
  {
    name: "Sea Fantasy",
    img: "/assets/Slot/PP-SLOT-419.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-419",
    platFormCode: "PP",
  },
  {
    name: "Seamen",
    img: "/assets/Slot/NLC-SLOT-116.Seamen.webp?v=1764387074068",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-116",
    platFormCode: "NLC",
  },
  {
    name: "Seasons",
    img: "/assets/Slot/YGG-SLOT-024.webp?v=1767056428351",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-024",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret City Gold",
    img: "/assets/Slot/PP-SLOT-316.Secret City Gold.webp?v=1764325586295",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-316",
    platFormCode: "PP",
  },
  {
    name: "Secret Riches of the Irish",
    img: "/assets/Slot/YGG-SLOT-265.webp?v=1767056428773",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-265",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret Treasure",
    img: "/assets/Slot/JILI-SLOT-039.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-039",
    platFormCode: "JILI",
  },
  {
    name: "Secret of Anubis DoubleMax",
    img: "/assets/Slot/YGG-SLOT-232.webp?v=1767056428582",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-232",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret of Cleopatra",
    img: "/assets/Slot/PG-SLOT-061.webp?v=1765933237797",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-061",
    platFormCode: "PG",
  },
  {
    name: "Secrets of the Amazon",
    img: "/assets/Slot/PT-SLOT-054.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-054",
    platFormCode: "PT",
  },
  {
    name: "Serendipity",
    img: "/assets/Slot/YGG-SLOT-122.webp?v=1767056428460",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-122",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Serial",
    img: "/assets/Slot/NLC-SLOT-004.Serial.webp?v=1764387035138",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-004",
    platFormCode: "NLC",
  },
  {
    name: "Serpent Shrine",
    img: "/assets/Slot/RELAX-SLOT-076.webp?v=1761902885817",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-076",
    platFormCode: "RELAX",
  },
  {
    name: "SevenSevenSeven",
    img: "/assets/Slot/JILI-SLOT-013.SevenSevenSeven.webp?v=1764311390508",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-013",
    platFormCode: "JILI",
  },
  {
    name: "Sexy Joker",
    img: "/assets/Slot/YesBingo-SLOT-044.Sexy Joker.webp?v=1765101662613",
    platForm: "YB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-044",
    platFormCode: "YESBINGO",
  },
  {
    name: "Shadow Raiders MultiMax",
    img: "/assets/Slot/YGG-SLOT-190.webp?v=1767056428528",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-190",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shadow Society",
    img: "/assets/Slot/RT-SLOT-225.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-225",
    platFormCode: "RT",
  },
  {
    name: "Shadow Summoner Elementals",
    img: "/assets/Slot/RELAX-SLOT-255.webp?v=1761902910067",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-255",
    platFormCode: "RELAX",
  },
  {
    name: "Shah Mat",
    img: "/assets/Slot/RT-SLOT-128.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-128",
    platFormCode: "RT",
  },
  {
    name: "Shaker Club",
    img: "/assets/Slot/YGG-SLOT-210.webp?v=1767056428558",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-210",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shamrock Money Pot 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-132.webp?v=1761902942186",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-132",
    platFormCode: "RELAX",
  },
  {
    name: "Shanghai Beauty",
    img: "/assets/Slot/JILI-SLOT-008.webp?v=1755509061892",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-008",
    platFormCode: "JILI",
  },
  {
    name: "Shaolin Panda Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-045.Shaolin Panda Chaos reels.webp?v=1764935335988",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-045",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Shaolin Panda: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-101.Shaolin Panda Hold & Win.webp?v=1764935353894",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-101",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Shaolin Soccer",
    img: "/assets/Slot/PG-SLOT-046.webp?v=1765933237787",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-046",
    platFormCode: "PG",
  },
  {
    name: "Shark Bait",
    img: "/assets/Slot/YGG-SLOT-329.webp?v=1767056428829",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-329",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shark Wash",
    img: "/assets/Slot/RELAX-SLOT-183.webp?v=1761902973666",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-183",
    platFormCode: "RELAX",
  },
  {
    name: "Sheep Gone Wild",
    img: "/assets/Slot/RT-SLOT-239.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-239",
    platFormCode: "RT",
  },
  {
    name: "Sheep King",
    img: "/assets/Slot/OCTOPLAY-SLOT-022.Sheep King.webp?v=1764935399515",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-022",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sherlock Bones",
    img: "/assets/Slot/RELAX-SLOT-072.webp?v=1761903001610",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-072",
    platFormCode: "RELAX",
  },
  {
    name: "Shield of Sparta",
    img: "/assets/Slot/PP-SLOT-302.Shield of Sparta.webp?v=1764325533401",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-302",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 100",
    img: "/assets/Slot/PP-SLOT-267.Shining Hot 100.webp?v=1764325481426",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-267",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 20",
    img: "/assets/Slot/PP-SLOT-269.Shining Hot 20.webp?v=1764325428308",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-269",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 40",
    img: "/assets/Slot/PP-SLOT-268.Shining Hot 40.webp?v=1764325342186",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-268",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 5",
    img: "/assets/Slot/PP-SLOT-270.Shining Hot 5.webp?v=1764324994758",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-270",
    platFormCode: "PP",
  },
  {
    name: "Shinobi Spirit",
    img: "/assets/Slot/RELAX-SLOT-188.webp?v=1761903033099",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-188",
    platFormCode: "RELAX",
  },
  {
    name: "Shipwrecked",
    img: "/assets/Slot/YGG-SLOT-294.webp?v=1767056428797",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-294",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Show Me The Honey",
    img: "/assets/Slot/YGG-SLOT-309.webp?v=1767056428810",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-309",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Si Xiang",
    img: "/assets/Slot/PT-SLOT-040.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-040",
    platFormCode: "PT",
  },
  {
    name: "Sidewinder DoubleMax",
    img: "/assets/Slot/YGG-SLOT-236.webp?v=1767056428589",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-236",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Silent Samurai: Mega cash collect",
    img: "/assets/Slot/PT-SLOT-270.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-270",
    platFormCode: "PT",
  },
  {
    name: "Silver Bullet",
    img: "/assets/Slot/PT-SLOT-135.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-135",
    platFormCode: "PT",
  },
  {
    name: "Silver Bullet Bandit: Cash Collect",
    img: "/assets/Slot/PT-SLOT-107.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-107",
    platFormCode: "PT",
  },
  {
    name: "Silver's Gold PowerLinks",
    img: "/assets/Slot/YGG-SLOT-293.webp?v=1767056428796",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-293",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "SilverBullet Progressive",
    img: "/assets/Slot/ruufkzk1kpefn.SilverBullet-Progressive.webp?v=1765048157426",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-150",
    platFormCode: "JOKER",
  },
  {
    name: "Sinbad's Golden Voyage",
    img: "/assets/Slot/PT-SLOT-081.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-081",
    platFormCode: "PT",
  },
  {
    name: "Sizzling Hot",
    img: "/assets/Slot/ww3a8wsu4de7c.Sizzling-Hot.webp?v=1765037633224",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-151",
    platFormCode: "JOKER",
  },
  {
    name: "Skate or Die",
    img: "/assets/Slot/NLC-SLOT-095.Skate or Die.webp?v=1764386984614",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-095",
    platFormCode: "NLC",
  },
  {
    name: "Sky Queen",
    img: "/assets/Slot/PT-SLOT-007.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-007",
    platFormCode: "PT",
  },
  {
    name: "Skylantis 2",
    img: "/assets/Slot/YGG-SLOT-243.webp?v=1767056428594",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-243",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sloth Tumble",
    img: "/assets/Slot/RELAX-SLOT-189.webp?v=1761903057813",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-189",
    platFormCode: "RELAX",
  },
  {
    name: "Smugglers Cove",
    img: "/assets/Slot/PP-SLOT-222.Smugglers Cove.webp?v=1764324881330",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-222",
    platFormCode: "PP",
  },
  {
    name: "Snake Arena",
    img: "/assets/Slot/RELAX-SLOT-044.webp?v=1761903080190",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-044",
    platFormCode: "RELAX",
  },
  {
    name: "Snakes & Ladders - Snake Eyes",
    img: "/assets/Slot/PP-SLOT-285.Snakes & Ladders - Snake Eyes.webp?v=1764324826945",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-285",
    platFormCode: "PP",
  },
  {
    name: "Snakes Gold",
    img: "/assets/Slot/RELAX-SLOT-205.webp?v=1761903141402",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-205",
    platFormCode: "RELAX",
  },
  {
    name: "Snakes and Ladders Megadice",
    img: "/assets/Slot/PP-SLOT-246.Snakes and Ladders Megadice.webp?v=1764324766903",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-246",
    platFormCode: "PP",
  },
  {
    name: "Songkran Splash",
    img: "/assets/Slot/PG-SLOT-116.webp?v=1765933237842",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-116",
    platFormCode: "PG",
  },
  {
    name: "Sorcerer's Guild of Magic",
    img: "/assets/Slot/PT-SLOT-154.sorcerer_s-guild-of-magic.webp?v=1764330813986",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-154",
    platFormCode: "PT",
  },
  {
    name: "Space Miners",
    img: "/assets/Slot/RELAX-SLOT-105.webp?v=1761903170533",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-105",
    platFormCode: "RELAX",
  },
  {
    name: "Spartacus 10K Ways",
    img: "/assets/Slot/YGG-SLOT-317.webp?v=1767056428817",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-317",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Spartan King",
    img: "/assets/Slot/PP-SLOT-017.Spartan King.webp?v=1764324717782",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-017",
    platFormCode: "PP",
  },
  {
    name: "Spartan Wildz",
    img: "/assets/Slot/RT-SLOT-370.Spartan Wildz.webp?v=1765033831478",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-370",
    platFormCode: "RT",
  },
  {
    name: "Speed Freaks",
    img: "/assets/Slot/YGG-SLOT-386.webp?v=1767056428891",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-386",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Speed Winner",
    img: "/assets/Slot/PG-SLOT-102.webp?v=1765933237830",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-102",
    platFormCode: "PG",
  },
  {
    name: "Spellbinding Mystery",
    img: "/assets/Slot/PP-SLOT-363.Spellbinding Mystery.webp?v=1764324615635",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-363",
    platFormCode: "PP",
  },
  {
    name: "Sphere Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-041.Sphere smash.webp?v=1764935454527",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-041",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Spin & Score Megaways",
    img: "/assets/Slot/PP-SLOT-290.Spin & Score Megaways.webp?v=1764324537575",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-290",
    platFormCode: "PP",
  },
  {
    name: "Spin of Fate",
    img: "/assets/Slot/ACEWIN-SLOT-007.Spin of Fate.webp?v=1764854700633",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-007",
    platFormCode: "ACEWIN",
  },
  {
    name: "Spina Colada",
    img: "/assets/Slot/YGG-SLOT-074.webp?v=1767056428413",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-074",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Spinata Grande",
    img: "/assets/Slot/NETENT-SLOT-104.Spinata-Grande.webp?v=1764954949863",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-104",
    platFormCode: "NETENT",
  },
  {
    name: "Spirit Blast",
    img: "/assets/Slot/OCTOPLAY-SLOT-017.spirit blast.webp?v=1764935498116",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-017",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Spirit of Adventure",
    img: "/assets/Slot/PP-SLOT-234.Spirit of Adventure.webp?v=1764324487714",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-234",
    platFormCode: "PP",
  },
  {
    name: "Spirit of The Beast",
    img: "/assets/Slot/RELAX-SLOT-056.webp?v=1761903198378",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-056",
    platFormCode: "RELAX",
  },
  {
    name: "Spirited Wonders",
    img: "/assets/Slot/PG-SLOT-087.webp?v=1765933237818",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-087",
    platFormCode: "PG",
  },
  {
    name: "Splendour Forest",
    img: "/assets/Slot/RELAX-SLOT-084.webp?v=1761903223893",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-084",
    platFormCode: "RELAX",
  },
  {
    name: "St Louis 1904",
    img: "/assets/Slot/RELAX-SLOT-254.webp?v=1761903256315",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-254",
    platFormCode: "RELAX",
  },
  {
    name: "Stallion Strike",
    img: "/assets/Slot/PT-SLOT-200.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-200",
    platFormCode: "PT",
  },
  {
    name: "Stampede Rush Trident",
    img: "/assets/Slot/PT-SLOT-427.stampede-rush-trident.webp?v=1764332989353",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-427",
    platFormCode: "PT",
  },
  {
    name: "Star Bounty",
    img: "/assets/Slot/PP-SLOT-029.Star Bounty.webp?v=1764324270811",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-029",
    platFormCode: "PP",
  },
  {
    name: "Star Clusters 2",
    img: "/assets/Slot/BTG-SLOT-068.webp?v=1757921611296",
    platForm: "BTG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-068",
    platFormCode: "BTG",
  },
  {
    name: "Star Kingdom",
    img: "/assets/Slot/OCTOPLAY-SLOT-018.Star Kingdom.webp?v=1764935541742",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-018",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Star Pirates Code",
    img: "/assets/Slot/PP-SLOT-207.Star Pirates Code.webp?v=1764324027785",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-207",
    platFormCode: "PP",
  },
  {
    name: "Star Pops",
    img: "/assets/Slot/RELAX-SLOT-102.webp?v=1761903279983",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-102",
    platFormCode: "RELAX",
  },
  {
    name: "Starburst™ XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-017.Starburst-XXXtreme.webp?v=1764954790743",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    platFormCode: "NETENT",
  },
  {
    name: "Starfire Fortunes Tophit",
    img: "/assets/Slot/YGG-SLOT-203.webp?v=1767056428553",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-203",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Starlight Archer 1000",
    img: "/assets/Slot/PP-SLOT-658.webp?v=1770095329095",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-658",
    platFormCode: "PP",
  },
  {
    name: "Starlight Christmas",
    img: "/assets/Slot/PP-SLOT-297.Starlight Christmas.webp?v=1764323979076",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-297",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess",
    img: "/assets/Slot/PP-SLOT-189.Starlight Princess.webp?v=1764323817551",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-189",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess Pachi",
    img: "/assets/Slot/PP-SLOT-463.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-463",
    platFormCode: "PP",
  },
  {
    name: "Starmada Exiles",
    img: "/assets/Slot/PT-SLOT-227.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-227",
    platFormCode: "PT",
  },
  {
    name: "Starstruck",
    img: "/assets/Slot/NLC-SLOT-050.Starstruck.webp?v=1764386884106",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-050",
    platFormCode: "NLC",
  },
  {
    name: "Starz Megaways",
    img: "/assets/Slot/PP-SLOT-045.Starz Megaways.webp?v=1764323626226",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-045",
    platFormCode: "PP",
  },
  {
    name: "Sticky Bees",
    img: "/assets/Slot/PP-SLOT-348.Sticky Bees.webp?v=1764323577839",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-348",
    platFormCode: "PP",
  },
  {
    name: "Stolen Treasures",
    img: "/assets/Slot/RT-SLOT-224.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-224",
    platFormCode: "RT",
  },
  {
    name: "Stone Hominid",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-030.stone-hominid.webp?v=1765272089064",
    platForm: "DS",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-030",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Strawberry Cocktail",
    img: "/assets/Slot/PP-SLOT-433.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-433",
    platFormCode: "PP",
  },
  {
    name: "Street Fighter™ II: The World Warrior Slot",
    img: "/assets/Slot/NETENT-SLOT-038.Street-Fighter-II.webp?v=1764954675780",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-038",
    platFormCode: "NETENT",
  },
  {
    name: "Street Ninja",
    img: "/assets/Slot/YGG-SLOT-341.webp?v=1767056428838",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-341",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Street Racer",
    img: "/assets/Slot/PP-SLOT-038.Street Racer.webp?v=1764323493082",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-038",
    platFormCode: "PP",
  },
  {
    name: "Streets Of Chicago",
    img: "/assets/Slot/h33c3rho1gmjq.Streets-Of-Chicago.webp?v=1765044349576",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-153",
    platFormCode: "JOKER",
  },
  {
    name: "Striking Hot 5",
    img: "/assets/Slot/PP-SLOT-286.Striking Hot 5.webp?v=1764323446179",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-286",
    platFormCode: "PP",
  },
  {
    name: "Sugar Bomb 2 MultiBoost",
    img: "/assets/Slot/YGG-SLOT-338.webp?v=1767056428836",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-338",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sugar Bomb MultiBoost",
    img: "/assets/Slot/YGG-SLOT-250.webp?v=1767056428753",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-250",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sugar Bonanza",
    img: "/assets/Slot/SG-SLOT-092.webp?v=1751418030688",
    platForm: "SPADE",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "SG-SLOT-092",
    platFormCode: "SPADE",
  },
  {
    name: "Sugar Rush",
    img: "/assets/Slot/PP-SLOT-245.Sugar Rush.webp?v=1764323391940",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-245",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush Xmas",
    img: "/assets/Slot/PP-SLOT-403.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-403",
    platFormCode: "PP",
  },
  {
    name: "Sugar Splash",
    img: "/assets/Slot/OCTOPLAY-SLOT-070.suger splash.webp?v=1764935582372",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-070",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sugar Supreme Powernudge",
    img: "/assets/Slot/PP-SLOT-397.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-397",
    platFormCode: "PP",
  },
  {
    name: "Sultan Spins",
    img: "/assets/Slot/RELAX-SLOT-229.webp?v=1761903302652",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-229",
    platFormCode: "RELAX",
  },
  {
    name: "Sumo Spins",
    img: "/assets/Slot/RT-SLOT-071.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-071",
    platFormCode: "RT",
  },
  {
    name: "Sumo Supreme Megaways",
    img: "/assets/Slot/PP-SLOT-480.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-480",
    platFormCode: "PP",
  },
  {
    name: "Suncatcher Gigablox",
    img: "/assets/Slot/YGG-SLOT-053.webp?v=1767056428385",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-053",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sunny Shores",
    img: "/assets/Slot/YGG-SLOT-098.webp?v=1767056428438",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-098",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super 7s",
    img: "/assets/Slot/PP-SLOT-060.Super 7s.webp?v=1764322372309",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-060",
    platFormCode: "PP",
  },
  {
    name: "Super AceWin",
    img: "/assets/Slot/ACEWIN-SLOT-008.Super Ace Win.webp?v=1764854849943",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-008",
    platFormCode: "ACEWIN",
  },
  {
    name: "Super Boost",
    img: "/assets/Slot/RELAX-SLOT-071.webp?v=1761903328994",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-071",
    platFormCode: "RELAX",
  },
  {
    name: "Super Cash Drop Giga Blox",
    img: "/assets/Slot/YGG-SLOT-131.webp?v=1767056428467",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-131",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super Cash: Three Little Wins",
    img: "/assets/Slot/OCTOPLAY-SLOT-112.Super Cash Three Little Wins.webp?v=1764935598397",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-112",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super Crown 40",
    img: "/assets/Slot/YGG-SLOT-324.webp?v=1767056428825",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-324",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super Golf Drive",
    img: "/assets/Slot/PG-SLOT-118.webp?v=1765933237844",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-118",
    platFormCode: "PG",
  },
  {
    name: "Super Grand Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-096.Super Grand Link Express Hold & Win.webp?v=1764935616486",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-096",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super Gummy Strike",
    img: "/assets/Slot/PP-SLOT-659.webp?v=1765433889444",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-659",
    platFormCode: "PP",
  },
  {
    name: "Super JOKER",
    img: "/assets/Slot/PP-SLOT-071.Super JOKER.webp?v=1764322321008",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-071",
    platFormCode: "PP",
  },
  {
    name: "Super Rich",
    img: "/assets/Slot/JILI-SLOT-041.webp?v=1755509521282",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-041",
    platFormCode: "JILI",
  },
  {
    name: "Super Sundae",
    img: "/assets/Slot/OCTOPLAY-SLOT-020.Super Sundae.webp?v=1764935656694",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-020",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super X",
    img: "/assets/Slot/PP-SLOT-218.Super X.webp?v=1764322273187",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-218",
    platFormCode: "PP",
  },
  {
    name: "SuperCash Drop",
    img: "/assets/Slot/YGG-SLOT-256.webp?v=1767056428763",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-256",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Supermarket Spree",
    img: "/assets/Slot/PG-SLOT-084.webp?v=1765933237814",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-084",
    platFormCode: "PG",
  },
  {
    name: "Supersonic Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-095.Supersonic Express Hold & Win.webp?v=1764935820760",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-095",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Supreme Caishen",
    img: "/assets/Slot/byz81hmsq748k.Supreme-Caishen.webp?v=1765054394194",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-155",
    platFormCode: "JOKER",
  },
  {
    name: "Sweet Bonanza Dice",
    img: "/assets/Slot/PP-SLOT-388.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-388",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza Xmas",
    img: "/assets/Slot/PP-SLOT-067.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-067",
    platFormCode: "PP",
  },
  {
    name: "Sweet Kingdom",
    img: "/assets/Slot/PP-SLOT-473.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-473",
    platFormCode: "PP",
  },
  {
    name: "Sweet Powernudge",
    img: "/assets/Slot/PP-SLOT-310.Sweet-Powernudge.webp?v=1764321833332",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-310",
    platFormCode: "PP",
  },
  {
    name: "Sweet Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-028.Sweet Smash.webp?v=1764935863584",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-028",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sweet n' Juicy",
    img: "/assets/Slot/PT-SLOT-356.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-356",
    platFormCode: "PT",
  },
  {
    name: "Sweetopia Royale",
    img: "/assets/Slot/RELAX-SLOT-226.webp?v=1761903352995",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-226",
    platFormCode: "RELAX",
  },
  {
    name: "Sword of Ares",
    img: "/assets/Slot/PP-SLOT-289.Sword of Ares.webp?v=1764321620624",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-289",
    platFormCode: "PP",
  },
  {
    name: "Sylvan Spirits",
    img: "/assets/Slot/RT-SLOT-163.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-163",
    platFormCode: "RT",
  },
  {
    name: "Symbols of Egypt",
    img: "/assets/Slot/PG-SLOT-025.webp?v=1765933237770",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-025",
    platFormCode: "PG",
  },
  {
    name: "Syncronite",
    img: "/assets/Slot/YGG-SLOT-113.webp?v=1767056428450",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-113",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "TIGER_TIGER",
    img: "/assets/Slot/YGG-SLOT-083.webp?v=1767056428426",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-083",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "TNT Tumble",
    img: "/assets/Slot/RELAX-SLOT-048.webp?v=1761903382661",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-048",
    platFormCode: "RELAX",
  },
  {
    name: "TNT Tumble 10K",
    img: "/assets/Slot/RELAX-SLOT-240.webp?v=1761903412881",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-240",
    platFormCode: "RELAX",
  },
  {
    name: "TNT Tumble 5K",
    img: "/assets/Slot/RELAX-SLOT-239.webp?v=1761903433660",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-239",
    platFormCode: "RELAX",
  },
  {
    name: "TREASURE OF AZTEC",
    img: "/assets/Slot/2J-SLOT-036.TREASURE OF AZTEC.webp?v=1763547748187",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-036",
    platFormCode: "JJ",
  },
  {
    name: "TRUMP IT",
    img: "/assets/Slot/2J-SLOT-056.TRUMP IT.webp?v=1763547692575",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-056",
    platFormCode: "JJ",
  },
  {
    name: "TWIN WINS",
    img: "/assets/Slot/JILI-SLOT-047.webp?v=1755509670427",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-047",
    platFormCode: "JILI",
  },
  {
    name: "Tai Shang Lao Jun",
    img: "/assets/Slot/dxxsh3dfmjpio.Tai-Shang-Lao-Jun.webp?v=1765044848586",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-156",
    platFormCode: "JOKER",
  },
  {
    name: "Tarasque",
    img: "/assets/Slot/RELAX-SLOT-225.webp?v=1761903460902",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-225",
    platFormCode: "RELAX",
  },
  {
    name: "Teddy's Quest",
    img: "/assets/Slot/OCTOPLAY-SLOT-039.Teddy_s Quest.webp?v=1764935918809",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-039",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Tempered Steel",
    img: "/assets/Slot/YGG-SLOT-137.webp?v=1767056428472",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-137",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Templar Tumble",
    img: "/assets/Slot/RELAX-SLOT-045.webp?v=1761903495891",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-045",
    platFormCode: "RELAX",
  },
  {
    name: "Templar Tumble 2",
    img: "/assets/Slot/RELAX-SLOT-148.webp?v=1761903585193",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-148",
    platFormCode: "RELAX",
  },
  {
    name: "Temple Stacks: Splitz",
    img: "/assets/Slot/YGG-SLOT-044.webp?v=1767056428371",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-044",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Temple Tumble",
    img: "/assets/Slot/RELAX-SLOT-046.webp?v=1761903610231",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-046",
    platFormCode: "RELAX",
  },
  {
    name: "Temple Tumble 2",
    img: "/assets/Slot/RELAX-SLOT-121.webp?v=1761903635366",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-121",
    platFormCode: "RELAX",
  },
  {
    name: "Temple of Fury",
    img: "/assets/Slot/RELAX-SLOT-195.webp?v=1761903703159",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-195",
    platFormCode: "RELAX",
  },
  {
    name: "Temujin Treasures",
    img: "/assets/Slot/PP-SLOT-171.Temujin-Treasures.webp?v=1764321539608",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-171",
    platFormCode: "PP",
  },
  {
    name: "Ten Thousand Wonders Multimax",
    img: "/assets/Slot/YGG-SLOT-267.webp?v=1767056428775",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-267",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tesla Jolt",
    img: "/assets/Slot/NLC-SLOT-057.Tesla Jolt.webp?v=1764386726914",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-057",
    platFormCode: "NLC",
  },
  {
    name: "Thai River Wonders",
    img: "/assets/Slot/PG-SLOT-060.webp?v=1765933237796",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-060",
    platFormCode: "PG",
  },
  {
    name: "The 4 Invention",
    img: "/assets/Slot/rqaonzn7kjjiy.The-4-Invention.webp?v=1765053337649",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-159",
    platFormCode: "JOKER",
  },
  {
    name: "The Alter Ego",
    img: "/assets/Slot/PP-SLOT-431.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-431",
    platFormCode: "PP",
  },
  {
    name: "The Big Bark: Golden Jackpots",
    img: "/assets/Slot/OCTOPLAY-SLOT-108.The Big Bark Golden Jackpots.webp?v=1764935943975",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-108",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Big Dawgs",
    img: "/assets/Slot/PP-SLOT-410.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-410",
    platFormCode: "PP",
  },
  {
    name: "The Border",
    img: "/assets/Slot/NLC-SLOT-022.The Border.webp?v=1764386672138",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-022",
    platFormCode: "NLC",
  },
  {
    name: "The Bounty Hunter",
    img: "/assets/Slot/YGG-SLOT-082.webp?v=1767056428425",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-082",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Creepy Carnival",
    img: "/assets/Slot/NLC-SLOT-061.The Creepy Carnival.webp?v=1764386539788",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-061",
    platFormCode: "NLC",
  },
  {
    name: "The Cursed Idol of Montezuma",
    img: "/assets/Slot/YGG-SLOT-396.webp?v=1767056428905",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-396",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Dog House",
    img: "/assets/Slot/PP-SLOT-085.The-Dog-House.webp?v=1764321362361",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-085",
    platFormCode: "PP",
  },
  {
    name: "The Dog House - Muttley Crew",
    img: "/assets/Slot/PP-SLOT-500.The Dog House – Muttley Crew.webp?v=1764321304699",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-500",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Dice Show",
    img: "/assets/Slot/PP-SLOT-416.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-416",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Megaways",
    img: "/assets/Slot/PP-SLOT-036.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-036",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Multihold",
    img: "/assets/Slot/PP-SLOT-327.The Dog House Multihold.webp?v=1764321158592",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-327",
    platFormCode: "PP",
  },
  {
    name: "The Dragon Tiger",
    img: "/assets/Slot/PP-SLOT-022.Dragon-Tiger.webp?v=1764320989065",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-022",
    platFormCode: "PP",
  },
  {
    name: "The First Emperor",
    img: "/assets/Slot/ACEWIN-SLOT-003.The First Emperor.webp?v=1764854872373",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-003",
    platFormCode: "ACEWIN",
  },
  {
    name: "The Good Farmer",
    img: "/assets/Slot/YGG-SLOT-387.webp?v=1767056428892",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-387",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Great Chicken Escape",
    img: "/assets/Slot/PP-SLOT-074.The-Great-Chicken-Escape.webp?v=1764320909468",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-074",
    platFormCode: "PP",
  },
  {
    name: "The Great Icescape",
    img: "/assets/Slot/PG-SLOT-032.webp?v=1765933237773",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-032",
    platFormCode: "PG",
  },
  {
    name: "The Great Jackpot Expedition",
    img: "/assets/Slot/OCTOPLAY-SLOT-062.The great Jackpot Expedition.webp?v=1764935984069",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-062",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Great Pigsby",
    img: "/assets/Slot/RELAX-SLOT-047.webp?v=1761903731452",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-047",
    platFormCode: "RELAX",
  },
  {
    name: "The Great Pigsby Megaways",
    img: "/assets/Slot/RELAX-SLOT-145.webp?v=1761903755290",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-145",
    platFormCode: "RELAX",
  },
  {
    name: "The Great Stick-Up",
    img: "/assets/Slot/PP-SLOT-240.The-Great-Stick-Up.webp?v=1764320857457",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-240",
    platFormCode: "PP",
  },
  {
    name: "The Greed Machine",
    img: "/assets/Slot/OCTOPLAY-SLOT-116.The Greed Machine.webp?v=1764937691327",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-116",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Hand of Midas",
    img: "/assets/Slot/PP-SLOT-005.Hand-of-Midas.webp?v=1764320795978",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    platFormCode: "PP",
  },
  {
    name: "The Handsome Bandit",
    img: "/assets/Slot/YGG-SLOT-305.webp?v=1767056428807",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-305",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Hot Offer",
    img: "/assets/Slot/YGG-SLOT-017.webp?v=1767056428344",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-017",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Knight King",
    img: "/assets/Slot/PP-SLOT-330.The-Knight-King.webp?v=1764319559436",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-330",
    platFormCode: "PP",
  },
  {
    name: "The Legend Of White Snake",
    img: "/assets/Slot/3jxqtp7wssiks.The-Legend-Of-White-Snake.webp?v=1765051382831",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-160",
    platFormCode: "JOKER",
  },
  {
    name: "The Legend of Musashi",
    img: "/assets/Slot/YGG-SLOT-173.webp?v=1767056428512",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-173",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Magic Cauldron - Enchanted Brew",
    img: "/assets/Slot/PP-SLOT-181.The-Magic-Cauldron-Enchanted-Brew.webp?v=1764319404194",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-181",
    platFormCode: "PP",
  },
  {
    name: "The Money Men Megaways",
    img: "/assets/Slot/PP-SLOT-392.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-392",
    platFormCode: "PP",
  },
  {
    name: "The One Armed Bandit",
    img: "/assets/Slot/YGG-SLOT-107.webp?v=1767056428445",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-107",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Queen's Banquet",
    img: "/assets/Slot/PG-SLOT-098.webp?v=1765933237826",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-098",
    platFormCode: "PG",
  },
  {
    name: "The Rave",
    img: "/assets/Slot/NLC-SLOT-023.The Rave.webp?v=1764386438479",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-023",
    platFormCode: "NLC",
  },
  {
    name: "The Red Queen",
    img: "/assets/Slot/PP-SLOT-332.The-Red-Queen.webp?v=1764319323135",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-332",
    platFormCode: "PP",
  },
  {
    name: "The Riches of Don Quixote",
    img: "/assets/Slot/PT-SLOT-052.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-052",
    platFormCode: "PT",
  },
  {
    name: "The Runemakers DoubleMax",
    img: "/assets/Slot/YGG-SLOT-242.webp?v=1767056428593",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-242",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Tiger Warrior",
    img: "/assets/Slot/PP-SLOT-037.Tiger-Warrior.webp?v=1764319271411",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-037",
    platFormCode: "PP",
  },
  {
    name: "The Tumbles",
    img: "/assets/Slot/RELAX-SLOT-262.webp?v=1761903801762",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-262",
    platFormCode: "RELAX",
  },
  {
    name: "The Tweety House",
    img: "/assets/Slot/PP-SLOT-206.The-Tweety-House.webp?v=1764319204116",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-206",
    platFormCode: "PP",
  },
  {
    name: "The Ultimate 5",
    img: "/assets/Slot/PP-SLOT-231.The-Ultimate-5.webp?v=1764319103542",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-231",
    platFormCode: "PP",
  },
  {
    name: "The Vigilantes",
    img: "/assets/Slot/YGG-SLOT-360.webp?v=1767056428868",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-360",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Wild Drifter",
    img: "/assets/Slot/RELAX-SLOT-233.webp?v=1761903851278",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-233",
    platFormCode: "RELAX",
  },
  {
    name: "The Wild Gang",
    img: "/assets/Slot/PP-SLOT-422.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-422",
    platFormCode: "PP",
  },
  {
    name: "The Wild Hatter",
    img: "/assets/Slot/RT-SLOT-164.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-164",
    platFormCode: "RT",
  },
  {
    name: "The Wild Machine",
    img: "/assets/Slot/PP-SLOT-055.The-Wild-Machine.webp?v=1764319141457",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-055",
    platFormCode: "PP",
  },
  {
    name: "The Wisecracker Lightning",
    img: "/assets/Slot/RT-SLOT-209.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-209",
    platFormCode: "RT",
  },
  {
    name: "Third Prince's Journey",
    img: "/assets/Slot/bzgza4umpbwsh.Third-Prince_s-journey.webp?v=1765047620041",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-161",
    platFormCode: "JOKER",
  },
  {
    name: "Thor Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-011.webp?v=1767056428335",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-011",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thor X",
    img: "/assets/Slot/JILI-SLOT-052.webp?v=1755509710532",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-052",
    platFormCode: "JILI",
  },
  {
    name: "Thor's Hammer Time",
    img: "/assets/Slot/YGG-SLOT-325.webp?v=1767056428825",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-325",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thor's Rage",
    img: "/assets/Slot/RT-SLOT-360.Thor_s-Rage.webp?v=1765033913260",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-360",
    platFormCode: "RT",
  },
  {
    name: "Thor's Vengeance",
    img: "/assets/Slot/RT-SLOT-165.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-165",
    platFormCode: "RT",
  },
  {
    name: "Thor: Hammer Time",
    img: "/assets/Slot/NLC-SLOT-046.Thor_ Hammer Time.webp?v=1764386215749",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-046",
    platFormCode: "NLC",
  },
  {
    name: "Three Kingdoms 2",
    img: "/assets/Slot/yqe1n9d7qj3zy.Three-Kingdoms-2.webp?v=1765045113149",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-162",
    platFormCode: "JOKER",
  },
  {
    name: "Three Kingdoms Quest",
    img: "/assets/Slot/fwria11mjbrwh.Three-Kingdoms-Quest.webp?v=1765037105265",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-163",
    platFormCode: "JOKER",
  },
  {
    name: "Three Musketeers",
    img: "/assets/Slot/RT-SLOT-077.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-077",
    platFormCode: "RT",
  },
  {
    name: "Three Star Fortune",
    img: "/assets/Slot/PP-SLOT-048.Three-Star-Fortune.webp?v=1764318976338",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-048",
    platFormCode: "PP",
  },
  {
    name: "Thug Life",
    img: "/assets/Slot/b1cnw7mkppwg1.Thug-Life.webp?v=1765048404830",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-164",
    platFormCode: "JOKER",
  },
  {
    name: "Thunder Hog Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-080.Thunder Hog Chaos Reels.webp?v=1764938018871",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-080",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "ThunderOfThor",
    img: "/assets/Slot/YGG-SLOT-127.webp?v=1767056428464",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-127",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thunderhawk",
    img: "/assets/Slot/YGG-SLOT-204.webp?v=1767056428554",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-204",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tic Tac Take",
    img: "/assets/Slot/PP-SLOT-248.Tic-Tac-Take.webp?v=1764318927408",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-248",
    platFormCode: "PP",
  },
  {
    name: "Ticket To Fortune",
    img: "/assets/Slot/RELAX-SLOT-171.webp?v=1761903917896",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-171",
    platFormCode: "RELAX",
  },
  {
    name: "Ticket To Wild",
    img: "/assets/Slot/NETENT-SLOT-213.Ticket-to-Wild.webp?v=1764953731795",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-213",
    platFormCode: "NETENT",
  },
  {
    name: "Tiger Kingdom Infinity Reels",
    img: "/assets/Slot/RELAX-SLOT-107.webp?v=1761903940174",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-107",
    platFormCode: "RELAX",
  },
  {
    name: "Tiger Stacks",
    img: "/assets/Slot/PT-SLOT-208.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-208",
    platFormCode: "PT",
  },
  {
    name: "Tigers Lair",
    img: "/assets/Slot/y5n8sh5oqf58q.Tigers-Lair.webp?v=1765050611383",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-166",
    platFormCode: "JOKER",
  },
  {
    name: "Tiki Fruits Totem Frenzy",
    img: "/assets/Slot/RT-SLOT-205.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-205",
    platFormCode: "RT",
  },
  {
    name: "Tiki Infinity Reels Megaways",
    img: "/assets/Slot/YGG-SLOT-062.webp?v=1767056428400",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-062",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner 2 DoubleMax",
    img: "/assets/Slot/YGG-SLOT-134.webp?v=1767056428470",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-134",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner Clusters",
    img: "/assets/Slot/YGG-SLOT-379.webp?v=1767056428885",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-379",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner GigaBlox",
    img: "/assets/Slot/YGG-SLOT-240.webp?v=1767056428592",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-240",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Timber Stacks",
    img: "/assets/Slot/PP-SLOT-400.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-400",
    platFormCode: "PP",
  },
  {
    name: "Time Travel Tigers",
    img: "/assets/Slot/YGG-SLOT-038.webp?v=1767056428364",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-038",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiny Toads",
    img: "/assets/Slot/PP-SLOT-526.Tiny Toads.webp?v=1764318806675",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-526",
    platFormCode: "PP",
  },
  {
    name: "Tip Top Totems",
    img: "/assets/Slot/PT-SLOT-212.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-212",
    platFormCode: "PT",
  },
  {
    name: "Titan Clash",
    img: "/assets/Slot/YGG-SLOT-372.webp?v=1767056428879",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-372",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Titan Strike",
    img: "/assets/Slot/RELAX-SLOT-201.webp?v=1761903964533",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-201",
    platFormCode: "RELAX",
  },
  {
    name: "Toad's Gift",
    img: "/assets/Slot/PT-SLOT-177.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-177",
    platFormCode: "PT",
  },
  {
    name: "Tomb of Akhenaten",
    img: "/assets/Slot/NLC-SLOT-005.Tomb of Akhenaten.webp?v=1764386161875",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-005",
    platFormCode: "NLC",
  },
  {
    name: "Tomb of Nefertiti",
    img: "/assets/Slot/NLC-SLOT-042.Tomb of Nefertiti.webp?v=1764386045394",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-042",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone",
    img: "/assets/Slot/NLC-SLOT-049.Tombstone.webp?v=1764385910310",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-049",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone No Mercy",
    img: "/assets/Slot/NLC-SLOT-082.Tombstone No Mercy.webp?v=1764385855419",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-082",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone RIP",
    img: "/assets/Slot/NLC-SLOT-006.Tombstone RIP.webp?v=1764385806996",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-006",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone Slaughter",
    img: "/assets/Slot/NLC-SLOT-104.Tombstone Slaughter.webp?v=1764385757007",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-104",
    platFormCode: "NLC",
  },
  {
    name: "Tons Of Money",
    img: "/assets/Slot/ACEWIN-SLOT-024.Tons of Money.webp?v=1764854929526",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-024",
    platFormCode: "ACEWIN",
  },
  {
    name: "Top Dawg$",
    img: "/assets/Slot/RELAX-SLOT-055.webp?v=1761903997495",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-055",
    platFormCode: "RELAX",
  },
  {
    name: "Torii Tumble",
    img: "/assets/Slot/RELAX-SLOT-194.webp?v=1761904046101",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-194",
    platFormCode: "RELAX",
  },
  {
    name: "Totem Guardians",
    img: "/assets/Slot/RELAX-SLOT-259.webp?v=1761904077811",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-259",
    platFormCode: "RELAX",
  },
  {
    name: "Totem Wonders",
    img: "/assets/Slot/PG-SLOT-107.webp?v=1765933237834",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-107",
    platFormCode: "PG",
  },
  {
    name: "Tower Tumble",
    img: "/assets/Slot/RELAX-SLOT-049.webp?v=1761904100564",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-049",
    platFormCode: "RELAX",
  },
  {
    name: "Towering Fortunes",
    img: "/assets/Slot/PP-SLOT-298.Towering-Fortunes.webp?v=1764318751703",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-298",
    platFormCode: "PP",
  },
  {
    name: "Towering Pays Excalibur",
    img: "/assets/Slot/YGG-SLOT-088.webp?v=1767056428430",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-088",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Towering Pays Valhalla",
    img: "/assets/Slot/YGG-SLOT-080.webp?v=1767056428422",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-080",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Transylvanian: Night of Blood",
    img: "/assets/Slot/RT-SLOT-237.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-237",
    platFormCode: "RT",
  },
  {
    name: "Treasure Bowl",
    img: "/assets/Slot/JDB-SLOT-075.treasure_bowl.webp?v=1765259421924",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-075",
    platFormCode: "JDB",
  },
  {
    name: "Treasure Horse",
    img: "/assets/Slot/PP-SLOT-090.Treasure-Horse.webp?v=1764318704229",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-090",
    platFormCode: "PP",
  },
  {
    name: "Treasure Journey: Genie`s Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-065.Treasure Journey Genie`s Gold.webp?v=1764938076453",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-065",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Treasure Wild",
    img: "/assets/Slot/PP-SLOT-200.Treasure-Wild.webp?v=1764318655083",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-200",
    platFormCode: "PP",
  },
  {
    name: "Treasures of Aztec",
    img: "/assets/Slot/PG-SLOT-058.webp?v=1765933237795",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-058",
    platFormCode: "PG",
  },
  {
    name: "Treasures of Olympus 1000",
    img: "/assets/Slot/KM-SLOT-023.Treasures of Olympus 1000.webp?v=1764779734865",
    platForm: "KM",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "KM-SLOT-023",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Treasures of the Lamps",
    img: "/assets/Slot/PT-SLOT-114.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-114",
    platFormCode: "PT",
  },
  {
    name: "Tree Wishes",
    img: "/assets/Slot/PT-SLOT-407.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-407",
    platFormCode: "PT",
  },
  {
    name: "Tree of Fortune",
    img: "/assets/Slot/PG-SLOT-013.webp?v=1765933237760",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-013",
    platFormCode: "PG",
  },
  {
    name: "Tree of Riches",
    img: "/assets/Slot/PP-SLOT-073.Tree-of-Riches.webp?v=1764318594665",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-073",
    platFormCode: "PP",
  },
  {
    name: "Trees of Treasure",
    img: "/assets/Slot/PP-SLOT-425.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-425",
    platFormCode: "PP",
  },
  {
    name: "Tricks and Treats",
    img: "/assets/Slot/RT-SLOT-139.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-139",
    platFormCode: "RT",
  },
  {
    name: "Trickstar Spins",
    img: "/assets/Slot/YGG-SLOT-330.webp?v=1767056428830",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-330",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Trillionaire",
    img: "/assets/Slot/RT-SLOT-166.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-166",
    platFormCode: "RT",
  },
  {
    name: "Triple Dragons",
    img: "/assets/Slot/PP-SLOT-094.Triple-Dragons.webp?v=1764318525538",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-094",
    platFormCode: "PP",
  },
  {
    name: "Triple Pot Gold",
    img: "/assets/Slot/PP-SLOT-553.webp?v=1755571977968",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-553",
    platFormCode: "PP",
  },
  {
    name: "Triple Stop: Mermaids Find",
    img: "/assets/Slot/PT-SLOT-243.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-243",
    platFormCode: "PT",
  },
  {
    name: "Troll's Gold",
    img: "/assets/Slot/RELAX-SLOT-062.webp?v=1761904174056",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-062",
    platFormCode: "RELAX",
  },
  {
    name: "Trolls Bridge",
    img: "/assets/Slot/YGG-SLOT-057.webp?v=1767056428392",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-057",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Trolls Frenzy",
    img: "/assets/Slot/YGG-SLOT-399.webp?v=1767056428909",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-399",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tropical Tiki",
    img: "/assets/Slot/PP-SLOT-262.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-262",
    platFormCode: "PP",
  },
  {
    name: "True Love",
    img: "/assets/Slot/PT-SLOT-139.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-139",
    platFormCode: "PT",
  },
  {
    name: "True kult",
    img: "/assets/Slot/NLC-SLOT-074.True kult.webp?v=1764385595847",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-074",
    platFormCode: "NLC",
  },
  {
    name: "Tsai Shen 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-168.webp?v=1761904194893",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-168",
    platFormCode: "RELAX",
  },
  {
    name: "Tsai Shen's Gift",
    img: "/assets/Slot/PT-SLOT-210.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-210",
    platFormCode: "PT",
  },
  {
    name: "Tsar Wars",
    img: "/assets/Slot/NLC-SLOT-115.Tsar Wars.webp?v=1764385549400",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-115",
    platFormCode: "NLC",
  },
  {
    name: "Tumble in the Jungle Wild Fight",
    img: "/assets/Slot/YGG-SLOT-251.webp?v=1767056428755",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-251",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Turbo Diamonds: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-117.Turbo Diamonds Hold & Win.webp?v=1764938122751",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-117",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "TutsTwister",
    img: "/assets/Slot/YGG-SLOT-033.webp?v=1767056428361",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-033",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Twice as Nice",
    img: "/assets/Slot/OCTOPLAY-SLOT-019.Twice as Nice.webp?v=1764938161146",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-019",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Twilight Princess",
    img: "/assets/Slot/PP-SLOT-394.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-394",
    platFormCode: "PP",
  },
  {
    name: "Twin Cash: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-061.Twin Cash Hold & Win.webp?v=1764938204846",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-061",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Twisted Turbine",
    img: "/assets/Slot/RELAX-SLOT-075.webp?v=1761904234376",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-075",
    platFormCode: "RELAX",
  },
  {
    name: "Ugga Bugga",
    img: "/assets/Slot/PT-SLOT-015.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-015",
    platFormCode: "PT",
  },
  {
    name: "Ultra Burn",
    img: "/assets/Slot/PP-SLOT-043.Ultra-Burn.webp?v=1764317323117",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-043",
    platFormCode: "PP",
  },
  {
    name: "Ultra Hold and Spin",
    img: "/assets/Slot/PP-SLOT-032.Ultra-Hold-and-Spin.webp?v=1764317274039",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-032",
    platFormCode: "PP",
  },
  {
    name: "Ultra Hotfire",
    img: "/assets/Slot/YGG-SLOT-276.webp?v=1767056428782",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-276",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vacation Station",
    img: "/assets/Slot/PT-SLOT-118.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-118",
    platFormCode: "PT",
  },
  {
    name: "Vacation Station Deluxe",
    img: "/assets/Slot/PT-SLOT-024.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-024",
    platFormCode: "PT",
  },
  {
    name: "Valkyries",
    img: "/assets/Slot/YGG-SLOT-091.webp?v=1767056428433",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-091",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Dead",
    img: "/assets/Slot/YGG-SLOT-306.webp?v=1767056428808",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-306",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Gods",
    img: "/assets/Slot/YGG-SLOT-086.webp?v=1767056428429",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-086",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Gods 2",
    img: "/assets/Slot/YGG-SLOT-092.webp?v=1767056428434",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-092",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vampire Riches",
    img: "/assets/Slot/YGG-SLOT-221.webp?v=1767056428568",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-221",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vampire's Charm",
    img: "/assets/Slot/PG-SLOT-062.webp?v=1765933237798",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-062",
    platFormCode: "PG",
  },
  {
    name: "Vampires VS Wolves",
    img: "/assets/Slot/PP-SLOT-075.Vampires-vs-Wolves.webp?v=1764317184649",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-075",
    platFormCode: "PP",
  },
  {
    name: "Vampy Party",
    img: "/assets/Slot/PP-SLOT-505.Vampy Party.webp?v=1764317130724",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-505",
    platFormCode: "PP",
  },
  {
    name: "Vault Blast Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-049.Vault Blast Hold & Win.webp?v=1764938263629",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-049",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Vault Cracker",
    img: "/assets/Slot/RT-SLOT-167.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-167",
    platFormCode: "RT",
  },
  {
    name: "Vault Raiders DoubleMax",
    img: "/assets/Slot/YGG-SLOT-418.webp?v=1767056428926",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-418",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vault of Anubis",
    img: "/assets/Slot/RT-SLOT-100.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-100",
    platFormCode: "RT",
  },
  {
    name: "Vault of Fortune",
    img: "/assets/Slot/YGG-SLOT-048.webp?v=1767056428377",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-048",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vegas Blitz: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-094.Vegas Blitz Hold & Win.webp?v=1764938285612",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-094",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Vegas Magic",
    img: "/assets/Slot/PP-SLOT-096.Vegas-Magic.webp?v=1764317077585",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-096",
    platFormCode: "PP",
  },
  {
    name: "Vegas is Dead: Battle Arena",
    img: "/assets/Slot/OCTOPLAY-SLOT-110.Vegas is Dead Battle Arena.webp?v=1764938305451",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-110",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Viking Forge",
    img: "/assets/Slot/PP-SLOT-396.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-396",
    platFormCode: "PP",
  },
  {
    name: "Viking Glory",
    img: "/assets/Slot/ACEWIN-SLOT-033.webp?v=1762477170478",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-033",
    platFormCode: "ACEWIN",
  },
  {
    name: "Vikings Go Berzerk",
    img: "/assets/Slot/YGG-SLOT-109.webp?v=1767056428447",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-109",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings Go Berzerk: Reloaded",
    img: "/assets/Slot/YGG-SLOT-121.webp?v=1767056428459",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-121",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings Go To Egypt",
    img: "/assets/Slot/YGG-SLOT-266.webp?v=1767056428774",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-266",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go Wild",
    img: "/assets/Slot/YGG-SLOT-110.webp?v=1767056428447",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-110",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go to Hell",
    img: "/assets/Slot/YGG-SLOT-089.webp?v=1767056428431",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-089",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go to Valhalla",
    img: "/assets/Slot/YGG-SLOT-051.webp?v=1767056428382",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-051",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Viral Spiral",
    img: "/assets/Slot/RT-SLOT-132.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-132",
    platFormCode: "RT",
  },
  {
    name: "Volatile Egypt",
    img: "/assets/Slot/RELAX-SLOT-162.webp?v=1761904259838",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-162",
    platFormCode: "RELAX",
  },
  {
    name: "Volatile Vikings",
    img: "/assets/Slot/RELAX-SLOT-066.webp?v=1761904287172",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-066",
    platFormCode: "RELAX",
  },
  {
    name: "Volatile Vikings 2",
    img: "/assets/Slot/RELAX-SLOT-143.webp?v=1761904313475",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-143",
    platFormCode: "RELAX",
  },
  {
    name: "Volcano Goddess",
    img: "/assets/Slot/PP-SLOT-551.Volcano Goddess.webp?v=1764316944398",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-551",
    platFormCode: "PP",
  },
  {
    name: "Voodoo Hex",
    img: "/assets/Slot/YGG-SLOT-157.webp?v=1767056428489",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-157",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Voodoo Magic",
    img: "/assets/Slot/PP-SLOT-013.Voodoo-Magic.webp?v=1764316779634",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-013",
    platFormCode: "PP",
  },
  {
    name: "WILD VEGAS",
    img: "/assets/Slot/2J-SLOT-006.WILD VEGAS.webp?v=1763547643573",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-006",
    platFormCode: "JJ",
  },
  {
    name: "Walrus King",
    img: "/assets/Slot/OCTOPLAY-SLOT-079.Walrus King.webp?v=1764938350494",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-079",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "War Of Dragons",
    img: "/assets/Slot/JILI-SLOT-004.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-004",
    platFormCode: "JILI",
  },
  {
    name: "War of Gods",
    img: "/assets/Slot/RT-SLOT-168.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-168",
    platFormCode: "RT",
  },
  {
    name: "Water Blox",
    img: "/assets/Slot/YGG-SLOT-142.webp?v=1767056428476",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-142",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Water Margin",
    img: "/assets/Slot/foff4ikkjprr1.Water-Margin.webp?v=1765044402124",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-169",
    platFormCode: "JOKER",
  },
  {
    name: "Water Reel",
    img: "/assets/Slot/5ypkuepgw61kk.Water-reel.webp?v=1765040929603",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-170",
    platFormCode: "JOKER",
  },
  {
    name: "Ways of the Phoenix",
    img: "/assets/Slot/PT-SLOT-116.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-116",
    platFormCode: "PT",
  },
  {
    name: "Ways of the Qilin",
    img: "/assets/Slot/PG-SLOT-076.webp?v=1765933237808",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-076",
    platFormCode: "PG",
  },
  {
    name: "Wealth God",
    img: "/assets/Slot/e9qs4cbtga5ue.Wealth-God.webp?v=1765046784919",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-171",
    platFormCode: "JOKER",
  },
  {
    name: "Wealthway",
    img: "/assets/Slot/JDB-SLOT-122.wealthway.webp?v=1765259266525",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-122",
    platFormCode: "JDB",
  },
  {
    name: "Wealthy Frog",
    img: "/assets/Slot/PP-SLOT-613.Wealthy Frog.webp?v=1764316659958",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-613",
    platFormCode: "PP",
  },
  {
    name: "Well Of Wishes",
    img: "/assets/Slot/RT-SLOT-169.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-169",
    platFormCode: "RT",
  },
  {
    name: "Well of Wilds MegaWays + PowerWheel",
    img: "/assets/Slot/RT-SLOT-214.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-214",
    platFormCode: "RT",
  },
  {
    name: "Whacked",
    img: "/assets/Slot/NLC-SLOT-068.Whacked.webp?v=1764385326004",
    platForm: "NLC",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-068",
    platFormCode: "NLC",
  },
  {
    name: "What The Fox MegaWays",
    img: "/assets/Slot/RT-SLOT-206.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-206",
    platFormCode: "RT",
  },
  {
    name: "What The Fruit!",
    img: "/assets/Slot/YGG-SLOT-424.webp?v=1767056428932",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-424",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wheels of Flame",
    img: "/assets/Slot/PT-SLOT-242.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-242",
    platFormCode: "PT",
  },
  {
    name: "White King II",
    img: "/assets/Slot/PT-SLOT-125.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-125",
    platFormCode: "PT",
  },
  {
    name: "Wild Bandito",
    img: "/assets/Slot/PG-SLOT-075.webp?v=1765933237807",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-075",
    platFormCode: "PG",
  },
  {
    name: "Wild Bison Charge",
    img: "/assets/Slot/PP-SLOT-343.Wild-Bison-Charge.webp?v=1764316562740",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-343",
    platFormCode: "PP",
  },
  {
    name: "Wild Booster",
    img: "/assets/Slot/PP-SLOT-173.Wild-Booster.webp?v=1764316482856",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-173",
    platFormCode: "PP",
  },
  {
    name: "Wild Bounty Showdown",
    img: "/assets/Slot/PG-SLOT-105.webp?v=1765933237832",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    platFormCode: "PG",
  },
  {
    name: "Wild Buccaneers Megaways",
    img: "/assets/Slot/RELAX-SLOT-136.webp?v=1761904345177",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-136",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Cats Multiline",
    img: "/assets/Slot/RT-SLOT-101.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-101",
    platFormCode: "RT",
  },
  {
    name: "Wild Celebrity Bus Megaways",
    img: "/assets/Slot/PP-SLOT-337.Wild-Celebrity-Bus-Megaways.webp?v=1764316439500",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-337",
    platFormCode: "PP",
  },
  {
    name: "Wild Chapo",
    img: "/assets/Slot/RELAX-SLOT-054.webp?v=1761904377844",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-054",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 10K",
    img: "/assets/Slot/RELAX-SLOT-242.webp?v=1761904440810",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-242",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 2",
    img: "/assets/Slot/RELAX-SLOT-165.webp?v=1761904474696",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-165",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 5K",
    img: "/assets/Slot/RELAX-SLOT-241.webp?v=1761904504533",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-241",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chips",
    img: "/assets/Slot/ACEWIN-SLOT-010.Wild Chips.webp?v=1764854957931",
    platForm: "ACEWIN",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-010",
    platFormCode: "ACEWIN",
  },
  {
    name: "Wild Circus",
    img: "/assets/Slot/RT-SLOT-083.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-083",
    platFormCode: "RT",
  },
  {
    name: "Wild Coaster",
    img: "/assets/Slot/PG-SLOT-104.webp?v=1765933237831",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-104",
    platFormCode: "PG",
  },
  {
    name: "Wild Depths",
    img: "/assets/Slot/PP-SLOT-225.Wild-Depths.webp?v=1764316392665",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-225",
    platFormCode: "PP",
  },
  {
    name: "Wild Donuts",
    img: "/assets/Slot/RELAX-SLOT-140.webp?v=1761904528924",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-140",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Duel",
    img: "/assets/Slot/YGG-SLOT-138.webp?v=1767056428473",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-138",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Elements",
    img: "/assets/Slot/RT-SLOT-198.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-198",
    platFormCode: "RT",
  },
  {
    name: "Wild Esqueleto Lightning Chase",
    img: "/assets/Slot/RELAX-SLOT-112.webp?v=1761904551091",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-112",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Expedition",
    img: "/assets/Slot/RT-SLOT-218.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-218",
    platFormCode: "RT",
  },
  {
    name: "Wild Fairies",
    img: "/assets/Slot/1wt58azdhdo6c.Wild-Fairies.webp?v=1765044294801",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-173",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Fireworks",
    img: "/assets/Slot/PG-SLOT-055.webp?v=1765933237794",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-055",
    platFormCode: "PG",
  },
  {
    name: "Wild Fishin' Wild Ways",
    img: "/assets/Slot/YGG-SLOT-163.webp?v=1767056428501",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-163",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Gangs",
    img: "/assets/Slot/YGG-SLOT-403.webp?v=1767056428914",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-403",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Giant Panda",
    img: "/assets/Slot/q9gi4yybyadoe.Wild-Giant-Panda.webp?v=1765049426838",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-174",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Hike",
    img: "/assets/Slot/RELAX-SLOT-164.webp?v=1761904584790",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-164",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Hop & Drop",
    img: "/assets/Slot/PP-SLOT-287.Wild-Hop-&-Drop.webp?v=1764316272123",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-287",
    platFormCode: "PP",
  },
  {
    name: "Wild Hot Chilli Reels",
    img: "/assets/Slot/RT-SLOT-208.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-208",
    platFormCode: "RT",
  },
  {
    name: "Wild Joker Blitz",
    img: "/assets/Slot/YGG-SLOT-347.webp?v=1767056428851",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-347",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Joker Stacks",
    img: "/assets/Slot/YGG-SLOT-015.webp?v=1767056428341",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-015",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Lava",
    img: "/assets/Slot/PT-SLOT-184.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-184",
    platFormCode: "PT",
  },
  {
    name: "Wild Lava Scratch",
    img: "/assets/Slot/PT-SLOT-246.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-246",
    platFormCode: "PT",
  },
  {
    name: "Wild Linx",
    img: "/assets/Slot/PT-SLOT-159.Wild Linx.webp?v=1764329922948",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-159",
    platFormCode: "PT",
  },
  {
    name: "Wild O'Clock",
    img: "/assets/Slot/RT-SLOT-199.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-199",
    platFormCode: "RT",
  },
  {
    name: "Wild One",
    img: "/assets/Slot/YGG-SLOT-152.webp?v=1767056428485",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-152",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Pixies",
    img: "/assets/Slot/PP-SLOT-081.Wild-Pixies.webp?v=1764316207870",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-081",
    platFormCode: "PP",
  },
  {
    name: "Wild Racer",
    img: "/assets/Slot/JILI-SLOT-072.webp?v=1755509913162",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-072",
    platFormCode: "JILI",
  },
  {
    name: "Wild Robo Factory",
    img: "/assets/Slot/YGG-SLOT-041.webp?v=1767056428368",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-041",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Roll",
    img: "/assets/Slot/PT-SLOT-419.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-419",
    platFormCode: "PT",
  },
  {
    name: "Wild Spells",
    img: "/assets/Slot/PP-SLOT-120.Wild-Spells.webp?v=1764315650040",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-120",
    platFormCode: "PP",
  },
  {
    name: "Wild Spirit",
    img: "/assets/Slot/itzp5iqk3xrc1.Wild-Spirit.webp?v=1765052305671",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-175",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Stack Frenzy",
    img: "/assets/Slot/YGG-SLOT-224.webp?v=1767056428570",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-224",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Storm Legionnaire",
    img: "/assets/Slot/YGG-SLOT-270.webp?v=1767056428777",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-270",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Tundra",
    img: "/assets/Slot/RT-SLOT-189.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-189",
    platFormCode: "RT",
  },
  {
    name: "Wild Walker",
    img: "/assets/Slot/PP-SLOT-026.Wild-Walker.webp?v=1764315595466",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-026",
    platFormCode: "PP",
  },
  {
    name: "Wild West Duels",
    img: "/assets/Slot/PP-SLOT-325.Wild-West-Duels.webp?v=1764315479816",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-325",
    platFormCode: "PP",
  },
  {
    name: "Wild West Gold",
    img: "/assets/Slot/PP-SLOT-052.Wild-West-Gold.webp?v=1764315365149",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-052",
    platFormCode: "PP",
  },
  {
    name: "Wild West Gold Megaways",
    img: "/assets/Slot/PP-SLOT-233.Wild-West-Gold-Megaways.webp?v=1764315130088",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-233",
    platFormCode: "PP",
  },
  {
    name: "Wild West Wilds",
    img: "/assets/Slot/PT-SLOT-201.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-201",
    platFormCode: "PT",
  },
  {
    name: "Wild White Rhino",
    img: "/assets/Slot/OCTOPLAY-SLOT-082.Wild White Rhino.webp?v=1764938399840",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-082",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Wild Wild Bananas",
    img: "/assets/Slot/PP-SLOT-315.Wild-Wild-Bananas.webp?v=1764315021279",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-315",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Joker",
    img: "/assets/Slot/PP-SLOT-549.webp?v=1755571945294",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-549",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Pearls",
    img: "/assets/Slot/PP-SLOT-536.Wild Wild Pearls.webp?v=1764314880438",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-536",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches",
    img: "/assets/Slot/PP-SLOT-031.Wild-Wild-Riches.webp?v=1764314774949",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-031",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches Megaways",
    img: "/assets/Slot/PP-SLOT-323.Wild-Wild-Riches-Megaways.webp?v=1764314674837",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-323",
    platFormCode: "PP",
  },
  {
    name: "Wild Wildebeest Wins",
    img: "/assets/Slot/PP-SLOT-538.Wild Wildebeest Wins.webp?v=1764314457356",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-538",
    platFormCode: "PP",
  },
  {
    name: "Wild Yield",
    img: "/assets/Slot/RELAX-SLOT-151.webp?v=1761904610936",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-151",
    platFormCode: "RELAX",
  },
  {
    name: "Wildchemy",
    img: "/assets/Slot/RELAX-SLOT-050.webp?v=1761904640663",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-050",
    platFormCode: "RELAX",
  },
  {
    name: "Wildies",
    img: "/assets/Slot/PP-SLOT-465.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-465",
    platFormCode: "PP",
  },
  {
    name: "Wildman Super Bonanza",
    img: "/assets/Slot/PP-SLOT-280.Wildman-Super-Bonanza.webp?v=1764314324997",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-280",
    platFormCode: "PP",
  },
  {
    name: "Wilfred's Wheel",
    img: "/assets/Slot/OCTOPLAY-SLOT-037.Wilfred_s Wheel.webp?v=1764938451378",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-037",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Wilhelm Tell",
    img: "/assets/Slot/YGG-SLOT-039.webp?v=1767056428365",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-039",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Win Drop",
    img: "/assets/Slot/JILI-SLOT-061.webp?v=1751418030805",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-061",
    platFormCode: "JILI",
  },
  {
    name: "Win Escalator",
    img: "/assets/Slot/RT-SLOT-195.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-195",
    platFormCode: "RT",
  },
  {
    name: "Win Win Fish Prawn Crab",
    img: "/assets/Slot/PG-SLOT-100.webp?v=1765933237828",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-100",
    platFormCode: "PG",
  },
  {
    name: "Win Win Won",
    img: "/assets/Slot/PG-SLOT-011.webp?v=1766369839569",
    platForm: "PG",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PG-SLOT-011",
    platFormCode: "PG",
  },
  {
    name: "Win-O-Mart",
    img: "/assets/Slot/RELAX-SLOT-261.webp?v=1761904663223",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-261",
    platFormCode: "RELAX",
  },
  {
    name: "Wings Of Ra",
    img: "/assets/Slot/RT-SLOT-141.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-141",
    platFormCode: "RT",
  },
  {
    name: "Winning Mask",
    img: "/assets/Slot/JDB-SLOT-011.Winning Mask.webp?v=1765259218237",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    platFormCode: "JDB",
  },
  {
    name: "WinningMask II",
    img: "/assets/Slot/JDB-SLOT-050.Winning Mask 2.webp?v=1765259150809",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-050",
    platFormCode: "JDB",
  },
  {
    name: "Wins of Mermaid Multipower",
    img: "/assets/Slot/RELAX-SLOT-223.webp?v=1761904686213",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-223",
    platFormCode: "RELAX",
  },
  {
    name: "Wins of Winter",
    img: "/assets/Slot/RELAX-SLOT-152.webp?v=1761904708622",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-152",
    platFormCode: "RELAX",
  },
  {
    name: "Winter Champions",
    img: "/assets/Slot/RELAX-SLOT-272.webp?v=1761904731511",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-272",
    platFormCode: "RELAX",
  },
  {
    name: "Winter Sweets",
    img: "/assets/Slot/ipz77igi3mfho.Winter-Sweets.webp?v=1765047729065",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-176",
    platFormCode: "JOKER",
  },
  {
    name: "Winterberries",
    img: "/assets/Slot/YGG-SLOT-090.webp?v=1767056428433",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-090",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Winterberries 2",
    img: "/assets/Slot/YGG-SLOT-179.webp?v=1767056428517",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-179",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wisdom of Athena",
    img: "/assets/Slot/PP-SLOT-354.Wisdom-of-Athena.webp?v=1764314161067",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-354",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000",
    img: "/assets/Slot/PP-SLOT-499.Wisdom-of-Athena-1000.webp?v=1764314033462",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-499",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000 Xmas",
    img: "/assets/Slot/PP-SLOT-662.Wisdom of Athena 1000 Xmas.webp?v=1764940501677",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-662",
    platFormCode: "PP",
  },
  {
    name: "Wish for a Cash Star",
    img: "/assets/Slot/OCTOPLAY-SLOT-071.Wish for a Cash Star.webp?v=1764938531346",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-071",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Witch's Brew",
    img: "/assets/Slot/bmr8675wqiigs.Witch_s-Brew.webp?v=1765051614214",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-177",
    platFormCode: "JOKER",
  },
  {
    name: "Witches: Cash Collect",
    img: "/assets/Slot/PT-SLOT-337.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-337",
    platFormCode: "PT",
  },
  {
    name: "Witchy Poppins",
    img: "/assets/Slot/RELAX-SLOT-271.webp?v=1761904801337",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-271",
    platFormCode: "RELAX",
  },
  {
    name: "Wizard Deluxe",
    img: "/assets/Slot/pz7wsnombyroh.Wizard-Deluxe.webp?v=1765046489887",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-178",
    platFormCode: "JOKER",
  },
  {
    name: "Wolf Gold",
    img: "/assets/Slot/PP-SLOT-127.Wolf-Gold.webp?v=1764313763918",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-127",
    platFormCode: "PP",
  },
  {
    name: "Wolf Gold Ultimate",
    img: "/assets/Slot/PP-SLOT-518.Wolf Gold Ultimate.webp?v=1764313546580",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-518",
    platFormCode: "PP",
  },
  {
    name: "Wolf Hunters",
    img: "/assets/Slot/YGG-SLOT-035.webp?v=1767056428363",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-035",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wolf Stacks MegaWays",
    img: "/assets/Slot/RT-SLOT-344.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-344",
    platFormCode: "RT",
  },
  {
    name: "Wonders of Christmas",
    img: "/assets/Slot/NETENT-SLOT-132.Wonders-of-Christmas.webp?v=1764951697787",
    platForm: "NETENT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-132",
    platFormCode: "NETENT",
  },
  {
    name: "World Cup",
    img: "/assets/Slot/JILI-SLOT-063.webp?v=1755509865312",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-063",
    platFormCode: "JILI",
  },
  {
    name: "Wrigley's World",
    img: "/assets/Slot/RT-SLOT-238.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-238",
    platFormCode: "RT",
  },
  {
    name: "Wu Long",
    img: "/assets/Slot/PT-SLOT-123.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-123",
    platFormCode: "PT",
  },
  {
    name: "Wu kong",
    img: "/assets/Slot/JDB-SLOT-012.wukong.webp?v=1765259033775",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    platFormCode: "JDB",
  },
  {
    name: "Wukong",
    img: "/assets/Slot/texkt79w6ziqs.Wukong.webp?v=1765028783982",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-179",
    platFormCode: "JOKER",
  },
  {
    name: "Wushu Punch",
    img: "/assets/Slot/PT-SLOT-233.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-233",
    platFormCode: "PT",
  },
  {
    name: "X-PLOSIVE ROCK",
    img: "/assets/Slot/2J-SLOT-054.X-PLOSIVE ROCK.webp?v=1763547602776",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-054",
    platFormCode: "JJ",
  },
  {
    name: "Xi Yang Yang",
    img: "/assets/Slot/JDB-SLOT-054.xi_yangyang.webp?v=1765258980724",
    platForm: "JDB",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-054",
    platFormCode: "JDB",
  },
  {
    name: "XiYangYang",
    img: "/assets/Slot/JILI-SLOT-018.webp?v=1755509281708",
    platForm: "JILI",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-018",
    platFormCode: "JILI",
  },
  {
    name: "Xibalba",
    img: "/assets/Slot/YGG-SLOT-071.webp?v=1767056428408",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-071",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Xmas Pop Delight",
    img: "/assets/Slot/YGG-SLOT-313.webp?v=1767056428813",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-313",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Xtreme Fire Blaze Roulette",
    img: "/assets/Slot/PT-SLOT-353.Xtreme Fire Blaze Roulette.webp?v=1762321214585",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-353",
    platFormCode: "PT",
  },
  {
    name: "Xuan Pu Lian Huan",
    img: "/assets/Slot/c41bsraonrmbq.Xuan-Pu-Lian-Huan.webp?v=1765036589922",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-180",
    platFormCode: "JOKER",
  },
  {
    name: "Y-PLOSIVE ROCK",
    img: "/assets/Slot/2J-SLOT-055.Y-PLOSIVE ROCK.webp?v=1763547560362",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-055",
    platFormCode: "JJ",
  },
  {
    name: "Yakuza",
    img: "/assets/Slot/y4jnah5oqf58q.Yakuza.webp?v=1765054085763",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-181",
    platFormCode: "JOKER",
  },
  {
    name: "Year of Olympia",
    img: "/assets/Slot/YGG-SLOT-263.webp?v=1767056428771",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-263",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Year of the Dragon King",
    img: "/assets/Slot/PP-SLOT-406.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-406",
    platFormCode: "PP",
  },
  {
    name: "Yeh Hsien Deluxe",
    img: "/assets/Slot/uygm7axgh91qk.Yeh-Hsien-Deluxe.webp?v=1765027277133",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-182",
    platFormCode: "JOKER",
  },
  {
    name: "Yeti Quest",
    img: "/assets/Slot/PP-SLOT-484.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-484",
    platFormCode: "PP",
  },
  {
    name: "Yggdrasil",
    img: "/assets/Slot/9ii7s6u5xbhzh.Yggdrasil.webp?v=1765027217185",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-183",
    platFormCode: "JOKER",
  },
  {
    name: "Yokozuna Clash",
    img: "/assets/Slot/YGG-SLOT-042.webp?v=1767056428369",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-042",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Your Own Island",
    img: "/assets/Slot/YGG-SLOT-414.webp?v=1767056428923",
    platForm: "YGGDRASIL",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-414",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Yu Tu Jin Cai: Cash Collect",
    img: "/assets/Slot/PT-SLOT-237.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-237",
    platFormCode: "PT",
  },
  {
    name: "Yucatan's Mystery",
    img: "/assets/Slot/RT-SLOT-170.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-170",
    platFormCode: "RT",
  },
  {
    name: "Yun Cong Long",
    img: "/assets/Slot/PT-SLOT-028.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-028",
    platFormCode: "PT",
  },
  {
    name: "ZEUS POWER",
    img: "/assets/Slot/2J-SLOT-010.ZEUS POWER.webp?v=1763547486878",
    platForm: "JJ",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "2J-SLOT-010",
    platFormCode: "JJ",
  },
  {
    name: "Zaida's Fortune",
    img: "/assets/Slot/RT-SLOT-186.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-186",
    platFormCode: "RT",
  },
  {
    name: "Zeus Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-027.Zeus Smash.webp?v=1764938620276",
    platForm: "OCTOPLAY",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-027",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Zeus vs Hades - Gods of War",
    img: "/assets/Slot/PP-SLOT-346.Zeus-vs-Hades-Gods-of-War.webp?v=1764312948793",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-346",
    platFormCode: "PP",
  },
  {
    name: "Zeus vs Typhon",
    img: "/assets/Slot/PP-SLOT-661.Zeus vs Typhon.webp?v=1764940343737",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-661",
    platFormCode: "PP",
  },
  {
    name: "Zhao Cai Jin Bao 2",
    img: "/assets/Slot/PT-SLOT-180.webp?v=1751418030707",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-180",
    platFormCode: "PT",
  },
  {
    name: "Zillard King",
    img: "/assets/Slot/RT-SLOT-102.webp?v=1751418030566",
    platForm: "RT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RT-SLOT-102",
    platFormCode: "RT",
  },
  {
    name: "Zodiac Charms",
    img: "/assets/Slot/PT-SLOT-164.zodiac-charms.webp?v=1764328328357",
    platForm: "PT",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PT-SLOT-164",
    platFormCode: "PT",
  },
  {
    name: "Zodiac Deluxe",
    img: "/assets/Slot/hj5cb8hhusjjg.Zodiac-Deluxe.webp?v=1765027088280",
    platForm: "JOKER",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-185",
    platFormCode: "JOKER",
  },
  {
    name: "Zombie Carnival",
    img: "/assets/Slot/PP-SLOT-252.Zombie-Carnival.webp?v=1764312762518",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-252",
    platFormCode: "PP",
  },
  {
    name: "Zombie Circus",
    img: "/assets/Slot/RELAX-SLOT-051.webp?v=1761883852180",
    platForm: "RELAX",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-051",
    platFormCode: "RELAX",
  },
  {
    name: "Zombie Train",
    img: "/assets/Slot/PP-SLOT-437.webp?v=1751418030744",
    platForm: "PP",
    type: "SLOTS",
    gameType: "SLOT",
    casinoType: "PP-SLOT-437",
    platFormCode: "PP",
  },
];

export const LiveCasino = [
  {
    name: "Cash or Crash",
    img: "/assets/Casino/GAME-SHOW-2.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-175",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dead or Alive Saloon",
    img: "/assets/Casino/GAME-SHOW-4.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Fever",
    img: "/assets/Casino/GAME-SHOW-8.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extra Chilli",
    img: "/assets/Casino/GAME-SHOW-9.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Gonzo's Treasure Map",
    img: "/assets/Casino/EVOLUTION-LIVE-246.png",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-246",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Wounderland",
    img: "/assets/Casino/GAME-SHOW-16.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-011",
    platFormCode: "PT",
  },
  {
    name: "Shweet Bonanza Candy Land",
    img: "/assets/Casino/GAME-SHOW-17.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    platFormCode: "PP",
  },
  {
    name: "Spin and Win Wild B X2",
    img: "/assets/Casino/GAME-SHOW-19.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
    platFormCode: "PT",
  },
  {
    name: "Mega Roulette 500x",
    img: "/assets/Casino/GAME-SHOW-23.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    platFormCode: "PP",
  },
  {
    name: "Power Roulette",
    img: "/assets/Casino/GAME-SHOW-26.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-055",
    platFormCode: "PP",
  },
  {
    name: "Sicbo Delux",
    img: "/assets/Casino/GAME-SHOW-27.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-003",
    platFormCode: "PT",
  },
  {
    name: "Bet on Dragon Tiger",
    img: "/assets/Casino/GAME-SHOW-29.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-030",
    platFormCode: "PT",
  },
  {
    name: "Hi-lo Club",
    img: "/assets/Casino/GAME-SHOW-30.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-014",
    platFormCode: "PT",
  },
  {
    name: "Baccarat no commission",
    img: "/assets/Casino/BACCARAT-2.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Baccarat First Person",
    img: "/assets/Casino/BACCARAT-5.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat 3",
    img: "/assets/Casino/BACCARAT-15.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-001",
    platFormCode: "PT",
  },
  {
    name: "Baccarat Insurance",
    img: "/assets/Casino/BACCARAT-27.webp",
    platForm: "SEXYBCRT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "MX-LIVE-002",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Roulette First Person",
    img: "/assets/Casino/ROULETTE-6.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Amercian Roulette Live",
    img: "/assets/Casino/ROULETTE-7.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Azure Roulette",
    img: "/assets/Casino/ROULETTE-15.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-028",
    platFormCode: "PP",
  },
  {
    name: "American Roulette Live",
    img: "/assets/Casino/ROULETTE-16.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-021",
    platFormCode: "PT",
  },
  {
    name: "Deutsches Roulette Live",
    img: "/assets/Casino/ROULETTE-17.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-022",
    platFormCode: "PT",
  },
  {
    name: "Spread Bets Roulette",
    img: "/assets/Casino/ROULETTE-21.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-027",
    platFormCode: "PT",
  },
  {
    name: "Bac Bo Live",
    img: "/assets/Casino/DICE-1.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-053",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Craps Live",
    img: "/assets/Casino/DICE-3.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Experor Sic Bo",
    img: "/assets/Casino/DICE-4.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Red Blue Duel",
    img: "/assets/Casino/DICE-6.webp",
    platForm: "SEXYBCRT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "MX-LIVE-010",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Super Andhar Bahar",
    img: "/assets/Casino/TRADINATIONAL-1.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Teen Patti Live",
    img: "/assets/Casino/TRADINATIONAL-5.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-026",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extra Teen Patti",
    img: "/assets/Casino/TRADINATIONAL-9.webp",
    platForm: "SEXYBCRT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "MX-LIVE-012",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Andhar Bahar Live",
    img: "/assets/Casino/TRADINATIONAL-11.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-004",
    platFormCode: "PT",
  },
  {
    name: "Andhar Bahar",
    img: "/assets/Casino/TRADINATIONAL-14.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-043",
    platFormCode: "PP",
  },
  {
    name: "Lightning Black Jack First Person",
    img: "/assets/Casino/EVOLUTION-LIVE-208.webp",
    platForm: "EVO",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-207",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Alexandrite Blackjack",
    img: "/assets/Casino/PT-LIVE-006.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-007",
    platFormCode: "PT",
  },
  {
    name: "One Blackjack",
    img: "/assets/Casino/PP-LIVE-040.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-040",
    platFormCode: "PP",
  },
  {
    name: "ONE Blackjack 2 - Ruby",
    img: "/assets/Casino/PP-LIVE-041.webp",
    platForm: "PP",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PP-LIVE-041",
    platFormCode: "PP",
  },
  {
    name: "Majority Rules Speed Blackjack",
    img: "/assets/Casino/PT-LIVE-008.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-008",
    platFormCode: "PT",
  },
  {
    name: "Casino Hold AEM",
    img: "/assets/Casino/PT-LIVE-017.webp",
    platForm: "PT",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "PT-LIVE-017",
    platFormCode: "PT",
  },
  {
    name: "Live Casino BG",
    img: "/assets/Casino/BG-LIVE-001.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-001",
    platFormCode: "BG",
  },
  {
    name: "Roulette Awc",
    img: "/assets/Casino/BG-LIVE-003.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-003",
    platFormCode: "BG",
  },
  {
    name: "Sicbo Awc",
    img: "/assets/Casino/BG-LIVE-004.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-004",
    platFormCode: "BG",
  },
  {
    name: "Mi Card Baccarat",
    img: "/assets/Casino/BG-LIVE-007.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-007",
    platFormCode: "BG",
  },
  {
    name: "Full Color Baccarat",
    img: "/assets/Casino/BG-LIVE-008.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-008",
    platFormCode: "BG",
  },
  {
    name: "BullBull",
    img: "/assets/Casino/BG-LIVE-009.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-009",
    platFormCode: "BG",
  },
  {
    name: "Win Three Cards",
    img: "/assets/Casino/BG-LIVE-010.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-010",
    platFormCode: "BG",
  },
  {
    name: "RedBlack",
    img: "/assets/Casino/BG-LIVE-011.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-011",
    platFormCode: "BG",
  },
  {
    name: "CasinoWar",
    img: "/assets/Casino/BG-LIVE-014.webp",
    platForm: "BG",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "BG-LIVE-014",
    platFormCode: "BG",
  },
  {
    name: "SV388",
    img: "/assets/Casino/SV-LIVE-001.webp",
    platForm: "SV388",
    type: "CASINO",
    gameType: "LIVE",
    casinoType: "SV-LIVE-001",
    platFormCode: "SV388",
  },
  {
    name: "24D Spin",
    img: "/assets/Casino/PP-LIVE-190.24D Spin.webp?v=1764405191092",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-190",
    platFormCode: "PP",
  },
  {
    name: "2 Hand Casino Hold'em",
    img: "/assets/Casino/EVOLUTION-LIVE-021.webp?v=1765933237412",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-021",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Agent Spinity",
    img: "/assets/Casino/WINFINITY-LIVE-031.Agent Spinity.webp?v=1764402083653",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-031",
    platFormCode: "WINFINITY",
  },
  {
    name: "Andar Bahar x5000",
    img: "/assets/Casino/WINFINITY-LIVE-035.Andar Bahar x5000.webp?v=1764402004788",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-035",
    platFormCode: "WINFINITY",
  },
  {
    name: "AndarBahar A15",
    img: "/assets/Casino/DREAMGAMING-LIVE-029.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-029",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Auto-Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-170.webp?v=1765933237542",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-170",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Auto-Roulette 1",
    img: "/assets/Casino/PP-LIVE-026.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-026",
    platFormCode: "PP",
  },
  {
    name: "Auto-Roulette VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-171.webp?v=1765933237544",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-171",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bac Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-172.webp?v=1765933237544",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat 1",
    img: "/assets/Casino/PP-LIVE-001.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-001",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 11",
    img: "/assets/Casino/PP-LIVE-010.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-010",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 2",
    img: "/assets/Casino/PP-LIVE-002.Baccarat 2.webp?v=1764404982627",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-002",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 5",
    img: "/assets/Casino/PP-LIVE-004.Baccarat 5.webp?v=1764404914436",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-004",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 6",
    img: "/assets/Casino/PP-LIVE-005.Baccarat 6.webp?v=1764404841203",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-005",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 7",
    img: "/assets/Casino/PP-LIVE-006.Baccarat 7.webp?v=1764404769590",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-006",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 8",
    img: "/assets/Casino/PP-LIVE-007.Baccarat 8.webp?v=1764404708051",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-007",
    platFormCode: "PP",
  },
  {
    name: "Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-120.webp?v=1765933237496",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-120",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat A01",
    img: "/assets/Casino/DREAMGAMING-LIVE-021.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-021",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat A02",
    img: "/assets/Casino/DREAMGAMING-LIVE-022.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-022",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat A03",
    img: "/assets/Casino/DREAMGAMING-LIVE-023.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-023",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat A05",
    img: "/assets/Casino/DREAMGAMING-LIVE-024.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-024",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-122.webp?v=1765933237497",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-122",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat Classic-SEXY hall",
    img: "/assets/Casino/MX-LIVE-001_SEXY.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-001_SEXY_1.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_1",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table2",
    img: "/assets/Casino/MX-LIVE-001_SEXY_2.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_2",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table3",
    img: "/assets/Casino/MX-LIVE-001_SEXY_3.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_3",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table4",
    img: "/assets/Casino/MX-LIVE-001_SEXY_4.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_4",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table5",
    img: "/assets/Casino/MX-LIVE-001_SEXY_5.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_5",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table6",
    img: "/assets/Casino/MX-LIVE-001_SEXY_6.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001_SEXY_6",
    platFormCode: "MX",
  },
  {
    name: "Baccarat Control Squeeze",
    img: "/assets/Casino/EVOLUTION-LIVE-041.webp?v=1765933237428",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat D01",
    img: "/assets/Casino/DREAMGAMING-LIVE-001.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-001",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D02",
    img: "/assets/Casino/DREAMGAMING-LIVE-002.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-002",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D03",
    img: "/assets/Casino/DREAMGAMING-LIVE-003.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-003",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D05",
    img: "/assets/Casino/DREAMGAMING-LIVE-004.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-004",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D06",
    img: "/assets/Casino/DREAMGAMING-LIVE-005.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-005",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D07",
    img: "/assets/Casino/DREAMGAMING-LIVE-006.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-006",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D08",
    img: "/assets/Casino/DREAMGAMING-LIVE-007.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-007",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D09",
    img: "/assets/Casino/DREAMGAMING-LIVE-008.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-008",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat D10",
    img: "/assets/Casino/DREAMGAMING-LIVE-009.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-009",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat S01",
    img: "/assets/Casino/DREAMGAMING-LIVE-037.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-037",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat S02",
    img: "/assets/Casino/DREAMGAMING-LIVE-038.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-038",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat S03",
    img: "/assets/Casino/DREAMGAMING-LIVE-039.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-039",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat S05",
    img: "/assets/Casino/DREAMGAMING-LIVE-040.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-040",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat S06",
    img: "/assets/Casino/DREAMGAMING-LIVE-041.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-041",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat Squeeze",
    img: "/assets/Casino/EVOLUTION-LIVE-036.webp?v=1765933237423",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat V01",
    img: "/assets/Casino/DREAMGAMING-LIVE-081.baccarat.webp?v=1764344644783",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-081",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat V02",
    img: "/assets/Casino/DREAMGAMING-LIVE-082.baccarat.webp?v=1764344594028",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-082",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Balloon Race",
    img: "/assets/Casino/EVOLUTION-LIVE-363.webp?v=1765933237694",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-363",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bar Black Jack 3",
    img: "/assets/Casino/WINFINITY-LIVE-026.Bar Black Jack 3.webp?v=1764401884810",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-026",
    platFormCode: "WINFINITY",
  },
  {
    name: "Bar Black Jack 4",
    img: "/assets/Casino/WINFINITY-LIVE-027.Bar Black Jack 4.webp?v=1764401851110",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-027",
    platFormCode: "WINFINITY",
  },
  {
    name: "Bar Black Jack 5",
    img: "/assets/Casino/WINFINITY-LIVE-001.Bar Black Jack 5.webp?v=1764401812120",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-001",
    platFormCode: "WINFINITY",
  },
  {
    name: "Bar Instant Blackjack",
    img: "/assets/Casino/WINFINITY-LIVE-046.webp?v=1767778904515",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-046",
    platFormCode: "WINFINITY",
  },
  {
    name: "Bar Roulette 2000X",
    img: "/assets/Casino/WINFINITY-LIVE-004.bar-roulette-2000x.webp?v=1764401700323",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-004",
    platFormCode: "WINFINITY",
  },
  {
    name: "Bid Baccarat D11",
    img: "/assets/Casino/DREAMGAMING-LIVE-010.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-010",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Bid Baccarat D12",
    img: "/assets/Casino/DREAMGAMING-LIVE-011.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-011",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Big Bang Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-009.big-bang-roulette.webp?v=1764401646832",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-009",
    platFormCode: "WINFINITY",
  },
  {
    name: "BigBang INSTANT Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-045.webp?v=1765954402908",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-045",
    platFormCode: "WINFINITY",
  },
  {
    name: "BlackJack Atrium A",
    img: "/assets/Casino/CREEDROOMZ-LIVE-032.webp?v=1757466006239",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-032",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Atrium B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-033.webp?v=1757466006240",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-033",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Creed P",
    img: "/assets/Casino/CREEDROOMZ-LIVE-034.webp?v=1757466006240",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-034",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Persian D",
    img: "/assets/Casino/CREEDROOMZ-LIVE-037.webp?v=1757466006241",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-037",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Premium",
    img: "/assets/Casino/CREEDROOMZ-LIVE-038.webp?v=1757466006242",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-038",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Turkish B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-039.webp?v=1757466006243",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-039",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack Turkish C",
    img: "/assets/Casino/CREEDROOMZ-LIVE-040.webp?v=1757466006244",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-040",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack VIP A",
    img: "/assets/Casino/CREEDROOMZ-LIVE-041.webp?v=1757466006245",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-041",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "BlackJack VIP B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-042.webp?v=1757466006246",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "CREEDROOMZ-LIVE-042",
    platFormCode: "CREEDROOMZ",
  },
  {
    name: "Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-002.webp?v=1765933237394",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-002",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack A16",
    img: "/assets/Casino/DREAMGAMING-LIVE-076.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-076",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-082.webp?v=1765933237463",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-082",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-083.webp?v=1765933237464",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-083",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Diamond VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-118.webp?v=1765933237495",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-118",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Fortune VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-115.webp?v=1765933237492",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-115",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Grand VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-116.webp?v=1765933237493",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-116",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Party",
    img: "/assets/Casino/EVOLUTION-LIVE-042.webp?v=1765933237429",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-042",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Platinum VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-117.webp?v=1765933237494",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-117",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver A",
    img: "/assets/Casino/EVOLUTION-LIVE-075.webp?v=1765933237457",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-075",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver B",
    img: "/assets/Casino/EVOLUTION-LIVE-053.webp?v=1765933237438",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-053",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver C",
    img: "/assets/Casino/EVOLUTION-LIVE-056.webp?v=1765933237441",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-056",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver D",
    img: "/assets/Casino/EVOLUTION-LIVE-074.webp?v=1765933237456",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-074",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver E",
    img: "/assets/Casino/EVOLUTION-LIVE-051.webp?v=1765933237437",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-051",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver F",
    img: "/assets/Casino/EVOLUTION-LIVE-070.webp?v=1765933237452",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-070",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver G",
    img: "/assets/Casino/EVOLUTION-LIVE-068.webp?v=1765933237451",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-068",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 1",
    img: "/assets/Casino/EVOLUTION-LIVE-050.webp?v=1765933237435",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-050",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 10",
    img: "/assets/Casino/EVOLUTION-LIVE-073.webp?v=1765933237455",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-073",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 11",
    img: "/assets/Casino/EVOLUTION-LIVE-084.webp?v=1765933237464",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-084",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 12",
    img: "/assets/Casino/EVOLUTION-LIVE-054.webp?v=1765933237439",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-054",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 13",
    img: "/assets/Casino/EVOLUTION-LIVE-085.webp?v=1765933237465",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-085",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 14",
    img: "/assets/Casino/EVOLUTION-LIVE-072.webp?v=1765933237454",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-072",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 15",
    img: "/assets/Casino/EVOLUTION-LIVE-055.webp?v=1765933237440",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-055",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 16",
    img: "/assets/Casino/EVOLUTION-LIVE-066.webp?v=1765933237449",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-066",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 17",
    img: "/assets/Casino/EVOLUTION-LIVE-086.webp?v=1765933237466",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-086",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 19",
    img: "/assets/Casino/EVOLUTION-LIVE-088.webp?v=1765933237468",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-088",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 2",
    img: "/assets/Casino/EVOLUTION-LIVE-089.webp?v=1765933237469",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-089",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 22",
    img: "/assets/Casino/EVOLUTION-LIVE-091.webp?v=1765933237470",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-091",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 25",
    img: "/assets/Casino/EVOLUTION-LIVE-052.webp?v=1765933237438",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-052",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 26",
    img: "/assets/Casino/EVOLUTION-LIVE-092.webp?v=1765933237471",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-092",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 27",
    img: "/assets/Casino/EVOLUTION-LIVE-093.webp?v=1765933237472",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-093",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 28",
    img: "/assets/Casino/EVOLUTION-LIVE-234.webp?v=1765933237610",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-234",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 3",
    img: "/assets/Casino/EVOLUTION-LIVE-094.webp?v=1765933237473",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-094",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 30",
    img: "/assets/Casino/EVOLUTION-LIVE-243.webp?v=1765933237618",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-243",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 31",
    img: "/assets/Casino/EVOLUTION-LIVE-275.webp?v=1765933237648",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-275",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 32",
    img: "/assets/Casino/EVOLUTION-LIVE-276.webp?v=1765933237649",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-276",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 33",
    img: "/assets/Casino/EVOLUTION-LIVE-281.webp?v=1765933237653",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-281",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 34",
    img: "/assets/Casino/EVOLUTION-LIVE-282.webp?v=1765933237654",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-282",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 35",
    img: "/assets/Casino/EVOLUTION-LIVE-283.webp?v=1765933237655",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-283",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 36",
    img: "/assets/Casino/EVOLUTION-LIVE-332.webp?v=1765933237669",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-332",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 37",
    img: "/assets/Casino/EVOLUTION-LIVE-333.webp?v=1765933237670",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-333",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 38",
    img: "/assets/Casino/EVOLUTION-LIVE-286.webp?v=1765933237656",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-286",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 4",
    img: "/assets/Casino/EVOLUTION-LIVE-095.webp?v=1765933237473",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-095",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 41",
    img: "/assets/Casino/EVOLUTION-LIVE-287.webp?v=1765933237657",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-287",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 5",
    img: "/assets/Casino/EVOLUTION-LIVE-096.webp?v=1765933237475",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-096",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 6",
    img: "/assets/Casino/EVOLUTION-LIVE-097.webp?v=1765933237476",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-097",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 7",
    img: "/assets/Casino/EVOLUTION-LIVE-064.webp?v=1765933237447",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-064",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 8",
    img: "/assets/Casino/EVOLUTION-LIVE-098.webp?v=1765933237477",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-098",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 9",
    img: "/assets/Casino/EVOLUTION-LIVE-099.webp?v=1765933237478",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-099",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP A",
    img: "/assets/Casino/EVOLUTION-LIVE-100.webp?v=1765933237479",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-100",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP B",
    img: "/assets/Casino/EVOLUTION-LIVE-039.webp?v=1765933237426",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-039",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Beta",
    img: "/assets/Casino/EVOLUTION-LIVE-067.webp?v=1765933237450",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-067",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP C",
    img: "/assets/Casino/EVOLUTION-LIVE-101.webp?v=1765933237480",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-101",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP D",
    img: "/assets/Casino/EVOLUTION-LIVE-059.webp?v=1765933237443",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-059",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP E",
    img: "/assets/Casino/EVOLUTION-LIVE-069.webp?v=1765933237452",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-069",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP G",
    img: "/assets/Casino/EVOLUTION-LIVE-061.webp?v=1765933237445",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-061",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Gamma",
    img: "/assets/Casino/EVOLUTION-LIVE-060.webp?v=1765933237444",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-060",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP H",
    img: "/assets/Casino/EVOLUTION-LIVE-103.webp?v=1765933237482",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-103",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP I",
    img: "/assets/Casino/EVOLUTION-LIVE-065.webp?v=1765933237448",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-065",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP K",
    img: "/assets/Casino/EVOLUTION-LIVE-105.webp?v=1765933237483",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-105",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP M",
    img: "/assets/Casino/EVOLUTION-LIVE-071.webp?v=1765933237453",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-071",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP N",
    img: "/assets/Casino/EVOLUTION-LIVE-107.webp?v=1765933237485",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-107",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP O",
    img: "/assets/Casino/EVOLUTION-LIVE-108.webp?v=1765933237486",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-108",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP P",
    img: "/assets/Casino/EVOLUTION-LIVE-109.webp?v=1765933237487",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-109",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Q",
    img: "/assets/Casino/EVOLUTION-LIVE-110.webp?v=1765933237488",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-110",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP R",
    img: "/assets/Casino/EVOLUTION-LIVE-111.webp?v=1765933237489",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-111",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP T",
    img: "/assets/Casino/EVOLUTION-LIVE-113.webp?v=1765933237490",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-113",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP U",
    img: "/assets/Casino/EVOLUTION-LIVE-049.webp?v=1765933237435",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-049",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP X",
    img: "/assets/Casino/EVOLUTION-LIVE-057.webp?v=1765933237442",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-057",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Z",
    img: "/assets/Casino/EVOLUTION-LIVE-076.webp?v=1765933237458",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-076",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack X 1",
    img: "/assets/Casino/PP-LIVE-082.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-082",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 10",
    img: "/assets/Casino/PP-LIVE-091.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-091",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 14",
    img: "/assets/Casino/PP-LIVE-092.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-092",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 15",
    img: "/assets/Casino/PP-LIVE-093.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-093",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 16",
    img: "/assets/Casino/PP-LIVE-094.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-094",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 17",
    img: "/assets/Casino/PP-LIVE-095.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-095",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 18",
    img: "/assets/Casino/PP-LIVE-096.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-096",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 19",
    img: "/assets/Casino/PP-LIVE-097.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-097",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 2",
    img: "/assets/Casino/PP-LIVE-083.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-083",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 20",
    img: "/assets/Casino/PP-LIVE-098.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-098",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 3",
    img: "/assets/Casino/PP-LIVE-084.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-084",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 4",
    img: "/assets/Casino/PP-LIVE-085.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-085",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 5",
    img: "/assets/Casino/PP-LIVE-086.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-086",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 6",
    img: "/assets/Casino/PP-LIVE-087.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-087",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 7",
    img: "/assets/Casino/PP-LIVE-088.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-088",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 8",
    img: "/assets/Casino/PP-LIVE-089.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-089",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 9",
    img: "/assets/Casino/PP-LIVE-090.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-090",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 11",
    img: "/assets/Casino/PP-LIVE-112.BlackjackX 11.webp?v=1764404185843",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 12",
    img: "/assets/Casino/PP-LIVE-111.BlackjackX 12.webp?v=1764403999031",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-111",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 13",
    img: "/assets/Casino/PP-LIVE-110.BlackjackX 13.webp?v=1764403934245",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-110",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 21",
    img: "/assets/Casino/PP-LIVE-120.BlackjackX 21.webp?v=1764403866947",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-120",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 22",
    img: "/assets/Casino/PP-LIVE-109.BlackjackX 22.webp?v=1764403765848",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-109",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 23",
    img: "/assets/Casino/PP-LIVE-108.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-108",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 24",
    img: "/assets/Casino/PP-LIVE-121.BlackjackX 24.webp?v=1764402812353",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-121",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 25",
    img: "/assets/Casino/PP-LIVE-122.BlackjackX 25.webp?v=1764403641440",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-122",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 26",
    img: "/assets/Casino/PP-LIVE-107.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-107",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 27",
    img: "/assets/Casino/PP-LIVE-106.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-106",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 28",
    img: "/assets/Casino/PP-LIVE-105.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-105",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 29",
    img: "/assets/Casino/PP-LIVE-104.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-104",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 30",
    img: "/assets/Casino/PP-LIVE-103.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-103",
    platFormCode: "PP",
  },
  {
    name: "Blockchain AndarBahar QC13",
    img: "/assets/Casino/DREAMGAMING-LIVE-066.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-066",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain AndarBahar QD13",
    img: "/assets/Casino/DREAMGAMING-LIVE-053.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-053",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC01",
    img: "/assets/Casino/DREAMGAMING-LIVE-055.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-055",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC02",
    img: "/assets/Casino/DREAMGAMING-LIVE-056.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-056",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC03",
    img: "/assets/Casino/DREAMGAMING-LIVE-057.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-057",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC05",
    img: "/assets/Casino/DREAMGAMING-LIVE-058.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-058",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC06",
    img: "/assets/Casino/DREAMGAMING-LIVE-059.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-059",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QC07",
    img: "/assets/Casino/DREAMGAMING-LIVE-060.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-060",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD01",
    img: "/assets/Casino/DREAMGAMING-LIVE-042.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-042",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD02",
    img: "/assets/Casino/DREAMGAMING-LIVE-043.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-043",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD03",
    img: "/assets/Casino/DREAMGAMING-LIVE-044.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-044",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD05",
    img: "/assets/Casino/DREAMGAMING-LIVE-045.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-045",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD06",
    img: "/assets/Casino/DREAMGAMING-LIVE-046.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-046",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Baccarat QD07",
    img: "/assets/Casino/DREAMGAMING-LIVE-047.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-047",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QC17",
    img: "/assets/Casino/DREAMGAMING-LIVE-074.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-074",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QC18",
    img: "/assets/Casino/DREAMGAMING-LIVE-075.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-075",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QC19",
    img: "/assets/Casino/DREAMGAMING-LIVE-079.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-079",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QC20",
    img: "/assets/Casino/DREAMGAMING-LIVE-080.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-080",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QD17",
    img: "/assets/Casino/DREAMGAMING-LIVE-072.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-072",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QD18",
    img: "/assets/Casino/DREAMGAMING-LIVE-073.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-073",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QD19",
    img: "/assets/Casino/DREAMGAMING-LIVE-077.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-077",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Blackjack QD20",
    img: "/assets/Casino/DREAMGAMING-LIVE-078.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-078",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Bull bull QC11",
    img: "/assets/Casino/DREAMGAMING-LIVE-064.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-064",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Bull bull QD11",
    img: "/assets/Casino/DREAMGAMING-LIVE-051.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-051",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain DragonTiger QC08",
    img: "/assets/Casino/DREAMGAMING-LIVE-061.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-061",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain DragonTiger QC09",
    img: "/assets/Casino/DREAMGAMING-LIVE-062.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-062",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain DragonTiger QD08",
    img: "/assets/Casino/DREAMGAMING-LIVE-048.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-048",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain DragonTiger QD09",
    img: "/assets/Casino/DREAMGAMING-LIVE-049.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-049",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Roulette QC15",
    img: "/assets/Casino/DREAMGAMING-LIVE-071.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-071",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Roulette QD15",
    img: "/assets/Casino/DREAMGAMING-LIVE-070.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-070",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Sedie QD21",
    img: "/assets/Casino/DREAMGAMING-LIVE-086.Blockchain Sedie.webp?v=1764852601845",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-086",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Sicbo QC16",
    img: "/assets/Casino/DREAMGAMING-LIVE-068.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-068",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Sicbo QD16",
    img: "/assets/Casino/DREAMGAMING-LIVE-067.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-067",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Three Cards QC10",
    img: "/assets/Casino/DREAMGAMING-LIVE-063.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-063",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain Three Cards QD10",
    img: "/assets/Casino/DREAMGAMING-LIVE-050.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-050",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain ThreeFace QC12",
    img: "/assets/Casino/DREAMGAMING-LIVE-065.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-065",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Blockchain ThreeFace QD12",
    img: "/assets/Casino/DREAMGAMING-LIVE-052.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-052",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Bonsai Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-231.webp?v=1765933237606",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-231",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-232.webp?v=1765933237607",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-232",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-233.webp?v=1765933237609",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-233",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bull D18",
    img: "/assets/Casino/DREAMGAMING-LIVE-018.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-018",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Cabaret Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-019.cabaret-roulette.webp?v=1764401610165",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-019",
    platFormCode: "WINFINITY",
  },
  {
    name: "Caribbean Stud Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-024.webp?v=1765933237414",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-024",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Casino Malta Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-350.webp?v=1771552333425",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-350",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Craps",
    img: "/assets/Casino/EVOLUTION-LIVE-003.webp?v=1765933237395",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Coin Flip",
    img: "/assets/Casino/EVOLUTION-LIVE-014.webp?v=1765933237406",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-014",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Pachinko",
    img: "/assets/Casino/EVOLUTION-LIVE-261.webp?v=1765933237634",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-261",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Time",
    img: "/assets/Casino/EVOLUTION-LIVE-006.webp?v=1765933237399",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Time A",
    img: "/assets/Casino/EVOLUTION-LIVE-114.webp?v=1765933237491",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-114",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dead or Alive: Saloon",
    img: "/assets/Casino/EVOLUTION-LIVE-176.webp?v=1765933237547",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Deutsches Roulette",
    img: "/assets/Casino/PT-LIVE-022.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-022",
    platFormCode: "PT",
  },
  {
    name: "Double Ball Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-043.webp?v=1765933237430",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-043",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dragon Tiger-SEXY hall",
    img: "/assets/Casino/MX-LIVE-006_SEXY.webp?v=1761310589605",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Dragon Tiger-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-006_SEXY_31.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006_SEXY_31",
    platFormCode: "MX",
  },
  {
    name: "Dragon Tiger-SEXY hall-Table2",
    img: "/assets/Casino/MX-LIVE-006_SEXY_32.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-006_SEXY_32",
    platFormCode: "MX",
  },
  {
    name: "DragonTiger A09",
    img: "/assets/Casino/DREAMGAMING-LIVE-026.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-026",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "DragonTiger D16",
    img: "/assets/Casino/DREAMGAMING-LIVE-014.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-014",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "DragonTiger D17",
    img: "/assets/Casino/DREAMGAMING-LIVE-015.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-015",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Dream Catcher",
    img: "/assets/Casino/EVOLUTION-LIVE-035.webp?v=1765933237422",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-450.webp?v=1765933237748",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-450",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 1",
    img: "/assets/Casino/EVOLUTION-LIVE-441.webp?v=1765933237741",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-441",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 2",
    img: "/assets/Casino/EVOLUTION-LIVE-442.webp?v=1765933237742",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-442",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 3",
    img: "/assets/Casino/EVOLUTION-LIVE-443.webp?v=1765933237743",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-443",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 4",
    img: "/assets/Casino/EVOLUTION-LIVE-444.webp?v=1765933237744",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-444",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 5",
    img: "/assets/Casino/EVOLUTION-LIVE-445.webp?v=1765933237744",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-445",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 6",
    img: "/assets/Casino/EVOLUTION-LIVE-446.webp?v=1765933237745",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-446",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 7",
    img: "/assets/Casino/EVOLUTION-LIVE-447.webp?v=1765933237746",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-447",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 8",
    img: "/assets/Casino/EVOLUTION-LIVE-448.webp?v=1765933237747",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-448",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Bac Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-230.webp?v=1765933237605",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-230",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-077.webp?v=1765933237459",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-077",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-414.webp?v=1765933237722",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-414",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-080.webp?v=1765933237461",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-080",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-047.webp?v=1765933237434",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-047",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo A",
    img: "/assets/Casino/EVOLUTION-LIVE-211.webp?v=1765933237588",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-150.webp?v=1765933237523",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-150",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-147.webp?v=1765933237520",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-147",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-153.webp?v=1765933237526",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-153",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-210.webp?v=1765933237587",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-210",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 1",
    img: "/assets/Casino/EVOLUTION-LIVE-263.webp?v=1765933237636",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-263",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 10",
    img: "/assets/Casino/EVOLUTION-LIVE-279.webp?v=1765933237652",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-279",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 11",
    img: "/assets/Casino/EVOLUTION-LIVE-280.webp?v=1765933237653",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-280",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 2",
    img: "/assets/Casino/EVOLUTION-LIVE-264.webp?v=1765933237637",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-264",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 3",
    img: "/assets/Casino/EVOLUTION-LIVE-265.webp?v=1765933237638",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-265",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 4",
    img: "/assets/Casino/EVOLUTION-LIVE-266.webp?v=1765933237639",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-266",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 5",
    img: "/assets/Casino/EVOLUTION-LIVE-267.webp?v=1765933237640",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-267",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 6",
    img: "/assets/Casino/EVOLUTION-LIVE-268.webp?v=1765933237641",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-268",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 7",
    img: "/assets/Casino/EVOLUTION-LIVE-269.webp?v=1765933237643",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-269",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extra Chili Epic Spins",
    img: "/assets/Casino/EVOLUTION-LIVE-168.webp?v=1765933237541",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extreme Texas Hold'em",
    img: "/assets/Casino/EVOLUTION-LIVE-032.webp?v=1765933237419",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-032",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fan Tan",
    img: "/assets/Casino/EVOLUTION-LIVE-178.webp?v=1765933237549",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fireball Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-436.webp?v=1765933237740",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-436",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person American Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-206.webp?v=1765933237582",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-029.webp?v=1765933237417",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-029",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Craps",
    img: "/assets/Casino/EVOLUTION-LIVE-031.webp?v=1765933237419",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-033.webp?v=1765933237420",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Dream Catcher",
    img: "/assets/Casino/EVOLUTION-LIVE-023.webp?v=1765933237412",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-046.webp?v=1765933237433",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person HiLo",
    img: "/assets/Casino/EVOLUTION-LIVE-364.webp?v=1768216195140",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-364",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-207.webp?v=1765933237583",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-207",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-208.webp?v=1765933237585",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-209.webp?v=1765933237586",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-209",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Mega Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-034.webp?v=1765933237421",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Prosperity Tree Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-244.webp?v=1765933237619",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-244",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-013.webp?v=1765933237405",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-013",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Super Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-259.webp?v=1765933237632",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Top Card",
    img: "/assets/Casino/EVOLUTION-LIVE-030.webp?v=1770892780819",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-030",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person XXXtreme Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-226.webp?v=1765933237601",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-226",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First person Video Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-258.webp?v=1765933237631",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-258",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First person XXXtreme lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-256.webp?v=1765933237629",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football Studio",
    img: "/assets/Casino/EVOLUTION-LIVE-045.webp?v=1765933237432",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-045",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football Studio Dice",
    img: "/assets/Casino/EVOLUTION-LIVE-044.webp?v=1765933237430",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-044",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football Studio Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-214.webp?v=1765933237590",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-214",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fortune 6 Baccarat",
    img: "/assets/Casino/PP-LIVE-047.Fortune 6 Baccarat.webp?v=1764410366343",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-047",
    platFormCode: "PP",
  },
  {
    name: "Free Bet VIP Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-314.webp?v=1765933237664",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-314",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Funky Time",
    img: "/assets/Casino/EVOLUTION-LIVE-183.webp?v=1765933237553",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    platFormCode: "EVOLUTION",
  },
  {
    name: "German Roulette",
    img: "/assets/Casino/PP-LIVE-031.German Roulette.webp?v=1764410254534",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-031",
    platFormCode: "PP",
  },
  {
    name: "Gold Vault Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-228.webp?v=1765933237603",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-228",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-179.webp?v=1765933237550",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    platFormCode: "EVOLUTION",
  },
  {
    name: "HOT 7up 7down",
    img: "/assets/Casino/HOTROAD-LIVE-008.HOT 7UP 7DOWN.webp?v=1764336800993",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT 8 Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-012.HOT 8 BACCARAT.webp?v=1764336849992",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-012",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-007.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT COLOR GAME",
    img: "/assets/Casino/HOTROAD-LIVE-005.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-005",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT ROULETTE",
    img: "/assets/Casino/HOTROAD-LIVE-004.webp?v=1761390862733",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT SICBO",
    img: "/assets/Casino/HOTROAD-LIVE-006.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT Thai HI-LO",
    img: "/assets/Casino/HOTROAD-LIVE-009.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-009",
    platFormCode: "HOTROAD",
  },
  {
    name: "Hanguk Auto Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-030.Hanguk Auto Roulette.webp?v=1764401247448",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-030",
    platFormCode: "WINFINITY",
  },
  {
    name: "Hindi Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-429.webp?v=1765933237733",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-429",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-229.webp?v=1765933237604",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-229",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-277.webp?v=1765933237650",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-277",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Immersive Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-180.webp?v=1765933237551",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Imperial Quest",
    img: "/assets/Casino/EVOLUTION-LIVE-169.webp?v=1765933237542",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
    platFormCode: "EVOLUTION",
  },
  {
    name: "InBaccarat A08",
    img: "/assets/Casino/DREAMGAMING-LIVE-025.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-025",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "InBaccarat D13",
    img: "/assets/Casino/DREAMGAMING-LIVE-012.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-012",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "InBaccarat D15",
    img: "/assets/Casino/DREAMGAMING-LIVE-013.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-013",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Indonesia Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-072.Indonesian Speed Baccarat 1.webp?v=1764410189179",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-072",
    platFormCode: "PP",
  },
  {
    name: "Infinite Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-012.webp?v=1765933237404",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Infinite Free Bet Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-037.webp?v=1765933237424",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-037",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Infinite Fun Fun 21 Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-397.webp?v=1765933237715",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-397",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Instant Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-008.webp?v=1765933237401",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Japanese Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-119.Japanese Speed Baccarat 2.webp?v=1764409165583",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-119",
    platFormCode: "PP",
  },
  {
    name: "Japanses Speed baccarat 3",
    img: "/assets/Casino/PP-LIVE-099.Japanese Speed Baccarat 3.webp?v=1764409089433",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-099",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat",
    img: "/assets/Casino/PT-LIVE-095.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-095",
    platFormCode: "PT",
  },
  {
    name: "Korean Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-056.Korean Speed Baccarat 1.webp?v=1764408833701",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-056",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-057.Korean Speed Baccarat 2.webp?v=1764408785169",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-057",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 6",
    img: "/assets/Casino/PP-LIVE-113.Korean Speed Baccarat 6.webp?v=1764408585580",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-113",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat NC",
    img: "/assets/Casino/PT-LIVE-096.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-096",
    platFormCode: "PT",
  },
  {
    name: "Le Rouge Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-049.webp?v=1769055957590",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-049",
    platFormCode: "WINFINITY",
  },
  {
    name: "Lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-133.webp?v=1765933237507",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-376.webp?v=1765933237705",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-376",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-181.webp?v=1765933237552",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-181",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Dice",
    img: "/assets/Casino/EVOLUTION-LIVE-011.webp?v=1765933237404",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-011",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-344.webp?v=1765933237677",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-344",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-040.webp?v=1765933237427",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-362.webp?v=1765933237693",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-362",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Storm",
    img: "/assets/Casino/EVOLUTION-LIVE-369.webp?v=1765933237699",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotto Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-020.lotto-baccarat.webp?v=1765268206684",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-020",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotto Super Six",
    img: "/assets/Casino/VIACASINO-LIVE-021.lotto-super-six.webp?v=1765267870703",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-021",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotus Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-417.webp?v=1765933237725",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-417",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotus Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-411.webp?v=1765933237720",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-411",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lucky 6 Roulette",
    img: "/assets/Casino/PP-LIVE-077.Lucky 6 Roulette.webp?v=1764408516141",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-077",
    platFormCode: "PP",
  },
  {
    name: "Lucky 7 Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-013.LUCKY 7 BACCARAT.webp?v=1764336954926",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-013",
    platFormCode: "HOTROAD",
  },
  {
    name: "MONOPOLY Big Baller",
    img: "/assets/Casino/EVOLUTION-LIVE-018.webp?v=1765933237410",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-018",
    platFormCode: "EVOLUTION",
  },
  {
    name: "MONOPOLY Live",
    img: "/assets/Casino/EVOLUTION-LIVE-007.webp?v=1765933237400",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Mega Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-010.webp?v=1765933237403",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Mega Roulette",
    img: "/assets/Casino/PP-LIVE-039.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    platFormCode: "PP",
  },
  {
    name: "Mega Sic Bo",
    img: "/assets/Casino/PP-LIVE-025.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    platFormCode: "PP",
  },
  {
    name: "Mega Wheel",
    img: "/assets/Casino/PP-LIVE-038.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    platFormCode: "PP",
  },
  {
    name: "Monaco Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-036.Monaco Blackjack 1.webp?v=1764401203886",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-036",
    platFormCode: "WINFINITY",
  },
  {
    name: "Monaco Blackjack 2",
    img: "/assets/Casino/WINFINITY-LIVE-037.Monaco Blackjack 2.webp?v=1764401150711",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-037",
    platFormCode: "WINFINITY",
  },
  {
    name: "Monaco Instant Blackjack",
    img: "/assets/Casino/WINFINITY-LIVE-048.webp?v=1768445245535",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-048",
    platFormCode: "WINFINITY",
  },
  {
    name: "Monaco VIP Blackjack 6",
    img: "/assets/Casino/WINFINITY-LIVE-041.Monaco VIP Blackjack 6.webp?v=1764400896395",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-041",
    platFormCode: "WINFINITY",
  },
  {
    name: "No Commission Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-038.webp?v=1765933237425",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Peek Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-182.webp?v=1765933237552",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 1",
    img: "/assets/Casino/EVOLUTION-LIVE-377.webp?v=1765933237706",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-377",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 2",
    img: "/assets/Casino/EVOLUTION-LIVE-378.webp?v=1765933237707",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-378",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 3",
    img: "/assets/Casino/EVOLUTION-LIVE-379.webp?v=1765933237708",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-379",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 4",
    img: "/assets/Casino/EVOLUTION-LIVE-380.webp?v=1765933237708",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-380",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 5",
    img: "/assets/Casino/EVOLUTION-LIVE-381.webp?v=1765933237710",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-381",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 6",
    img: "/assets/Casino/EVOLUTION-LIVE-382.webp?v=1765933237711",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-382",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Pok Deng",
    img: "/assets/Casino/MX-LIVE-018.Pok Deng.webp?v=1764335053969",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-018",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Power Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-016.webp?v=1765933237408",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-016",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Privé Lounge Baccarat with Squeeze 1",
    img: "/assets/Casino/PP-LIVE-192.webp?v=1766711113592",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-192",
    platFormCode: "PP",
  },
  {
    name: "Prosperity Tree Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-245.webp?v=1765933237620",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Race Track A",
    img: "/assets/Casino/EVOLUTION-LIVE-427.webp?v=1765933237731",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-427",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Red Door Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-257.webp?v=1765933237630",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-257",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Rocket HiLo Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-016.rocket-hilo-baccarat.webp?v=1765267618051",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-016",
    platFormCode: "VIACASINO",
  },
  {
    name: "Romanian Roulette",
    img: "/assets/Casino/PP-LIVE-048.Romanian Roulett.webp?v=1764408006250",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-048",
    platFormCode: "PP",
  },
  {
    name: "Roulette 1",
    img: "/assets/Casino/PP-LIVE-028.Roulette 1.webp?v=1764407962916",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-028",
    platFormCode: "PP",
  },
  {
    name: "Roulette 2 Extra Time",
    img: "/assets/Casino/PP-LIVE-029.Roulette 2 Extra Time.webp?v=1764407909678",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-029",
    platFormCode: "PP",
  },
  {
    name: "Roulette A11",
    img: "/assets/Casino/DREAMGAMING-LIVE-027.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-027",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Roulette D21",
    img: "/assets/Casino/DREAMGAMING-LIVE-016.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-016",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Roulette Italia Tricolore",
    img: "/assets/Casino/PP-LIVE-032.Roulette Italia Tricolore.webp?v=1764407826039",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-032",
    platFormCode: "PP",
  },
  {
    name: "Roulette Latina",
    img: "/assets/Casino/PP-LIVE-053.Roulette Latina.webp?v=1764407778108",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-053",
    platFormCode: "PP",
  },
  {
    name: "Roulette Macao",
    img: "/assets/Casino/PP-LIVE-034.Roulette Macao.webp?v=1764407636914",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-034",
    platFormCode: "PP",
  },
  {
    name: "Roulette Ruby",
    img: "/assets/Casino/PP-LIVE-037.Roulette Ruby.webp?v=1764838203349",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-037",
    platFormCode: "PP",
  },
  {
    name: "Roulette-SEXY hall",
    img: "/assets/Casino/MX-LIVE-009_SEXY.webp?v=1761310711498",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Roulette-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-009_SEXY_71.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009_SEXY_71",
    platFormCode: "MX",
  },
  {
    name: "Russian Roulette",
    img: "/assets/Casino/PP-LIVE-030.Russian Roulette.webp?v=1764407491013",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-030",
    platFormCode: "PP",
  },
  {
    name: "Salon Privé Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-125.webp?v=1765933237500",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-125",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-124.webp?v=1765933237499",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-124",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-126.webp?v=1765933237501",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-126",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-127.webp?v=1765933237502",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-127",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat E",
    img: "/assets/Casino/EVOLUTION-LIVE-128.webp?v=1765933237503",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-128",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat F",
    img: "/assets/Casino/EVOLUTION-LIVE-129.webp?v=1765933237503",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-129",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat G",
    img: "/assets/Casino/EVOLUTION-LIVE-121.webp?v=1765933237496",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-121",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat H",
    img: "/assets/Casino/EVOLUTION-LIVE-130.webp?v=1765933237504",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-130",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat I",
    img: "/assets/Casino/EVOLUTION-LIVE-131.webp?v=1765933237505",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-131",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat J",
    img: "/assets/Casino/EVOLUTION-LIVE-132.webp?v=1765933237506",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-132",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat K",
    img: "/assets/Casino/EVOLUTION-LIVE-236.webp?v=1765933237611",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-236",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat L",
    img: "/assets/Casino/EVOLUTION-LIVE-237.webp?v=1765933237612",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-237",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat M",
    img: "/assets/Casino/EVOLUTION-LIVE-271.webp?v=1765933237645",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-271",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat N",
    img: "/assets/Casino/EVOLUTION-LIVE-272.webp?v=1765933237646",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-272",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-215.webp?v=1765933237591",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-215",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-216.webp?v=1765933237592",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-216",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-217.webp?v=1765933237593",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-217",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack D",
    img: "/assets/Casino/EVOLUTION-LIVE-218.webp?v=1765933237594",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-218",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack E",
    img: "/assets/Casino/EVOLUTION-LIVE-219.webp?v=1765933237595",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-219",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack F",
    img: "/assets/Casino/EVOLUTION-LIVE-220.webp?v=1765933237595",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-220",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack G",
    img: "/assets/Casino/EVOLUTION-LIVE-221.webp?v=1765933237596",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-221",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack H",
    img: "/assets/Casino/EVOLUTION-LIVE-222.webp?v=1765933237597",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-222",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack I",
    img: "/assets/Casino/EVOLUTION-LIVE-223.webp?v=1765933237598",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-223",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack J",
    img: "/assets/Casino/EVOLUTION-LIVE-224.webp?v=1765933237599",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-224",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack K",
    img: "/assets/Casino/EVOLUTION-LIVE-365.webp?v=1765933237696",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-365",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack L",
    img: "/assets/Casino/EVOLUTION-LIVE-366.webp?v=1765933237697",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-366",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack M",
    img: "/assets/Casino/EVOLUTION-LIVE-367.webp?v=1765933237698",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-367",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack N",
    img: "/assets/Casino/EVOLUTION-LIVE-368.webp?v=1765933237698",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-368",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack O",
    img: "/assets/Casino/EVOLUTION-LIVE-386.webp?v=1765933237713",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-386",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-081.webp?v=1765933237462",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Sedie A13",
    img: "/assets/Casino/DREAMGAMING-LIVE-028.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-028",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Sedie V03",
    img: "/assets/Casino/DREAMGAMING-LIVE-083.sedie.webp?v=1764343335462",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-083",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Sedie V04",
    img: "/assets/Casino/DREAMGAMING-LIVE-084.sedie.webp?v=1764343107562",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-084",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Sexy Baccarat",
    img: "/assets/Casino/MX-LIVE-002.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-002",
    platFormCode: "MX",
  },
  {
    name: "Shangrila Baccarat 5",
    img: "/assets/Casino/WINFINITY-LIVE-016.Shangrila Baccarat 5.webp?v=1764400855116",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-016",
    platFormCode: "WINFINITY",
  },
  {
    name: "Shangrila Baccarat 6",
    img: "/assets/Casino/WINFINITY-LIVE-017.Shangrila Baccarat 6.webp?v=1762330568837",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-017",
    platFormCode: "WINFINITY",
  },
  {
    name: "Shangrila Baccarat 7",
    img: "/assets/Casino/WINFINITY-LIVE-028.Shangrila-Baccarat-7.webp?v=1764400796973",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-028",
    platFormCode: "WINFINITY",
  },
  {
    name: "Shangrila Baccarat 8",
    img: "/assets/Casino/WINFINITY-LIVE-029.Shangrila-Baccarat-8.webp?v=1764400763754",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-029",
    platFormCode: "WINFINITY",
  },
  {
    name: "Sic Bo-SEXY hall",
    img: "/assets/Casino/MX-LIVE-016_SEXY.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Sic Bo-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-016_SEXY_51.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016_SEXY_51",
    platFormCode: "MX",
  },
  {
    name: "Sicbo A12",
    img: "/assets/Casino/DREAMGAMING-LIVE-069.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-069",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Sicbo D22",
    img: "/assets/Casino/DREAMGAMING-LIVE-017.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-017",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Baccarat C01",
    img: "/assets/Casino/DREAMGAMING-LIVE-030.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-030",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Baccarat C02",
    img: "/assets/Casino/DREAMGAMING-LIVE-031.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-031",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Baccarat C03",
    img: "/assets/Casino/DREAMGAMING-LIVE-032.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-032",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Baccarat C05",
    img: "/assets/Casino/DREAMGAMING-LIVE-033.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-033",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Baccarat C06",
    img: "/assets/Casino/DREAMGAMING-LIVE-054.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-054",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site DragonTiger C07",
    img: "/assets/Casino/DREAMGAMING-LIVE-034.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-034",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Site Roulette C08",
    img: "/assets/Casino/DREAMGAMING-LIVE-035.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-035",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Speed Auto-Roulette 1",
    img: "/assets/Casino/PP-LIVE-060.Speed Auto-Roulette 1.webp?v=1764407358457",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-060",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 10",
    img: "/assets/Casino/PP-LIVE-021.Speed Baccarat 10.webp?v=1764407284309",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-021",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 11",
    img: "/assets/Casino/PP-LIVE-022.Speed Baccarat 11.webp?v=1764407188602",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-022",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 12",
    img: "/assets/Casino/PP-LIVE-023.Speed Baccarat 12.webp?v=1764407088573",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-023",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 13",
    img: "/assets/Casino/PP-LIVE-024.Speed Baccarat 13.webp?v=1764407013590",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-024",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 14",
    img: "/assets/Casino/PP-LIVE-003.Speed Baccarat 14.webp?v=1764406902947",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-003",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 15",
    img: "/assets/Casino/PP-LIVE-008.Speed Baccarat 15.webp?v=1764406831103",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-008",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 3",
    img: "/assets/Casino/PP-LIVE-015.Speed Baccarat 3.webp?v=1764406523845",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-015",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-145.webp?v=1765933237518",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-145",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-139.webp?v=1765933237512",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-139",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-146.webp?v=1765933237519",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-146",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-158.webp?v=1765933237531",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-158",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat E",
    img: "/assets/Casino/EVOLUTION-LIVE-148.webp?v=1765933237521",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-148",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat F",
    img: "/assets/Casino/EVOLUTION-LIVE-137.webp?v=1765933237510",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-137",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat G",
    img: "/assets/Casino/EVOLUTION-LIVE-154.webp?v=1765933237527",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-154",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat H",
    img: "/assets/Casino/EVOLUTION-LIVE-140.webp?v=1765933237513",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-140",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat I",
    img: "/assets/Casino/EVOLUTION-LIVE-138.webp?v=1765933237511",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-138",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat J",
    img: "/assets/Casino/EVOLUTION-LIVE-157.webp?v=1765933237529",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-157",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat L",
    img: "/assets/Casino/EVOLUTION-LIVE-155.webp?v=1765933237527",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-155",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat N",
    img: "/assets/Casino/EVOLUTION-LIVE-156.webp?v=1765933237528",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-156",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Q",
    img: "/assets/Casino/EVOLUTION-LIVE-141.webp?v=1765933237514",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-141",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat R",
    img: "/assets/Casino/EVOLUTION-LIVE-162.webp?v=1765933237535",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-162",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat S",
    img: "/assets/Casino/EVOLUTION-LIVE-163.webp?v=1765933237535",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-163",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat T",
    img: "/assets/Casino/EVOLUTION-LIVE-164.webp?v=1765933237536",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-164",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat U",
    img: "/assets/Casino/EVOLUTION-LIVE-165.webp?v=1765933237537",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-165",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat V",
    img: "/assets/Casino/EVOLUTION-LIVE-166.webp?v=1765933237539",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-166",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat W",
    img: "/assets/Casino/EVOLUTION-LIVE-152.webp?v=1765933237525",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-152",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat X",
    img: "/assets/Casino/EVOLUTION-LIVE-143.webp?v=1765933237516",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-143",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Z",
    img: "/assets/Casino/EVOLUTION-LIVE-167.webp?v=1765933237540",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-167",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-078.webp?v=1765933237460",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Roulette 1",
    img: "/assets/Casino/PP-LIVE-027.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-027",
    platFormCode: "PP",
  },
  {
    name: "Speed Roulette Latina",
    img: "/assets/Casino/PP-LIVE-191.webp?v=1766711113586",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-191",
    platFormCode: "PP",
  },
  {
    name: "Speed VIP Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-191.webp?v=1765933237561",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-191",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-192.webp?v=1765933237562",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-192",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-193.webp?v=1765933237563",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-193",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack D",
    img: "/assets/Casino/EVOLUTION-LIVE-194.webp?v=1765933237564",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-194",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack E",
    img: "/assets/Casino/EVOLUTION-LIVE-195.webp?v=1765933237565",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-195",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack F",
    img: "/assets/Casino/EVOLUTION-LIVE-196.webp?v=1765933237569",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-196",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack G",
    img: "/assets/Casino/EVOLUTION-LIVE-197.webp?v=1765933237570",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-197",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack H",
    img: "/assets/Casino/EVOLUTION-LIVE-198.webp?v=1765933237570",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-198",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack I",
    img: "/assets/Casino/EVOLUTION-LIVE-199.webp?v=1765933237571",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-199",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack J",
    img: "/assets/Casino/EVOLUTION-LIVE-200.webp?v=1765933237572",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-200",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack K",
    img: "/assets/Casino/EVOLUTION-LIVE-201.webp?v=1765933237578",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-201",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack L",
    img: "/assets/Casino/EVOLUTION-LIVE-202.webp?v=1765933237579",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-202",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack M",
    img: "/assets/Casino/EVOLUTION-LIVE-203.webp?v=1765933237580",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-203",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack N",
    img: "/assets/Casino/EVOLUTION-LIVE-238.webp?v=1765933237613",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-238",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack Q",
    img: "/assets/Casino/EVOLUTION-LIVE-241.webp?v=1765933237616",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-241",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack R",
    img: "/assets/Casino/EVOLUTION-LIVE-242.webp?v=1765933237617",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-242",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Stock Market A",
    img: "/assets/Casino/EVOLUTION-LIVE-292.webp?v=1770892628348",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-292",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super 8 Baccarat",
    img: "/assets/Casino/PP-LIVE-045.Super 8 Baccarat.webp?v=1764405987916",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-045",
    platFormCode: "PP",
  },
  {
    name: "Super Andar Bahar",
    img: "/assets/Casino/EVOLUTION-LIVE-204.webp?v=1765933237580",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-005.webp?v=1765933237398",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Speed Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-451.webp?v=1765933237749",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-451",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Trunfo (Football Blitz Top Card)",
    img: "/assets/Casino/PP-LIVE-123.Super-Trunfo.webp?v=1764405936060",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-123",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza Candyland",
    img: "/assets/Casino/PP-LIVE-044.Sweet-Bonanza-CandyLand.webp?v=1764405889106",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    platFormCode: "PP",
  },
  {
    name: "Symphony Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-043.Symphony Blackjack 1.webp?v=1764854507006",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-043",
    platFormCode: "WINFINITY",
  },
  {
    name: "TIGER BACCARAT",
    img: "/assets/Casino/HOTROAD-LIVE-011.TIGER BACCARAT.webp?v=1764337077277",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-011",
    platFormCode: "HOTROAD",
  },
  {
    name: "Tao Yuan Baccarat 1",
    img: "/assets/Casino/WINFINITY-LIVE-010.Tao Yuan Baccarat 1.webp?v=1764400580001",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-010",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 2",
    img: "/assets/Casino/WINFINITY-LIVE-011.Tao Yuan Baccarat 2.webp?v=1764400545420",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-011",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 3",
    img: "/assets/Casino/WINFINITY-LIVE-032.Tao Yuan Baccarat 3.webp?v=1764400488765",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-032",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 5",
    img: "/assets/Casino/WINFINITY-LIVE-012.Tao Yuan Baccarat 5.webp?v=1764400446904",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-012",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 6",
    img: "/assets/Casino/WINFINITY-LIVE-013.Tao Yuan Baccarat 6.webp?v=1764400405456",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-013",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 7",
    img: "/assets/Casino/WINFINITY-LIVE-014.Tao Yuan Baccarat 7.webp?v=1764400373034",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-014",
    platFormCode: "WINFINITY",
  },
  {
    name: "Tao Yuan Baccarat 8",
    img: "/assets/Casino/WINFINITY-LIVE-015.tao-yuan-bacarrat-8.webp?v=1764400320049",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-015",
    platFormCode: "WINFINITY",
  },
  {
    name: "Teen Patti",
    img: "/assets/Casino/EVOLUTION-LIVE-026.webp?v=1765933237415",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-026",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Texas Hold'em Bonus Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-027.webp?v=1765933237416",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-027",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Thai Fish Prawn Crab-SEXY hall",
    img: "/assets/Casino/MX-LIVE-015_SEXY.webp?v=1761310921467",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-015_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Thai Fish Prawn Crab-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-015_SEXY_126.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-015_SEXY_126",
    platFormCode: "MX",
  },
  {
    name: "Thai Hi Lo-SEXY hall",
    img: "/assets/Casino/MX-LIVE-014_SEXY.webp?v=1761310815167",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-014_SEXY",
    platFormCode: "MX",
  },
  {
    name: "Thai Hi Lo-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-014_SEXY_121.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-014_SEXY_121",
    platFormCode: "MX",
  },
  {
    name: "Thai Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-162.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-162",
    platFormCode: "PP",
  },
  {
    name: "The Bingo Spot",
    img: "/assets/Casino/PP-LIVE-076.webp?v=1766376295552",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-076",
    platFormCode: "PP",
  },
  {
    name: "Three Face D20",
    img: "/assets/Casino/DREAMGAMING-LIVE-020.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-020",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "ThreeCard D19",
    img: "/assets/Casino/DREAMGAMING-LIVE-019.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-019",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Top Card",
    img: "/assets/Casino/WINFINITY-LIVE-020.top-card.webp?v=1764400256350",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "WINFINITY-LIVE-020",
    platFormCode: "WINFINITY",
  },
  {
    name: "VIP Roulette",
    img: "/assets/Casino/PP-LIVE-036.VIP Roulette.webp?v=1764405553904",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-036",
    platFormCode: "PP",
  },
  {
    name: "XXXtreme Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-205.webp?v=1765933237581",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-205",
    platFormCode: "EVOLUTION",
  },
  {
    name: "XXXtreme lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-255.webp?v=1765933237628",
    platForm: "EVO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    platFormCode: "EVOLUTION",
  },
  // PT
  {
    name: "Roulette",
    img: "/assets/Casino/PT005.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-032",
  },
  {
    name: "3 Card Brag",
    img: "/assets/Casino/PT008.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-016",
  },
  {
    name: "Sette E Mezzo",
    img: "/assets/Casino/PT010.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-009",
  },
  {
    name: "Adventures Beyond Wonderland",
    img: "/assets/Casino/PT018.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-011",
  },
  {
    name: "Spin a Win",
    img: "/assets/Casino/PT057.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
  },
  {
    name: "All Bets Blackjack",
    img: "/assets/Casino/PT060.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-007",
  },
  {
    name: "American Roulette",
    img: "/assets/Casino/PT063.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-021",
  },
  {
    name: "Baccarat",
    img: "/assets/Casino/PT090.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-001",
  },
  {
    name: "Cash Collect Roulette Live",
    img: "/assets/Casino/PT162.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-131",
  },
  {
    name: "Casino HoldÂ´em",
    img: "/assets/Casino/PT177.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-017",
  },
  {
    name: "Mega Fire Blaze Roulette Live",
    img: "/assets/Casino/PT578.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
  },
  {
    name: "French Roulette",
    img: "/assets/Casino/PT646.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-025",
  },
  {
    name: "Quantum Roulette Live",
    img: "/assets/Casino/PT659.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-067",
  },
  {
    name: "Spread Bet Roulette",
    img: "/assets/Casino/PT737.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-027",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/PT866.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-002",
  },
  {
    name: "SicBo Deluxe",
    img: "/assets/Casino/PT867.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-003",
  },
  {
    name: "Andar Bahar Live",
    img: "/assets/Casino/PT868.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-004",
  },
  {
    name: "Bet on Baccarat Live",
    img: "/assets/Casino/PT869.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-005",
  },
  {
    name: "All Bets Blackjack",
    img: "/assets/Casino/PT870.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-007",
  },
  {
    name: "Unlimited Blackjack",
    img: "/assets/Casino/PT871.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-010",
  },
  {
    name: "Bet on Poker Live",
    img: "/assets/Casino/PT872.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-019",
  },
  {
    name: "Deutsches Speed Roulette",
    img: "/assets/Casino/PT873.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-022",
  },
  {
    name: "Football French Roulette",
    img: "/assets/Casino/PT874.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-023",
  },
  {
    name: "Football Roulette",
    img: "/assets/Casino/PT875.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-024",
  },
  {
    name: "Quantum Auto Roulette",
    img: "/assets/Casino/PT876.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-026",
  },
  {
    name: "Bet On Dragon Tiger Live",
    img: "/assets/Casino/PT877.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-030",
  },
  {
    name: "Italian Cashback Blackjack",
    img: "/assets/Casino/PT878.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-031",
  },
  {
    name: "Grand Baccarat",
    img: "/assets/Casino/PT879.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-034",
  },
  {
    name: "Speed 6 Scanner Baccarat",
    img: "/assets/Casino/PT880.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-035",
  },
  {
    name: "Grand Baccarat NC",
    img: "/assets/Casino/PT881.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-037",
  },
  {
    name: "Speed 6 Scanner Baccarat NC",
    img: "/assets/Casino/PT882.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-038",
  },
  {
    name: "Blackjack Italiano 1",
    img: "/assets/Casino/PT883.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-041",
  },
  {
    name: "Blackjack Italiano 2",
    img: "/assets/Casino/PT884.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-042",
  },
  {
    name: "Blackjack Italiano VIP",
    img: "/assets/Casino/PT885.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-043",
  },
  {
    name: "Deutsches Blackjack",
    img: "/assets/Casino/PT886.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-044",
  },
  {
    name: "Royale Blackjack 1",
    img: "/assets/Casino/PT887.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-045",
  },
  {
    name: "Royale Blackjack 3",
    img: "/assets/Casino/PT888.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-052",
  },
  {
    name: "Soho All Bets Blackjack",
    img: "/assets/Casino/PT889.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-054",
  },
  {
    name: "Greek Roulette",
    img: "/assets/Casino/PT890.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-055",
  },
  {
    name: "Hindi Roulette",
    img: "/assets/Casino/PT891.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-056",
  },
  {
    name: "Prestige Roulette",
    img: "/assets/Casino/PT892.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-057",
  },
  {
    name: "Speed Auto Roulette",
    img: "/assets/Casino/PT893.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-058",
  },
  {
    name: "Roleta Brasileira",
    img: "/assets/Casino/PT894.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-059",
  },
  {
    name: "Roulette Italiana",
    img: "/assets/Casino/PT895.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-060",
  },
  {
    name: "Auto Roulette",
    img: "/assets/Casino/PT896.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-061",
  },
  {
    name: "Bucharest Roulette",
    img: "/assets/Casino/PT897.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-063",
  },
  {
    name: "Turkish Roulette",
    img: "/assets/Casino/PT898.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-064",
  },
  {
    name: "Bucharest French Roulette",
    img: "/assets/Casino/PT899.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-066",
  },
  {
    name: "Blackjack 9",
    img: "/assets/Casino/PT900.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-068",
  },
  {
    name: "Blackjack 3",
    img: "/assets/Casino/PT901.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-069",
  },
  {
    name: "Blackjack 4",
    img: "/assets/Casino/PT902.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-070",
  },
  {
    name: "Blackjack 5",
    img: "/assets/Casino/PT903.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-071",
  },
  {
    name: "Blackjack 6",
    img: "/assets/Casino/PT904.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-072",
  },
  {
    name: "Blackjack 7",
    img: "/assets/Casino/PT905.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-073",
  },
  {
    name: "Blackjack 8",
    img: "/assets/Casino/PT906.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-074",
  },
  {
    name: "Baccarat NC",
    img: "/assets/Casino/PT907.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-075",
  },
  {
    name: "Greek Quantum Roulette",
    img: "/assets/Casino/PT908.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-076",
  },
  {
    name: "Ruleta Automatica Cuantica",
    img: "/assets/Casino/PT909.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-077",
  },
  {
    name: "Arabic Roulette",
    img: "/assets/Casino/PT910.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-078",
  },
  {
    name: "Quantum Ruleta España",
    img: "/assets/Casino/PT911.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-079",
  },
  {
    name: "Ruyi French Roulette",
    img: "/assets/Casino/PT912.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-080",
  },
  {
    name: "Ruyi Roulette",
    img: "/assets/Casino/PT913.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-081",
  },
  {
    name: "Slingshot Ruleta Espana",
    img: "/assets/Casino/PT914.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-083",
  },
  {
    name: "The Greatest Cards Show",
    img: "/assets/Casino/PT915.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-086",
  },
  {
    name: "Spin a Win Wild Live",
    img: "/assets/Casino/PT916.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
  },
  {
    name: "Japanese Squeeze Baccarat",
    img: "/assets/Casino/PT917.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-091",
  },
  {
    name: "Japanese Squeeze Baccarat NC",
    img: "/assets/Casino/PT918.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-092",
  },
  {
    name: "Ru Yi Speed Baccarat",
    img: "/assets/Casino/PT919.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-093",
  },
  {
    name: "Ru Yi Speed Baccarat NC",
    img: "/assets/Casino/PT920.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-094",
  },
  {
    name: "Speed Baccarat Korean",
    img: "/assets/Casino/PT921.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
  },
  {
    name: "Baccarat Brasileira",
    img: "/assets/Casino/PT922.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-097",
  },
  {
    name: "Baccarat Brasileira NC",
    img: "/assets/Casino/PT923.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-098",
  },
  {
    name: "Speed SicBo",
    img: "/assets/Casino/PT924.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-099",
  },
  {
    name: "Auto Roulette 2",
    img: "/assets/Casino/PT925.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-100",
  },
  {
    name: "x1000 Quantum Roulette",
    img: "/assets/Casino/PT926.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-102",
  },
  {
    name: "Mega Fire Blaze Blackjack Live",
    img: "/assets/Casino/PT927.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-106",
  },
  {
    name: "Mega Fire Blaze Lucky Ball Brasileiro",
    img: "/assets/Casino/PT928.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-108",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/PT929.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-109",
  },
  {
    name: "Mega Fire Blaze Lucky Ball Live",
    img: "/assets/Casino/PT930.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-110",
  },
  {
    name: "Blackjack Soirée 1",
    img: "/assets/Casino/PT931.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-111",
  },
  {
    name: "Blackjack Soirée 2",
    img: "/assets/Casino/PT932.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-112",
  },
  {
    name: "Blackjack Soirée 3",
    img: "/assets/Casino/PT933.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-113",
  },
  {
    name: "Soirée Privée Blackjack",
    img: "/assets/Casino/PT934.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-114",
  },
  {
    name: "Baccarat Soirée",
    img: "/assets/Casino/PT935.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-115",
  },
  {
    name: "Gangnam Speed Baccarat",
    img: "/assets/Casino/PT936.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-117",
  },
  {
    name: "Gangnam Speed Baccarat NC",
    img: "/assets/Casino/PT937.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-118",
  },
  {
    name: "Emperor Baccarat",
    img: "/assets/Casino/PT938.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-119",
  },
  {
    name: "Emperor Baccarat NC",
    img: "/assets/Casino/PT939.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-120",
  },
  {
    name: "Blackjack Soirée Gold 1",
    img: "/assets/Casino/PT940.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-121",
  },
  {
    name: "Blackjack Soirée Gold 2",
    img: "/assets/Casino/PT941.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-122",
  },
  {
    name: "Blackjack Soirée Gold 3",
    img: "/assets/Casino/PT942.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-123",
  },
  {
    name: "Blackjack Soirée Gold 4",
    img: "/assets/Casino/PT943.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-124",
  },
  {
    name: "Punto Banco Soirée Gold",
    img: "/assets/Casino/PT944.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-125",
  },
  {
    name: "All Bets Blackjack Brasileira",
    img: "/assets/Casino/PT945.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-126",
  },
  {
    name: "Blackjack 10",
    img: "/assets/Casino/PT946.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-127",
  },
  {
    name: "Sticky Bandits Roulette Live",
    img: "/assets/Casino/PT947.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-128",
  },
  {
    name: "Baccarat Soirée NC",
    img: "/assets/Casino/PT948.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-129",
  },
  {
    name: "Lucky Ball Roulette Live",
    img: "/assets/Casino/PT949.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-130",
  },
  {
    name: "Blackjack VZN 1",
    img: "/assets/Casino/PT950.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-132",
  },
  {
    name: "Blackjack VZN 2",
    img: "/assets/Casino/PT951.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-133",
  },
  {
    name: "Blackjack VZN 3",
    img: "/assets/Casino/PT952.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-134",
  },
  {
    name: "Blackjack VZN 4",
    img: "/assets/Casino/PT953.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-135",
  },
  {
    name: "Blackjack VZN 5",
    img: "/assets/Casino/PT954.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-136",
  },
  {
    name: "Blackjack VZN 6",
    img: "/assets/Casino/PT955.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-137",
  },
  {
    name: "Blackjack VZN 7",
    img: "/assets/Casino/PT956.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-138",
  },
  {
    name: "Blackjack VZN 8",
    img: "/assets/Casino/PT957.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-139",
  },
  {
    name: "Blackjack VZN 9",
    img: "/assets/Casino/PT958.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-140",
  },
  {
    name: "Blackjack VZN 10",
    img: "/assets/Casino/PT959.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-141",
  },
  {
    name: "Elite Roulette",
    img: "/assets/Casino/PT960.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-142",
  },
  {
    name: "Quantum Baccarat Live",
    img: "/assets/Casino/PT961.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-143",
  },
  {
    name: "Speed Baccarat 1",
    img: "/assets/Casino/PT962.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-144",
  },
  {
    name: "Speed Baccarat 2",
    img: "/assets/Casino/PT963.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-145",
  },
  {
    name: "Super Speed Baccarat",
    img: "/assets/Casino/PT964.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-146",
  },
  {
    name: "Super Card Blackjack Live",
    img: "/assets/Casino/PT965.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-147",
  },
  {
    name: "Speed Baccarat Korean NC",
    img: "/assets/Casino/PT921.webp",
    vendor: "/assets/Platform/pt.png",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-096",
  },

  // PT

  {
    name: "Always 9 Baccarat",
    img: "/assets/Casino/EG4622.webp?t=1763370052470",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-454",
  },
  {
    name: "Dragon Tiger Phoenix",
    img: "/assets/Casino/EG4621.webp?t=1763370770255",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-453",
  },
  // {
  //   name: "Insurance Baccarat",
  //   img: "/assets/Casino/EG4620.webp?t=1763369453751",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Salon Prive Baccarat",
  //   img: "/assets/Casino/EG4619.webp?t=1763368972949",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack em Português Ouro",
  //   img: "/assets/Casino/EG4618.webp?t=1763369233858",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Platinum Private Blackjack 2",
  //   img: "/assets/Casino/EG4617.webp?t=1763367587643",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Platinum Private Blackjack 1",
  //   img: "/assets/Casino/EG4616.webp?t=1763370463496",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Super Speed Dragon Tiger",
  //   img: "/assets/Casino/EG4615.webp?t=1763367629906",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 8",
  //   img: "/assets/Casino/EG4614.webp?t=1763369181741",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 7",
  //   img: "/assets/Casino/EG4613.webp?t=1763368171124",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 6",
  //   img: "/assets/Casino/EG4612.webp?t=1763367437059",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 5",
  //   img: "/assets/Casino/EG4611.webp?t=1763370471596",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Lightning Roulette",
  //   img: "/assets/Casino/EG4610.webp?t=1763370376317",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Salon Privé Auto-Roulette A",
  //   img: "/assets/Casino/EG4609.webp?t=1763367766738",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack em Português 1",
  //   img: "/assets/Casino/EG4606.webp?t=1763369465984",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack Ilimitado Ao Vivo",
  //   img: "/assets/Casino/EG4605.webp?t=1763369818439",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta Bola Rápida en Vivo",
  //   img: "/assets/Casino/EG4603.webp?t=1763368222229",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Ice Fishing",
    img: "/assets/Casino/EG4601.webp?t=1763368540891",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-449",
  },
  // {
  //   name: "Roleta ao Vivo",
  //   img: "/assets/Casino/EG4600.webp?t=1763370344547",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack Ilimitado en Vivo",
  //   img: "/assets/Casino/EG4599.webp?t=1763369172159",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Platinum Private Blackjack 12",
  //   img: "/assets/Casino/EG4560.webp?t=1763369807716",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Platinum Private Blackjack 11",
  //   img: "/assets/Casino/EG4559.webp?t=1763370695224",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta en Vivo",
  //   img: "/assets/Casino/EG4598.webp?t=1763370746627",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack en Español 3",
  //   img: "/assets/Casino/EG4597.webp?t=1763370572337",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack en Español 2",
  //   img: "/assets/Casino/EG4596.webp?t=1763367750802",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack en Español 1",
  //   img: "/assets/Casino/EG4595.webp?t=1763370789531",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta en Español",
  //   img: "/assets/Casino/EG4593.webp?t=1763368275670",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Bac Bo Ao Vivo",
  //   img: "/assets/Casino/EG4592.webp?t=1763370479185",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Bacará Rápido",
  //   img: "/assets/Casino/EG4589.webp?t=1763369770199",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack em Português 5",
  //   img: "/assets/Casino/EG4586.webp?t=1763368849745",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack em Português 4",
  //   img: "/assets/Casino/EG4585.webp?t=1763369838862",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack em Português 3",
  //   img: "/assets/Casino/EG4584.webp?t=1763370085146",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack em Português 2",
  //   img: "/assets/Casino/EG4583.webp?t=1763368035190",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack em Português",
  //   img: "/assets/Casino/EG4582.webp?t=1763369087399",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Lightning Baccarat",
  //   img: "/assets/Casino/EG4581.webp?t=1763368123859",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Baccarat Rápido ao Vivo 3",
  //   img: "/assets/Casino/EG4579.webp?t=1763367514740",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Baccarat Rápido ao Vivo 1",
  //   img: "/assets/Casino/EG4577.webp?t=1763369617906",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 9",
  //   img: "/assets/Casino/EG4572.webp?t=1763367897643",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 8",
  //   img: "/assets/Casino/EG4571.webp?t=1763368459285",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 7",
  //   img: "/assets/Casino/EG4570.webp?t=1763368450809",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 6",
  //   img: "/assets/Casino/EG4569.webp?t=1763370975988",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 5",
  //   img: "/assets/Casino/EG4568.webp?t=1763370534259",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 4",
  //   img: "/assets/Casino/EG4567.webp?t=1763367859179",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 3",
  //   img: "/assets/Casino/EG4566.webp?t=1763369245102",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español 2",
  //   img: "/assets/Casino/EG4565.webp?t=1763368604085",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Blackjack en Español",
  //   img: "/assets/Casino/EG4564.webp?t=1763368181500",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Platinum Private Blackjack 10",
  //   img: "/assets/Casino/EG4558.webp?t=1763367933934",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack M",
  //   img: "/assets/Casino/EG4557.webp?t=1763369223683",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack L",
  //   img: "/assets/Casino/EG4556.webp?t=1763368430599",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack K",
  //   img: "/assets/Casino/EG4555.webp?t=1763368740834",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack J",
  //   img: "/assets/Casino/EG4554.webp?t=1763367619765",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack I",
  //   img: "/assets/Casino/EG4553.webp?t=1763367427974",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack H",
  //   img: "/assets/Casino/EG4552.webp?t=1763370003731",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 4",
  //   img: "/assets/Casino/EG4551.webp?t=1763368940349",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 3",
  //   img: "/assets/Casino/EG4550.webp?t=1763367925737",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 2",
  //   img: "/assets/Casino/EG4549.webp?t=1763370515159",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Perya Speed Baccarat 1",
  //   img: "/assets/Casino/EG4548.webp?t=1763367827623",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Lightning Dragon Tiger",
  //   img: "/assets/Casino/EG4546.webp?t=1763369402155",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Lightning Bac Bo",
    img: "/assets/Casino/EG4545.webp?t=1763368795532",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-440",
  },
  {
    name: "Super Color Game",
    img: "/assets/Casino/EG4544.webp?t=1763368264482",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-435",
  },
  // {
  //   name: "Korean Dragon Tiger",
  //   img: "/assets/Casino/EG4543.webp?t=1763370665305",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Marble Race",
    img: "/assets/Casino/EG4542.webp?t=1763370443338",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-434",
  },
  {
    name: "Lotus Speed Baccarat C",
    img: "/assets/Casino/EG4541.webp?t=1763368702081",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-421",
  },
  {
    name: "Thai Speed Baccarat C",
    img: "/assets/Casino/EG4540.webp?t=1763370985678",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-433",
  },
  {
    name: "Thai Speed Baccarat B",
    img: "/assets/Casino/EG4539.webp?t=1763370148421",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-432",
  },
  {
    name: "War",
    img: "/assets/Casino/EG4538.webp?t=1763369330295",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-431",
  },
  {
    name: "Lotus Speed Baccarat B",
    img: "/assets/Casino/EG4537.webp?t=1763370334434",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-420",
  },
  // {
  //   name: "Korean Speed Baccarat G",
  //   img: "/assets/Casino/EG4536.webp?t=1763369059969",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat H",
  //   img: "/assets/Casino/EG4535.webp?t=1763368307971",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Race Track",
    img: "/assets/Casino/EG4534.webp?t=1763370067195",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-426",
  },
  {
    name: "Bet Stacker Blackjack 2",
    img: "/assets/Casino/EG4532.webp?t=1763368470716",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-423",
  },
  {
    name: "Bet Stacker Blackjack 1",
    img: "/assets/Casino/EG4531.webp?t=1763370920515",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-422",
  },
  {
    name: "Bet Stacker Blackjack 3",
    img: "/assets/Casino/EG4530.webp?t=1763367097052",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-424",
  },
  {
    name: "Thai Speed Baccarat A",
    img: "/assets/Casino/EG4526.webp?t=1763369566932",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-415",
  },
  {
    name: "Lotus Speed Baccarat A",
    img: "/assets/Casino/EG4524.webp?t=1763369318724",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-416",
  },
  // {
  //   name: "Korean Prosperity Tree Baccarat",
  //   img: "/assets/Casino/EG4522.webp?t=1763370404355",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Golden Wealth Baccarat",
  //   img: "/assets/Casino/EG4521.webp?t=1763369004056",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Infinite Bet Stacker Blackjack",
    img: "/assets/Casino/EG4520.webp?t=1763367906519",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-412",
  },
  {
    name: "Easy Blackjack",
    img: "/assets/Casino/EG4519.webp?t=1763369040621",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-413",
  },
  {
    name: "Crazy Balls",
    img: "/assets/Casino/EG4518.webp?t=1763369915986",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-409",
  },
  {
    name: "Always 8 Baccarat",
    img: "/assets/Casino/EG4517.webp?t=1763368859162",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-410",
  },
  {
    name: "Deal or No Deal",
    img: "/assets/Casino/EG4516.webp?t=1763370044715",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-025",
  },
  // {
  //   name: "Korean Speed Blackjack F",
  //   img: "/assets/Casino/EG4514.webp?t=1763368830774",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack D",
  //   img: "/assets/Casino/EG4511.webp?t=1763367075824",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack C",
  //   img: "/assets/Casino/EG4510.webp?t=1763368440750",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack B",
  //   img: "/assets/Casino/EG4509.webp?t=1763367179893",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Blackjack A",
  //   img: "/assets/Casino/EG4508.webp?t=1763367809261",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Grand Korean Speed Blackjack",
  //   img: "/assets/Casino/EG4507.webp?t=1763367543716",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Super Speed Baccarat",
    img: "/assets/Casino/EG4505.webp?t=1763368550512",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-398",
  },
  // {
  //   name: "Korean Speed Baccarat F",
  //   img: "/assets/Casino/EG4504.webp?t=1763370385895",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat E",
  //   img: "/assets/Casino/EG4503.webp?t=1763368879576",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat D",
  //   img: "/assets/Casino/EG4502.webp?t=1763368337928",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat C",
  //   img: "/assets/Casino/EG4501.webp?t=1763369634089",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat B",
  //   img: "/assets/Casino/EG4500.webp?t=1763367696585",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Korean Speed Baccarat A",
  //   img: "/assets/Casino/EG4499.webp?t=1763369162609",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Video Poker",
    img: "/assets/Casino/EG4497.webp?t=1763367838924",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-227",
  },
  {
    name: "Triple Card Poker",
    img: "/assets/Casino/EG4496.webp?t=1763369202686",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-009",
  },
  // {
  //   name: "Stock Market A",
  //   img: "/assets/Casino/EG4495.webp",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  // },
  {
    name: "Stock Market",
    img: "/assets/Casino/EG4494.webp?t=1763368509933",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
  },
  {
    name: "Speed VIP Blackjack Z",
    img: "/assets/Casino/EG4493.webp?t=1763370965231",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-191",
  },
  {
    name: "Speed VIP Blackjack Y",
    img: "/assets/Casino/EG4492.webp?t=1763370159747",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-192",
  },
  {
    name: "Speed VIP Blackjack X",
    img: "/assets/Casino/EG4491.webp?t=1763369297167",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-193",
  },
  {
    name: "Speed VIP Blackjack W",
    img: "/assets/Casino/EG4490.webp?t=1763367888203",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-194",
  },
  {
    name: "Speed VIP Blackjack V",
    img: "/assets/Casino/EG4489.webp?t=1763037022178",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-195",
  },
  {
    name: "Speed VIP Blackjack U",
    img: "/assets/Casino/EG4488.webp?t=1763038401556",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-196",
  },
  {
    name: "Speed VIP Blackjack T",
    img: "/assets/Casino/EG4487.webp?t=1763039453656",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-197",
  },
  {
    name: "Speed VIP Blackjack S",
    img: "/assets/Casino/EG4486.webp?t=1763367986439",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-199",
  },
  {
    name: "Speed VIP Blackjack 2",
    img: "/assets/Casino/EG4485.webp?t=1763369994395",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-200",
  },
  {
    name: "Speed VIP Blackjack 1",
    img: "/assets/Casino/EG4484.webp?t=1763368144936",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-203",
  },
  {
    name: "Speed Super Sic Bo",
    img: "/assets/Casino/EG4483.webp?t=1763370524280",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-260",
  },
  {
    name: "Speed Baccarat 9",
    img: "/assets/Casino/EG4482.webp?t=1763368994048",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-020",
  },
  {
    name: "Speed Baccarat 8",
    img: "/assets/Casino/EG4481.webp?t=1763369855979",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-019",
  },
  {
    name: "Speed Baccarat 7",
    img: "/assets/Casino/EG4480.webp?t=1763368072420",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-018",
  },
  {
    name: "Speed Baccarat 6",
    img: "/assets/Casino/EG4479.webp?t=1763369848277",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-017",
  },
  {
    name: "Speed Baccarat 5",
    img: "/assets/Casino/EG4478.webp?t=1763368919985",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-248",
  },
  {
    name: "Speed Baccarat 4",
    img: "/assets/Casino/EG4477.webp?t=1763370711815",
    vendor: "/assets/Platform/EG4-COLOR.webp",
    platForm: "EVO",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-247",
  },
  // {
  //   name: "Speed Baccarat 15",
  //   img: "/assets/Casino/EG4476.webp",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-008",
  // },
  // {
  //   name: "Speed Baccarat 14",
  //   img: "/assets/Casino/EG4475.webp",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-003",
  // },
  // {
  //   name: "Speed Baccarat 13",
  //   img: "/assets/Casino/EG4474.webp",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-024",
  // },
  // {
  //   name: "Speed Baccarat 12",
  //   img: "/assets/Casino/EG4473.webp?t=1763368093722",
  //   vendor: "/assets/Platform/EG4-COLOR.webp",
  //   platForm: "EVO",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-023",
  // },
  {
    name: "Mega Roulette 3000",
    img: "/assets/Casino/PP1083.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-189",
  },
  {
    name: "Money Time",
    img: "/assets/Casino/PP1069.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-188",
  },
  {
    name: "Indonesian BlackjackX 17",
    img: "/assets/Casino/PP1045.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-173",
    platFormCode: "PP",
  },
  {
    name: "Privé Lounge Roulette Deluxe",
    img: "/assets/Casino/PP1031.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-184",
  },
  {
    name: "Jacks or Better Draw Poker",
    img: "/assets/Casino/PP1026.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-183",
  },
  {
    name: "Casino Hold’em",
    img: "/assets/Casino/PP1021.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-182",
  },
  {
    name: "French Roulette",
    img: "/assets/Casino/PP1013.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-181",
  },
  {
    name: "Indonesian BlackjackX 18",
    img: "/assets/Casino/PP1003.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-172",
    platFormCode: "PP",
  },
  {
    name: "Indonesian Blackjack X 20",
    img: "/assets/Casino/PP1002.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-171",
    platFormCode: "PP",
  },
  // {
  //   name: "Korean Privé Lounge Baccarat",
  //   img: "/assets/Casino/PP0993.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Korean Baccarat 2",
    img: "/assets/Casino/PP0991.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-180",
  },
  {
    name: "Squeeze Baccarat",
    img: "/assets/Casino/PP0973.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-179",
  },
  {
    name: "Thai Roulette",
    img: "/assets/Casino/PP0964.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-178",
  },
  {
    name: "Vietnamese Speed Baccarat 3",
    img: "/assets/Casino/PP0947.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-177",
  },
  {
    name: "American Roulette",
    img: "/assets/Casino/PP0942.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-176",
  },
  {
    name: "Immersive Roulette Deluxe",
    img: "/assets/Casino/PP0936.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-175",
  },
  {
    name: "Indonesian BlackjackX 15",
    img: "/assets/Casino/PP0935.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-173",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 14",
    img: "/assets/Casino/PP0934.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-172",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 13",
    img: "/assets/Casino/PP0933.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-171",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 12",
    img: "/assets/Casino/PP0932.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-170",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 11",
    img: "/assets/Casino/PP0931.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-169",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 10",
    img: "/assets/Casino/PP0930.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-168",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 9",
    img: "/assets/Casino/PP0929.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-167",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 8",
    img: "/assets/Casino/PP0928.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-166",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 7",
    img: "/assets/Casino/PP0927.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-165",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 6",
    img: "/assets/Casino/PP0926.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-164",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 2",
    img: "/assets/Casino/PP0923.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-174",
  },
  {
    name: "Fortune Roulette",
    img: "/assets/Casino/PP0916.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-163",
  },
  {
    name: "Thai Speed Baccarat",
    img: "/assets/Casino/PP0915.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
  },
  {
    name: "BlackjackX 40",
    img: "/assets/Casino/PP0906.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-103",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 39",
    img: "/assets/Casino/PP0905.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-104",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 38",
    img: "/assets/Casino/PP0904.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-105",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 37",
    img: "/assets/Casino/PP0903.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-107",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 36",
    img: "/assets/Casino/PP0902.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-109",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 35",
    img: "/assets/Casino/PP0901.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-110",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 34",
    img: "/assets/Casino/PP0900.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 33",
    img: "/assets/Casino/PP0899.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-114",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 32",
    img: "/assets/Casino/PP0898.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-114",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 31",
    img: "/assets/Casino/PP0897.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-114",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 5",
    img: "/assets/Casino/PP0887.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-151",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 4",
    img: "/assets/Casino/PP0886.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-150",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 3",
    img: "/assets/Casino/PP0885.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-149",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 2",
    img: "/assets/Casino/PP0884.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-148",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 1",
    img: "/assets/Casino/PP0883.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-147",
    platFormCode: "PP",
  },
  {
    name: "Indonesian Roulette",
    img: "/assets/Casino/PP0882.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-146",
  },
  // {
  //   name: "Roulette Lobby",
  //   img: "/assets/Casino/PP0874.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Bet Behind Pro Blackjack",
    img: "/assets/Casino/PP0852.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-143",
  },
  {
    name: "VIP Auto Roulette",
    img: "/assets/Casino/PP0850.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-142",
  },
  {
    name: "Mega Roulette - Brazilian",
    img: "/assets/Casino/PP0834.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-141",
  },
  {
    name: "BlackjackX 30 - Emerald",
    img: "/assets/Casino/PP0819.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-103",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 29 - Emerald",
    img: "/assets/Casino/PP0818.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-104",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 28 - Emerald",
    img: "/assets/Casino/PP0817.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-105",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 27 - Emerald",
    img: "/assets/Casino/PP0816.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-106",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 26 - Emerald",
    img: "/assets/Casino/PP0815.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-108",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 23 - Emerald",
    img: "/assets/Casino/PP0814.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-109",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 22 - Emerald",
    img: "/assets/Casino/PP0813.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-109",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 13 - Emerald",
    img: "/assets/Casino/PP0812.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-110",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 12 - Emerald",
    img: "/assets/Casino/PP0811.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-111",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 11 - Emerald",
    img: "/assets/Casino/PP0810.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 25 - Azure",
    img: "/assets/Casino/PP0809.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-122",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 21 - Ruby",
    img: "/assets/Casino/PP0808.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-120",
    platFormCode: "PP",
  },
  // {
  //   name: "Blackjack X 20 - Ruby",
  //   img: "/assets/Casino/PP0807.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Blackjack X 19 - Ruby",
    img: "/assets/Casino/PP0806.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-110",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 18 - Azure",
    img: "/assets/Casino/PP0805.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 17 - Azure",
    img: "/assets/Casino/PP0804.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 15 - Ruby",
    img: "/assets/Casino/PP0803.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 7 - Azure",
    img: "/assets/Casino/PP0801.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 6 - Azure",
    img: "/assets/Casino/PP0800.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 10 - Ruby",
    img: "/assets/Casino/PP0799.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 9 - Ruby",
    img: "/assets/Casino/PP0798.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  {
    name: "Blackjack X 16 - Azure",
    img: "/assets/Casino/PP0794.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
  },
  // {
  //   name: "Privé Lounge Baccarat 8",
  //   img: "/assets/Casino/PP0771.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Privé Lounge Baccarat 7",
  //   img: "/assets/Casino/PP0770.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Privé Lounge Baccarat 6",
  //   img: "/assets/Casino/PP0769.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Chinese Speed Baccarat 3",
    img: "/assets/Casino/PP0768.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-139",
  },
  // {
  //   name: "Roulette Ruby",
  //   img: "/assets/Casino/PP0762.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Mega Sic Bac",
    img: "/assets/Casino/PP0758.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-140",
  },
  {
    name: "Blackjack X 8 - Ruby",
    img: "/assets/Casino/PP0752.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-089",
    platFormCode: "PP",
  },
  {
    name: "Turkish Mega Roulette",
    img: "/assets/Casino/PP0741.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-081",
  },
  {
    name: "BlackjackX 24 - Azure",
    img: "/assets/Casino/PP0740.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-121",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 1",
    img: "/assets/Casino/PP0737.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-115",
  },
  // {
  //   name: "Korean Turbo Baccarat 1",
  //   img: "/assets/Casino/PP0732.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Super Trunfo",
  //   img: "/assets/Casino/PP0729.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Chinese Speed Baccarat 2",
    img: "/assets/Casino/PP0716.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-114",
  },
  // {
  //   name: "Blackjack X 4 - Ruby",
  //   img: "/assets/Casino/PP0714.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Japanese Speed Baccarat 3",
    img: "/assets/Casino/PP0709.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-099",
  },
  {
    name: "Chinese Speed Baccarat 1",
    img: "/assets/Casino/PP0694.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-080",
  },
  // {
  //   name: "Blackjack X 5 - Ruby",
  //   img: "/assets/Casino/PP0692.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack X 3 - Azure",
  //   img: "/assets/Casino/PP0690.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Blackjack X 2 - Azure",
  //   img: "/assets/Casino/PP0689.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Korean Speed Baccarat 5",
    img: "/assets/Casino/PP0679.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-117",
  },
  {
    name: "Speed Baccarat 2 - Japanese",
    img: "/assets/Casino/PP0678.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-119",
    platFormCode: "PP",
  },
  {
    name: "Japanese Speed Baccarat 1",
    img: "/assets/Casino/PP0677.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-118",
  },
  {
    name: "Sic Bo",
    img: "/assets/Casino/PP0663.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-079",
  },
  // {
  //   name: "Privé Lounge Baccarat 1",
  //   img: "/assets/Casino/PP0660.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Privé Lounge Baccarat 2",
  //   img: "/assets/Casino/PP0659.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Privé Lounge Baccarat 3",
  //   img: "/assets/Casino/PP0658.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  // {
  //   name: "Privé Lounge Baccarat 5",
  //   img: "/assets/Casino/PP0656.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Thai Speed Baccarat 1",
    img: "/assets/Casino/PP0654.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-069",
  },
  {
    name: "Vietnamese Roulette",
    img: "/assets/Casino/PP0652.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-068",
  },
  {
    name: "Indonesian Speed Baccarat 1",
    img: "/assets/Casino/PP0638.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-072",
  },
  {
    name: "Treasure Island",
    img: "/assets/Casino/PP0631.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-078",
  },
  {
    name: "Korean Baccarat 1",
    img: "/assets/Casino/PP0626.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-071",
  },
  {
    name: "Korean Speed Baccarat 3",
    img: "/assets/Casino/PP0625.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-070",
  },
  {
    name: "Auto Mega Roulette",
    img: "/assets/Casino/PP0581.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-075",
  },
  // {
  //   name: "Speed Auto Roulette 1",
  //   img: "/assets/Casino/PP0578.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Brazilian Roulette",
    img: "/assets/Casino/PP0575.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-074",
  },
  {
    name: "Korean Roulette",
    img: "/assets/Casino/PP0574.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-073",
  },
  {
    name: "Snakes & Ladders Live",
    img: "/assets/Casino/PP0449.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-062",
  },
  {
    name: "Mega Baccarat",
    img: "/assets/Casino/PP0433.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-061",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 2 - Korean",
    img: "/assets/Casino/PP0419.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-057",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 1 - Korean",
    img: "/assets/Casino/PP0397.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "PP-LIVE-056",
    platFormCode: "PP",
  },
  {
    name: "Speed Roulette 2",
    img: "/assets/Casino/PP0373.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-054",
  },
  {
    name: "PowerUP Roulette",
    img: "/assets/Casino/PP0369.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-055",
  },
  // {
  //   name: "Roulette 14 - Spanish",
  //   img: "/assets/Casino/PP0359.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Speed Baccarat 17",
    img: "/assets/Casino/PP0342.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-051",
  },
  {
    name: "Speed Baccarat 16",
    img: "/assets/Casino/PP0341.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-050",
  },
  {
    name: "Baccarat 9",
    img: "/assets/Casino/PP0340.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-052",
  },
  {
    name: "Dice City",
    img: "/assets/Casino/PP0330.webp",
    vendor: "/assets/Platform/PP-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-049",
  },
  // {
  //   name: "Roulette 12 - Romanian",
  //   img: "/assets/Casino/PP0329.webp",
  //   vendor: "/assets/Platform/PP-COLOR.webp",
  //   platForm: "PP",
  //   type: "LIVE",
  // },
  {
    name: "Baccarat",
    img: "/assets/Casino/SEX055.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "TABLE",
    casinoType: "PP-TABLE-003",
  },
  {
    name: "Sedie",
    img: "/assets/Casino/SEX013.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "SEXYBCRT",
    type: "LIVE",
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
  },
  {
    name: "Extra Sicbo",
    img: "/assets/Casino/SEX011.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "SEXYBCRT",
    type: "LIVE",
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016",
  },
  {
    name: "Thai Fish Prawn Crab",
    img: "/assets/Casino/SEX009.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-011",
  },
  {
    name: "Thai Hi Lo",
    img: "/assets/Casino/SEX008.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-008",
  },
  {
    name: "Roulette",
    img: "/assets/Casino/SEX005.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "PP",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "TABLE",
    casinoType: "PP-TABLE-006",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/SEX003.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-006",
  },
  {
    name: "Baccarat Classic",
    img: "/assets/Casino/SEX002.webp",
    vendor: "/assets/Platform/SEX-COLOR.webp",
    platForm: "SEXYBCRT",
    type: "LIVE",
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
  },
  // {
  //   name: "EZ Dealer Roulette Bengali",
  //   img: "/assets/Casino/EZ0133.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Imperial Fortune",
  //   img: "/assets/Casino/EZ0132.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Manga Madness",
  //   img: "/assets/Casino/EZ0131.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Coin Rush",
  //   img: "/assets/Casino/EZ0130.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Coin Rush Pro",
  //   img: "/assets/Casino/EZ0129.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Diwali",
  //   img: "/assets/Casino/EZ0128.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Halloween Auto Roulette",
  //   img: "/assets/Casino/EZ0127.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Diwali Auto Roulette",
  //   img: "/assets/Casino/EZ0126.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Bet with Streamers",
  //   img: "/assets/Casino/EZ0125.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-408",
  // },
  // {
  //   name: "Ultimate Flip",
  //   img: "/assets/Casino/EZ0124.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Canada Blackjack",
  //   img: "/assets/Casino/EZ0123.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Marble Race Monaco",
  //   img: "/assets/Casino/EZ0122.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Matka",
  //   img: "/assets/Casino/EZ0119.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Xoc Dia",
  //   img: "/assets/Casino/EZ0118.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "VIACASINO",
  //   gameType: "LIVE",
  //   casinoType: "VIACASINO-LIVE-015",
  // },
  // {
  //   name: "Cricket Ball Roulette",
  //   img: "/assets/Casino/EZ0115.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Fortune Pusher",
  //   img: "/assets/Casino/EZ0114.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Magic Claw",
  //   img: "/assets/Casino/EZ0113.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Auto Claw Roulette",
  //   img: "/assets/Casino/EZ0112.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Cricket War",
  //   img: "/assets/Casino/EZ0111.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Dragon Tiger da Sorte",
  //   img: "/assets/Casino/EZ0110.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Dragon Tiger",
  //   img: "/assets/Casino/EZ0109.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "VIACASINO",
  //   gameType: "LIVE",
  //   casinoType: "VIACASINO-LIVE-006",
  // },
  // {
  //   name: "Ultimate Sic Bo",
  //   img: "/assets/Casino/EZ0108.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Sic Bo",
  //   img: "/assets/Casino/EZ0107.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-079",
  // },
  // {
  //   name: "EZ Baccarat",
  //   img: "/assets/Casino/EZ0106.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "No Commission Over Under Baccarat",
  //   img: "/assets/Casino/EZ0105.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "No Commission Baccarat B",
  //   img: "/assets/Casino/EZ0104.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "No Commission Baccarat A",
  //   img: "/assets/Casino/EZ0103.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Super 6 Baccarat",
  //   img: "/assets/Casino/EZ0102.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Knockout Baccarat",
  //   img: "/assets/Casino/EZ0101.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Baccarat D",
  //   img: "/assets/Casino/EZ0100.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Baccarat C",
  //   img: "/assets/Casino/EZ0099.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Baccarat B",
  //   img: "/assets/Casino/EZ0098.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Baccarat A",
  //   img: "/assets/Casino/EZ0097.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Over Under Baccarat",
  //   img: "/assets/Casino/EZ0096.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Baccarat E",
  //   img: "/assets/Casino/EZ0095.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Baccarat D",
  //   img: "/assets/Casino/EZ0094.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Baccarat C",
  //   img: "/assets/Casino/EZ0093.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-123",
  // },
  // {
  //   name: "Baccarat B",
  //   img: "/assets/Casino/EZ0092.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-122",
  // },
  // {
  //   name: "Baccarat A",
  //   img: "/assets/Casino/EZ0091.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-120",
  // },
  // {
  //   name: "Lucky 7",
  //   img: "/assets/Casino/EZ0089.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ultimate Andar Bahar",
  //   img: "/assets/Casino/EZ0088.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Andar Bahar",
  //   img: "/assets/Casino/EZ0087.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Andar Bahar",
  //   img: "/assets/Casino/EZ0086.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-043",
  // },
  // {
  //   name: "One Day Teen Patti",
  //   img: "/assets/Casino/EZ0085.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Bet on Teen Patti",
  //   img: "/assets/Casino/EZ0084.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Teen Patti 3 Card",
  //   img: "/assets/Casino/EZ0083.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Hold'em",
  //   img: "/assets/Casino/EZ0082.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-015",
  // },
  // {
  //   name: "Revolution Roulette",
  //   img: "/assets/Casino/EZ0081.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ultimate Auto Roulette",
  //   img: "/assets/Casino/EZ0080.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ultimate Roulette",
  //   img: "/assets/Casino/EZ0079.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Savanna",
  //   img: "/assets/Casino/EZ0078.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Latina",
  //   img: "/assets/Casino/EZ0077.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Nederlands",
  //   img: "/assets/Casino/EZ0076.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Hindi",
  //   img: "/assets/Casino/EZ0075.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Brazil",
  //   img: "/assets/Casino/EZ0073.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Mandarin",
  //   img: "/assets/Casino/EZ0072.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Japanese",
  //   img: "/assets/Casino/EZ0071.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette Thai",
  //   img: "/assets/Casino/EZ0070.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "EZ Dealer Roulette",
  //   img: "/assets/Casino/EZ0069.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta del Sol",
  //   img: "/assets/Casino/EZ0068.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Roulette 2",
  //   img: "/assets/Casino/EZ0067.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Casino Marina Roulette 1",
  //   img: "/assets/Casino/EZ0066.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "VIP Roulette",
  //   img: "/assets/Casino/EZ0065.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "PP",
  //   gameType: "LIVE",
  //   casinoType: "PP-LIVE-036",
  // },
  // {
  //   name: "Oracle 360 Roulette",
  //   img: "/assets/Casino/EZ0064.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Oracle Real Roulette",
  //   img: "/assets/Casino/EZ0063.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Portomaso Roulette 2",
  //   img: "/assets/Casino/EZ0062.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Horse Racing Auto Roulette",
  //   img: "/assets/Casino/EZ0061.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Football Auto Roulette",
  //   img: "/assets/Casino/EZ0060.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Cricket Auto Roulette",
  //   img: "/assets/Casino/EZ0059.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Prestige Auto Roulette",
  //   img: "/assets/Casino/EZ0058.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Auto Roulette",
  //   img: "/assets/Casino/EZ0057.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  //   platFormCode: "EVOLUTION",
  //   gameType: "LIVE",
  //   casinoType: "EVOLUTION-LIVE-212",
  // },
  // {
  //   name: "Auto Roulette",
  //   img: "/assets/Casino/EZ0056.webp",
  //   vendor: "/assets/Platform/EZ-COLOR.webp",
  //   platForm: "EZUGI",
  //   type: "LIVE",
  // },
  {
    name: "Lucky Tree Baccarat",
    img: "/assets/Casino/PT0825.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-148",
  },
  {
    name: "Super Card Blackjack Live",
    img: "/assets/Casino/PT0762.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-147",
  },
  {
    name: "Speed Baccarat 2",
    img: "/assets/Casino/PT0732.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-014",
  },
  {
    name: "Speed Baccarat 1",
    img: "/assets/Casino/PT0731.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-013",
  },
  {
    name: "Super Speed Baccarat",
    img: "/assets/Casino/PT0730.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-398",
  },
  {
    name: "Quantum Baccarat Live",
    img: "/assets/Casino/PT0698.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-143",
  },
  {
    name: "Slingshot Ruleta España",
    img: "/assets/Casino/PT0697.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-083",
  },
  {
    name: "Ruyi 如意 Roulette",
    img: "/assets/Casino/PT0696.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-081",
  },
  {
    name: "Ruyi 如意 French Roulette",
    img: "/assets/Casino/PT0695.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-080",
  },
  // {
  //   name: "Ruleta Rápida",
  //   img: "/assets/Casino/PT0694.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta Clásica Francesa",
  //   img: "/assets/Casino/PT0693.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta Clásica",
  //   img: "/assets/Casino/PT0692.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Ruleta Automática Cuántica",
  //   img: "/assets/Casino/PT0690.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Quantum Ruleta España",
    img: "/assets/Casino/PT0689.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-079",
  },
  // {
  //   name: "Mega Fire Blaze Ruleta España",
  //   img: "/assets/Casino/PT0688.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Turkish Speed Roulette",
  //   img: "/assets/Casino/PT0686.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Soho All Bets Blackjack",
    img: "/assets/Casino/PT0685.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-054",
  },
  {
    name: "Roleta Brasileira",
    img: "/assets/Casino/PT0684.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-059",
  },
  {
    name: "Greek Quantum Roulette",
    img: "/assets/Casino/PT0682.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-076",
  },
  {
    name: "Greek Speed Roulette",
    img: "/assets/Casino/PT0681.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
  },
  {
    name: "Bucharest Roulette",
    img: "/assets/Casino/PT0680.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-063",
  },
  {
    name: "Bucharest Quantum Roulette",
    img: "/assets/Casino/PT0679.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-066",
  },
  {
    name: "Bucharest French Roulette",
    img: "/assets/Casino/PT0678.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-066",
  },
  {
    name: "Casino Hold'em",
    img: "/assets/Casino/PT0675.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-017",
  },
  {
    name: "Blackjack 5",
    img: "/assets/Casino/PT0674.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-071",
  },
  {
    name: "Blackjack 4",
    img: "/assets/Casino/PT0673.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-070",
  },
  {
    name: "Blackjack 3",
    img: "/assets/Casino/PT0672.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-069",
  },
  // {
  //   name: "Blackjack 2",
  //   img: "/assets/Casino/PT0671.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Blackjack 10",
    img: "/assets/Casino/PT0670.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-127",
  },
  {
    name: "Blackjack 1",
    img: "/assets/Casino/PT0669.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-127",
  },
  {
    name: "3 Card Brag",
    img: "/assets/Casino/PT0668.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-016",
  },
  {
    name: "Buffalo Blitz España",
    img: "/assets/Casino/PT0665.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
  },
  // {
  //   name: "Speed Baccarat 한국어 2 NC",
  //   img: "/assets/Casino/PT0664.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Baccarat 한국어 2",
  //   img: "/assets/Casino/PT0663.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Punto Banco Soirée Gold",
    img: "/assets/Casino/PT0662.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-125",
  },
  // {
  //   name: "Speed Baccarat 한국어 1 NC",
  //   img: "/assets/Casino/PT0661.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Baccarat 한국어 1",
  //   img: "/assets/Casino/PT0660.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Blackjack Soirée Gold 4",
    img: "/assets/Casino/PT0659.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-124",
  },
  {
    name: "All Bets Blackjack Brasileira",
    img: "/assets/Casino/PT0658.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-126",
  },
  // {
  //   name: "Speed Blackjack 3",
  //   img: "/assets/Casino/PT0657.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Blackjack 2",
  //   img: "/assets/Casino/PT0656.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Blackjack 1",
  //   img: "/assets/Casino/PT0655.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "K-Pop Roulette Live",
  //   img: "/assets/Casino/PT0654.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Blackjack Soirée Gold 3",
    img: "/assets/Casino/PT0653.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-123",
  },
  {
    name: "Blackjack Soirée Gold 2",
    img: "/assets/Casino/PT0652.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-122",
  },
  {
    name: "Blackjack Soirée Gold 1",
    img: "/assets/Casino/PT0651.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-121",
  },
  {
    name: "Spin a Win Wild Brasileiro",
    img: "/assets/Casino/PT0650.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
  },
  // {
  //   name: "Speed Baccarat 普通话 NC",
  //   img: "/assets/Casino/PT0649.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Speed Baccarat 普通话",
  //   img: "/assets/Casino/PT0648.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Mega Fire Blaze Lucky Ball Brasileiro",
    img: "/assets/Casino/PT0647.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-108",
  },
  // {
  //   name: "Japanese Baccarat Squeeze NC",
  //   img: "/assets/Casino/PT0646.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Japanese Baccarat Squeeze",
  //   img: "/assets/Casino/PT0645.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Colombia Blackjack",
  //   img: "/assets/Casino/PT0644.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Blackjack 8",
    img: "/assets/Casino/PT0643.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-074",
  },
  {
    name: "Baccarat Brasileira NC",
    img: "/assets/Casino/PT0642.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-098",
  },
  {
    name: "Baccarat Brasileira",
    img: "/assets/Casino/PT0641.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-097",
  },
  // {
  //   name: "Speed Roleta Brasileira",
  //   img: "/assets/Casino/PT0640.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Deutsches Speed Roulette",
    img: "/assets/Casino/PT0639.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-022",
  },
  {
    name: "Sette e Mezzo Live",
    img: "/assets/Casino/PT0636.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-009",
  },
  {
    name: "Roulette Italiana",
    img: "/assets/Casino/PT0635.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-060",
  },
  {
    name: "Mega Fire Blaze Roulette Italiana",
    img: "/assets/Casino/PT0634.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
  },
  // {
  //   name: "Jade Baccarat NC",
  //   img: "/assets/Casino/PT0632.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Jade Baccarat",
  //   img: "/assets/Casino/PT0631.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Hindi Roulette",
    img: "/assets/Casino/PT0629.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-056",
  },
  {
    name: "Deutsches Blackjack",
    img: "/assets/Casino/PT0628.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-044",
  },
  {
    name: "Blackjack Italiano VIP",
    img: "/assets/Casino/PT0627.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-043",
  },
  {
    name: "Blackjack Italiano 1",
    img: "/assets/Casino/PT0625.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-041",
  },
  {
    name: "Andar Bahar",
    img: "/assets/Casino/PT0624.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-043",
  },
  {
    name: "Sakura Fortune Live",
    img: "/assets/Casino/PT0623.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-241",
  },
  // {
  //   name: "Busted Or Bailed",
  //   img: "/assets/Casino/PT0622.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Quantum Boost Roulette",
  //   img: "/assets/Casino/PT0621.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Unlimited Blackjack",
    img: "/assets/Casino/PT0620.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-010",
  },
  {
    name: "The Greatest Cards Show Live",
    img: "/assets/Casino/PT0619.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-086",
  },
  {
    name: "Sticky Bandits Roulette Live",
    img: "/assets/Casino/PT0618.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-128",
  },
  {
    name: "Spin A Win",
    img: "/assets/Casino/PT0617.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
  },
  {
    name: "Speed Baccarat NC",
    img: "/assets/Casino/PT0616.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-094",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/PT0615.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-109",
  },
  {
    name: "Speed Auto Roulette",
    img: "/assets/Casino/PT0614.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-058",
  },
  {
    name: "Speed 6 Scanner Baccarat NC",
    img: "/assets/Casino/PT0613.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-038",
  },
  {
    name: "Speed 6 Scanner Baccarat",
    img: "/assets/Casino/PT0612.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-035",
  },
  {
    name: "Soirée Privée Blackjack",
    img: "/assets/Casino/PT0611.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-114",
  },
  // {
  //   name: "Soirée Elite VIP Blackjack 2",
  //   img: "/assets/Casino/PT0610.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  // {
  //   name: "Soirée Elite VIP Blackjack",
  //   img: "/assets/Casino/PT0609.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Sicbo Deluxe",
    img: "/assets/Casino/PT0608.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-003",
  },
  {
    name: "Royale Blackjack 4",
    img: "/assets/Casino/PT0606.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-045",
  },
  {
    name: "Royale Blackjack 3",
    img: "/assets/Casino/PT0605.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-052",
  },
  {
    name: "Royale Blackjack 2",
    img: "/assets/Casino/PT0604.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-045",
  },
  {
    name: "Royale Blackjack 1",
    img: "/assets/Casino/PT0603.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-045",
  },
  {
    name: "Roulette Live",
    img: "/assets/Casino/PT0602.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-128",
  },
  {
    name: "Quantum Roulette Live",
    img: "/assets/Casino/PT0601.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-067",
  },
  // {
  //   name: "Quantum Blackjack Plus",
  //   img: "/assets/Casino/PT0600.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Prestige Roulette",
    img: "/assets/Casino/PT0599.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-057",
  },
  // {
  //   name: "Ontario Blackjack",
  //   img: "/assets/Casino/PT0598.webp",
  //   vendor: "/assets/Platform/PT-COLOR.webp",
  //   platForm: "PT",
  //   type: "LIVE",
  // },
  {
    name: "Mega Fire Blaze Roulette Live",
    img: "/assets/Casino/PT0597.webp",
    vendor: "/assets/Platform/PT-COLOR.webp",
    platForm: "PT",
    type: "LIVE",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
  },
  {
    name: "Blockchain Color Game",
    img: "/assets/Casino/VIA029.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-030",
  },
  {
    name: "Blockchain Xoc Dia",
    img: "/assets/Casino/VIA028.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-029",
  },
  {
    name: "Blockchain Viet FishShrimpCrab",
    img: "/assets/Casino/VIA027.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-028",
  },
  {
    name: "Blockchain Thai FishShrimpCrab",
    img: "/assets/Casino/VIA026.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-027",
  },
  {
    name: "Tornado Marbles",
    img: "/assets/Casino/VIA025.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-026",
  },
  {
    name: "Crazy Marbles",
    img: "/assets/Casino/VIA024.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-025",
    platFormCode: "VIACASINO",
  },
  // {
  //   name: "Rage",
  //   img: "/assets/Casino/VIA023.webp",
  //   vendor: "/assets/Platform/VIA-COLOR.webp",
  //   platForm: "VIACASINO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Good Old 7'S™",
  //   img: "/assets/Casino/VIA022.webp",
  //   vendor: "/assets/Platform/VIA-COLOR.webp",
  //   platForm: "VIACASINO",
  //   type: "LIVE",
  // },
  // {
  //   name: "Jack Hammer 3: Diamond Affair",
  //   img: "/assets/Casino/VIA021.webp",
  //   vendor: "/assets/Platform/VIA-COLOR.webp",
  //   platForm: "VIACASINO",
  //   type: "LIVE",
  // },
  {
    name: "Lotto Lucky Wheel",
    img: "/assets/Casino/VIA020.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-024",
  },
  {
    name: "Lotto Xoc Dia",
    img: "/assets/Casino/VIA019.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-023",
  },
  {
    name: "Lotto Lucky Natural",
    img: "/assets/Casino/VIA018.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-022",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain Tai Xiu",
    img: "/assets/Casino/VIA017.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-019",
  },
  {
    name: "Blockchainthai Hi Lo",
    img: "/assets/Casino/VIA016.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-018",
  },
  {
    name: "Blockchain Classic Sic Bo",
    img: "/assets/Casino/VIA015.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-017",
  },
  {
    name: "Xoc Dia",
    img: "/assets/Casino/VIA014.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-015",
  },
  {
    name: "Viet Fish Prawn Crab",
    img: "/assets/Casino/VIA013.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-012",
  },
  {
    name: "Thai Fish Prawn Crab",
    img: "/assets/Casino/VIA012.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-011",
  },
  {
    name: "Color Game",
    img: "/assets/Casino/VIA011.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-010",
  },
  {
    name: "Tai Xiu",
    img: "/assets/Casino/VIA010.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-009",
  },
  {
    name: "Thai Hi Lo",
    img: "/assets/Casino/VIA009.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-008",
  },
  {
    name: "Classic Sic Bo",
    img: "/assets/Casino/VIA008.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-007",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/VIA007.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-006",
  },
  {
    name: "Wealth Supersix",
    img: "/assets/Casino/VIA006.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-005",
  },
  {
    name: "Pair Baccarat",
    img: "/assets/Casino/VIA005.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-004",
  },
  {
    name: "Lucky Natural",
    img: "/assets/Casino/VIA004.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-003",
    platFormCode: "VIACASINO",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/VIA003.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-002",
    platFormCode: "VIACASINO",
  },
  {
    name: "Classic Baccarat",
    img: "/assets/Casino/VIA002.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    platFormCode: "VIACASINO",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-001",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/VIA001.webp",
    vendor: "/assets/Platform/VIA-COLOR.webp",
    platForm: "VIACASINO",
    type: "LIVE",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-001",
    platFormCode: "VIACASINO",
  },
];

export const Fishing = [
  {
    name: "Fishing 2",
    img: "/assets/Old/YL-FISH-001.png",
    platForm: "YL",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YL-FISH-001",
    platFormCode: "YL",
  },
  {
    name: "Heroes of the Deep Sea",
    img: "/assets/Old/YL-FISH-005.png",
    platForm: "YL",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YL-FISH-005",
    platFormCode: "YL",
  },
  {
    name: "Jackpot Fishery",
    img: "/assets/Old/YL-FISH-004.png",
    platForm: "YL",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YL-FISH-004",
    platFormCode: "YL",
  },
  {
    name: "New Fishing Season",
    img: "/assets/Old/YL-FISH-003.png",
    platForm: "YL",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YL-FISH-003",
    platFormCode: "YL",
  },
  {
    name: "Shark Hunter",
    img: "/assets/Old/YL-FISH-002.png",
    platForm: "YL",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YL-FISH-002",
    platFormCode: "YL",
  },
  {
    name: "Aladdin Adventure",
    img: "/assets/Fishing/ACEWIN-FISH-003.Aladdin Adventure.webp?v=1764855214634",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-003",
    platFormCode: "ACEWIN",
  },
  {
    name: "Circus",
    img: "/assets/Fishing/ACEWIN-FISH-002.Circus.webp?v=1764855285805",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-002",
    platFormCode: "ACEWIN",
  },
  {
    name: "Circus Jackpot",
    img: "/assets/Fishing/JILI-FISH-015.webp?v=1765360805430",
    platForm: "JILI",
    type: "FISHING",
    gameType: "FH",
    casinoType: "JILI-FISH-015",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter",
    img: "/assets/Fishing/JILI-SLOT-045.webp?v=1751418030805",
    platForm: "JILI",
    type: "FISHING",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter 2",
    img: "/assets/Fishing/JILI-SLOT-099.webp?v=1751418030805",
    platForm: "JILI",
    type: "FISHING",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-099",
    platFormCode: "JILI",
  },
  {
    name: "ICE & FIRE",
    img: "/assets/Fishing/ACEWIN-FISH-009.Ice and Fire.webp?v=1764855312781",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-009",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jackypot Frenzy",
    img: "/assets/Fishing/ACEWIN-FISH-007.Jackpot Frenzy.webp?v=1764855332532",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-007",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lucky Buddha",
    img: "/assets/Fishing/ACEWIN-FISH-004.Lucky Buddha.webp?v=1764855353280",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-004",
    platFormCode: "ACEWIN",
  },
  {
    name: "Money Tree",
    img: "/assets/Fishing/ACEWIN-FISH-005.Money Tree.webp?v=1764855593811",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-005",
    platFormCode: "ACEWIN",
  },
  {
    name: "Mr Fortune",
    img: "/assets/Fishing/ACEWIN-FISH-006.Mister Fortune.webp?v=1764855563782",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-006",
    platFormCode: "ACEWIN",
  },
  {
    name: "Ocean Pioneers",
    img: "/assets/Fishing/ACEWIN-FISH-008.Ocean Pioneers.webp?v=1764855526874",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-008",
    platFormCode: "ACEWIN",
  },
  {
    name: "OceanPhoenix",
    img: "/assets/Fishing/YesBingo-FH-001.Ocean Phonix.webp?v=1765098731730",
    platForm: "YESBINGO",
    type: "FISHING",
    gameType: "FH",
    casinoType: "YesBingo-FH-001",
    platFormCode: "YESBINGO",
  },
  {
    name: "SuperStar",
    img: "/assets/Fishing/ACEWIN-FISH-001.Super Star.webp?v=1764855546330",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-001",
    platFormCode: "ACEWIN",
  },
  {
    name: "ZombieAwaken",
    img: "/assets/Fishing/ACEWIN-FISH-010.Zombie Awaken.webp?v=1764855561553",
    platForm: "ACEWIN",
    type: "FISHING",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-010",
    platFormCode: "ACEWIN",
  },
  {
    name: "Ocean Carnival",
    img: "/assets/Fishing/FastSpin-FISH-002.ocean-carnival.webp?v=1765112789238",
    platForm: "FASTSPIN",
    type: "FISHING",
    gameType: "FH",
    casinoType: "FastSpin-FISH-002",
    platFormCode: "FASTSPIN",
  },
  {
    name: "Fishdom",
    img: "/assets/Fishing/2J-FISH-002.FISHDOM.webp?v=1763542203455",
    platForm: "JJ",
    type: "FISHING",
    platFormCode: "JJ",
    casinoType: "2J-FISH-002",
    gameType: "FISH",
  },
  {
    name: "Fishing",
    img: "/assets/Fishing/2J-FISH-001.FISHING.webp?v=1763542163535",
    platForm: "JJ",
    type: "FISHING",
    platFormCode: "JJ",
    casinoType: "2J-FISH-001",
    gameType: "FISH",
  },
  {
    name: "FORTUNE ZOMBIE",
    img: "/assets/Casino/JL0231.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-014",
  },
  {
    name: "Fortune King Jackpot",
    img: "/assets/Casino/JL0183.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-013",
  },
  {
    name: "Ocean King Jackpot",
    img: "/assets/Casino/JL0136.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-012",
  },
  {
    name: "Dinosaur Tycoon II",
    img: "/assets/Casino/JL0111.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-011",
  },
  {
    name: "All-Star Fishing",
    img: "/assets/Casino/JL0050.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-009",
  },
  {
    name: "Happy Fishing",
    img: "/assets/Casino/JL0009.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-005",
  },
  {
    name: "Boom Legend",
    img: "/assets/Casino/JL0008.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-008",
  },
  {
    name: "Mega Fishing",
    img: "/assets/Casino/JL0007.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-007",
  },
  {
    name: "Dragon Fortune",
    img: "/assets/Casino/JL0006.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-006",
  },
  {
    name: "Jackpot Fishing",
    img: "/assets/Casino/JL0005.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-003",
  },
  {
    name: "Dinosaur Tycoon",
    img: "/assets/Casino/JL0004.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-004",
  },
  {
    name: "Bombing Fishing",
    img: "/assets/Casino/JL0003.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-002",
  },
  {
    name: "Royal Fishing",
    img: "/assets/Casino/JL0002.webp",
    vendor: "/assets/Platform/JL-COLOR.webp",
    platForm: "JILI",
    type: "FISHING",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-001",
  },
  {
    name: "Gods Grant Fortune",
    img: "/assets/Casino/FC0053.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-006",
  },
  {
    name: "Star Hunter",
    img: "/assets/Casino/FC0027.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-005",
  },
  {
    name: "Fa Chai Fishing",
    img: "/assets/Casino/FC0021.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "EGAME",
    casinoType: "FC-EGAME-002",
  },
  {
    name: "Fierce Fishing",
    img: "/assets/Casino/FC0020.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-004",
  },
  {
    name: "Bao Chuan Fishing",
    img: "/assets/Casino/FC0019.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-002",
  },
  {
    name: "Monkey King Fishing",
    img: "/assets/Casino/FC0018.webp",
    vendor: "/assets/Platform/FC-COLOR.webp",
    platForm: "FC",
    type: "FISHING",
    platFormCode: "FC",
    gameType: "FH",
    casinoType: "FC-FISH-001",
  },
  {
    name: "Fishing Legend",
    img: "/assets/Casino/SG0179.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "FISHING",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-005",
  },
  {
    name: "Fishing War",
    img: "/assets/Casino/SG0131.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "FISHING",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-002",
  },
  {
    name: "Fishing God",
    img: "/assets/Casino/SG0130.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "FISHING",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-001",
  },
  {
    name: "Alien Hunter",
    img: "/assets/Casino/SG0129.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "FISHING",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-003",
  },
  {
    name: "Zombie Party",
    img: "/assets/Casino/SG0128.webp",
    vendor: "/assets/Platform/SG-COLOR.webp",
    platForm: "SPADE",
    type: "FISHING",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-004",
  },
  // {
  //   name: "Bird's Paradise - Flying Tiger",
  //   img: "/assets/Casino/BT0099.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Seafood Paradise 3",
  //   img: "/assets/Casino/BT0090.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "SeaFood Paradise2",
  //   img: "/assets/Casino/BT0070.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Bird's Paradise",
  //   img: "/assets/Casino/BT0069.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Shark Dance",
  //   img: "/assets/Casino/BT0068.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Space War",
  //   img: "/assets/Casino/BT0067.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Insect Doctor",
  //   img: "/assets/Casino/BT0066.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Phoenix World",
  //   img: "/assets/Casino/BT0065.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Seafood Paradise Iv Plus+2",
  //   img: "/assets/Casino/BT0064.webp",
  //   vendor: "/assets/Platform/BT-COLOR.webp",
  //   platForm: "BTG",
  //   type: "FISHING",
  // },
  // {
  //   name: "Insect Paradise",
  //   img: "/assets/Casino/JK0109.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fishermans Wharf",
  //   img: "/assets/Casino/JK0082.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunting: Yao Qian Shu",
  //   img: "/assets/Casino/JK0078.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunting: Li Kui Pi Yu",
  //   img: "/assets/Casino/JK0077.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunting: Happy Fish 5",
  //   img: "/assets/Casino/JK0076.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunting: Golden Toad",
  //   img: "/assets/Casino/JK0075.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunting: Da Sheng Nao Hai",
  //   img: "/assets/Casino/JK0074.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter Spongebob",
  //   img: "/assets/Casino/JK0072.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter Monster Awaken",
  //   img: "/assets/Casino/JK0071.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter Haiba",
  //   img: "/assets/Casino/JK0070.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter 2 Ex - Pro",
  //   img: "/assets/Casino/JK0069.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter 2 Ex - Novice",
  //   img: "/assets/Casino/JK0068.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter 2 Ex - Newbie",
  //   img: "/assets/Casino/JK0067.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Fish Hunter 2 Ex - My Club",
  //   img: "/assets/Casino/JK0066.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  // {
  //   name: "Bird Paradise",
  //   img: "/assets/Casino/JK0019.webp",
  //   vendor: "/assets/Platform/JK-COLOR.webp",
  //   platForm: "JOKER",
  //   type: "FISHING",
  // },
  {
    name: "Dragon of Demons",
    img: "/assets/Casino/JDB234.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-017",
  },
  {
    name: "Fighter Fire",
    img: "/assets/Casino/JDB213.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-014",
  },
  {
    name: "Spirit Tide Legend",
    img: "/assets/Casino/JDB206.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-013",
  },
  {
    name: "Fishing Disco",
    img: "/assets/Casino/JDB154.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-012",
  },
  {
    name: "Dragon Master",
    img: "/assets/Casino/JDB152.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-011",
  },
  {
    name: "Fishing Yi Lu Fa",
    img: "/assets/Casino/JDB141.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-010",
  },
  {
    name: "Shade Dragons Fishing",
    img: "/assets/Casino/JDB083.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-009",
  },
  {
    name: "Cai Shen Fishing",
    img: "/assets/Casino/JDB082.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-008",
  },
  {
    name: "Dragon Fishing II",
    img: "/assets/Casino/JDB081.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-015",
  },
  {
    name: "Dragon Fishing",
    img: "/assets/Casino/JDB080.webp",
    vendor: "/assets/Platform/JDB-COLOR.webp",
    platForm: "JDB",
    type: "FISHING",
    platFormCode: "JDB",
    gameType: "FH",
    casinoType: "JDB-FISH-016",
  },
  {
    name: "Fishing Treasure",
    img: "/assets/Casino/FS0045.webp",
    vendor: "/assets/Platform/FS-COLOR.webp",
    platForm: "FASTSPIN",
    type: "FISHING",
    platFormCode: "FASTSPIN",
    gameType: "FH",
    casinoType: "FastSpin-FISH-001",
  },
];

export const HomeIconList = [
  {
    title: "Hot Games",
    titleBn: "হট গেম",
    key: "hot",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon HOT  icon_HOT"
      />
    ),
  },
  {
    title: "JILI Slots",
    titleBn: "জিলি স্লট",
    key: "jili",
    image: (
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAABvCAMAAAC0L45VAAADAFBMVEUAAABPBgAiBABYAQDe2wBdAgA5IABYQAByOQBgAgCglQJJBAArBQBeCgBgEABfDABjDABnDgBjGADj2ltoJABnCwA+AgDDti5ZAwBeBgBgCABkHABdDwCnmwJPBADi2U3AlABZAwCsmADhyi9ZAwBaBADj0TzDtSmKXBBaAwBbBADDshWnlgFbAQBeEwBdBQDKpQLXxSJ2PwGJYgLDtCGIWQDZxktyNQCKYAC7mwd5OwBrLQGdcQh4QACliwt5QgOVbg2vlgGVcAFuLwGziAC3oSGTcACKZgC6oCmOXwGQWwmlgALqoABaBQBhHgDqogbonQDqpA73rgGLVwDooQPPmwDnog3xogBcDAB7RQH//6nspxVlJQDeoRNfFgDOtV3prwP//6L++HH//pWUagSfdAD//7b//3TKtmTnphX//73+/ZvjohDypwKFUwLNsVLdsD+8oz7knwH//8R3QQHVs1HZski3mzOzlS7Ynxjtqhz//6/lrS33sgFZFwDhrzj64Hv9+HjnqB7XnQDorCXKmyDdnwm6lynjqgPBmCbQnR3xswXDqEPUlgD//oXq0m/HsVzawg3hngGabgC/ni3guwrxrgP//8rJrUrhqSb+9WPNqkDgrDDGnSX+/X/vqAvktAXm0X702XLWrD7aqjOgfAOyggDu2H3axXL/5FvErVPcpB3//9zjymj+823Rvm3GsCnZsSPUoiHiphnOoie9jAD//9P+7F7UuFfSsEfeui2regBuMgD89Izx3IbZpSj//oz+/GvAqEvQsCj775jTpzL2sA2MXAFrKgD/64S8ozbJojDIsxHCnALfy3r7uQHdpQH+2lDJqjnVuxj/7nfXwGLew12sjy7rsRPLnAD6323/7WbKvTTguBXApgXMkQCTYQD21UT/9aP+41LNv0nr4TvYrQeATQLsyzjrvjf55JH8+lrApiSxmCOtjgX/5mrisBzp5Wb90EvUuTvDoTfj1R708XfPtlD1x0HruAns5FLNux/aygiymBPq02D27lATvcR5AAAATHRSTlMADBbsDJ0IBP05Wh8QUNFppXTd++aVU8D3qc/ct1Us+/7gJP3Vwf3A/pRevz169Yn9/K50wD/9iCn+VdLw547LwahT8+auppPj2+7O9YslUAAAFeFJREFUeNrswYEAAAAAgKD9qRepAgAAmP05RgEYhKEASiEoeIFMLl0ytJstdHIo5P5XaoK0KCiCW8G35vv5TtP0W9YYA1VyyFPQStl+mZK2mn73OAvr7huc9/sKKaYpV6epd4S2uRbJFWv7b7Qbhj+os+/IW+ZISCAScbx1+nIGRsIWDiekthAZC/RCOrTtsrUFcv6iDyflE9I2FMfxTtFVdKsuCOpKQ6kWFVapstpVwY4d1m3UcxylYNqRg+AYOPQ23l3ekF1GlNx6yKXYU0AUEnpQhpd2hR4qA6lSxVlpQ2rpFPZ7acOqsEs/tNA/j/e+n9/v/dJIYAR6CXu3bOed8gfcbrfDAW8dpw5NoCiK9gT8017TQ99k4ISm/osnMOkjF8877V/3UHegDchHZ8A/dd/Pa/EHPHTTSqeOQweiHb57/byzRb3uvrlbDZxgtzPCMZDK5/OSJPE8ixAbp7JPLZ026wIdV5CAWB3UjCBjhKi31q5OU0/fzGoJISwLqL4yrsPXQSzP19bm+rymZnp8M7Nkb/IvD8eKIhyfIjkgjtO549B+vemHkrRCp29k2X2qqp/VHcI5UK2Wy6lUShRBEGGMK+tmq80yEFUwpGYVNs4aIIADcCQSqWQHJrpNXdaVaxm+Yfi1IZcjSKIEZPaQwJ0sWH0PmiPYel+txbGAES/lRADOLpfL1Wr1/BwSqZuq9jP62NLTkl7btL3w51S9/qgmE4nE1tbWl4ZgWRdEkYhcWjUPj48FR2tyZAkrPB+vYzhyCicvvl/6OsuM2Ezj9pVPlcXFRcwpIKe7XV2JDUBPxpX0wpOJtuYIj4YPsiWoEJIabgC4EblEIrn5XdUO911jba3dzQ7XbmxDczrVdDIBQAON/uXFHAv9on6MhuzPBpndrKciywKnKIYXvAgCaO9RWXPY3mWytIdG10t7S9A+QxCQdLlcBgls7Sh64OrobkoAJZkvrFEVjNmclM/rfkbrEsm06tAOv5ldvd2t6fW7wrvRF4ealkwnQZBc0LOz6nEZ5i8HcejtWCEUto+PMbDs0gMhiCD3DwHqDiWI7oaZIZvJYmdChdgRhSOkEAQekAjxDHvh3C4uH4Tbx+51j5lf+fCbjguZnEj89Kmr38z0jnZT3D8Iu/pb615Pnz0IyZeLNxvbaVX3I48Y8niBanO120KICQ6M2CwMw4TNMYeCZcw128lgRxfN4SCjz95IMMiEli9LWJ8/w4+H1mVyF+7YCuzGDFnuzt7gAMPM/6W9/l6aCsM4gFPRDzH7RcUyMUYmFVh4I/RHrJtudIRjrVZs4DhM22AQ80qE4QwXG4oDT8jmaGkQeQadMXVRm8uLuU0Y0oVlF242omygpn3f90wzd3Rl23PhjWfnnM95nvd5n7fpy/xYO3wbvIt03U0srQ6+bmyU1ZzE2ttLlJ2TyPBKR24sfU5H+9BgwCO6oUws05uafXuzUSaT1u2rrsJVza3p9ftOvLjT6exCOLsCWi2W02xLM/5bQzpnnRQ3e3e3Ae1UqXI67yNIjcZisdHU+pfXjbjuwPXqw3984auV+M3NltlUL54JH3i14H375EtPL9HfSM6V7XFnP1RRdUCCuw+uTr9PR32+bw2JxNraWjJpzgyBhxeXSK+UkxKSSBqPLC6PwafUapUkyN+A0/kj3IQM19SRnJRfkUoab1/+hI6Ky1QkAoEuno+NfkzN99zEddKD2191f12NRNbcNJJKfcyYzckky66tJRoaON/EjenVwdsyyYGqq7j3Hn1l1ysPyJoHVyM30iN9WS7u9VqtLGtOZj4S3jXpueO07quvVF57vbiMekSjNKk1Go3aJJcjk+C1ymquI3f0XY9XScHDDhDQ4jqTSQ4lH3pOeHebJdKqk+V5idhXcbDmGuUNJc0Il8vqTXC+6AjlSS6drMa99+wrL7ta+Yjy0lEdF4fO5WLZpJC9U3XVQtkfLq84dmTxK+klSuj0ej18StRmADxp3dFDG+9adv305U8oXpUWX0GtJj4+hFVFeFUV1fuhy/NVHz8FXu9QhvD8hBcHL/0zAt6liqP4yf/E/nOP7j2O/OwIW8BzWwcoL5lpH5ttOX9188tVE15XIAAedNRHUqMCr/Ls1m4FHq9SIXnQER/hZTJj4J05tNMSOQ/e82QyCZ3fT3hZR9S2GHk8eBt7wn/GvhOEt0h4irh7CjwXeEnnHWTvd5srI7yACllR6/V2hB48BM/k87DwkDwNCVykIrw7hHd4F95YDOtO4A2AZwnbZkaKwyPZG5kxGhjPJo9NmnkRnkqrJcmzv3r1ym7XmOCTi/G05B+bJQye2dy+c/aw+k6BF2JZVtBNueM6S9hQAt4weILPzLeL8NAv1UT3DD6kTy43BcV4gAslTNKnDYUK8loFnmuTxxiMReUZwRvvBm8qxwuJZE+rRG2C9+wZfJSnFuXhP0geClhPeegYsULZ6zVb0dXgGwBP4WGMpeA9ENKHJ7Eh8eIEDzri02tMhXj2HI9lC/BaN3gu6KaGS8mDj/LGxHkae45n35ln2soL/hUvZcaWO4BA8oa7xxlDSXjUN2XFo8y9/8/TI8PKoJm1WjMFeJEUm6C+KegeCLyJovLCFk830jfsdru9CDFegO4L/8DTaExzlJcsxFu3JuCbgg48D3gdxeRNGDsEnuDDo1hRnkoJHnwCb8fOqQQvt/fPLZhRDIV5a1wi7kaQ5JWG5wCP+OLxeCLBjq7k8bp4DC16+x+8sDjPpIGPJm+B9WJQX9q9c0bWvRwXjw8jHuR4xmLyOghPpwAPEcejrOt5vGUnz2tNmq0bg4kPi2/rdO4myQv6UXaFefMJR5ZTEFyJeDbCI77ubkU2y3nzeD+X20MhFd34EMJUJhfjqeR05NSo1SR5LhwAuAsFedw4/boCz/LdVhqegtzd43DoEsv5vJg5xCtJ0xCGMiVCjMcrVRjeTEQ3t+Af8HJZXUNBXpaxjHvo6lCUkIdAbVgs49z8Ssv5bTwcOEPonZsjNUZQ0RODFi0IhSufo8nD/G8B7+auvFoHwzDwQafQOQivo6i8TlvUodPleHhUtjaynTefxG4fVJKuQXc0KLQivFmnCmt0jkQQycP4zzCzqz278j5ctBgNlKfI8TqLzuvb5BkMBkc+r3YNu/3CXO64jpMcz6t+pPN57XwoxAcRC9C54w7GYBgpxKsPz1Ce4jfvRdF4T150CjyO3B084wxzMXJrG+/ihQR8QfjoOTwYgkKMdyeEIl5A+KEb7rYYjMaCvGnDVl4f5T0pEq+H8Cajfb62No5+vDAeVv8hj9fAcV6XfyEoFB49CYyK8DAe42yDyM2P/8Aj5cOBN9lPePeKz+N0Od7Kdt6X+m8OXdw7AB8tPDpsLefx3taPWun4KMyPHoH3uCAPaw/Njegor78U2UMIPCN4Ldt4KyMMo4u7B/x+UncuK5lGRHgrywlhwCIjSDflGQrzbAJPx3FtOh/hdRY1e/2Tk+CRILwOo206jxdJkyO9cCYkZ2qyn9V+aMrj1WYdW7fosIE0+bsFebbv4LUhfKXgvQTvIb17X9Rm24FnNIx7MJaSUHjQ8KP1+bxIPWNgNrfojT2s5x94fUXn9fe/fPP06UP4BF6HOE84NglpQb+fCU/fyOf9YtVeQpsIwjiA+4imvkVUfBODgkp9kFKq1vosihryWNeNoa7soR4CiYalqBGj0Ni4TfSSaDBoSKC1l5xsmoNU8GQrSEnwYnpQc0ovIh68FC/+Z3a76TarNtW/UJB8mXy/nZlN0s5PzV2Q8Hr/zsMr/nj29BXl9YHX8195PT0yDyG8Xn3egwe4wrRveU99fKzD+/zz5i3w6JsoNvKH9497e1/+dXGmHjx+/4xujxuv+t4O9fT0fv9/vO+E91blvU89SOnwhnp7wVP6pp8Lv+rwDtCZeHgdCw0h+wi8J3/hfcIrEh7tgPJ65s4zkujw/HTwvrfoKPVpbCavMqTcX3F3U956h8BbqctDmbrQUqm/8cY+pXrB66O8vn/i4SyLubGx0Ww2zOD19/n9/ht+Mnqqd0iHN5hKUV51VvR5tFV0Wp2Jv/OG8Bxle/jxnEhkTjzgDm49egI5urQRQJUXGXzT3+8n6etHR/q8aTuUzgqqdHh0JrDSNTMxe57f3/92cI48o3np6faxAySHzh/FmR+FF6G8e4TXT3g9gzW8gUpW5vmVK0yrTDq8SM8Q6vyI0mpEl2c0anjy2HIHc+QZG88cOZCRioiUqbQfbzKTP6GUFd7ze/Dd6+9/MxjR50WqcyxXZXV5gz1q2T2UDeryjGZsD5WH50SwPfxTY8+JZ2y2XK1kQo9oQlLGdLbFTHkl0vhz8JDntKOsDi9HedWqQESHd+HAp4BahjoMFgjU8gxNp0+cONM8nTdIeeoFrpu3uNnSWZkMfVHyCL5zLQdbKC+QfZOkPpxvQeP6vACtukerkm8CgUAuo8MrZSMBOhiCwbKoK83kmS1nTZXKsOXk4iqP7g7oZF6kVCcPczdKdI+UEF++rcmyr5wpofFsErI7d+48T2azaHyylufhA9lk8g5NUq4q1fLGSyjLokypo7yMhmc0tNjyghQNXdiyROY9yWJBv+mfmnFcukgpUx/P3NKWnyzKOnV9Xm1dua9T4SWnGuJ5PZ7k4flcLnmfVt1P5nie95TyOjxvgEeZykOdhoes2FzOSI/w6mtblpM/X45NkhnH9lBWRrZ+3vw9x+IVSWbRf0gxM+a+cjcOHp/NgUf7Jo2HPTq8Di+f6+6+L6c7x3v5Dl2eh/fmUCYnlwNvRMub3/LONBkGb/jUom3GKV4WvOfQzY13cLc7nyk+Ck1PWKqM2sAbQQvoXOk75wUvWstLe71ej1x1u7vbg/+lo/muGl7UqZZhtG6M5p3Ba7a4K0I4JGSGG7YsMWJxmiZzAbLwn2sWdD28xYe3XBvPhGVeGKE/JCn+7m6nwqMtoW80Hnbq8Tivx3NbicfD/YlH6+7fvk1H844IGt7htvikFJvB46fv6wBfJ2/5qtbyRSEs2/gA1h+JV7oKngCeN+fpluPhOC6Wjpom1tTyOE+HwutA2e94ahlCeJyWZ2jpMhXEWCih8DaD5wmQfU13LHZHlq+Xt2D/2nilRE08ovA4hedFPPChbUwLy8Z8ejwn5/R0dMi6Dieugj4vDR7KqldBy8PavFAJxmIxmTdP5vHgdavbGryRunjLFp0Cj6/iYogoFeOXZR6HljwdiMcJnuhD42v2LK7hOVGh8JxOLp3Q5XGcWgYeouEtXtU2HLXHxFhCUGcv2oH1I28P/JgLb/W7zlDJq8wecCSsELpgIzwOQUsk0IHHRAcaVurzlLI/8ZyaOs6p4R20jBaDDlHLc/J0+dDkvF60WCdv4+XyuCCGgAp7vSKZOlH0CfmuK4THgif37rSzVqvVwQjDrzetN2p4CXu1b7SNSl8i79bhsfZqWQ1vflPbQMElOlhxOi8d5sCjPuxWJFzv7O27ZhLYGI0ox54oli9fAo9hWcpD7HYrSRCP7Fwxk0f6dqq63/ASPtZOfPo8Y/OxqwLjcGCFjEzj+WIcfEqgE2NBoa5by7p9XcNSGjQ1VkYawGFTWxw8NE6DuUMcrsL4xL6NS7Q8nx1tq6E8vcXJUJ4m4N3dTXnGg2fKoYJVtGIHTPHWdJmCPpFcYFnHIWKMEeL1vDHs3fFu9GLUKvNYUXS4oHPjsOnlFwqPsyNWymOiw6+nny1t3kF4VlbDszrAa2hdMZPn0pTJs1e+u5sMZsA3sotBnwOvwXLgvSZ3zh1uhaemft78PTuvNAxEmZjooDxc+eKw+8qlDfsa8lEf4VGcrLMWQqO27dNO2Dfu6CKzpwnZe1GTu/Wwhle+SHjagDdqw5E5A75MU53DihKZ1zxvxZqJ8aBLtHNYDnLAY2NM9Opry6x5RhwtvjyKdRFzkFh9woF4A3Q7W3eNB61WapODR8l989Km6tYznmwdHRdc1RrEjm5cTKiz9aTmU/sLXAUOddWAwhDeAvPSo+cHilRnR1iG8gyH2zqLjJ3lsC9IFCF5a5qwHDTO/n194ZXXLyaDWJaIK3HghfvdlQ07LMe+CT6HqkPwYOHiBduG1dvUmceSMklpO0sa0AB9wtiR042GqS/gTcdf4M6iwdEwQtl27MyJdlM4wbhwV6Gv5qC8w42nj4zhbkRxKg8+NiF9O9tkNhhne3J65wZbV77AOEQ6e9LYVfflNVuOtQuMFgedFH99afvUCXSjoelse1FI2+UOtL50opjH7zRID4tPnm4flxLpWh14nbZTR0JCwuezW1laIPMaWi3nTXhOzdAA2hNCqP00GXtWWbZ34SXbhKlQAAF7m+y9tpWt54qFNMuqOMRXyLzADRX3NPWNKi/odECbgC/xpW31AvpZ60gomiZ1uryGgYQPj1JblXfq3JeoZmwHDR3bmY4Wh4+1LJjtwfDVOKk+kRcKjIuMwAS/XFt7Kh4dUQensxoMhn61b8a8bQJhGLZBtrEwddyhslNkGQkGLFkeK3Xt2tAU5PiQEGIII5684iVLJNTJEms2/gGTmWs2vGaCjb/RD9QmoT1QHSnbPYOH+97v5e6AM8trMwoSnj44P3/ceOo3+Ja5xgCvjGvtaa7dYj99CV3/5gYjg3+gW0MP/QeoPtuUy9seLPU73hvO0gf3h8ZDvOy/GHDSFVL0w53nqs7669pJj0ZkWz/h5l2XwJDq3odZBEeOzP45Vpa7zE0cYI3BeXAS97CbsC3u3TZN3DVO5yRepuizRAX1i2riwfICP3GgCWu9VpO77P2i+fZVUxHIjLJgdQ8rVF04QCLbU8vnBewcVfVPM3gjIcDQeTpXKB7lqecCKgYYBhtThAyREB1OLlbnJtZmx4RJUq0mlh3H2cpzwaXG2gr0MnbUTDX1YTDHQ7g6+VaYm/HeS1QfzHzft06PwT6PTVSJfrA8MrQgfVzVkAbHGJURKVO3wxSreQyYXZzN/h4ONaXYbOipYXbIjTMiUrA+qcjVKJF+tIMgi5Cipfcn4G6VhsFe28Ym1Gn5RVqk3Sk2JN9oeDY5YyDET1sfRGTGW7wuZxQo6pXaUdvA1ZBpbOu99UhB9LLh4cSlPsawQFOJmahwj7W9bdv722yjM7FSBn2kRSXpM6QLvanUYCJoGVFF3OkKIbNGg1DhgRmFnnrrXZHROitl050OJyINqwDr8leJoyiKY6OcJ4R2JJmrpkVYGeSN0B3Yj+5cGjdo8LWx0Oxd5JPY1lm0+6OOJNDjorn4RSWlFy1K8hymWqUvSyJdD/SULdRwcinUingJMyrwy0ZvQeQX4H0evfaUW1xIoiBIE0kYlwsb04IgSp1Fn+r9a0dxC7lTh7zg2N7vfZsva3QXw/4cU1pyFNvkvRzCfF6TjRpAOGo04qZwZy4Bib9YjuZ9qt2rkVP1DLrP+1anA+MutrXZewDzeS3tAbj3qGkJyxbXIhAIBAKBQCAQCAQCgfBm/AJaB2BVN68ZPAAAAABJRU5ErkJggg=="
        alt
        className="category-icon JLSLOT icon_JLSLOT"
      />
    ),
  },
  {
    title: "PG Slots",
    titleBn: "পিজি স্লট",
    key: "pg",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon PGSLOT icon_PGSLOT"
      />
    ),
  },
  {
    title: "Slots",
    titleBn: "স্লট",
    key: "slots",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon RNG icon_RNG"
      />
    ),
  },
  {
    title: "Live",
    titleBn: "লাইভ",
    key: "live",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon LIVE icon_LIVE"
      />
    ),
  },
  {
    title: "Fish",
    titleBn: "মাছ",
    key: "fish",
    image: (
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACHCAMAAAAWa0bmAAADAFBMVEUAAAB7a1K1qoyCclWrpovhv4mnw//3rxOpR0KYqqG2iWJTo+toHRrb6/7BbS3X2dfGq3Lf4cTy2KY+c33I2/5FkbD410bo1KBKGRj+8nXtoi3+9EyTdFLm5tE8jcO1HB2su8N+QiV1aVdOu/RRgozwQzn11H7IVk5ywNhkpcTowWaHvO2JQ0PPMCBNr9CjyeS6jFH6/vnUZ0r399XznFQ2pMvm1Sn98FNTk6X99JN5qbhSV0/9+MvW5fvoeG7Rq1Ddjjr5aWO4Tj/dp0mdemjkiWb8+u/h49rm2Fnyl5mWvvdRb3V6lo6VakvjtI/44L9OLC66uazN1+j36tLm4tj04sL25sr8+u/Mvq3+//367tiGYUfu6dzVyLfk3dDg18nNvKT27uZcCATJt6oskO3o2cHVv6KnjXng0LrVwayRCwrYzL/w3LuXdF5DBALRw7LHt5+9qJq+pI/n0LFPBAHc1MSYe2f89eGggW7eyrCDCQfs3siWa1FAiv63nYqLaFJzTThoQjFgjP8riPgckuN/WUAyBAMLc/wGjuIPgtzdxqXGr6G1mIA0k/zRtZa/oYGif2OEqf9Qhf8Jj88Ffp1Em/0jnPkqg+Hw485zn/5Ae/7CERGqCwnq2LYJhqtpmP9XlP8HgsCrkYGXtv8sev6zzvsKfczGqIt8IBZwCwMkaf/62CELoOQHk7sJbqATf+yEcF4Mcrvnx53FsZG0npezkXUMoc0PWXWojG3+8RkWgf0Mj/ngqhPZEhHgigkSc+Afgc7DqpcDYYnRr4J0WEvCZxQrg5qsnICABVPm9/UHc5HDm3CqelqZLywJs+PxwDmBDjirUhCFLAsYAgMYb4Cchnb2IyP3xhMFnfcjhLaaQg8vqOUHasjMwLqicVkMrvO+jYK9c2rJjx0NVf95lZ6gkokfSk/L1tNodWm2vba0s6WvakeTuMuxq46Dg3lwo81cUUtoAzvAShqaqq+YXjpSPDn896Y5X2GUE1JlXmiXqV5nhzQaLDdw2jJglG8UlQCb70NKAAAAU3RSTlMAEB4uPf78/v5o/vz9+/l+WTv+/v37+Xj++/r8VlH9/IT+cv38/Pj31Mr+/f3977B8z7+B/Pv6yce5oUX91YH++PChybGtqJ+Z+d+mkMjFzK/LxYyAOM4AABbOSURBVGje7JVtbAtxHMevaxWpbd3oVTdWQ9cEpbba0oTSzjwlSOic45DORaIRLMKiVGQVHVJhcj3rXai0ldVNJiESfVAvjDRBQ5M+KBGypcZs0vFCPP6vIxESNjGvfN7cu/vc9/f/3u8P/ec///n7cCZoypVcDgf6Vwi1sWAwqFWv0PwbJ6cmRlE0FaQDZTHZv3ByyinaaDQZpXSHShaMaTU50PAChCaviaalFEAhA2g10LBSbvSCfBSdBThZaQ0PGj6EJm8r8BlZBpxUMBbTiodttDmlXqmCNppMWWXr3VFyuTwDlLKl+cNUoYUmBUVnfSZj6zucEAgEnrBeqyh9P2JlATQM5MxQUN8CjsXtZF9Pf//Oo+mw/v3nj3MN+X/8Wt5ooXCCkAv9zAS5dEBoKhUlQlNfbMJOY9i+7ukez6ePH08snfhHvvzZSOFSrUpVBKt/HpOG+hrwkt1/bs+OMGIwoAiK6vtaWjrf348t/YP+cBahuxSKmpoilUp+XSKGfkBHs/lMN3t9iXOXNqCowYB0vX17BU2XEA5BlywmHrpwRcNxGiyRJUwlLJEH4R9ScqXA573ZR/ish9YfQ1EEQ3uj0eg7FO2/QRA2QZd2yCE1hStpDRDnMVxdXCIL/vDNSlDT0h4XYfWl3twxoGEM2R09HO3c8HqjQYSb3W63YBZniL/3tIlyHVuQIoYLVcNiqbyiouD7BWds7Z3ucvqsid773Sga1qP12w9HP4w/fAXtP28xW9xu87J83lCk1WViBReUtTrCVEHc6opyhWR+2SJxwdd38OjXUyzusw6r/8nYN2kUCeuRx3VjotHDdZvRtWfsZoJwNDtbPPPyuYP+LRaoa+QgSjUTiRSLocnTVIFiRVCmUpWpK8RCHk/52t9ONpvN7f4nzx+mQUYMQ256Hz6oO4igG0TtNsJsdp5tOXmSP27xIBctL69ApxOrq5jKSoaRFAgDIzMdsRh7+WbudxSp5t9KhMizZqsFb3py7+aBMAuC7S99sH4jGj6eNTpZo8vF549bNXEww52Ql6PLK4sw8UglA6srqpiRUiprZBeb11t3rknQ6LBZ2qd4Um0Xe7vD4dxczIBs2o3p03u7kvavRqDkAzzzJnEGkVGs61iiDDBwJSOZyFEG4lQwGxEsGkBd0kw0OwkyJMid0nTv6tTu3Y/Tm3anN27aeqy+V5QCQodzQHnS5fHwXZ55vN+eY96Ip5kl0OQAzDBqDqQLjATGIBUMDgjHOh0hApwiLkilniSazp2ZeuJ2/Yv6+gNdnaJTbfZvRqBkRztunOekZ/HvYpbPV9FwDjQ5AhcLIe4zJkMBpEEKGL1jSiwWB0m4L9hT5JG2VN/06X0lyWRSJCpJnmprOmS3ZYvDKrNOMFqPx8Wf95sLZfIz2LigigOVw2oIWh4fSWeNFA0O8R1pDZFOkiRImz10RLCjtqFhXW1PT+ectrZEInEIxy02giCczc2NwNfCSlkn35P7650Adk2eCa7iKONKqIZhMsBI07Sx9eHLEn/IYrlhw0M2HMfJvq21DQiCNKxbU7hr7auZcxIJu90CcLAhGxsbQUww2GxpXfzZOb9sa9G1+0ZYAscrq67FM6zNKB2VF4FfJa03cNsj3BYi8faQYMe21QYAYsCw07W12wq7Z/r9OO7zWQjC3AxoBAzEZMn9ZYGERcWZBx3XA4HrHawts2CaRFLMTLWeP0LesDwibTh5qJ28vEvPghkaDBj7xGoLt/TY/X6/3e77woj9BzVZx3EApxI3cmIaFT+MNDtL4rKuy+6KO/urn9dd3YBnz9jvMbb1yNgeNzZcDQUczREKIj9250qEMQZDYGs63A2Qn5oDNvRIfiRDPAUhI4XMuq7P80Badwh9ODj+4V73/nw/z+f5sqoqE6DfESgRkzBzqlciYbfF9HeR5Y2Oe/btDz/c/PgHLxkMbW3HmnLL2lINhlNls6EYh8PlcjksPp8FJAdQevKNmXVn8/NbWlqqcr8iqhhmiDTBjliRfGzz62/HvA3W609tfII49bDYUUOZoekYhGwbtVhaZ0MzMC5XJJJIRSwAOVwtkGDSE28wZraVtuQTbhW4JjIojG1ExHrYtCuiUP/8GvbK0SZDWWouHGCrIW901FLWkcaWcLnavVQrXk4HEcJywASUyaRHVM/cbskHlShbFaDfFleg6Nqd/3Ozh+3cMXL16zYAc8tSywyG1LZRQ6xDiqm45fSgcvCghMlkcbgqMBMXC/rMhKxTU7dTy8paWwm0ylZcvX5txfOrc0+EvbOtr76v72qeJfUb+AIx9k7s6KnJjjFMpWXuter1kXi5mhSBXMxJfPOZTDWTWb5nz/FNN16FmrltKz6Zs2WVtq7ZueNY6Y/1fS6Xqz7PkFeaCpV3anL7TGvs4fYxTKRlBpV6pTJTwlSztCAumaQLVQ7zy4dSM9VIwkJCdbHNtmFFL2yHKb8l9+xZV/fTZrsrL48UYUxvb5qyPPODgoFpWeU+vUwQ34jT1cxyESn+211qMckifESdMHNtywrelnVVcHs4Vpp38ybV3+3qq8/LAw9OMW/m+NSVnwt0PCxRXSiQyWjP9TRiTDVdK1KpVJhqqUgXzIdR1QiacPvR4pqPTbbioqJXt400+uNTnra7XEdBPNVqMFhieRjj8PeVOA9jIUGZUvZpyJrLPclESJFEhWFsDIqEIe9SUCAJEVFLtjwy4LfgVa+vHnF1Dnce7DTb7XYQR9pG2yyjk81jjEKdGGeo1HQfiLQXN2emHIK+aoHE2EsFKpl0CV3sLPLGxkeAO6tspqL16PptV37Z2tmZfemC2X7iKJBtTRbL6CyIjoJKBYOLNO9TKmXKWprsgFikhuERSbLYGUQ9QB90lyTRsEc8fx9fs+XkVKMR21wApmR/eanEfOKExQL5QGyblo4JFT0gJiLjMr1AUCtQRmoa2+mLJDuDQdSSSgZdIiHjG48tf4QAFpOg+Zf4gynZt26WlJScgGoatUDdkTKEQkVlpSKDxRx3NgqgZBrW9cYsNUKSUimDxxOS6L+CcggRXf75D/vOBgmLoKX2/db9+1O+TL8Eoh3Apsk7z1gmD40JGUKFWKzIUHMq+Wg8pFSyUX5muhYmo5wkQRT+14SUIL6xLLjBcM2Uk1MRcX6d+a/wDkdPY/zvADaYAbzT3CyfToOuLYpsNVdszJTJlEpBvFAzf7BAjSJqejmcJZByOY/3oLmQEkQWunHZlo7km0zf5pyMqGi6H7UQFRW10JF++lwDcZCTzQyGVJrBILqKg4gh3PQDkXqZTCaA+Ym8nFKAkGTS8SxClAuFgJImkNBV5INlp/QVi81UXFyxtshyPybGPeTxDLnrdp8+ZzabJ0NBgmZBRiGZUYVglxl8TuSgXgmX2K1js9k1QPL5dO0SuZgTUDZGvESXH5swV4vNBKdY1NoNntcf3uXze2JCL5U0dIeOTS2Ki5MjxiXImJOFjhH/b9TuE6Qk3nBm4wgKJjMZDvMhSYrly/YUaofBZjLlVBTljt53U3wDv1Kpvbfq3FGOcw2zaUI5gESXHojYdbZQDxHhUqlMR1FO536cjxI3Ldh4EPMByYZjRJff4e++dspmg1f2sa+73UMTt4K3BsI9brc7ZuHKZLPQaDQSIpsUe8RODME0BdBTvdVXC5tHiGXr96drRAhCmkmirDRAeUBmsLlaOMRla/OVfBu8sU1X7ffddSBtv9vl9gyHb1+YcjKmjQRJzEGGUGjUiXVjiDYYL1Pq9TSrDOZHDwOULhc3OpLVQJI5YWqlhIip1O+HLF9hlhYbkKVHzbvcFP+wJybeT7H2zl1EknHg2o1GBoBESKOzUsc4z3z5CIPrjNTrBwdhv4KYiSTOHnnSISJfxvTkJMLkSdkSPoDL14t9pfm2ltL6kgu76nxzcwE31RpN7e2dYy20KxSKdqOcwZZIMIJUFIwLWWqNAkXReRAhoADiNqIoNt+p0xw+tDcpIWnPnj2kmMEE8JHi2ZaWs/Wu0wG3Z+Bery/63pw1GD8X3x8jdJKiNEsiUknYIPaMt3MQhSLxvBFWAKwBAflQXr8eOfjJmqfONIpx3FHocDiI2WG+GbKCOFJd7bLb54fdE3O9A1TfgG/Yv3v7s5ShQieO40aeVCISkdva2CPWSRD29WnF3X0CgbUWRCilHg70s5CQLZ+PzQ8e+DKzB8flctbzISuILtf66hJztwDEAWq410uhDA3193u83jinswZEiKjVAimF0akUqvka8UXfC1aazwc9hZCLL5IXP/tsw2V9p6ZSp9MpFFoAVxDfir1iN9vna4fddRQKxdP/bH9c3ISXAvdynROvkadlibTJ5Lbm4d+LcQ46Tg3eLWQh41aaHkQgaTQBjO1gZLbTiM8COCvaGLKy+Bq8JroF+wK7hrzeruG7/f2UIe/wsLd/O4gOuRQilhNiBqO9QFwpVdNfDk4nIqixtnbxKIkfMrhPakJDO3DnLK4QrXJBDWso6W4w/wmfW3jqKNHDASvE8743MOfvjzuswx08IiKdDiRbKteJL+Na9KN4OQtBLsKag6fDaiVyyjrvZJ35bfIZZ6HRodoQsqoIPRVYAwGPu8sKuwSCBsJfnqP27waRaGpSMp1JvJHYPFysEfPUSHA88ca074sAlQb5AkDS4qKOb6r74+v8NqGUvQoIW677Usl8LfxdYMLtn+sN9westK3N1AFf3Kaaghq5dK8IIoKoJWanQKPRiRB6sHK6cR81Cx0X6PUwOLKtQ54u7/2nT3xT9Cr2/upX/hR9pDXgpwlqu9zw5PsoExPRUc7eewOhCYyCmrRDElIkF5hUfvjMEU07HU3MvhX8KQtFk3wHfobNo6dN7Kob2n2had3a4rWP/49P+GsDXX6/NZI2HBPshRUQPhFO7b13b6AZwQo60rKOa5MBhJCL03rkyJk0PppIpcoTz3OCVBZ6QE/TC6UTnujol0ZbTaaTq4vwj2rXr34/LdI6vGAEqbd3YID4nsMWOnDHQxHamsVr/7tZO41tMY7jAN5HO8fEWSIEcYUhcUbiDC/c5wu3xzFBS3jYuuRR0fXp1jZrt17bw7BkpTXm6Lp2s61MsJk2ujkiXcxVcw8hEkIkXvg+TzfnXFWNb5ZIvNgn3//z23P9H6Wctkg3bV++9h59Z1FC3/qly5mtK2u3naitr652utXJWfv6CH4jPUdd4MRrGzbC4rSrl1oHExefPlPxbFNSLjc4PIlrUQZKUrR92drly1fZ5UFq3UpcIJeuSaQfncg3ezkxFY+Lv2leO3JkyEDOet5+yukrb5cvvXJmSkVx+pciDmSFwUNRcvu6vXiJvO5e8NGdRMb+5GktbbfLpN49XMdJxO++X51y8+j941N6tEKuH+++cNHk+9Vmsyk9aQtEkKFpja+QGeQULbcnbkbNpRsyntlbD1I+oktK7NVit6YwL+sg3qj8ZogRre+fBNejx5n7sS/FTLD+hO8rEdOKvw+ZUipHS+mJdRsX4jJ8cXXRrPoSD0XX1zr1GtxNtFyO5/7fN7t1nIC9zLFuf2WAkT8ymBMTQuKnkpswOwapnKYt8keyjDubcf5bnFvsYapcsQNstzSFaQ8Otgtj62O8e5c/4KLtBnN+qGPTsqJkPEryJC2X2pW4gMp8tIvUkgqX85xGF67Yx+n3B0jqSxFk0+ygpMEulXOplUpr4XGpeufco/stsbnBEvZ2+gNaRtqsiNkBCROpldMUw/Dg4zL3ucOsDmKXX3VsZrKIrhBJ0vOViFMrfxKQJICEqVRya0tBZBTad4/LnG5bAcRjLbuEsZ9EDHZDfCP/RlzBi5sSMhJByngQJMxXjx8/rjynYVld4YO8QxeFgnBGx19GBr8UYaJi6BkqoSIRJpYUoS3Ue3ioqHHodeVpD7K6TBKEEdGNXWVai6WkUeRLQl2yOCSipdJTy0Ve8/7xBw70szrk1IMHme3ahCMSY60B0kJ/JQJcsjOXfzSNT/RhbDy1nlhuQd+9E4sDN/R6na6u/AFGFbMY1rJCpDyfRQQgVxEPFsU+n90uLYltEA8oq/TC81oLdIi+PC0PcxNW5tp2iWtoi4ETc5vExTtzk/AkI4lX+kB6LA3usS3axN1wu91sKV426bjDuC9MEH+RVnENhQNpkiTlbmkSt3BisUSilPp81XLn4eEE/1qt7V0di7eGdXfr1MPD3zYfy4qfU5THgCtyaFkBhkSZxKTMyIgx3LgdB5CLcO74uLhhw+LixosE4aeNY5criJJY1s/iBojp+fnm+FVJFTf0/UXNvAgOP6Jb1obnCszOeX5ZYYY6pqebSvJXbUy4YXOMF0Q0RJwNIkqeN6XzIkCIO3akm+slG4u63i4Yik4RTR/WS3EirslFIBG+IxY1P6Hz68Ps5bkR/95gmI1SgKw+H1PUGSIHQjSZuGk9pyvtH/mPOQbbXEEFVRNrbiJRMXdHerpkU9FD1vHTo0i0EIna9Bnd5w8/9+joGBBEydhQSZAQMaoSiNj/u/Xjs2ev0ZO6YAsyM7Pd6D8sGVdAK5pKgvwk7ojx2tj+wh/M+IyRhzJTs1Jz8jI7/PG6tykdoFAogqGSuVuQxo4Du9pscUSz9SZ1abkvKycn+Vje4DDOBsQwLwXS0kQ2ifExXVm2uRvvTiO77EtNPZCcvFvdtmN45x3rS8WbxpJFSbkAkwBKKmJ6s47vxRbT22XuT83KycNnGHFhDjJKBkmFoqaRRHZwosz0jHV8t6q94O0/gIJ5aWp+ozzMki4FqQjWVIdIgJxYbI4Zox/2zS/tcCgrB3uAOcnGNCPGOOyMFT8nSa4k5jWmKB0gJ/pMncecE361oiMzczAwamOyOq3tX30AJezaQGp58vx5kwkabgAkxSUnTJ2fdvsSnLQ/9UBWsrrQmJ22B+DfZI6XUakaW8I0FZtM8cUez4uMpIm9PoMtczCfycbdewpP/V1D/s5VTKY0kuZ8LsWmCilVn3/i2aLRn8BjamwZGtXZ6ws1HQV/mwnDGlQhsgQmF5lMytAGn0+6CSQP5u02Yo8Te3jlGgzNX2f8QzIlRaXlyBIDH6WFqaI8Ugu9kVtBUcs89W6jcT02YTV1gyNyaZ5vUfFk0OIpCcXCqKpoJHYGQXQYmmcEaMzW6M+VDxNG5mPHfCaFI0nO5GMhVSkkTT9/2Xb27LZn8WnOenV2drZGUzc3QpfmGDnJkZxJWfiQ2hQV1d6lO3u2fH1h4XokO9uh0d1CxYhkZj1V1Uhiy45CGK1K+6bBocOxMyJqVLx711GOipGJaKCc0YZILY8yDPdPqU6HzUk0hAfwssMxQRCpjDPTCpBNJjT8BBtYltWfxeuNQnzSAbBuMBExURRjp0B+YUKknjfYsDGpxwMONtTvXi6ti+T967gKqYXC+FSpVLwJlGFcNfQAG4vAxMcKpWN6RlBssUVmx+PwVOGEflPncR1VPGmJHVBQYCsAWnq5lB0jFEQw3XITDdId/IWdEPbs2W/q1KnzgoyLrvFakQI+kRWJBdsy1nX46n8I4TwsbMMuxGrFjw1iJNNpYufv9i5bWEhaEXD6YSK2roQgsmQzn3BP1brIgN/PkX5rV1T85xmhcmkDlZV+p9O5aw4hiEJ6klWqssrKSqfTPUcQlYgUKRAR61g0jEaENRBBOr0TBNEJEatKKQPpxJpGKdP6pryC6EfFKKXjG050iglBtCKs7vsqUOYcK4he5mtV78oqBwuiF1Fs33eVfgxO9NJNCzGaq4q7WZwDIEYxouoy5wBCEM10fMmdcqKabqwVyxrVDNcfRsmops/guYL/MR8BhozHNbVruk0AAAAASUVORK5CYII="
        alt
        className="category-icon FISH  icon_FISH"
      />
    ),
  },
  {
    title: "Poker",
    titleBn: "জুজু",
    key: "poker",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon PVP icon_PVP"
      />
    ),
  },
  {
    title: "Sports",
    titleBn: "খেলাধুলা",
    key: "sports",
    image: (
      <img
        src="data:image/png;base64,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"
        alt
        className="category-icon SPORTS icon_SPORTS"
      />
    ),
  },
  // {
  //   title: "Lottery",
  //   key: "Lottery",
  //   image: (
  //     <img
  //       src="data:image/png;base64,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"
  //       alt
  //       className="category-icon ELOTT  icon_ELOTT"
  //     />
  //   ),
  // },
];

export const HomeBanner = [
  "/assets/Banner/1747841888557_window%20web%208.webp",
  "/assets/Banner/1750497103742_window%20web%201.webp",
  "/assets/Banner/1750497112510_window%20web%202.webp",
  "/assets/Banner/1747841848374_window%20web%203.webp",
  "/assets/Banner/1747841856385_window%20web%204.webp",
  "/assets/Banner/1750497120004_window%20web%205.webp",
  "/assets/Banner/1747841870414_window%20web%206.webp",
  "/assets/Banner/1747841880933_window%20web%207.webp",
  "/assets/Banner/1747841888557_window%20web%208.webp",
  "/assets/Banner/1750497103742_window%20web%201.webp",
];

export const SlotsPlatform = [
  {
    name: "FC",
    key: "FC",
    img: "/assets/Platform/FC-COLOR.webp",
  },
  {
    name: "Spribe",
    key: "SPRIBE",
    img: "/assets/Platform/SPB-COLOR.webp",
  },
  {
    name: "JDB",
    key: "JDB",
    img: "/assets/Platform/JDB-COLOR.webp",
  },
  {
    name: "Jili",
    key: "JILI",
    img: "/assets/Platform/JL-COLOR.webp",
  },
  {
    name: "PG",
    key: "PG",
    img: "/assets/Platform/PG-COLOR.webp",
  },
  {
    name: "PP",
    key: "PP",
    img: "/assets/Platform/PP-COLOR.webp",
  },

  {
    name: "RT",
    key: "RT",
    img: "/assets/Platform/RT-COLOR.webp",
  },
  {
    name: "Evoplay",
    key: "EVO",
    img: "/assets/Platform/EP-COLOR.webp",
  },

  {
    name: "SG",
    key: "SPADE",
    img: "/assets/Platform/SG-COLOR.webp",
  },

  {
    name: "CG",
    key: "CG",
    img: "/assets/Platform/cg.png",
  },

  {
    name: "YELLOW BAT",
    key: "YB",
    img: "/assets/Platform/YB-COLOR.webp",
  },
  // {
  //   name: "Nextspin",
  //   key: "NEXTSPIN",
  //   img: "/assets/Platform/NS-COLOR.webp",
  // },
  {
    name: "DS",
    key: "DS",
    img: "/assets/Platform/dragoon.png",
  },

  {
    name: "BTG",
    key: "BTG",
    img: "/assets/Platform/BTG-COLOR.webp",
  },

  {
    name: "Joker",
    key: "JOKER",
    img: "/assets/Platform/JK-COLOR.webp",
  },
  {
    name: "NetEnt",
    key: "NETENT",
    img: "/assets/Platform/NE-COLOR.webp",
  },
  {
    name: "LL",
    key: "LADYLUCK",
    img: "/assets/Platform/ladyluck.png",
  },

  {
    name: "NLC",
    key: "NLC",
    img: "/assets/Platform/NLC-COLOR.webp",
  },

  {
    name: "Fastspin",
    key: "FASTSPIN",
    img: "/assets/Platform/FS-COLOR.webp",
  },
  {
    name: "ILU",
    key: "ILU",
    img: "/assets/Platform/iloveu.png",
  },

  {
    name: "PLAY8",
    key: "PLAY8",
    img: "/assets/Platform/play8.png",
  },

  {
    name: "KingMidas",
    key: "KM",
    img: "/assets/Platform/KM-COLOR.webp",
  },
  {
    name: "Playtech",
    key: "PT",
    img: "/assets/Platform/PT-COLOR.webp",
  },
  {
    name: "Relax",
    key: "RELAX",
    img: "/assets/Platform/provider-awcv2_relax.png",
  },
  {
    name: "YGGDRASIL",
    key: "YGGDRASIL",
    img: "/assets/Platform/provider-awcv2_yggdrasil.png",
  },
  {
    name: "Octo Play",
    key: "OCTOPLAY",
    img: "/assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "Acewin",
    key: "ACEWIN",
    img: "/assets/Platform/provider-awcv2_acewin.png",
  },
  {
    name: "PlayNGO",
    key: "PLAYNGO",
    img: "/assets/Platform/provider-playngo.png",
  },
  {
    name: "YL",
    key: "YL",
    img: "/assets/Platform/darkIcon.png",
  },
  {
    name: "JJ",
    key: "JJ",
    img: "/assets/Platform/provider-awcv2_jj.png",
  },
];

export const LiveCasinoPlatform = [
  {
    name: "EVO",
    key: "EVO",
    img: "/assets/Platform/EG4-COLOR.webp",
  },
  {
    name: "PP",
    key: "PP",
    img: "/assets/Platform/PP-COLOR.webp",
  },

  {
    name: "YGG",
    key: "VIACASINO",
    img: "/assets/Platform/VIA-COLOR.webp",
  },

  {
    name: "Playtech",
    key: "PT",
    img: "/assets/Platform/PT-COLOR.webp",
  },

  {
    name: "SEXYBCRT",
    key: "SEXYBCRT",
    img: "/assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "BG",
    key: "BG",
    img: "/assets/Platform/provider-BG.png",
  },

  //  {
  //   name: "SV388",
  //   key: "SV388",
  //   img: "/assets/Platform/icon-sv388.svg",
  // },
  {
    name: "WINFINITY",
    key: "WINFINITY",
    img: "/assets/Platform/provider-awcv2_winfinity.png",
  },
  {
    name: "DG",
    key: "DREAMGAMING",
    img: "/assets/Platform/provider-awcmdg.png",
  },
  {
    name: "Creed",
    key: "CREEDROOMZ",
    img: "/assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "HOTROAD",
    key: "HOTROAD",
    img: "/assets/Platform/provider-awcmhotroad.png",
  },
];

export const PokerPlatform = [
  {
    name: "Kings Poker",
    key: "KP",
    img: "/assets/bdtwin/KP-WHITE.png",
  },
  {
    name: "Baison Poker",
    key: "BSP",
    img: "/assets/bdtwin/BSP-WHITE.png",
  },
  {
    name: "KingMidas",
    key: "KINGMAKER",
    img: "/assets/bdtwin/KM-WHITE.png",
  },
  {
    name: "RGSlot",
    key: "RG",
    img: "/assets/bdtwin/RG-WHITE.png",
  },
];

export const FishingPlatform = [
  {
    name: "Jili",
    key: "JILI",
    img: "/assets/Platform/JL-COLOR.webp",
  },
  {
    name: "FC",
    key: "FC",
    img: "/assets/Platform/FC-COLOR.webp",
  },
  {
    name: "SG",
    key: "SPADE",
    img: "/assets/Platform/SG-COLOR.webp",
  },
  {
    name: "Fastspin",
    key: "FASTSPIN",
    img: "/assets/Platform/FS-COLOR.webp",
  },
  {
    name: "JDB",
    key: "JDB",
    img: "/assets/Platform/JDB-COLOR.webp",
  },
  {
    name: "YL",
    key: "YL",
    img: "/assets/Platform/darkIcon.png",
  },
    {
    name: "Acewin",
    key: "ACEWIN",
    img: "/assets/Platform/provider-awcv2_acewin.png",
  },  {
    name: "YESBINGO",
    key: "YESBINGO",
    img: "/assets/Platform/provider-awcv2_yesbingo.png",
  },
  {
    name: "JJ",
    key: "JJ",
    img: "/assets/Platform/provider-awcv2_jj.png",
  },

];

export const PlatformObject = {
  FC: "/assets/Platform/FC-COLOR.webp",
  SPRIBE: "/assets/Platform/SPB-COLOR.webp",
  JILI: "/assets/Platform/JL-COLOR.webp",
  JDB: "/assets/Platform/JDB-COLOR.webp",
  PG: "/assets/Platform/PG-COLOR.webp",
  PP: "/assets/Platform/PP-COLOR.webp",
  RT: "/assets/Platform/RT-COLOR.webp",
  EVO: "/assets/Platform/EG4-COLOR.webp",
  SPADE: "/assets/Platform/SG-COLOR.webp",
  YB: "/assets/Platform/YB-COLOR.webp",
  BTG: "/assets/Platform/BTG-COLOR.webp",
  JOKER: "/assets/Platform/JK-COLOR.webp",
  NETENT: "/assets/Platform/NE-COLOR.webp",
  NLC: "/assets/Platform/NLC-COLOR.webp",
  FASTSPIN: "/assets/Platform/FS-COLOR.webp",
  KM: "/assets/Platform/KM-COLOR.webp",
  PT: "/assets/Platform/PT-COLOR.webp",
  DS: "/assets/Platform/dragoon.png",
  CG: "/assets/Platform/cg.png",
  LADYLUCK: "/assets/Platform/ladyluck.png",
  PLAY8: "/assets/Platform/play8.png",
  ILU: "/assets/Platform/iloveu.png",
  RELAX: "/assets/Platform/provider-awcv2_relax.png",
  YGGDRASIL: "../assets/Platform/provider-awcv2_yggdrasil.png",
  OCTOPLAY: "/assets/Platform/provider-awcv2_octoplay.png",
  ACEWIN: "/assets/Platform/provider-awcv2_acewin.png",
  PLAYNGO: "/assets/Platform/provider-playngo.png",
  YL: "/assets/Platform/darkIcon.png",
  JJ: "/assets/Platform/provider-awcv2_jj.png",

  SEXYBCRT: "/assets/Platform/provider-awcmsexy.png",
  BG: "/assets/Platform/provider-BG.png",
  SV388: "/assets/Platform/icon-sv388.svg?v=1772072361392&source=mcdsrc",
  WINFINITY: "/assets/Platform/provider-awcv2_winfinity.png",
  DREAMGAMING: "/assets/Platform/provider-awcmdg.png",
  CREEDROOMZ: "/assets/Platform/provider-awcv2_creedroomz.png",
  HOTROAD: "/assets/Platform/provider-awcmhotroad.png",
  VIACASINO: "/assets/Platform/provider-awcmvia.png",
  YESBINGO:"/assets/Platform/provider-awcv2_yesbingo.png",
};
